webpackJsonp([1],{

/***/ "+01a":
/***/ (function(module, exports) {

module.exports = "<div class=\"view-container\" *ngIf=\"testTakerInfo\">\r\n    <div class=\"singlePane pane-content start-screen\">\r\n        <div class=\"main\">\r\n            <start-screen-photo\r\n                [testTakerPhotoUrl]=\"testTakerPhotoUrl\"\r\n                [stationNumber]=\"regId\"\r\n                [testTakerInfo]=\"testTakerInfo\"\r\n            ></start-screen-photo>\r\n            <div style=\"clear: both;\"></div>\r\n            <div id=\"start-screen-error\" [class.visible]=\"errorMsg && errorMsg.length > 0\">\r\n                {{errorMsg}}\r\n            </div>\r\n            <div id=\"panel-content\">\r\n                <div class=\"start-code\">\r\n                    <div style=\"display:flex; justify-content: space-around; flex-direction:row-reverse;\">\r\n                        <div>\r\n                            <p><button class=\"btn btn-warning\" (click)=\"onStartTest()\">Continue</button></p>\r\n                        </div>\r\n                        <div style=\"font-size:13px; flex-grow: 1; padding-right: 25px; margin-right: 25px; text-align:left;\">\r\n                                <strong>By starting my test, I agree that:</strong>\r\n                                <br><br>\r\n                                <ul>\r\n                                    <li>I am the test taker identified by the personal details of this Paragon registration number</li>\r\n                                    <li>I have stored all of my personal belongings, including any cellphones and other electronic devices</li>\r\n                                    <li>I will provide test responses that are not copied, memorized or used by any other person to the best of my knowledge</li>\r\n                                    <li>I will not share the test questions I see today or the responses I give with anyone, through any communication platform (including social media, blogs, or in conversation)</li>\r\n                                    <li>I will follow the instructions of my proctor</li>\r\n                                </ul>\r\n                            \t<br>\r\n                                <strong>I understand that if I do not follow any of the above that my test scores may be invalidated by Paragon Testing Enterprises and my test score users may be notified</strong>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),

/***/ "+2Ou":
/***/ (function(module, exports) {

module.exports = "<top-nav\r\n    [assessmentTest]=\"assessmentTest$ | async\"\r\n    [activeAssessmentItem]=\"assessmentItem$ | async\"\r\n    [testlet$]=\"testlet$\"\r\n    [assessmentItem$]=\"assessmentItem$\"\r\n    [testNavigation]=\"testNavigation$ | async\"\r\n    >\r\n</top-nav>\r\n<div class=\"view-container\">\r\n    <div>\r\n        <page-nav\r\n            [testlet$]=\"testlet$\"\r\n            [itemIndex$]=\"itemIndex$\"\r\n            >\r\n        </page-nav>\r\n        <item-body\r\n            [assessmentItem$]=\"assessmentItem$\"\r\n            >\r\n        </item-body>\r\n    </div>\r\n</div>\r\n<footer *ngIf=\"isIppMode\">\r\n    <p>Copyright {{currentYear}} - Paragon Testing Enterprises, a subsidiary of UBC | <a href=\"https://www.cael.ca/\" target=\"blank\">www.cael.ca</a> | <a href=\"https://www.cael.ca/contact/\" target=\"blank\">Contact Us</a></p>\r\n</footer>\r\n<navigation-modal></navigation-modal>\r\n<test-form-validation #testFormValidation></test-form-validation>\r\n"

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("cDNt");


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "25aa":
/***/ (function(module, exports) {

module.exports = "<div class=\"info-box\" [ngClass]=\"{'microphone-check-info-box': forMicrophoneCheck === true }\" [class.hidden]=\"!visible\">\r\n    <div class=\"icon-holder\">\r\n        <span class=\"value\">\r\n            <span class=\"cover\" [style.height]=\"iconCover + '%'\"></span>\r\n            <span class=\"{{iconCssClass}} icon\"></span>\r\n        </span>\r\n    </div>\r\n    <div class=\"info-box-content\">\r\n        <div class=\"text\">{{text}}</div>\r\n        <div [ngSwitch]=\"mode\">\r\n            <ng-template [ngSwitchCase]=\"'ProgressBar'\">\r\n                <div class=\"progress-bar\">\r\n                    <span class=\"progress-bar-value\">\r\n                        <em class=\"progress-bar-cover\" [style.width]=\"progressPercentage + '%'\"></em>\r\n                    </span>\r\n                </div>\r\n            </ng-template>\r\n            <ng-template [ngSwitchCase]=\"'CountDownTimer'\">\r\n                <div class=\"counter-text\" *ngIf=\"counterText && counterText.length > 0\">\r\n                    {{counterText}}\r\n                </div>\r\n                <div class=\"text\">second(s)</div>\r\n            </ng-template>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),

/***/ "2coj":
/***/ (function(module, exports) {

module.exports = "<span class=\"timing\" *ngIf=\"visible === true && displayMode == 'standard' && timerDisplayText\">\r\n    Time Remaining: <strong [ngClass]=\"{'hurry-up': runningLowOnTime === true}\">{{timerDisplayText}}</strong>\r\n</span>\r\n<span class=\"timing-speaking\" *ngIf=\"visible === true && displayMode == 'speaking'\">\r\n    Preparation Time: <strong>{{speakingPreparationTime}} seconds</strong><br />\r\n    Speaking Time: <strong>{{speakingRecordingTime}} seconds</strong>\r\n</span>"

/***/ }),

/***/ "37O9":
/***/ (function(module, exports) {

module.exports = "<div class=\"info-card\">\r\n  <div class=\"info-card-wrapper\">\r\n    <div *ngIf=\"isWebDelivery\">\r\n      <p>This is the end of the test.</p>\r\n      <br />\r\n      <p>Your results will be available online within 8 business days.</p>\r\n      <br />\r\n      <p>If you experienced any issues that you believe could have affected your performance, please email <a href=\"mailto:issues@cael.ca\">issues@cael.ca</a> within 48 hours of your test.</p>\r\n      <br />\r\n      <p>If you have any other questions, please check our website <a href=\"https://www.cael.ca/\">www.cael.ca</a> or email us at <a href=\"mailto:info@cael.ca\">info@cael.ca</a>.</p>\r\n    </div>\r\n    <div *ngIf=\"!isWebDelivery\">\r\n      <div class=\"end-of-test-top-banner\" *ngIf=\"testLogoImageData\">\r\n        <img [src]=\"testLogoImageData\" style=\"width: 410px; margin-left: 100px;\">\r\n      </div>\r\n      <div class=\"end-of-test-left-pane\">\r\n        <img [src]=\"testTakerPhotoUrl\" style=\"height: 70%\">\r\n      </div>\r\n      <div class=\"end-of-test-right-pane\">\r\n        <h3 style=\"margin-top: 25%;\">End of Test</h3>\r\n      </div>\r\n      <div class=\"end-of-test-bottom-banner\">\r\n        <p>Please raise your hand to let the test centre staff know that your test is complete. Thank you for taking {{testTypeName}}.</p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),

/***/ "5SK3":
/***/ (function(module, exports) {

module.exports = "<div class=\"page-nav-buttons\" *ngIf=\"testlet && assessmentItemList.length > 1\">    \r\n    <div>\r\n        <button class=\"btn btn-default\" (click)=\"goPrev()\"><i class=\"fa fa-arrow-left\"></i></button>\r\n        <button *ngFor=\"let item of assessmentItemList, let i=index\"\r\n                (click)=\"onPageChange(item.ItemIndex)\"\r\n                [class.active]=\"itemIndex == item.ItemIndex\"\r\n                [class.answered]=\"allInteractionsAnswered(item)\"\r\n                class=\"btn btn-default\">\r\n            {{item.DisplayPageNumber}}\r\n        </button>\r\n        <button class=\"btn btn-default\" (click)=\"goNext()\"><i class=\"fa fa-arrow-right\"></i></button>\r\n    </div>    \r\n</div>"

/***/ }),

/***/ "5XV9":
/***/ (function(module, exports) {

module.exports = "<button class=\"btn btn-default\" (click)=\"showDialog()\">{{title}}</button>"

/***/ }),

/***/ "5f4n":
/***/ (function(module, exports) {

module.exports = "<div class=\"align-center\">\r\n\t<div *ngIf=\"!resourceVisible\">\r\n    <p class=\"pane-message\" *ngIf=\"type == 'audio'\">An audio clip will play automatically after the preparation time.</p>\r\n    <p class=\"pane-message\" *ngIf=\"type == 'video'\">A video clip will play automatically after the preparation time.</p>\r\n\t\t<info-box \r\n      [text]=\"'Preparation Time'\"\r\n      [visible]=\"true\"\r\n      [iconCssClass]=\"'clock-icon'\"\r\n      [mode]=\"'CountDownTimer'\"\r\n      [counterText]=\"timeLeft\"\r\n    ></info-box>\r\n\t</div>\r\n\t<div *ngIf=\"resourceVisible == true\">\r\n\t\t<media-resource [id]=\"resourceId\" [type]=\"type\" [autoplay]=\"true\"></media-resource>\r\n\t</div>\r\n</div>"

/***/ }),

/***/ "626h":
/***/ (function(module, exports) {

module.exports = "<div class=\"view-container\">\r\n    <div class=\"singlePane pane-content start-screen\">\r\n        <div class=\"main\">\r\n            <start-screen-photo\r\n                [testTakerPhotoUrl]=\"testTakerPhotoUrl\"\r\n                [stationNumber]=\"stationNumber\"\r\n                [testTakerInfo]=\"testTakerInfo\"\r\n            ></start-screen-photo>\r\n            <div style=\"clear: both;\"></div>\r\n            <div id=\"start-screen-error\" [class.visible]=\"errorMsg && errorMsg.length > 0\">\r\n                {{errorMsg}}\r\n            </div>\r\n            <div id=\"panel-content\">\r\n                <microphone-check (microphoneCheckCompleted)=\"audioCheckCompleted($event)\"></microphone-check>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),

/***/ "6wyb":
/***/ (function(module, exports) {

module.exports = "\r\n<div>\r\n    <div *ngIf=\"!hidepdf\" class=\"embed-responsive pdf-display\">\r\n        <embed [src]=\"srcUrl\" type=\"application/pdf\"/>\r\n    </div>\r\n    <a *ngIf=\"hidepdf && label\" [href]=\"srcUrl\" target=\"_blank\" class=\"animated fadeIn\"><button class=\"btn btn-primary\">{{label}}</button></a>\r\n</div>\r\n"

/***/ }),

/***/ "7sRl":
/***/ (function(module, exports) {

module.exports = "<div class=\"view-container\">\r\n    <div class=\"singlePane pane-content start-screen\">\r\n        <div class=\"main\">\r\n            <start-screen-photo\r\n                [testTakerPhotoUrl]=\"testTakerPhotoUrl\"\r\n                [stationNumber]=\"stationNumber\"\r\n                [testTakerInfo]=\"testTakerInfo\"\r\n            ></start-screen-photo>\r\n            <div style=\"clear: both;\"></div>\r\n            <div id=\"start-screen-error\" [class.visible]=\"errorMsg && errorMsg.length > 0\">\r\n                {{errorMsg}}\r\n            </div>\r\n            <div id=\"panel-content\">\r\n                <div class=\"start-code\">\r\n                    <div style=\"display:flex; justify-content: space-around; flex-direction:row-reverse;\">\r\n                        <div>\r\n                            <p>Please wait for your test supervisor to provide the 4-digit <strong>Start Code</strong>:</p>\r\n                            <p><input type=\"password\" maxlength=\"4\" #txtStartCode (keydown)=\"txtStartCodeKeyDown($event, txtStartCode.value)\" /></p>\r\n                            <p><button class=\"btn btn-warning\" (click)=\"verifyStartCodeAndBeginTest(txtStartCode.value)\">Start</button></p>\r\n                        </div>\r\n                        <div style=\"font-size:13px; flex-grow: 1; padding-right: 25px; margin-right: 25px; border-right: solid thin #ccc; text-align:left;\">\r\n                                <strong>By starting my test, I agree that:</strong>\r\n                                <br><br>\r\n                                <ul>\r\n                                    <li>I am the test taker identified by the personal details of this Paragon registration number</li>\r\n                                    <li>I have stored all of my personal belongings, including any cellphones and other electronic devices</li>\r\n                                    <li>I will provide test responses that are not copied, memorized or used by any other person to the best of my knowledge</li>\r\n                                    <li>I will not share the test questions I see today or the responses I give with anyone, through any communication platform (including social media, blogs, or in conversation)</li>\r\n                                    <li>I will follow the instructions of the test centre personnel</li>\r\n                                </ul>\r\n                            \t<br>\r\n                                <strong>I understand that if I do not follow any of the above that my test scores may be invalidated by Paragon Testing Enterprises and my test score users may be notified</strong>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n</div>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),

/***/ "8Byu":
/***/ (function(module, exports) {

module.exports = "<span [innerHTML]=\"counter\"></span>\r\n"

/***/ }),

/***/ "8I1P":
/***/ (function(module, exports) {

module.exports = "<div class=\"inline-choice\" [ngClass]=\"{active: isToggleOn}\">\r\n    <div class=\"dd-toggle\" (click)=\"inlineOnToggle(menu)\" [ngClass]=\"{texted: answerText !== ''}\">\r\n        <span [innerHtml]=\"answerText\"></span>\r\n        <span class=\"icon-filler\" *ngIf=\"!answerText || answerText.length == 0\">&#9662;</span>\r\n    </div>\r\n    <div class=\"dd-menu\" #menu positioned=\"false\">\r\n        <ul>\r\n            <li *ngFor=\"let choice of inlineChoiceInteraction.InlineChoices\" (click)=\"setResponse(choice.Identifier, choice.Html)\" [ngClass]=\"{selected: answerText == choice.Html}\">\r\n                <span [innerHtml]=\"choice.Html\"></span>\r\n            </li>\r\n        </ul>\r\n    </div>\r\n</div>\r\n"

/***/ }),

/***/ "8Sw2":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "FQor",
	"./af.js": "FQor",
	"./ar": "EcI0",
	"./ar-ly": "7CVz",
	"./ar-ly.js": "7CVz",
	"./ar-ma": "1dFW",
	"./ar-ma.js": "1dFW",
	"./ar-sa": "UxV2",
	"./ar-sa.js": "UxV2",
	"./ar-tn": "nm31",
	"./ar-tn.js": "nm31",
	"./ar.js": "EcI0",
	"./az": "EbpX",
	"./az.js": "EbpX",
	"./be": "SQlX",
	"./be.js": "SQlX",
	"./bg": "R3V+",
	"./bg.js": "R3V+",
	"./bn": "cAX3",
	"./bn.js": "cAX3",
	"./bo": "dHgA",
	"./bo.js": "dHgA",
	"./br": "W7ww",
	"./br.js": "W7ww",
	"./bs": "lZ6K",
	"./bs.js": "lZ6K",
	"./ca": "udbC",
	"./ca.js": "udbC",
	"./cs": "oSQb",
	"./cs.js": "oSQb",
	"./cv": "yPEm",
	"./cv.js": "yPEm",
	"./cy": "PpYB",
	"./cy.js": "PpYB",
	"./da": "oiZG",
	"./da.js": "oiZG",
	"./de": "LYe6",
	"./de-at": "KOG5",
	"./de-at.js": "KOG5",
	"./de.js": "LYe6",
	"./dv": "OkYT",
	"./dv.js": "OkYT",
	"./el": "QFnp",
	"./el.js": "QFnp",
	"./en-au": "dBGl",
	"./en-au.js": "dBGl",
	"./en-ca": "vv0C",
	"./en-ca.js": "vv0C",
	"./en-gb": "IoCy",
	"./en-gb.js": "IoCy",
	"./en-ie": "qVAg",
	"./en-ie.js": "qVAg",
	"./en-nz": "FbT0",
	"./en-nz.js": "FbT0",
	"./eo": "y/6j",
	"./eo.js": "y/6j",
	"./es": "ivpd",
	"./es-do": "DBbP",
	"./es-do.js": "DBbP",
	"./es.js": "ivpd",
	"./et": "FrUj",
	"./et.js": "FrUj",
	"./eu": "LAVD",
	"./eu.js": "LAVD",
	"./fa": "J2cK",
	"./fa.js": "J2cK",
	"./fi": "5FCP",
	"./fi.js": "5FCP",
	"./fo": "jIZb",
	"./fo.js": "jIZb",
	"./fr": "Lq8I",
	"./fr-ca": "ICRA",
	"./fr-ca.js": "ICRA",
	"./fr-ch": "QWmo",
	"./fr-ch.js": "QWmo",
	"./fr.js": "Lq8I",
	"./fy": "Fbnp",
	"./fy.js": "Fbnp",
	"./gd": "zhFu",
	"./gd.js": "zhFu",
	"./gl": "o10m",
	"./gl.js": "o10m",
	"./he": "gbvS",
	"./he.js": "gbvS",
	"./hi": "+UQz",
	"./hi.js": "+UQz",
	"./hr": "qGYH",
	"./hr.js": "qGYH",
	"./hu": "hGGh",
	"./hu.js": "hGGh",
	"./hy-am": "1AR5",
	"./hy-am.js": "1AR5",
	"./id": "Ie9h",
	"./id.js": "Ie9h",
	"./is": "piS+",
	"./is.js": "piS+",
	"./it": "5P9/",
	"./it.js": "5P9/",
	"./ja": "3cRe",
	"./ja.js": "3cRe",
	"./jv": "vwCJ",
	"./jv.js": "vwCJ",
	"./ka": "R7aq",
	"./ka.js": "R7aq",
	"./kk": "d8hV",
	"./kk.js": "d8hV",
	"./km": "nCdc",
	"./km.js": "nCdc",
	"./ko": "1jN3",
	"./ko.js": "1jN3",
	"./ky": "74/W",
	"./ky.js": "74/W",
	"./lb": "XAyT",
	"./lb.js": "XAyT",
	"./lo": "w/Mz",
	"./lo.js": "w/Mz",
	"./lt": "IetG",
	"./lt.js": "IetG",
	"./lv": "CRPd",
	"./lv.js": "CRPd",
	"./me": "1mee",
	"./me.js": "1mee",
	"./mi": "yRr3",
	"./mi.js": "yRr3",
	"./mk": "bfn1",
	"./mk.js": "bfn1",
	"./ml": "r1ky",
	"./ml.js": "r1ky",
	"./mr": "+K6p",
	"./mr.js": "+K6p",
	"./ms": "asMk",
	"./ms-my": "IcWU",
	"./ms-my.js": "IcWU",
	"./ms.js": "asMk",
	"./my": "Isng",
	"./my.js": "Isng",
	"./nb": "FjNp",
	"./nb.js": "FjNp",
	"./ne": "P9zQ",
	"./ne.js": "P9zQ",
	"./nl": "pejQ",
	"./nl.js": "pejQ",
	"./nn": "ALD8",
	"./nn.js": "ALD8",
	"./pa-in": "1YTd",
	"./pa-in.js": "1YTd",
	"./pl": "Gs99",
	"./pl.js": "Gs99",
	"./pt": "eunO",
	"./pt-br": "uHKL",
	"./pt-br.js": "uHKL",
	"./pt.js": "eunO",
	"./ro": "1FZw",
	"./ro.js": "1FZw",
	"./ru": "Cy48",
	"./ru.js": "Cy48",
	"./se": "EiHj",
	"./se.js": "EiHj",
	"./si": "77bI",
	"./si.js": "77bI",
	"./sk": "BgyH",
	"./sk.js": "BgyH",
	"./sl": "K7sG",
	"./sl.js": "K7sG",
	"./sq": "pwQJ",
	"./sq.js": "pwQJ",
	"./sr": "N0T2",
	"./sr-cyrl": "9OoP",
	"./sr-cyrl.js": "9OoP",
	"./sr.js": "N0T2",
	"./ss": "Mh9L",
	"./ss.js": "Mh9L",
	"./sv": "YZAt",
	"./sv.js": "YZAt",
	"./sw": "/7jV",
	"./sw.js": "/7jV",
	"./ta": "VKBt",
	"./ta.js": "VKBt",
	"./te": "TIcV",
	"./te.js": "TIcV",
	"./th": "Zi3L",
	"./th.js": "Zi3L",
	"./tl-ph": "D4Y9",
	"./tl-ph.js": "D4Y9",
	"./tlh": "muBP",
	"./tlh.js": "muBP",
	"./tr": "82s3",
	"./tr.js": "82s3",
	"./tzl": "vjXv",
	"./tzl.js": "vjXv",
	"./tzm": "Vhfe",
	"./tzm-latn": "m0Pg",
	"./tzm-latn.js": "m0Pg",
	"./tzm.js": "Vhfe",
	"./uk": "Y3Ex",
	"./uk.js": "Y3Ex",
	"./uz": "wDue",
	"./uz.js": "wDue",
	"./vi": "UbP6",
	"./vi.js": "UbP6",
	"./x-pseudo": "fQLM",
	"./x-pseudo.js": "fQLM",
	"./zh-cn": "DV5H",
	"./zh-cn.js": "DV5H",
	"./zh-hk": "iEKH",
	"./zh-hk.js": "iEKH",
	"./zh-tw": "X9uL",
	"./zh-tw.js": "X9uL"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8Sw2";

/***/ }),

/***/ "8h0P":
/***/ (function(module, exports) {

module.exports = "<div class=\"align-center\">\r\n    <div [ngSwitch]=\"type\">\r\n        <ng-template [ngSwitchCase]=\"'audio'\">\r\n            <audio #audioWrapper controls (play)=\"onPlay($event)\" (timeupdate)=\"onTimeupdate($event)\" (ended)=\"onEnded($event)\" (loadeddata)=\"onLoadeddata($event)\" class=\"hidden\" autoplay style=\"margin: auto auto; display: block;\" controlsList=\"nodownload\">\r\n                <source [src]=\"srcUrl\" type=\"video/mp4\">\r\n                Your browser does not support the audio element.\r\n            </audio>\r\n        </ng-template>\r\n        <ng-template [ngSwitchCase]=\"'video'\">\r\n            <div class=\"embed-responsive embed-responsive-16by9\">\r\n                <video controls controlsList=\"nodownload\" (play)=\"onPlay($event)\" (timeupdate)=\"onTimeupdate($event)\" (ended)=\"onEnded($event)\" (loadeddata)=\"onLoadeddata($event)\" autoplay>\r\n                    <source [src]=\"srcUrl\" type=\"video/mp4\">\r\n                    Your browser does not support the video element.\r\n                </video>\r\n            </div>\r\n        </ng-template>\r\n    </div>\r\n\r\n    <info-box [text]=\"infoBoxText\"\r\n            [visible]=\"infoBoxVisible\"\r\n            [iconCssClass]=\"'play-icon'\"\r\n            [mode]=\"'ProgressBar'\"\r\n            [progressPercentage]=\"currentProgress\">\r\n    </info-box>\r\n</div>\r\n"

/***/ }),

/***/ "AL60":
/***/ (function(module, exports) {

module.exports = "<div class=\"animated fadeIn body\">\r\n    <div #container></div>\r\n</div>\r\n\r\n<info-box [text]=\"''\" [visible]=\"infoBoxVisible\"></info-box>"

/***/ }),

/***/ "C1qz":
/***/ (function(module, exports) {

module.exports = "<div class=\"start-screen\" style=\"padding: 0\">\r\n    <div class=\"main\" style=\"padding: 0\">\r\n        <start-screen-photo\r\n            [testTakerPhotoUrl]=\"testTakerPhotoUrl\"\r\n            [stationNumber]=\"stationNumber\"\r\n            [testTakerInfo]=\"testTakerInfo\"\r\n        ></start-screen-photo>\r\n        <div id=\"start-screen-error\" [class.visible]=\"true\">\r\n            <ng-content></ng-content>\r\n        </div>\r\n        <div id=\"panel-content\">\r\n            <microphone-check (microphoneCheckCompleted)=\"audioCheckCompleted($event)\"></microphone-check>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),

/***/ "Coua":
/***/ (function(module, exports) {

module.exports = "<div class=\"view-container\">\r\n    <div class=\"singlePane pane-content start-screen\">\r\n        <div class=\"main\">\r\n            <start-screen-photo\r\n                [testTakerPhotoUrl]=\"testTakerPhotoUrl\"\r\n                [stationNumber]=\"stationNumber\"\r\n                [testTakerInfo]=\"testTakerInfo\"\r\n            ></start-screen-photo>\r\n            <div style=\"clear: both;\"></div>\r\n            <div id=\"start-screen-error\" [class.visible]=\"errorMsg && errorMsg.length > 0\">\r\n                {{errorMsg}}\r\n            </div>\r\n            <div id=\"panel-content\">\r\n                <audio-check (audioCheckCompleted)=\"audioCheckCompleted($event)\"></audio-check>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),

/***/ "FuR7":
/***/ (function(module, exports) {

module.exports = "<loading-overlay [loading]=\"!answerKeyReady\"></loading-overlay>\r\n<div *ngFor=\"let testletAnswerKey of answerKeys, let i = index\">\r\n    <table class=\"table table-bordered preview-response answer-key-table\">\r\n        <tr>\r\n            <th colspan=\"4\" class=\"text-center answer-key-testlet-title\">{{testletAnswerKey.TestletTitle}}</th>\r\n        </tr>\r\n        <tr>\r\n            <th class=\"text-center answer-key-table-question-title\">Question</th>\r\n            <th class=\"answer-key-table-correct-answer\">Correct Answer(s)</th>\r\n            <th class=\"answer-key-table-user-response\" *ngIf=\"isFOST === false\">Your Response(s)</th>\r\n        </tr>\r\n        <tr *ngFor=\"let interaction of testletAnswerKey.InteractionAnswers, let i = index\">\r\n            <td class=\"text-center\">Question {{ i + 1 }}</td>\r\n            <td><span [innerHtml]=\"interaction.CorrectResponses != '' ? interaction.CorrectResponses : 'N/A' \"></span></td>\r\n            <td *ngIf=\"isFOST === false\">\r\n                <div style=\"display: inline-block\" [innerHtml]=\"interaction.UserResponses\"></div>\r\n                <i class='fa fa-check answer-key-icon' style=\"color:green;\" *ngIf=\"interaction.IsCorrect != null && interaction.IsCorrect\" aria-hidden></i>\r\n                <i class='fa fa-times answer-key-icon' style=\"color: red;\" *ngIf=\"interaction.IsCorrect != null && !interaction.IsCorrect\" aria-hidden></i>\r\n            </td>\r\n        </tr>\r\n    </table>\r\n</div>\r\n<br>\r\n<br>\r\n"

/***/ }),

/***/ "GBf1":
/***/ (function(module, exports) {

module.exports = "<div class=\"overlay-screen-wrapper\" *ngIf=\"isExitScreenVisible == true\" style=\"z-index: 200001\">\r\n    <div class=\"overlay-screen\">\r\n        <div class=container>\r\n            <div class=\"row\">\r\n                <div class=\"col-md-6 col-md-offset-3\">\r\n                    <div class=\"form-horizontal\">\r\n                        <div class=\"form-group\">\r\n                            <label class=\"col-sm-3 control-label\"></label>\r\n                            <div class=\"col-sm-9\">\r\n                                <h2 class=\"text-center\">Exit Secure Browser</h2>\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"form-group\">\r\n                            <div class=\"col-sm-offset-2 col-sm-10\">\r\n                                <span class=\"error\">{{errorMsg}}</span>\r\n                            </div>\r\n                        </div>\r\n                        <ng-container *ngIf=\"hasTestTakerInfo\">\r\n                            <div class=\"form-group\">\r\n                                <label class=\"col-sm-3 control-label\">CTC Code:</label>\r\n                                <div class=\"col-sm-9\">\r\n                                    <input class=\"form-control\" type=\"password\" maxlength=\"6\" [(ngModel)]=\"exitCode\" [ngClass]=\"{'has-error': validationErrors.exitCode === true }\" />\r\n                                </div>\r\n                            </div>\r\n                            <div class=\"form-group\">\r\n                                <label class=\"col-sm-3 control-label\">Reason:</label>\r\n                                <div class=\"col-sm-9\">\r\n                                    <select class=\"form-control\" [(ngModel)]=\"selectedReason\" [ngClass]=\"{'has-error': validationErrors.reason === true }\" (change)=\"onFormUpdate()\">\r\n                                        <option disabled value=\"-1\">Select a reason:</option>\r\n                                        <option *ngFor=\"let reason of exitReasons\" [value]=\"reason.value\">{{reason.name}}</option>\r\n                                    </select>\r\n                                </div>\r\n                            </div>\r\n                            <div class=\"form-group\">\r\n                                <label class=\"col-sm-3 control-label\">Description:</label>\r\n                                <div class=\"col-sm-9\">\r\n                                    <textarea class=\"form-control\" rows=\"5\" [(ngModel)]=\"description\" [ngClass]=\"{'has-error': validationErrors.description === true }\"></textarea>\r\n                                </div>\r\n                            </div>\r\n                        </ng-container>\r\n                        <div class=\"form-group\">\r\n                            <div class=\"col-sm-offset-2 col-sm-10\">\r\n                                <button class=\"btn btn-warning\" (click)=\"confirmExit()\" [disabled]=\"btnConfirmDisabled\">Confirm Exit</button>\r\n                                <button class=\"btn btn-danger\" (click)=\"cancelExit()\">Cancel</button>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),

/***/ "H/ZB":
/***/ (function(module, exports) {

module.exports = "<div class=\"overlay-screen-wrapper\" *ngIf=\"isLockScreenVisible == true\">\r\n    <div class=\"overlay-screen\">\r\n        <p>The test is not paused. The timer is still running.</p>\r\n        <img src=\"{{testTakerPhotoUrl}}\" />        \r\n        <p>\r\n            <br />\r\n            <label>CTC Code: <input class=\"form-control\" type=\"password\" maxlength=\"12\" #txtExitCode /></label>\r\n            <br />\r\n            <span class=\"error\">{{errorMsg}}</span>\r\n            <br />\r\n            <button class=\"btn btn-warning\" (click)=\"checkExitCode(txtExitCode.value)\">Resume Test</button>\r\n        </p>\r\n    </div>\r\n</div>"

/***/ }),

/***/ "I4J1":
/***/ (function(module, exports) {

module.exports = "<img src=\"{{srcUrl}}\" class=\"img-responsive\" />"

/***/ }),

/***/ "KaX3":
/***/ (function(module, exports) {

module.exports = "<div class=\"match-interaction interaction-{{interaction.InteractionId}}\">\r\n    <p><span [innerHtml]=\"matchInteraction.Prompt\"></span></p>\r\n\r\n    <div class=\"choice-container\" [attr.data-parent-id]=\"interaction.InteractionId\">\r\n        <span class=\"draggable\" *ngFor=\"let choice of availableChoices\" [id]=\"choice.Identifier\" [attr.data-parent-id]=\"interaction.InteractionId\" [innerHtml]=\"choice.Html\"></span>\r\n    </div>\r\n\r\n    <div class=\"group-container\">\r\n        <div class=\"group\" *ngFor=\"let group of groups\">\r\n            <h4><span [innerHtml]=\"group.Html\"></span></h4>\r\n            <div class=\"placeholder\" [id]=\"group.Identifier\" [attr.data-match-max]=\"group.MatchMax\" [attr.data-parent-id]=\"interaction.InteractionId\">\r\n                <span class=\"draggable\" *ngFor=\"let choice of getGroupChoices(group.Identifier)\" [id]=\"choice.Identifier\" [attr.data-parent-id]=\"interaction.InteractionId\" [innerHtml]=\"choice.Html\"></span>                \r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),

/***/ "Lh+r":
/***/ (function(module, exports) {

module.exports = "{{hasMultiplePages}}\r\n<div *ngIf=\"assessmentItem\">\r\n    <div *ngIf=\"leftPane\" style=\"width: 50%;\" class=\"{{leftPane.CssClass}} pane-content\"\r\n        [ngClass]=\"{'offset-page-nav': showTab === true }\">\r\n        <item-body-panel [itemBodyPanel]=\"leftPane\" [interactions]=\"assessmentItem.Interactions\"></item-body-panel>\r\n    </div>\r\n\r\n    <div *ngIf=\"rightPane\" style=\"width: 50%;\" class=\"{{rightPane.CssClass}} pane-content\"\r\n        [ngClass]=\"{'has-page-nav': showTab === true }\"\r\n        >\r\n        <item-body-panel [itemBodyPanel]=\"rightPane\" [interactions]=\"assessmentItem.Interactions\"></item-body-panel>\r\n    </div>\r\n\r\n    <div *ngIf=\"mainPane\" style=\"width: 100%;\" class=\"singlePane pane-content\">\r\n        <item-body-panel [itemBodyPanel]=\"mainPane\" [interactions]=\"assessmentItem.Interactions\"></item-body-panel>\r\n    </div>    \r\n</div>\r\n"

/***/ }),

/***/ "OQQx":
/***/ (function(module, exports) {

module.exports = "<loading-overlay [loading]=\"!scoresReady\"></loading-overlay>\r\n<div *ngIf=\"scoresReady\">\r\n    <table class=\"table table-bordered scoring-page-table\" *ngIf=\"isLastScoresPage === true\">\r\n        <tr>\r\n            <th colspan=\"3\" class=\"text-center\" style=\"background-color:#D9DCE1\">Overall Reading Score</th>\r\n        </tr>\r\n        <tr>\r\n            <th class=\"text-center scoring-page-table-section-score\">Number of Scored Questions</th>\r\n            <th class=\"text-center scoring-page-table-question-count\">Your Score</th>\r\n            <th class=\"text-center scoring-page-table-score-percentage\">Your Score Percentage</th>\r\n        </tr>\r\n        <tr>\r\n            <th class=\"text-center\">{{ totalReadingQuestions }}</th>\r\n            <th class=\"text-center\">{{ totalReadingQuestions != 0 ? totalReadingScore : \"N/A\"}}</th>\r\n            <th class=\"text-center\">{{ totalReadingQuestions != 0 ? (totalReadingScore/totalReadingQuestions | percent:'1.0-0') : \"N/A\"}}</th>\r\n        </tr>\r\n    </table>\r\n    <table class=\"table table-bordered scoring-page-table\" *ngIf=\"isLastScoresPage === true\">\r\n        <tr>\r\n            <th colspan=\"3\" class=\"text-center\" style=\"background-color:#D9DCE1\">Overall Listening Score</th>\r\n        </tr>\r\n        <tr>\r\n            <th class=\"text-center scoring-page-table-section-score\">Number of Scored Questions</th>\r\n            <th class=\"text-center scoring-page-table-question-count\">Your Score</th>\r\n            <th class=\"text-center scoring-page-table-score-percentage\">Your Score Percentage</th>\r\n        </tr>\r\n        <tr>\r\n            <th class=\"text-center\">{{ totalListeningQuestions }}</th>\r\n            <th class=\"text-center\">{{ totalListeningQuestions != 0 ? totalListeningScore : \"N/A\"}}</th>\r\n            <th class=\"text-center\">{{ totalListeningQuestions != 0 ? (totalListeningScore/totalListeningQuestions | percent:'1.0-0') : \"N/A\"}}</th>\r\n        </tr>\r\n    </table>\r\n\r\n    <br>\r\n    <br>\r\n    <section id=\"scoring-page-disclaimer-text\" *ngIf=\"scoresReady\">\r\n        <div style=\"text-align: center\"><strong>A Note About Your CAEL CE Assessment Score</strong></div>\r\n        <div [innerHTML]=disclaimerText></div>\r\n    </section>\r\n    <br>\r\n    <br>\r\n</div>\r\n"

/***/ }),

/***/ "Oa82":
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"html\" [innerHtml]=\"html\"></div>\r\n"

/***/ }),

/***/ "SCeK":
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"pics && pics.length > 0\">\r\n    <div class=\"text-center\" style=\"margin-bottom: 5px;\">        \r\n        <button class=\"btn btn-default\" (click)=\"prev()\"><i class=\"fa fa-chevron-left\"></i></button>\r\n        <span style=\"padding: 0 10px;\">\r\n            Slide {{currentIndex + 1}}/{{pics.length}}\r\n        </span>\r\n        <button class=\"btn btn-default\" (click)=\"next()\"><i class=\"fa fa-chevron-right\"></i></button>\r\n    </div>\r\n    <img [src]=\"picUrl\" class=\"img-responsive\" />    \r\n</div>"

/***/ }),

/***/ "Wzg8":
/***/ (function(module, exports) {

module.exports = "<button class=\"btn btn-default\" (click)=\"showDialog()\">{{title}}</button>"

/***/ }),

/***/ "X16k":
/***/ (function(module, exports) {

module.exports = "<div class=\"microphone-check\" style=\"text-align: center;\">\r\n    <div *ngIf=\"step == 1\">\r\n        <p><button class=\"btn btn-warning\" (click)=\"start()\">Record</button></p>\r\n    </div>\r\n    <div *ngIf=\"step == 3\" class=\"animated fadeIn\">\r\n        <p>\r\n            <button class=\"btn btn-warning\" (click)=\"playRecording()\">Play Recording</button>\r\n            <button class=\"btn\" (click)=\"start()\">Record Again</button>\r\n        </p>\r\n    </div>\r\n</div>\r\n\r\n<audio id=\"audio-player\" #audioWrapper controls class=\"hidden\"></audio>\r\n\r\n<info-box\r\n    [text]=\"infoBoxText\"\r\n    [visible]=\"infoBoxVisible\"\r\n    [iconCssClass]=\"iconCssClass\"\r\n    [progressPercentage]=\"currentProgress\"\r\n    [counterText]=\"counterText\"\r\n    [mode]=\"infoBoxMode\"\r\n    [iconCover]=\"inputActivityLevel\"\r\n    [forMicrophoneCheck]=\"true\"\r\n    >\r\n</info-box>\r\n"

/***/ }),

/***/ "Z8TH":
/***/ (function(module, exports) {

module.exports = "<div class=\"view-container\">\r\n    <div class=\"singlePane pane-content start-screen\">\r\n        <div class=\"main\">\r\n            <start-screen-photo\r\n                [testTakerPhotoUrl]=\"testTakerPhotoUrl\"\r\n                [stationNumber]=\"stationNumber\"\r\n                [testTakerInfo]=\"testTakerInfo\"\r\n            ></start-screen-photo>\r\n            <div style=\"clear: both;\"></div>\r\n            <div id=\"start-screen-error\" [class.visible]=\"errorMsg && errorMsg.length > 0\">\r\n                {{errorMsg}}\r\n            </div>\r\n            <div id=\"panel-content\">\r\n                <div class=\"station-assigned\" *ngIf=\"testTakerInfo\">\r\n                    <div *ngIf=\"testTakerInfo.IsNonScored === false\">\r\n                        <div align=\"center\">\r\n                            By entering my PIN in the box below, I certify that I am the test taker identified under Registration Number <strong>{{testTakerInfo.TestTakerId}}</strong>,\r\n                            and I agree to follow {{testTakerInfo.TestTypeName}} test procedures and not to disclose the contents of any {{testTakerInfo.TestTypeName}} test items.\r\n                        </div>\r\n                        <div class=\"pin-div\">\r\n                            <div class=\"pin-input\">\r\n                                <input type=\"password\" maxlength=\"12\" #txtPin (keydown)=\"txtPinKeyDown($event, txtPin.value)\" />\r\n                            </div>\r\n                            <button class=\"btn btn-warning\" (click)=\"onVerifyPin(txtPin.value)\">Continue</button>\r\n                            <br />\r\n                            <div class=\"pin-notes\">Note: Your PIN can be found on your {{testTakerInfo.TestTypeName}} notepaper.</div>\r\n                        </div>\r\n                    </div>\r\n                    <div *ngIf=\"testTakerInfo.IsNonScored === true\">\r\n                        <div align=\"center\">\r\n                            Waiting for clicking 'Start Demo Test' button in Synchronizer to start the test run on this workstation...\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),

/***/ "ZWZZ":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-backdrop hidden loading-overlay\" [class.hidden]=\"loading === false\" [class.in]=\"loading === true\">\r\n    <img src=\"data:image/gif;base64,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\" />\r\n</div>"

/***/ }),

/***/ "ZlpU":
/***/ (function(module, exports) {

module.exports = "<div class=\"header-bar\">\r\n    <div class=\"header-bar-content\">\r\n        <div class=\"header-title\" [innerHTML]=\"title\"></div>\r\n        <div class=\"header-nav\">\r\n            <timer #timer\r\n                [assessmentTest]=\"assessmentTest\"\r\n                [assessmentItem$]=\"assessmentItem$\"\r\n            >\r\n            </timer>\r\n            <button\r\n                class=\"btn btn-primary\"\r\n                id=\"btn-next\"\r\n                [ngClass]=\"{ hidden : (testNavigation.canGoNext != true && (mode == 'tdp' || mode == 'tdp_web_delivey')) || testNavigation.isEndOfTest == true }\"\r\n                tabindex=\"-1\"\r\n                preventDoubleClick (throttledClick)=\"onClickNext()\" [throttleTime]=\"1500\"\r\n                >NEXT\r\n            </button>\r\n            <button\r\n                class=\"btn btn-primary\"\r\n                id=\"btn-back\"\r\n                [ngClass]=\"{ hidden : (mode == 'tdp' || mode == 'tdp_web_delivey') || (testNavigation.testletIndex==0 && testNavigation.testPartIndex==0)}\"\r\n                tabindex=\"0\"\r\n                >BACK\r\n            </button>\r\n            <nav-button\r\n                [assessmentTest]=\"assessmentTest\"\r\n                [mode]=\"mode\"\r\n            ></nav-button>\r\n            <button class=\"btn btn-default\" (click)=\"checkResponses()\" *ngIf=\"mode == 'preview'\">Check Responses</button>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),

/***/ "cDNt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var app_ui_action_namespaceObject = {};
__webpack_require__.d(app_ui_action_namespaceObject, "HIDE_LOADING_OVERLAY", function() { return HIDE_LOADING_OVERLAY; });
__webpack_require__.d(app_ui_action_namespaceObject, "SHOW_LOADING_OVERLAY", function() { return SHOW_LOADING_OVERLAY; });
__webpack_require__.d(app_ui_action_namespaceObject, "SHOW_LOCK_SCREEN", function() { return SHOW_LOCK_SCREEN; });
__webpack_require__.d(app_ui_action_namespaceObject, "HIDE_LOCK_SCREEN", function() { return HIDE_LOCK_SCREEN; });
__webpack_require__.d(app_ui_action_namespaceObject, "SHOW_EXIT_SCREEN", function() { return SHOW_EXIT_SCREEN; });
__webpack_require__.d(app_ui_action_namespaceObject, "HIDE_EXIT_SCREEN", function() { return HIDE_EXIT_SCREEN; });
__webpack_require__.d(app_ui_action_namespaceObject, "SHOW_PAUSE_SCREEN", function() { return SHOW_PAUSE_SCREEN; });
__webpack_require__.d(app_ui_action_namespaceObject, "HIDE_PAUSE_SCREEN", function() { return HIDE_PAUSE_SCREEN; });
__webpack_require__.d(app_ui_action_namespaceObject, "SHOW_GENERIC_PAGE", function() { return SHOW_GENERIC_PAGE; });
__webpack_require__.d(app_ui_action_namespaceObject, "HIDE_GENERIC_PAGE", function() { return HIDE_GENERIC_PAGE; });
__webpack_require__.d(app_ui_action_namespaceObject, "TOGGLE_NAVIGATION_MODAL_VISIBILITY", function() { return TOGGLE_NAVIGATION_MODAL_VISIBILITY; });
__webpack_require__.d(app_ui_action_namespaceObject, "HideLoadingOverlay", function() { return HideLoadingOverlay; });
__webpack_require__.d(app_ui_action_namespaceObject, "ShowLoadingOverlay", function() { return ShowLoadingOverlay; });
__webpack_require__.d(app_ui_action_namespaceObject, "ShowLockScreen", function() { return ShowLockScreen; });
__webpack_require__.d(app_ui_action_namespaceObject, "HideLockScreen", function() { return HideLockScreen; });
__webpack_require__.d(app_ui_action_namespaceObject, "ShowPauseScreen", function() { return ShowPauseScreen; });
__webpack_require__.d(app_ui_action_namespaceObject, "HidePauseScreen", function() { return HidePauseScreen; });
__webpack_require__.d(app_ui_action_namespaceObject, "ShowExitScreen", function() { return ShowExitScreen; });
__webpack_require__.d(app_ui_action_namespaceObject, "HideExitScreen", function() { return HideExitScreen; });
__webpack_require__.d(app_ui_action_namespaceObject, "ShowGenericPage", function() { return ShowGenericPage; });
__webpack_require__.d(app_ui_action_namespaceObject, "HideGenericPage", function() { return HideGenericPage; });
__webpack_require__.d(app_ui_action_namespaceObject, "ToggleNavigationModal", function() { return ToggleNavigationModal; });
var test_taker_action_namespaceObject = {};
__webpack_require__.d(test_taker_action_namespaceObject, "SET_ITEM_INDEX", function() { return SET_ITEM_INDEX; });
__webpack_require__.d(test_taker_action_namespaceObject, "LOAD_TESTLET", function() { return LOAD_TESTLET; });
__webpack_require__.d(test_taker_action_namespaceObject, "PRELOAD_TESTLET", function() { return PRELOAD_TESTLET; });
__webpack_require__.d(test_taker_action_namespaceObject, "LOAD_TESTLET_VERSION", function() { return LOAD_TESTLET_VERSION; });
__webpack_require__.d(test_taker_action_namespaceObject, "LOAD_TESTLET_SUCCESS", function() { return LOAD_TESTLET_SUCCESS; });
__webpack_require__.d(test_taker_action_namespaceObject, "PRELOAD_TESTLET_SUCCESS", function() { return PRELOAD_TESTLET_SUCCESS; });
__webpack_require__.d(test_taker_action_namespaceObject, "LOAD_SNAPSHOT_TESTLET", function() { return LOAD_SNAPSHOT_TESTLET; });
__webpack_require__.d(test_taker_action_namespaceObject, "TEST_NAVIGATION_NEXT", function() { return TEST_NAVIGATION_NEXT; });
__webpack_require__.d(test_taker_action_namespaceObject, "TEST_NAVIGATION_PREVIOUS", function() { return TEST_NAVIGATION_PREVIOUS; });
__webpack_require__.d(test_taker_action_namespaceObject, "LOAD_ASSESSMENT_TEST_BY_TEST_FORM", function() { return LOAD_ASSESSMENT_TEST_BY_TEST_FORM; });
__webpack_require__.d(test_taker_action_namespaceObject, "LOAD_ASSESSMENT_TEST", function() { return LOAD_ASSESSMENT_TEST; });
__webpack_require__.d(test_taker_action_namespaceObject, "LOAD_IPP_ASSESSMENT_TEST", function() { return LOAD_IPP_ASSESSMENT_TEST; });
__webpack_require__.d(test_taker_action_namespaceObject, "LOAD_LATEST_IPP_ASSESSMENT_TEST", function() { return LOAD_LATEST_IPP_ASSESSMENT_TEST; });
__webpack_require__.d(test_taker_action_namespaceObject, "LOAD_ASSESSMENT_TEST_SUCCESS", function() { return LOAD_ASSESSMENT_TEST_SUCCESS; });
__webpack_require__.d(test_taker_action_namespaceObject, "SET_TEST_NAVIGATION", function() { return SET_TEST_NAVIGATION; });
__webpack_require__.d(test_taker_action_namespaceObject, "SET_CAN_GO_NEXT", function() { return SET_CAN_GO_NEXT; });
__webpack_require__.d(test_taker_action_namespaceObject, "INDICATE_END_OF_TEST", function() { return INDICATE_END_OF_TEST; });
__webpack_require__.d(test_taker_action_namespaceObject, "SET_RESPONSE", function() { return SET_RESPONSE; });
__webpack_require__.d(test_taker_action_namespaceObject, "REMOVE_RESPONSE_ITEM", function() { return REMOVE_RESPONSE_ITEM; });
__webpack_require__.d(test_taker_action_namespaceObject, "CLEAR_RESPONSES", function() { return CLEAR_RESPONSES; });
__webpack_require__.d(test_taker_action_namespaceObject, "START_TIMER", function() { return START_TIMER; });
__webpack_require__.d(test_taker_action_namespaceObject, "STOP_TIMER", function() { return STOP_TIMER; });
__webpack_require__.d(test_taker_action_namespaceObject, "PAUSE_TIMER", function() { return PAUSE_TIMER; });
__webpack_require__.d(test_taker_action_namespaceObject, "UNPAUSE_TIMER", function() { return UNPAUSE_TIMER; });
__webpack_require__.d(test_taker_action_namespaceObject, "SET_TEST_TAKER_INFO", function() { return SET_TEST_TAKER_INFO; });
__webpack_require__.d(test_taker_action_namespaceObject, "CACHE_TEST_TAKER_ACTIVITIES", function() { return CACHE_TEST_TAKER_ACTIVITIES; });
__webpack_require__.d(test_taker_action_namespaceObject, "CLEAR_TEST_TAKER_ACTIVITIES", function() { return CLEAR_TEST_TAKER_ACTIVITIES; });
__webpack_require__.d(test_taker_action_namespaceObject, "SET_FLUSH_PAYLOAD", function() { return SET_FLUSH_PAYLOAD; });
__webpack_require__.d(test_taker_action_namespaceObject, "FLUSH_PAYLOAD_SUCCESS", function() { return FLUSH_PAYLOAD_SUCCESS; });
__webpack_require__.d(test_taker_action_namespaceObject, "SHOULD_GO_TO_NEXT_TESTLET", function() { return SHOULD_GO_TO_NEXT_TESTLET; });
__webpack_require__.d(test_taker_action_namespaceObject, "SET_TEST_INITIALIZATION_INFO", function() { return SET_TEST_INITIALIZATION_INFO; });
__webpack_require__.d(test_taker_action_namespaceObject, "LOAD_IPP_PRODUCT", function() { return LOAD_IPP_PRODUCT; });
__webpack_require__.d(test_taker_action_namespaceObject, "SET_IPP_PRODUCT_INFO", function() { return SET_IPP_PRODUCT_INFO; });
__webpack_require__.d(test_taker_action_namespaceObject, "TOGGLE_TIMER_VISIBILITY", function() { return TOGGLE_TIMER_VISIBILITY; });
__webpack_require__.d(test_taker_action_namespaceObject, "GET_STORED_HIGHLIGHTS", function() { return GET_STORED_HIGHLIGHTS; });
__webpack_require__.d(test_taker_action_namespaceObject, "SET_STORED_HIGHLIGHTS", function() { return SET_STORED_HIGHLIGHTS; });
__webpack_require__.d(test_taker_action_namespaceObject, "RESUME_TEST", function() { return RESUME_TEST; });
__webpack_require__.d(test_taker_action_namespaceObject, "SetItemIndex", function() { return SetItemIndex; });
__webpack_require__.d(test_taker_action_namespaceObject, "LoadTestlet", function() { return LoadTestlet; });
__webpack_require__.d(test_taker_action_namespaceObject, "PreloadTestlet", function() { return PreloadTestlet; });
__webpack_require__.d(test_taker_action_namespaceObject, "LoadTestletVersion", function() { return LoadTestletVersion; });
__webpack_require__.d(test_taker_action_namespaceObject, "LoadTestletSuccess", function() { return LoadTestletSuccess; });
__webpack_require__.d(test_taker_action_namespaceObject, "PreloadTestletSuccess", function() { return PreloadTestletSuccess; });
__webpack_require__.d(test_taker_action_namespaceObject, "LoadSnapshotTestlet", function() { return LoadSnapshotTestlet; });
__webpack_require__.d(test_taker_action_namespaceObject, "TestNavigationNext", function() { return TestNavigationNext; });
__webpack_require__.d(test_taker_action_namespaceObject, "TestNavigationPrevious", function() { return TestNavigationPrevious; });
__webpack_require__.d(test_taker_action_namespaceObject, "LoadAssessmentTestByTestForm", function() { return LoadAssessmentTestByTestForm; });
__webpack_require__.d(test_taker_action_namespaceObject, "LoadAssessmentTest", function() { return LoadAssessmentTest; });
__webpack_require__.d(test_taker_action_namespaceObject, "LoadIppAssessmentTest", function() { return LoadIppAssessmentTest; });
__webpack_require__.d(test_taker_action_namespaceObject, "LoadLatestIppAssessmentTest", function() { return LoadLatestIppAssessmentTest; });
__webpack_require__.d(test_taker_action_namespaceObject, "LoadAssessmentTestSuccess", function() { return LoadAssessmentTestSuccess; });
__webpack_require__.d(test_taker_action_namespaceObject, "SetTestNavigation", function() { return SetTestNavigation; });
__webpack_require__.d(test_taker_action_namespaceObject, "SetCanGoNext", function() { return SetCanGoNext; });
__webpack_require__.d(test_taker_action_namespaceObject, "IndicateEndOfTest", function() { return IndicateEndOfTest; });
__webpack_require__.d(test_taker_action_namespaceObject, "SetResponse", function() { return SetResponse; });
__webpack_require__.d(test_taker_action_namespaceObject, "RemoveResponseItem", function() { return RemoveResponseItem; });
__webpack_require__.d(test_taker_action_namespaceObject, "ClearResponses", function() { return ClearResponses; });
__webpack_require__.d(test_taker_action_namespaceObject, "StartTimer", function() { return StartTimer; });
__webpack_require__.d(test_taker_action_namespaceObject, "StopTimer", function() { return StopTimer; });
__webpack_require__.d(test_taker_action_namespaceObject, "PauseTimer", function() { return PauseTimer; });
__webpack_require__.d(test_taker_action_namespaceObject, "UnpauseTimer", function() { return UnpauseTimer; });
__webpack_require__.d(test_taker_action_namespaceObject, "SetTestTakerInfo", function() { return SetTestTakerInfo; });
__webpack_require__.d(test_taker_action_namespaceObject, "CacheTestTakerActivities", function() { return CacheTestTakerActivities; });
__webpack_require__.d(test_taker_action_namespaceObject, "ClearTestTakerActivities", function() { return ClearTestTakerActivities; });
__webpack_require__.d(test_taker_action_namespaceObject, "SetFlushPayload", function() { return SetFlushPayload; });
__webpack_require__.d(test_taker_action_namespaceObject, "FlushPayloadSuccess", function() { return FlushPayloadSuccess; });
__webpack_require__.d(test_taker_action_namespaceObject, "ShouldGoToNextTestlet", function() { return ShouldGoToNextTestlet; });
__webpack_require__.d(test_taker_action_namespaceObject, "SetTestInitializationInfo", function() { return SetTestInitializationInfo; });
__webpack_require__.d(test_taker_action_namespaceObject, "LoadIppProduct", function() { return LoadIppProduct; });
__webpack_require__.d(test_taker_action_namespaceObject, "SetIppProductInfo", function() { return SetIppProductInfo; });
__webpack_require__.d(test_taker_action_namespaceObject, "ToggleTimerVisibility", function() { return ToggleTimerVisibility; });
__webpack_require__.d(test_taker_action_namespaceObject, "GetStoredHighlights", function() { return GetStoredHighlights; });
__webpack_require__.d(test_taker_action_namespaceObject, "SetStoredHighlights", function() { return SetStoredHighlights; });
__webpack_require__.d(test_taker_action_namespaceObject, "ResumeTest", function() { return ResumeTest; });

// EXTERNAL MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/node_modules/lodash/lodash.js
var lodash = __webpack_require__("xrDH");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/node_modules/@angular/core/@angular/core.es5.js
var core_es5 = __webpack_require__("/oeL");

// EXTERNAL MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/node_modules/@angular/platform-browser-dynamic/@angular/platform-browser-dynamic.es5.js + 1 modules
var platform_browser_dynamic_es5 = __webpack_require__("Qa4U");

// EXTERNAL MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/node_modules/@angular/platform-browser/@angular/platform-browser.es5.js
var platform_browser_es5 = __webpack_require__("fc+i");

// EXTERNAL MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/node_modules/@angular/forms/@angular/forms.es5.js
var forms_es5 = __webpack_require__("bm2B");

// EXTERNAL MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/node_modules/@angular/http/@angular/http.es5.js
var http_es5 = __webpack_require__("CPp0");

// EXTERNAL MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/node_modules/@angular/common/@angular/common/http.es5.js
var common_http_es5 = __webpack_require__("XKz0");

// EXTERNAL MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/node_modules/@ngrx/store/@ngrx/store.es5.js
var store_es5 = __webpack_require__("ADVA");

// EXTERNAL MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/node_modules/@ngrx/effects/@ngrx/effects.es5.js
var effects_es5 = __webpack_require__("Tl+Y");

// EXTERNAL MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/node_modules/@ngrx/store-devtools/@ngrx/store-devtools.es5.js
var store_devtools_es5 = __webpack_require__("uIf7");

// EXTERNAL MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/node_modules/ng2-signalr/index.js + 12 modules
var ng2_signalr = __webpack_require__("oyEU");

// EXTERNAL MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/node_modules/@angular/router/@angular/router.es5.js
var router_es5 = __webpack_require__("BkNc");

// EXTERNAL MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/node_modules/ng2-cookies/ng2-cookies.js
var ng2_cookies = __webpack_require__("tnuH");
var ng2_cookies_default = /*#__PURE__*/__webpack_require__.n(ng2_cookies);

// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/services/logger.service.ts
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var JL = __webpack_require__("6GtU").JL;
var LoggerService = (function () {
    function LoggerService() {
        JL.setOptions({
            defaultAjaxUrl: _paragonConfig.testServerApiUrl + "/api/log/js"
        });
    }
    LoggerService.prototype.setAccessToken = function (accessToken) {
        var appender = JL.createAjaxAppender("header appender");
        appender.setOptions({
            "beforeSend": function (xhr) {
                xhr.setRequestHeader('Authorization', "Bearer " + accessToken);
            }
        });
        JL().setOptions({
            "appenders": [appender]
        });
    };
    LoggerService.prototype.reportDebugInfo = function (category, info) {
        console.log(category, info);
        if (_paragonConfig.mode == "tdp") {
            try {
                JL(category).debug(info);
            }
            catch (error) {
                console.error(error);
            }
        }
    };
    LoggerService.prototype.reportWarning = function (category, info) {
        console.log(category, info);
        if (_paragonConfig.mode == "tdp") {
            try {
                JL(category).warn(info);
            }
            catch (error) {
                console.error(error);
            }
        }
    };
    LoggerService.prototype.reportFatalError = function (category, info) {
        console.error(category, info);
        if (_paragonConfig.mode == "tdp") {
            try {
                JL(category).fatal(info);
            }
            catch (error) {
                console.error(error);
            }
        }
    };
    LoggerService.prototype.reportError = function (category, info) {
        console.error(category, info);
        if (_paragonConfig.mode == "tdp") {
            try {
                JL(category).error(info);
            }
            catch (error) {
                console.error(error);
            }
        }
    };
    return LoggerService;
}());
LoggerService = __decorate([
    Object(core_es5["C" /* Injectable */])(),
    __metadata("design:paramtypes", [])
], LoggerService);

//# sourceMappingURL=logger.service.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/services/auth.service.ts
var auth_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var auth_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var auth_service_JL = __webpack_require__("6GtU").JL;
var auth_service_AuthService = (function () {
    function AuthService(loggerService) {
        this.loggerService = loggerService;
    }
    AuthService.prototype.setAccessToken = function (accessToken) {
        this.accessToken = accessToken;
        this.loggerService.setAccessToken(accessToken);
    };
    AuthService.prototype.setWebDeliveryAuth = function (webDeliveryAuth) {
        sessionStorage.setItem('webDeliveryAuth', webDeliveryAuth);
    };
    AuthService.prototype.getAccessToken = function () {
        var token = ng2_cookies["Cookie"].get('token');
        if (token) {
            return token;
        }
        return this.accessToken;
    };
    AuthService.prototype.getWebDeliveryAuth = function () {
        return sessionStorage.getItem('webDeliveryAuth');
    };
    return AuthService;
}());
auth_service_AuthService = auth_service___decorate([
    Object(core_es5["C" /* Injectable */])(),
    auth_service___metadata("design:paramtypes", [typeof (auth_service__a = typeof LoggerService !== "undefined" && LoggerService) === "function" && auth_service__a || Object])
], auth_service_AuthService);

var auth_service__a;
//# sourceMappingURL=auth.service.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/environments/environment.ts
var environment = {
    production: true,
    mode: "tdp"
};
//# sourceMappingURL=environment.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/store/actions/app-ui.action.ts
var HIDE_LOADING_OVERLAY = '[AppUiActions] HIDE_LOADING_OVERLAY';
var SHOW_LOADING_OVERLAY = '[AppUiActions] SHOW_LOADING_OVERLAY';
var SHOW_LOCK_SCREEN = '[AppUiActions] SHOW_LOCK_SCREEN';
var HIDE_LOCK_SCREEN = '[AppUiActions] HIDE_LOCK_SCREEN';
var SHOW_EXIT_SCREEN = '[AppUiActions] SHOW_EXIT_SCREEN';
var HIDE_EXIT_SCREEN = '[AppUiActions] HIDE_EXIT_SCREEN';
var SHOW_PAUSE_SCREEN = '[AppUiActions] SHOW_PAUSE_SCREEN';
var HIDE_PAUSE_SCREEN = '[AppUiActions] HIDE_PAUSE_SCREEN';
var SHOW_GENERIC_PAGE = '[AppUiActions] SHOW_GENERIC_PAGE';
var HIDE_GENERIC_PAGE = '[AppUiActions] HIDE_GENERIC_PAGE';
var TOGGLE_NAVIGATION_MODAL_VISIBILITY = '[AppUiActions] TOGGLE_NAVIGATION_MODAL_VISIBILITY';
var HideLoadingOverlay = (function () {
    function HideLoadingOverlay() {
        this.type = HIDE_LOADING_OVERLAY;
    }
    return HideLoadingOverlay;
}());

var ShowLoadingOverlay = (function () {
    function ShowLoadingOverlay() {
        this.type = SHOW_LOADING_OVERLAY;
    }
    return ShowLoadingOverlay;
}());

var ShowLockScreen = (function () {
    function ShowLockScreen() {
        this.type = SHOW_LOCK_SCREEN;
    }
    return ShowLockScreen;
}());

var HideLockScreen = (function () {
    function HideLockScreen() {
        this.type = HIDE_LOCK_SCREEN;
    }
    return HideLockScreen;
}());

var ShowPauseScreen = (function () {
    function ShowPauseScreen() {
        this.type = SHOW_PAUSE_SCREEN;
    }
    return ShowPauseScreen;
}());

var HidePauseScreen = (function () {
    function HidePauseScreen() {
        this.type = HIDE_PAUSE_SCREEN;
    }
    return HidePauseScreen;
}());

var ShowExitScreen = (function () {
    function ShowExitScreen() {
        this.type = SHOW_EXIT_SCREEN;
    }
    return ShowExitScreen;
}());

var HideExitScreen = (function () {
    function HideExitScreen() {
        this.type = HIDE_EXIT_SCREEN;
    }
    return HideExitScreen;
}());

var ShowGenericPage = (function () {
    function ShowGenericPage(title, content, isNonRecoverable, redirectUrl) {
        this.type = SHOW_GENERIC_PAGE;
        this.payload = {
            title: title,
            content: content,
            visible: true,
            isNonRecoverable: isNonRecoverable,
            redirectUrl: redirectUrl
        };
    }
    return ShowGenericPage;
}());

var HideGenericPage = (function () {
    function HideGenericPage() {
        this.type = HIDE_GENERIC_PAGE;
    }
    return HideGenericPage;
}());

var ToggleNavigationModal = (function () {
    function ToggleNavigationModal(visible) {
        this.visible = visible;
        this.type = TOGGLE_NAVIGATION_MODAL_VISIBILITY;
    }
    return ToggleNavigationModal;
}());

//# sourceMappingURL=app-ui.action.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/store/actions/test-taker.action.ts
var SET_ITEM_INDEX = '[TestTakerAction] SET_ITEM_INDEX';
var LOAD_TESTLET = '[TestTakerAction] LOAD_TESTLET';
var PRELOAD_TESTLET = '[TestTakerAction] PRELOAD_TESTLET';
var LOAD_TESTLET_VERSION = '[TestTakerAction] LOAD_TESTLET_VERSION';
var LOAD_TESTLET_SUCCESS = '[TestTakerAction] LOAD_TESTLET_SUCCESS';
var PRELOAD_TESTLET_SUCCESS = '[TestTakerAction] PRELOAD_TESTLET_SUCCESS';
var LOAD_SNAPSHOT_TESTLET = '[TestTakerAction] LOAD_SNAPSHOT_TESTLET';
var TEST_NAVIGATION_NEXT = '[TestTakerAction] TEST_NAVIGATION_NEXT';
var TEST_NAVIGATION_PREVIOUS = '[TestTakerAction] TEST_NAVIGATION_PREVIOUS';
var LOAD_ASSESSMENT_TEST_BY_TEST_FORM = '[TestTakerAction] LOAD_ASSESSMENT_TEST_BY_TEST_FORM';
var LOAD_ASSESSMENT_TEST = '[TestTakerAction] LOAD_ASSESSMENT_TEST';
var LOAD_IPP_ASSESSMENT_TEST = '[TestTakerAction] LOAD_IPP_ASSESSMENT_TEST';
var LOAD_LATEST_IPP_ASSESSMENT_TEST = '[TestTakerAction] LOAD_LATEST_IPP_ASSESSMENT_TEST';
var LOAD_ASSESSMENT_TEST_SUCCESS = '[TestTakerAction] LOAD_ASSESSMENT_TEST_SUCCESS';
var SET_TEST_NAVIGATION = '[TestTakerAction] SET_TEST_NAVIGATION';
var SET_CAN_GO_NEXT = '[TestTakerAction] SET_CAN_GO_NEXT';
var INDICATE_END_OF_TEST = '[TestTakerAction] INDICATE_END_OF_TEST';
var SET_RESPONSE = '[TestTakerAction] SET_RESPONSE';
var REMOVE_RESPONSE_ITEM = '[TestTakerAction] REMOVE_RESPONSE_ITEM';
var CLEAR_RESPONSES = '[TestTakerAction] CLEAR_RESPONSES';
var START_TIMER = '[TestTakerAction] START_TIMER';
var STOP_TIMER = '[TestTakerAction] STOP_TIMER';
var PAUSE_TIMER = '[TestTakerAction] PAUSE_TIMER';
var UNPAUSE_TIMER = '[TestTakerAction] UNPAUSE_TIMER';
var SET_TEST_TAKER_INFO = '[TestTakerAction] SET_TEST_TAKER_INFO';
var CACHE_TEST_TAKER_ACTIVITIES = '[TestTakerAction] CACHE_TEST_TAKER_ACTIVITIES';
var CLEAR_TEST_TAKER_ACTIVITIES = '[TestTakerAction] CLEAR_TEST_TAKER_ACTIVITIES';
var SET_FLUSH_PAYLOAD = '[TestTakerAction] SET_FLUSH_PAYLOAD';
var FLUSH_PAYLOAD_SUCCESS = '[TestTakerAction] FLUSH_PAYLOAD_SUCCESS';
var SHOULD_GO_TO_NEXT_TESTLET = '[TestTakerAction] SHOULD_GO_TO_NEXT_TESTLET';
var SET_TEST_INITIALIZATION_INFO = '[TestTakerAction] SET_TEST_INITIALIZATION_INFO';
var LOAD_IPP_PRODUCT = '[TestTakerAction] LOAD_IPP_PRODUCT';
var SET_IPP_PRODUCT_INFO = '[TestTakerAction] SET_IPP_PRODUCT_INFO';
var TOGGLE_TIMER_VISIBILITY = '[TestTakerAction] TOGGLE_TIMER_VISIBILITY';
var GET_STORED_HIGHLIGHTS = '[TestTakerAction] GET_STORED_HIGHLIGHTS';
var SET_STORED_HIGHLIGHTS = '[TestTakerAction] SET_STORED_HIGHLIGHTS';
var RESUME_TEST = '[TestTakerAction] RESUME_TEST';
var SetItemIndex = (function () {
    function SetItemIndex(payload) {
        this.payload = payload;
        this.type = SET_ITEM_INDEX;
    }
    return SetItemIndex;
}());

var LoadTestlet = (function () {
    function LoadTestlet(testletId, assessmentTest) {
        this.type = LOAD_TESTLET;
        this.payload = {
            testletId: testletId,
            assessmentTestId: assessmentTest == null || isNaN(parseInt(assessmentTest.Identifier, 10)) ? 0 : parseInt(assessmentTest.Identifier, 10)
        };
    }
    return LoadTestlet;
}());

var PreloadTestlet = (function () {
    function PreloadTestlet(testletId, assessmentTest) {
        this.type = PRELOAD_TESTLET;
        this.payload = {
            testletId: testletId,
            assessmentTestId: assessmentTest == null || isNaN(parseInt(assessmentTest.Identifier, 10)) ? 0 : parseInt(assessmentTest.Identifier, 10)
        };
    }
    return PreloadTestlet;
}());

var LoadTestletVersion = (function () {
    function LoadTestletVersion(testletVersionId) {
        this.type = LOAD_TESTLET_VERSION;
        this.payload = testletVersionId;
    }
    return LoadTestletVersion;
}());

var LoadTestletSuccess = (function () {
    function LoadTestletSuccess(testlet) {
        this.type = LOAD_TESTLET_SUCCESS;
        this.payload = testlet;
    }
    return LoadTestletSuccess;
}());

var PreloadTestletSuccess = (function () {
    function PreloadTestletSuccess(testlet) {
        this.type = PRELOAD_TESTLET_SUCCESS;
        this.payload = testlet;
    }
    return PreloadTestletSuccess;
}());

var LoadSnapshotTestlet = (function () {
    function LoadSnapshotTestlet(snapShotId) {
        this.type = LOAD_SNAPSHOT_TESTLET;
        this.payload = snapShotId;
    }
    return LoadSnapshotTestlet;
}());

var TestNavigationNext = (function () {
    function TestNavigationNext(currentTestPartIndex, currentTestletIndex) {
        this.type = TEST_NAVIGATION_NEXT;
        this.payload = { currentTestPartIndex: currentTestPartIndex, currentTestletIndex: currentTestletIndex };
    }
    return TestNavigationNext;
}());

var TestNavigationPrevious = (function () {
    function TestNavigationPrevious() {
        this.type = TEST_NAVIGATION_PREVIOUS;
    }
    return TestNavigationPrevious;
}());

var LoadAssessmentTestByTestForm = (function () {
    function LoadAssessmentTestByTestForm(testFormId) {
        this.type = LOAD_ASSESSMENT_TEST_BY_TEST_FORM;
        this.payload = testFormId;
    }
    return LoadAssessmentTestByTestForm;
}());

var LoadAssessmentTest = (function () {
    function LoadAssessmentTest(assessmentTestId) {
        this.type = LOAD_ASSESSMENT_TEST;
        this.payload = assessmentTestId;
    }
    return LoadAssessmentTest;
}());

var LoadIppAssessmentTest = (function () {
    function LoadIppAssessmentTest(assessmentTestId) {
        this.type = LOAD_IPP_ASSESSMENT_TEST;
        this.payload = assessmentTestId;
    }
    return LoadIppAssessmentTest;
}());

var LoadLatestIppAssessmentTest = (function () {
    function LoadLatestIppAssessmentTest(ippAssessmentTestId) {
        this.type = LOAD_LATEST_IPP_ASSESSMENT_TEST;
        this.payload = ippAssessmentTestId;
    }
    return LoadLatestIppAssessmentTest;
}());

var LoadAssessmentTestSuccess = (function () {
    function LoadAssessmentTestSuccess(assessmentTest) {
        this.type = LOAD_ASSESSMENT_TEST_SUCCESS;
        this.payload = assessmentTest;
    }
    return LoadAssessmentTestSuccess;
}());

var SetTestNavigation = (function () {
    function SetTestNavigation(testNavigation) {
        this.type = SET_TEST_NAVIGATION;
        this.payload = testNavigation;
    }
    return SetTestNavigation;
}());

var SetCanGoNext = (function () {
    function SetCanGoNext(canGoNext) {
        this.type = SET_CAN_GO_NEXT;
        this.payload = canGoNext;
    }
    return SetCanGoNext;
}());

var IndicateEndOfTest = (function () {
    function IndicateEndOfTest() {
        this.type = INDICATE_END_OF_TEST;
    }
    return IndicateEndOfTest;
}());

var SetResponse = (function () {
    function SetResponse(response) {
        this.type = SET_RESPONSE;
        this.payload = response;
    }
    return SetResponse;
}());

var RemoveResponseItem = (function () {
    function RemoveResponseItem(interactionId, value) {
        this.type = REMOVE_RESPONSE_ITEM;
        this.payload = { interactionId: interactionId, value: value };
    }
    return RemoveResponseItem;
}());

var ClearResponses = (function () {
    function ClearResponses(interactionId) {
        this.type = CLEAR_RESPONSES;
        this.payload = interactionId;
    }
    return ClearResponses;
}());

var StartTimer = (function () {
    function StartTimer(timeLimits, speakingPreparationTime, speakingRecordingTime, timerVisibility, timesUpCallback, showTimesUpWarning, multiplier, timeAlreadyUsed) {
        this.type = START_TIMER;
        this.payload = { timeLimits: timeLimits, speakingPreparationTime: speakingPreparationTime, speakingRecordingTime: speakingRecordingTime, timerVisibility: timerVisibility, timesUpCallback: timesUpCallback, showTimesUpWarning: showTimesUpWarning, multiplier: multiplier, timeAlreadyUsed: timeAlreadyUsed };
    }
    return StartTimer;
}());

var StopTimer = (function () {
    function StopTimer() {
        this.type = STOP_TIMER;
    }
    return StopTimer;
}());

var PauseTimer = (function () {
    function PauseTimer() {
        this.type = PAUSE_TIMER;
    }
    return PauseTimer;
}());

var UnpauseTimer = (function () {
    function UnpauseTimer() {
        this.type = UNPAUSE_TIMER;
    }
    return UnpauseTimer;
}());

var SetTestTakerInfo = (function () {
    function SetTestTakerInfo(testTakerInfo) {
        this.type = SET_TEST_TAKER_INFO;
        this.payload = testTakerInfo;
    }
    return SetTestTakerInfo;
}());

var CacheTestTakerActivities = (function () {
    function CacheTestTakerActivities(testTakerActivities) {
        this.type = CACHE_TEST_TAKER_ACTIVITIES;
        this.payload = testTakerActivities;
    }
    return CacheTestTakerActivities;
}());

var ClearTestTakerActivities = (function () {
    function ClearTestTakerActivities() {
        this.type = CLEAR_TEST_TAKER_ACTIVITIES;
    }
    return ClearTestTakerActivities;
}());

var SetFlushPayload = (function () {
    function SetFlushPayload(flushPayload) {
        this.type = SET_FLUSH_PAYLOAD;
        this.payload = flushPayload;
    }
    return SetFlushPayload;
}());

var FlushPayloadSuccess = (function () {
    function FlushPayloadSuccess(shouldGoToNextTestlet) {
        this.type = FLUSH_PAYLOAD_SUCCESS;
        this.payload = shouldGoToNextTestlet;
    }
    return FlushPayloadSuccess;
}());

var ShouldGoToNextTestlet = (function () {
    function ShouldGoToNextTestlet(shouldGoToNextTestlet) {
        this.type = SHOULD_GO_TO_NEXT_TESTLET;
        this.payload = shouldGoToNextTestlet;
    }
    return ShouldGoToNextTestlet;
}());

var SetTestInitializationInfo = (function () {
    function SetTestInitializationInfo(testInitializationInfo) {
        this.type = SET_TEST_INITIALIZATION_INFO;
        this.payload = testInitializationInfo;
    }
    return SetTestInitializationInfo;
}());

var LoadIppProduct = (function () {
    function LoadIppProduct(productId) {
        this.type = LOAD_IPP_PRODUCT;
        this.payload = productId;
    }
    return LoadIppProduct;
}());

var SetIppProductInfo = (function () {
    function SetIppProductInfo(dto) {
        this.type = SET_IPP_PRODUCT_INFO;
        this.payload = dto;
    }
    return SetIppProductInfo;
}());

var ToggleTimerVisibility = (function () {
    function ToggleTimerVisibility(visible) {
        this.type = TOGGLE_TIMER_VISIBILITY;
        this.payload = visible;
    }
    return ToggleTimerVisibility;
}());

var GetStoredHighlights = (function () {
    function GetStoredHighlights(resourceId) {
        this.type = GET_STORED_HIGHLIGHTS;
        this.payload = resourceId;
    }
    return GetStoredHighlights;
}());

var SetStoredHighlights = (function () {
    function SetStoredHighlights(highlightDto) {
        this.type = SET_STORED_HIGHLIGHTS;
        this.payload = highlightDto;
    }
    return SetStoredHighlights;
}());

var ResumeTest = (function () {
    function ResumeTest() {
        this.type = RESUME_TEST;
    }
    return ResumeTest;
}());

//# sourceMappingURL=test-taker.action.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/store/actions/index.ts



//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/store/reducers/app-ui.reducer.ts

var initialState = {
    loading: false,
    isLockScreenVisible: false,
    isExitScreenVisible: false,
    isPauseScreenVisible: false,
    isNavigationModalVisible: false,
    genericPage: {
        title: null,
        content: null,
        visible: false,
        isNonRecoverable: false
    }
};
function appUiReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case app_ui_action_namespaceObject.HIDE_LOADING_OVERLAY:
            return Object.assign({}, state, { loading: false });
        case app_ui_action_namespaceObject.SHOW_LOADING_OVERLAY:
            return Object.assign({}, state, { loading: true });
        case app_ui_action_namespaceObject.HIDE_LOCK_SCREEN:
            return Object.assign({}, state, { isLockScreenVisible: false });
        case app_ui_action_namespaceObject.SHOW_LOCK_SCREEN:
            return Object.assign({}, state, { isLockScreenVisible: true });
        case app_ui_action_namespaceObject.SHOW_EXIT_SCREEN:
            return Object.assign({}, state, { isExitScreenVisible: true });
        case app_ui_action_namespaceObject.HIDE_EXIT_SCREEN:
            return Object.assign({}, state, { isExitScreenVisible: false });
        case app_ui_action_namespaceObject.HIDE_PAUSE_SCREEN:
            return Object.assign({}, state, { isPauseScreenVisible: false });
        case app_ui_action_namespaceObject.SHOW_PAUSE_SCREEN:
            return Object.assign({}, state, { isPauseScreenVisible: true });
        case app_ui_action_namespaceObject.SHOW_GENERIC_PAGE:
            return Object.assign({}, state, { genericPage: action.payload });
        case app_ui_action_namespaceObject.HIDE_GENERIC_PAGE:
            return Object.assign({}, state, { genericPage: {
                    title: null,
                    content: null,
                    visible: false,
                    isNonRecoverable: false
                } });
        case app_ui_action_namespaceObject.TOGGLE_NAVIGATION_MODAL_VISIBILITY:
            return Object.assign({}, state, { isNavigationModalVisible: action.visible });
        default:
            return state;
    }
}
var getIsLoading = function (state) { return state.loading; };
var getIsLockScreenVisible = function (state) { return state.isLockScreenVisible; };
var getIsExitScreenVisible = function (state) { return state.isExitScreenVisible; };
var getIsPauseScreenVisible = function (state) { return state.isPauseScreenVisible; };
var getGenericPage = function (state) { return state.genericPage; };
var getIsNavigationModalVisible = function (state) { return state.isNavigationModalVisible; };
//# sourceMappingURL=app-ui.reducer.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/dtos/enums.ts
var BankEnum;
(function (BankEnum) {
    BankEnum[BankEnum["None"] = 0] = "None";
    BankEnum[BankEnum["Live"] = 1] = "Live";
    BankEnum[BankEnum["TrainingMaterial"] = 2] = "TrainingMaterial";
    BankEnum[BankEnum["InstructionalProducts"] = 3] = "InstructionalProducts";
})(BankEnum || (BankEnum = {}));
var BaseTypeEnum;
(function (BaseTypeEnum) {
    BaseTypeEnum[BaseTypeEnum["Identifier"] = 1] = "Identifier";
    BaseTypeEnum[BaseTypeEnum["Boolean"] = 2] = "Boolean";
    BaseTypeEnum[BaseTypeEnum["Integer"] = 3] = "Integer";
    BaseTypeEnum[BaseTypeEnum["Float"] = 4] = "Float";
    BaseTypeEnum[BaseTypeEnum["String"] = 5] = "String";
    BaseTypeEnum[BaseTypeEnum["Point"] = 6] = "Point";
    BaseTypeEnum[BaseTypeEnum["Pair"] = 7] = "Pair";
    BaseTypeEnum[BaseTypeEnum["DirectedPair"] = 8] = "DirectedPair";
    BaseTypeEnum[BaseTypeEnum["Duration"] = 9] = "Duration";
    BaseTypeEnum[BaseTypeEnum["File"] = 10] = "File";
    BaseTypeEnum[BaseTypeEnum["Uri"] = 11] = "Uri";
    BaseTypeEnum[BaseTypeEnum["IntOrIdentifier"] = 12] = "IntOrIdentifier";
})(BaseTypeEnum || (BaseTypeEnum = {}));
var BrandEnum;
(function (BrandEnum) {
    BrandEnum[BrandEnum["CELPIP"] = 1] = "CELPIP";
    BrandEnum[BrandEnum["CAEL"] = 2] = "CAEL";
    BrandEnum[BrandEnum["LPI"] = 3] = "LPI";
})(BrandEnum || (BrandEnum = {}));
var CardinalityEnum;
(function (CardinalityEnum) {
    CardinalityEnum[CardinalityEnum["Single"] = 1] = "Single";
    CardinalityEnum[CardinalityEnum["Multiple"] = 2] = "Multiple";
    CardinalityEnum[CardinalityEnum["Ordered"] = 3] = "Ordered";
    CardinalityEnum[CardinalityEnum["Record"] = 4] = "Record";
})(CardinalityEnum || (CardinalityEnum = {}));
var ComponentTypeEnum;
(function (ComponentTypeEnum) {
    ComponentTypeEnum[ComponentTypeEnum["Listening"] = 1] = "Listening";
    ComponentTypeEnum[ComponentTypeEnum["Reading"] = 2] = "Reading";
    ComponentTypeEnum[ComponentTypeEnum["Writing"] = 3] = "Writing";
    ComponentTypeEnum[ComponentTypeEnum["Speaking"] = 4] = "Speaking";
    ComponentTypeEnum[ComponentTypeEnum["Nonspecific"] = 5] = "Nonspecific";
    ComponentTypeEnum[ComponentTypeEnum["Overall"] = 6] = "Overall";
    ComponentTypeEnum[ComponentTypeEnum["DSCScore"] = 7] = "DSCScore";
    ComponentTypeEnum[ComponentTypeEnum["SSSCore"] = 8] = "SSSCore";
    ComponentTypeEnum[ComponentTypeEnum["EUScore"] = 9] = "EUScore";
    ComponentTypeEnum[ComponentTypeEnum["Essay"] = 10] = "Essay";
    ComponentTypeEnum[ComponentTypeEnum["Level"] = 11] = "Level";
})(ComponentTypeEnum || (ComponentTypeEnum = {}));
var DifficultyLevelEnum;
(function (DifficultyLevelEnum) {
    DifficultyLevelEnum[DifficultyLevelEnum["Easy"] = 20] = "Easy";
    DifficultyLevelEnum[DifficultyLevelEnum["Medium"] = 50] = "Medium";
    DifficultyLevelEnum[DifficultyLevelEnum["Difficult"] = 100] = "Difficult";
})(DifficultyLevelEnum || (DifficultyLevelEnum = {}));
var FieldTestingPriorityEnum;
(function (FieldTestingPriorityEnum) {
    FieldTestingPriorityEnum[FieldTestingPriorityEnum["None"] = 10] = "None";
    FieldTestingPriorityEnum[FieldTestingPriorityEnum["Normal"] = 20] = "Normal";
    FieldTestingPriorityEnum[FieldTestingPriorityEnum["High"] = 30] = "High";
})(FieldTestingPriorityEnum || (FieldTestingPriorityEnum = {}));
var InteractionTypeEnum;
(function (InteractionTypeEnum) {
    InteractionTypeEnum[InteractionTypeEnum["Choice"] = 1] = "Choice";
    InteractionTypeEnum[InteractionTypeEnum["InlineChoice"] = 2] = "InlineChoice";
    InteractionTypeEnum[InteractionTypeEnum["TextEntry"] = 3] = "TextEntry";
    InteractionTypeEnum[InteractionTypeEnum["ExtendedText"] = 4] = "ExtendedText";
    InteractionTypeEnum[InteractionTypeEnum["Speaking"] = 5] = "Speaking";
    InteractionTypeEnum[InteractionTypeEnum["Hotspot"] = 6] = "Hotspot";
    InteractionTypeEnum[InteractionTypeEnum["Order"] = 7] = "Order";
    InteractionTypeEnum[InteractionTypeEnum["Associate"] = 8] = "Associate";
    InteractionTypeEnum[InteractionTypeEnum["Match"] = 9] = "Match";
    InteractionTypeEnum[InteractionTypeEnum["PaperBased"] = 10] = "PaperBased";
})(InteractionTypeEnum || (InteractionTypeEnum = {}));
var OrientationEnum;
(function (OrientationEnum) {
    OrientationEnum[OrientationEnum["Vertical"] = 1] = "Vertical";
    OrientationEnum[OrientationEnum["Horizontal"] = 2] = "Horizontal";
})(OrientationEnum || (OrientationEnum = {}));
var RatingTypeEnum;
(function (RatingTypeEnum) {
    RatingTypeEnum[RatingTypeEnum["HumanRated"] = 1] = "HumanRated";
    RatingTypeEnum[RatingTypeEnum["MachineScored"] = 2] = "MachineScored";
})(RatingTypeEnum || (RatingTypeEnum = {}));
var ResourceTypeEnum;
(function (ResourceTypeEnum) {
    ResourceTypeEnum[ResourceTypeEnum["Picture"] = 1] = "Picture";
    ResourceTypeEnum[ResourceTypeEnum["Audio"] = 2] = "Audio";
    ResourceTypeEnum[ResourceTypeEnum["Video"] = 3] = "Video";
    ResourceTypeEnum[ResourceTypeEnum["HTML"] = 4] = "HTML";
    ResourceTypeEnum[ResourceTypeEnum["PDF"] = 5] = "PDF";
})(ResourceTypeEnum || (ResourceTypeEnum = {}));
var ScoreCategoryEnum;
(function (ScoreCategoryEnum) {
    ScoreCategoryEnum[ScoreCategoryEnum["Global"] = 1] = "Global";
    ScoreCategoryEnum[ScoreCategoryEnum["Inference"] = 2] = "Inference";
    ScoreCategoryEnum[ScoreCategoryEnum["Local"] = 3] = "Local";
    ScoreCategoryEnum[ScoreCategoryEnum["NotSpecified"] = 4] = "NotSpecified";
})(ScoreCategoryEnum || (ScoreCategoryEnum = {}));
var ShapeEnum;
(function (ShapeEnum) {
    ShapeEnum[ShapeEnum["Default"] = 1] = "Default";
    ShapeEnum[ShapeEnum["Rect"] = 2] = "Rect";
    ShapeEnum[ShapeEnum["Circle"] = 3] = "Circle";
    ShapeEnum[ShapeEnum["Poly"] = 4] = "Poly";
    ShapeEnum[ShapeEnum["Ellipse"] = 5] = "Ellipse";
})(ShapeEnum || (ShapeEnum = {}));
var TestletStateEnum;
(function (TestletStateEnum) {
    TestletStateEnum[TestletStateEnum["Created"] = 1] = "Created";
    TestletStateEnum[TestletStateEnum["InFieldTesting"] = 2] = "InFieldTesting";
    TestletStateEnum[TestletStateEnum["RevisionNeeded"] = 3] = "RevisionNeeded";
    TestletStateEnum[TestletStateEnum["Revised"] = 4] = "Revised";
    TestletStateEnum[TestletStateEnum["ReadyForDecisionMaking"] = 5] = "ReadyForDecisionMaking";
    TestletStateEnum[TestletStateEnum["Operational"] = 6] = "Operational";
    TestletStateEnum[TestletStateEnum["InHibernation"] = 7] = "InHibernation";
    TestletStateEnum[TestletStateEnum["Rejected"] = 8] = "Rejected";
    TestletStateEnum[TestletStateEnum["PermanentlyRetired"] = 9] = "PermanentlyRetired";
})(TestletStateEnum || (TestletStateEnum = {}));
var TestletUpdateTypeEnum;
(function (TestletUpdateTypeEnum) {
    TestletUpdateTypeEnum[TestletUpdateTypeEnum["MetaDataUpdate"] = 1] = "MetaDataUpdate";
    TestletUpdateTypeEnum[TestletUpdateTypeEnum["MinorVersionUpdate"] = 2] = "MinorVersionUpdate";
    TestletUpdateTypeEnum[TestletUpdateTypeEnum["MajorVersionUpdate"] = 3] = "MajorVersionUpdate";
})(TestletUpdateTypeEnum || (TestletUpdateTypeEnum = {}));
var TestTakerActivityTypeEnum;
(function (TestTakerActivityTypeEnum) {
    TestTakerActivityTypeEnum[TestTakerActivityTypeEnum["EnterTestlet"] = 100] = "EnterTestlet";
    TestTakerActivityTypeEnum[TestTakerActivityTypeEnum["LeaveTestlet"] = 101] = "LeaveTestlet";
    TestTakerActivityTypeEnum[TestTakerActivityTypeEnum["TestletTimeout"] = 102] = "TestletTimeout";
    TestTakerActivityTypeEnum[TestTakerActivityTypeEnum["SetResponse"] = 103] = "SetResponse";
    TestTakerActivityTypeEnum[TestTakerActivityTypeEnum["StartSpeaking"] = 104] = "StartSpeaking";
    TestTakerActivityTypeEnum[TestTakerActivityTypeEnum["SetAssessmentItemIndex"] = 105] = "SetAssessmentItemIndex";
    TestTakerActivityTypeEnum[TestTakerActivityTypeEnum["PageNavigationArrowClick"] = 106] = "PageNavigationArrowClick";
    TestTakerActivityTypeEnum[TestTakerActivityTypeEnum["TabClick"] = 107] = "TabClick";
    TestTakerActivityTypeEnum[TestTakerActivityTypeEnum["IgnoreMinWordCountWarningYes"] = 108] = "IgnoreMinWordCountWarningYes";
    TestTakerActivityTypeEnum[TestTakerActivityTypeEnum["IgnoreMinWordCountWarningNo"] = 109] = "IgnoreMinWordCountWarningNo";
    TestTakerActivityTypeEnum[TestTakerActivityTypeEnum["IgnoreUnansweredInteractionWarningYes"] = 110] = "IgnoreUnansweredInteractionWarningYes";
    TestTakerActivityTypeEnum[TestTakerActivityTypeEnum["IgnoreUnansweredInteractionWarningNo"] = 111] = "IgnoreUnansweredInteractionWarningNo";
    TestTakerActivityTypeEnum[TestTakerActivityTypeEnum["TestStart"] = 200] = "TestStart";
    TestTakerActivityTypeEnum[TestTakerActivityTypeEnum["TestResume"] = 201] = "TestResume";
    TestTakerActivityTypeEnum[TestTakerActivityTypeEnum["TestEnd"] = 203] = "TestEnd";
    TestTakerActivityTypeEnum[TestTakerActivityTypeEnum["ScreenLockStart"] = 204] = "ScreenLockStart";
    TestTakerActivityTypeEnum[TestTakerActivityTypeEnum["ScreenLockEnd"] = 205] = "ScreenLockEnd";
    TestTakerActivityTypeEnum[TestTakerActivityTypeEnum["NewApplicationSession"] = 206] = "NewApplicationSession";
    TestTakerActivityTypeEnum[TestTakerActivityTypeEnum["StationAssigned"] = 207] = "StationAssigned";
    TestTakerActivityTypeEnum[TestTakerActivityTypeEnum["PinWrongInput"] = 208] = "PinWrongInput";
    TestTakerActivityTypeEnum[TestTakerActivityTypeEnum["PinCorrectInput"] = 209] = "PinCorrectInput";
    TestTakerActivityTypeEnum[TestTakerActivityTypeEnum["StartCodeWrongInput"] = 210] = "StartCodeWrongInput";
    TestTakerActivityTypeEnum[TestTakerActivityTypeEnum["StartCodeCorrectInput"] = 211] = "StartCodeCorrectInput";
    TestTakerActivityTypeEnum[TestTakerActivityTypeEnum["ApplicationShutdownUnknown"] = 430] = "ApplicationShutdownUnknown";
    TestTakerActivityTypeEnum[TestTakerActivityTypeEnum["ApplicationShutdownProgramFailure"] = 431] = "ApplicationShutdownProgramFailure";
    TestTakerActivityTypeEnum[TestTakerActivityTypeEnum["ApplicationShutdownHardwareIssue"] = 432] = "ApplicationShutdownHardwareIssue";
    TestTakerActivityTypeEnum[TestTakerActivityTypeEnum["ApplicationShutdownTestTakerBreak"] = 433] = "ApplicationShutdownTestTakerBreak";
    TestTakerActivityTypeEnum[TestTakerActivityTypeEnum["ApplicationShutdownEndOfTest"] = 435] = "ApplicationShutdownEndOfTest";
    TestTakerActivityTypeEnum[TestTakerActivityTypeEnum["ApplicationShutdownOther"] = 436] = "ApplicationShutdownOther";
})(TestTakerActivityTypeEnum || (TestTakerActivityTypeEnum = {}));
var TestTypeEnum;
(function (TestTypeEnum) {
    TestTypeEnum[TestTypeEnum["CELPIP_G"] = 5] = "CELPIP_G";
    TestTypeEnum[TestTypeEnum["CELPIP_LS"] = 7] = "CELPIP_LS";
    TestTypeEnum[TestTypeEnum["DEMO_G_2014"] = 8] = "DEMO_G_2014";
    TestTypeEnum[TestTypeEnum["PILOT_G_2014"] = 10] = "PILOT_G_2014";
    TestTypeEnum[TestTypeEnum["PRETEST_G"] = 11] = "PRETEST_G";
    TestTypeEnum[TestTypeEnum["PRETEST_LS"] = 12] = "PRETEST_LS";
    TestTypeEnum[TestTypeEnum["RESEARCH_G"] = 13] = "RESEARCH_G";
    TestTypeEnum[TestTypeEnum["CELPIP_SAFT"] = 14] = "CELPIP_SAFT";
    TestTypeEnum[TestTypeEnum["CAEL"] = 20] = "CAEL";
    TestTypeEnum[TestTypeEnum["CAEL_PLACEMENT"] = 21] = "CAEL_PLACEMENT";
    TestTypeEnum[TestTypeEnum["CAEL2"] = 22] = "CAEL2";
    TestTypeEnum[TestTypeEnum["SAFT"] = 23] = "SAFT";
    TestTypeEnum[TestTypeEnum["CAEL_CE_DEMO"] = 24] = "CAEL_CE_DEMO";
    TestTypeEnum[TestTypeEnum["LPI"] = 25] = "LPI";
    TestTypeEnum[TestTypeEnum["CAEL_SAFT"] = 26] = "CAEL_SAFT";
})(TestTypeEnum || (TestTypeEnum = {}));
var ViewEnum;
(function (ViewEnum) {
    ViewEnum[ViewEnum["Author"] = 1] = "Author";
    ViewEnum[ViewEnum["Candidate"] = 2] = "Candidate";
    ViewEnum[ViewEnum["Proctor"] = 3] = "Proctor";
    ViewEnum[ViewEnum["Scorer"] = 4] = "Scorer";
    ViewEnum[ViewEnum["TestConstructor"] = 5] = "TestConstructor";
    ViewEnum[ViewEnum["Tutor"] = 6] = "Tutor";
})(ViewEnum || (ViewEnum = {}));
//# sourceMappingURL=enums.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/services/config.helper.ts

var config_helper_ConfigHelper = (function () {
    function ConfigHelper() {
    }
    ConfigHelper.setTestTypeId = function (testTypeId) {
        _paragonConfig.testTypeId = +testTypeId;
    };
    ConfigHelper.getTestTypeId = function () {
        return _paragonConfig.testTypeId;
    };
    ConfigHelper.isIppMode = function () {
        return _paragonConfig.mode === "ipp";
    };
    ConfigHelper.isTdpMode = function (webDelivery) {
        if (webDelivery === void 0) { webDelivery = null; }
        if (webDelivery === true) {
            return _paragonConfig.mode === "tdp_web_delivey";
        }
        else if (webDelivery === false) {
            return _paragonConfig.mode === "tdp";
        }
        else {
            return _paragonConfig.mode === "tdp" || _paragonConfig.mode === "tdp_web_delivey";
        }
    };
    ConfigHelper.isPreviewMode = function () {
        return _paragonConfig.mode === "preview";
    };
    ConfigHelper.testContentServerApiUrl = function () {
        return _paragonConfig.testContentServerApiUrl;
    };
    ConfigHelper.testServerApiUrl = function () {
        return _paragonConfig.testServerApiUrl;
    };
    ConfigHelper.getAudioAssetUrl = function () {
        if (this.isTdpMode()) {
            return _paragonConfig.testContentServerApiUrl + "/assets/audio";
        }
        if (this.isIppMode()) {
            return _paragonConfig.testContentServerApiUrl + "/Content/RenderingEngine/assets/audio";
        }
        else {
            return _paragonConfig.testContentServerApiUrl + "/Content/Preview/assets/audio";
        }
    };
    ConfigHelper.shouldUseBeepAudioClipForSpeaking = function (testTypeId) {
        switch (testTypeId) {
            case TestTypeEnum.CAEL:
                return true;
            default:
                return false;
        }
    };
    ConfigHelper.shouldShowTimesUpDlgForSpeaking = function (testTypeId) {
        switch (testTypeId) {
            case TestTypeEnum.CAEL:
                return false;
            default:
                return true;
        }
    };
    ConfigHelper.shouldCheckForUnacceptableRecording = function (testTypeId) {
        if (this.isIppMode() || this.isPreviewMode() || this.isTdpMode(true)) {
            return false;
        }
        if (!testTypeId || testTypeId === TestTypeEnum.CAEL) {
            return false;
        }
        return true;
    };
    ConfigHelper.shouldAlwaysHideNextButton = function () {
        switch (ConfigHelper.getTestTypeId()) {
            case TestTypeEnum.CAEL:
                return true;
            default:
                return false;
        }
    };
    ConfigHelper.canSkipMicrophoneCheck = function () {
        return (this.isIppMode() || this.isPreviewMode());
    };
    return ConfigHelper;
}());

//# sourceMappingURL=config.helper.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/store/reducers/test-taker.reducer.ts




var test_taker_reducer_initialState = {
    assessmentTest: null,
    testlet: null,
    itemIndex: 0,
    testNavigation: {
        dateAdded: new Date(),
        testPartIndex: 0,
        testletIndex: 0,
        canGoNext: false,
        isEndOfTest: false
    },
    preloadNavigation: {
        dateAdded: new Date(),
        testPartIndex: 0,
        testletIndex: 0,
        canGoNext: false,
        isEndOfTest: false
    },
    flushPayload: null,
    testTakerInfo: null,
    responses: [],
    timer: getInitialTimerValue(),
    timerVisibility: false,
    testTakerActivitiesCache: [],
    testletHistory: [],
    shouldGoToNextTestlet: false,
    assessmentIds: [],
    highlights: [],
    isNavigatingInProgress: {}
};
var getAssociatedAssessmentTests = function (state) { return state.assessmentIds; };
var getTestTakerInfo = function (state) { return state.testTakerInfo; };
var getResponses = function (state) { return state.responses; };
var getTimer = function (state) { return state.timer; };
var getTestTakerActivitiesCache = function (state) { return state.testTakerActivitiesCache; };
var getTestletHistory = function (state) { return state.testletHistory; };
var getFlushPayload = function (state) { return state.flushPayload; };
var test_taker_reducer_shouldGoToNextTestlet = function (state) { return state.shouldGoToNextTestlet; };
var getAssessmentTest = function (state) { return state.assessmentTest; };
var getTestlet = function (state) { return state.testlet; };
var getItemIndex = function (state) { return state.itemIndex; };
var getAssessmentItem = function (state) { return state.testlet ? state.testlet.AssessmentItems[state.itemIndex] : null; };
var getCurrentTestletId = function (state) { return state.assessmentTest ? parseTestletId(state.assessmentTest.TestParts[state.testNavigation.testPartIndex].AssessmentSectionRefs[state.testNavigation.testletIndex].Href) : null; };
var getNextTestletId = function (state) { return state.assessmentTest ? parseTestletId(state.assessmentTest.TestParts[state.preloadNavigation.testPartIndex].AssessmentSectionRefs[state.preloadNavigation.testletIndex].Href) : null; };
var getTestNavigation = function (state) { return state.testNavigation; };
var getTimerVisibility = function (state) { return state.timerVisibility; };
var getStoredHighlights = function (state) { return state.highlights; };
var getIsNavigatingInProgress = function (state) { return state.isNavigatingInProgress; };
function testTakerReducer(state, action) {
    if (state === void 0) { state = test_taker_reducer_initialState; }
    switch (action.type) {
        case test_taker_action_namespaceObject.LOAD_TESTLET_SUCCESS: {
            setExtraTestletProperties(action.payload);
            return Object.assign({}, state, { testlet: action.payload, itemIndex: 0, canGoNext: false });
        }
        case test_taker_action_namespaceObject.SET_ITEM_INDEX:
            return Object.assign({}, state, { itemIndex: action.payload });
        case test_taker_action_namespaceObject.LOAD_ASSESSMENT_TEST_SUCCESS:
            return Object.assign({}, state, {
                assessmentTest: action.payload,
                testlet: null,
                itemIndex: 0,
                canGoNext: false
            });
        case test_taker_action_namespaceObject.TEST_NAVIGATION_NEXT:
            var newObject = {};
            var testNavigation = testNavigationNext(state, action.payload.currentTestPartIndex, action.payload.currentTestletIndex);
            var newState = Object.assign({}, state, {
                testNavigation: testNavigation,
                isNavigatingInProgress: newObject
            });
            var preloadNavigation = testNavigationNext(newState, testNavigation.testPartIndex, testNavigation.testletIndex);
            newState.preloadNavigation = preloadNavigation;
            return newState;
        case test_taker_action_namespaceObject.TEST_NAVIGATION_PREVIOUS:
            return Object.assign({}, state, {
                testNavigation: testNavigationPrevious(state)
            });
        case test_taker_action_namespaceObject.SET_TEST_NAVIGATION:
            return Object.assign({}, state, {
                testNavigation: action.payload
            });
        case test_taker_action_namespaceObject.SET_CAN_GO_NEXT: {
            var testNavigation_1 = Object.assign({}, state.testNavigation);
            testNavigation_1.canGoNext = action.payload;
            return Object.assign({}, state, { testNavigation: testNavigation_1 });
        }
        case test_taker_action_namespaceObject.INDICATE_END_OF_TEST: {
            var testNavigation_2 = Object.assign({}, state.testNavigation);
            testNavigation_2.isEndOfTest = true;
            return Object.assign({}, state, { testNavigation: testNavigation_2 });
        }
        case test_taker_action_namespaceObject.SET_RESPONSE:
            return setResponse(state, action.payload);
        case test_taker_action_namespaceObject.REMOVE_RESPONSE_ITEM:
            return removeResponseItem(state, action.payload.interactionId, action.payload.value);
        case test_taker_action_namespaceObject.CLEAR_RESPONSES:
            return clearResponses(state, action.payload);
        case test_taker_action_namespaceObject.START_TIMER: {
            var timer = getInitialTimerValue();
            timer.timeLimits = action.payload.timeLimits;
            timer.startedAt = new Date().getTime();
            if (config_helper_ConfigHelper.isTdpMode(true)) {
                timer.startedAt = timer.startedAt - (action.payload.timeAlreadyUsed * 1000);
            }
            //timer.previouslyUsedTimeInSeconds = state.timer.previouslyUsedTimeInSeconds;
            //todo
            timer.previouslyUsedTimeInSeconds = 0;
            timer.speakingPreparationTime = action.payload.speakingPreparationTime;
            timer.speakingRecordingTime = action.payload.speakingRecordingTime;
            timer.timesUpCallback = action.payload.timesUpCallback;
            timer.showTimesUpWarning = action.payload.showTimesUpWarning;
            timer.multiplier = action.payload.multiplier;
            return Object.assign({}, state, {
                timer: timer,
                timerVisibility: action.payload.timerVisibility
            });
        }
        case test_taker_action_namespaceObject.STOP_TIMER: {
            var timer = Object.assign({}, state.timer);
            timer.stoppedAt = new Date().getTime();
            return Object.assign({}, state, {
                timer: timer
            });
        }
        case test_taker_action_namespaceObject.PAUSE_TIMER: {
            var timer = Object.assign({}, state.timer);
            timer.pausedAt = new Date().getTime();
            return Object.assign({}, state, {
                timer: timer
            });
        }
        case test_taker_action_namespaceObject.UNPAUSE_TIMER: {
            var timer = Object.assign({}, state.timer);
            if (timer.pausedAt) {
                timer.previouslyUsedTimeInSeconds -= Math.round((new Date().getTime() - timer.pausedAt) / 1000);
            }
            timer.pausedAt = null;
            return Object.assign({}, state, {
                timer: timer
            });
        }
        case test_taker_action_namespaceObject.SET_TEST_TAKER_INFO:
            return Object.assign({}, state, {
                testTakerInfo: action.payload
            });
        case test_taker_action_namespaceObject.CACHE_TEST_TAKER_ACTIVITIES: {
            var newState_1 = Object.assign({}, state, {
                testTakerActivitiesCache: state.testTakerActivitiesCache.concat(action.payload),
            });
            var testletRelatedActivities = action.payload
                .filter(function (x) { return x.ActivityTypeId === TestTakerActivityTypeEnum.EnterTestlet || x.ActivityTypeId === TestTakerActivityTypeEnum.LeaveTestlet; })
                .map(function (x) {
                return {
                    TestletId: x.TestletId,
                    ActivityTypeId: x.ActivityTypeId,
                    DateCreatedUtc: x.DateCreatedUtc
                };
            });
            if (testletRelatedActivities.length > 0) {
                newState_1.testletHistory = state.testletHistory.concat(testletRelatedActivities);
            }
            return newState_1;
        }
        case test_taker_action_namespaceObject.CLEAR_TEST_TAKER_ACTIVITIES:
            return Object.assign({}, state, {
                testTakerActivitiesCache: []
            });
        case test_taker_action_namespaceObject.SET_FLUSH_PAYLOAD:
            return Object.assign({}, state, {
                flushPayload: action.payload
            });
        case test_taker_action_namespaceObject.FLUSH_PAYLOAD_SUCCESS:
            return Object.assign({}, state, {
                shouldGoToNextTestlet: action.payload
            });
        case test_taker_action_namespaceObject.SHOULD_GO_TO_NEXT_TESTLET:
            return Object.assign({}, state, {
                shouldGoToNextTestlet: action.payload
            });
        case test_taker_action_namespaceObject.SET_TEST_INITIALIZATION_INFO: {
            var testInitializationInfo = action.payload;
            var testNavigation_3 = Object.assign({}, state.testNavigation);
            testNavigation_3.testPartIndex = testInitializationInfo.TestTakerProgress.CurrentTestPartIndex;
            testNavigation_3.testletIndex = testInitializationInfo.TestTakerProgress.CurrentTestletIndex;
            testNavigation_3.isEndOfTest = false;
            var timer = getInitialTimerValue();
            timer.previouslyUsedTimeInSeconds = testInitializationInfo.TestTakerProgress.CurrentTestletUsedSeconds;
            return Object.assign({}, state, {
                testNavigation: testNavigation_3,
                timer: timer,
                responses: testInitializationInfo.CurrentTestletInteractionResponses
            });
        }
        case test_taker_action_namespaceObject.SET_IPP_PRODUCT_INFO: {
            return Object.assign({}, state, {
                assessmentIds: action.payload.AssociatedIppAssessmentTestIds.slice()
            });
        }
        case test_taker_action_namespaceObject.TOGGLE_TIMER_VISIBILITY: {
            return Object.assign({}, state, {
                timerVisibility: action.payload
            });
        }
        case test_taker_action_namespaceObject.SET_STORED_HIGHLIGHTS: {
            var resourceId = action.payload.ResourceId;
            var highlightedText = action.payload.HighlightedText;
            var highlight = state.highlights.find(function (h) { return h.ResourceId === resourceId; });
            if (highlight) {
                var existingRemoved = state.highlights.filter(function (r) { return r.ResourceId !== resourceId; });
                state.highlights = existingRemoved.concat([{
                        ResourceId: resourceId,
                        HighlightedText: highlightedText
                    }]);
            }
            else {
                var dto = {
                    ResourceId: resourceId,
                    HighlightedText: highlightedText
                };
                return Object.assign({}, state, { highlights: state.highlights.concat(dto) });
            }
            return Object.assign({}, state, { highlights: state.highlights });
        }
        case test_taker_action_namespaceObject.RESUME_TEST: {
            var timer = Object.assign({}, state.timer);
            timer.previouslyUsedTimeInSeconds = 0;
            timer.pausedAt = null;
            timer.startedAt = new Date().getTime();
            return Object.assign({}, state, {
                itemIndex: 0,
                timer: timer
            });
        }
        default:
            return state;
    }
}
function getInitialTimerValue() {
    return {
        timeLimits: { MinTime: null, MaxTime: null },
        startedAt: null,
        stoppedAt: null,
        pausedAt: null,
        previouslyUsedTimeInSeconds: 0,
        speakingPreparationTime: null,
        speakingRecordingTime: null,
        timesUpCallback: null,
        showTimesUpWarning: false,
        multiplier: 1,
    };
}
function setResponse(state, response) {
    var responses = state.responses.filter(function (r) { return r.InteractionId != response.InteractionId; }).concat([response]);
    return Object.assign({}, state, { responses: responses });
}
function removeResponseItem(state, interactionId, value) {
    var response = state.responses.find(function (r) { return r.InteractionId == interactionId; });
    if (response) {
        var responses = state.responses.filter(function (r) { return r.InteractionId != interactionId; });
        var responseItems = response.Items.filter(function (i) { return i.Value != value; });
        responses = responses.concat([{
                InteractionId: interactionId,
                Items: responseItems
            }]);
        return Object.assign({}, state, { responses: responses });
    }
    else {
        return Object.assign({}, state);
    }
}
function clearResponses(state, interactionId) {
    var responses = state.responses.filter(function (r) { return r.InteractionId != interactionId; });
    return Object.assign({}, state, { responses: responses });
}
function parseTestletId(href) {
    var matched = /testlet(\d+).xml/i.exec(href);
    if (matched) {
        return parseInt(matched[1]);
    }
    return null;
}
function testNavigationNext(state, currentTestPartIndex, currentTestletIndex) {
    var testNavigation = Object.assign({}, state.testNavigation);
    var ignoreNavigationAction = testNavigation.testPartIndex != currentTestPartIndex && testNavigation.testletIndex != currentTestletIndex;
    if (!ignoreNavigationAction && state.assessmentTest) {
        testNavigation.dateAdded = new Date();
        var testPart = state.assessmentTest.TestParts[testNavigation.testPartIndex];
        if (testNavigation.testletIndex < testPart.AssessmentSectionRefs.length - 1) {
            testNavigation.testletIndex += 1;
        }
        else {
            var nextTestPartIndex = getNextTestPartIndex(state);
            if (testNavigation.testPartIndex != nextTestPartIndex) {
                testNavigation.testPartIndex = nextTestPartIndex;
                testNavigation.testletIndex = 0;
            }
        }
    }
    return testNavigation;
}
function getNextTestPartIndex(state) {
    if (state.assessmentTest) {
        if (state.testNavigation.testPartIndex < state.assessmentTest.TestParts.length - 1) {
            return state.testNavigation.testPartIndex + 1;
        }
    }
    return state.testNavigation.testPartIndex;
}
function testNavigationPrevious(state) {
    var testNavigation = Object.assign({}, state.testNavigation);
    if (state.assessmentTest) {
        if (testNavigation.testletIndex > 0) {
            testNavigation.testletIndex -= 1;
        }
        else {
            var previousTestPartIndex = getPreviousTestPartIndex(state);
            if (testNavigation.testPartIndex != previousTestPartIndex) {
                testNavigation.testPartIndex = previousTestPartIndex;
                testNavigation.testletIndex = 0;
            }
        }
    }
    return testNavigation;
}
function getPreviousTestPartIndex(state) {
    if (state.assessmentTest) {
        if (state.testNavigation.testPartIndex > 0) {
            return state.testNavigation.testPartIndex - 1;
        }
    }
    return state.testNavigation.testPartIndex;
}
//properties like DisplayPageNumber and HasMixedPanelType are not provided by the backend
function setExtraTestletProperties(testlet) {
    var prevAssessmentItem = null;
    var groupNumber = 0;
    testlet.AssessmentItems.forEach(function (item, index) {
        var displayPageNumber = 1;
        var leftPane = item.ItemBody.ItemBodyPanels.find(function (x) { return x.CssClass.indexOf("leftpane") >= 0; });
        if (leftPane) {
            if (prevAssessmentItem && prevAssessmentItem.DisplayPageNumber) {
                displayPageNumber += prevAssessmentItem.DisplayPageNumber;
            }
            else {
                groupNumber += 1;
            }
        }
        else {
            displayPageNumber = null;
            groupNumber += 1;
        }
        item.ItemIndex = index;
        item.DisplayPageNumber = displayPageNumber;
        item.GroupNumber = groupNumber;
        prevAssessmentItem = item;
    });
    //for groups with only 1 AssessmentItem, set the item's DisplayPageNumber to null
    var groupNumbers = lodash["uniq"](testlet.AssessmentItems.map(function (x) { return x.GroupNumber; })).forEach(function (groupNumber) {
        var groupNumberAssessmentItems = testlet.AssessmentItems.filter(function (x) { return x.GroupNumber == groupNumber; });
        if (groupNumberAssessmentItems.length == 1) {
            groupNumberAssessmentItems[0].DisplayPageNumber = null;
        }
    });
    testlet.HasMixedPanelType = lodash["uniq"](testlet.AssessmentItems.map(function (item) { return item.ItemBody.ItemBodyPanels.length; })).length > 1;
}
//# sourceMappingURL=test-taker.reducer.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/store/reducers/index.ts




var reducers = {
    appUi: appUiReducer,
    testTaker: testTakerReducer
};
// export function logger(reducer: ActionReducer<State>): ActionReducer<any, any> {
//   return function(state: State, action: any): State {
//     console.log('action', action);
//     return reducer(state, action);
//   };
// }
var metaReducers = !environment.production ? [] : [];
/**
 * IAppUiState
 */
var getAppUiState = Object(store_es5["l" /* createFeatureSelector */])('appUi');
var reducers_getIsLoading = Object(store_es5["m" /* createSelector */])(getAppUiState, getIsLoading);
var reducers_getIsLockScreenVisible = Object(store_es5["m" /* createSelector */])(getAppUiState, getIsLockScreenVisible);
var reducers_getIsExitScreenVisible = Object(store_es5["m" /* createSelector */])(getAppUiState, getIsExitScreenVisible);
var reducers_getIsPauseScreenVisible = Object(store_es5["m" /* createSelector */])(getAppUiState, getIsPauseScreenVisible);
var reducers_getGenericPage = Object(store_es5["m" /* createSelector */])(getAppUiState, getGenericPage);
var reducers_getIsNavigationModalVisible = Object(store_es5["m" /* createSelector */])(getAppUiState, getIsNavigationModalVisible);
/**
 * ITestTakerState
 */
var getTestTakerState = Object(store_es5["l" /* createFeatureSelector */])('testTaker');
var reducers_getAssessmentTest = Object(store_es5["m" /* createSelector */])(getTestTakerState, getAssessmentTest);
var reducers_getTestlet = Object(store_es5["m" /* createSelector */])(getTestTakerState, getTestlet);
var reducers_getItemIndex = Object(store_es5["m" /* createSelector */])(getTestTakerState, getItemIndex);
var reducers_getAssessmentItem = Object(store_es5["m" /* createSelector */])(getTestTakerState, getAssessmentItem);
var reducers_getCurrentTestletId = Object(store_es5["m" /* createSelector */])(getTestTakerState, getCurrentTestletId);
var reducers_getNextTestletId = Object(store_es5["m" /* createSelector */])(getTestTakerState, getNextTestletId);
var reducers_getTestNavigation = Object(store_es5["m" /* createSelector */])(getTestTakerState, getTestNavigation);
var reducers_getTestTakerInfo = Object(store_es5["m" /* createSelector */])(getTestTakerState, getTestTakerInfo);
var reducers_getResponses = Object(store_es5["m" /* createSelector */])(getTestTakerState, getResponses);
var reducers_getTimer = Object(store_es5["m" /* createSelector */])(getTestTakerState, getTimer);
var reducers_getTestTakerActivitiesCache = Object(store_es5["m" /* createSelector */])(getTestTakerState, getTestTakerActivitiesCache);
var reducers_getFlushPayload = Object(store_es5["m" /* createSelector */])(getTestTakerState, getFlushPayload);
var reducers_shouldGoToNextTestlet = Object(store_es5["m" /* createSelector */])(getTestTakerState, test_taker_reducer_shouldGoToNextTestlet);
var reducers_getAssociatedAssessmentTests = Object(store_es5["m" /* createSelector */])(getTestTakerState, getAssociatedAssessmentTests);
var reducers_getTimerVisibility = Object(store_es5["m" /* createSelector */])(getTestTakerState, getTimerVisibility);
var reducers_getStoredHighlights = Object(store_es5["m" /* createSelector */])(getTestTakerState, getStoredHighlights);
var reducers_getTestletHistory = Object(store_es5["m" /* createSelector */])(getTestTakerState, getTestletHistory);
var reducers_getIsNavigatingInProgress = Object(store_es5["m" /* createSelector */])(getTestTakerState, getIsNavigatingInProgress);
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/node_modules/moment/moment.js
var moment = __webpack_require__("ge1L");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/node_modules/rxjs/Observable.js
var Observable = __webpack_require__("bKpL");
var Observable_default = /*#__PURE__*/__webpack_require__.n(Observable);

// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/errors/constants.ts
/* Microphone Check */
/* Microphone Check */ var Microphone_Check = "Unable to detect recording device. Please check your headset and try again.";
var Microphone_Check_With_Code = Microphone_Check + " (BMC0001)";
/* Speaking Interaction */
var SpeakingInteraction_Recorder_Start = "Unable to detect recording device. Please check your headset and try again.";
var SpeakingInteraction_Recorder_Start_With_Code = SpeakingInteraction_Recorder_Start + " (BSP0001)";
var SpeakingInteraction_Times_Up = "<p>The detected audio recording is unacceptable.</p>\n<p>There may be a problem with the audio recording device being used or the operating system settings for this computer.</p>\n<p>Please inform your Test Supervisor to resolve this issue.</p>";
/* Exit */
var Exit_ExitCode = "The CTC code provided is not correct. This code was provided when first initializing the application. (BEX0001)";
var Exit_ExitReason = "Please select a reason for exiting the application. (BEX0002)";
var Exit_ExitDescription = "The reason chosen must be accompanied with a description. Please provide a description. (BEX0003)";
/* Lock Screen */
var LockScreen_ExitCode = "The CTC code provided is not correct. This code was provided when first initializing the application. (BLK0001)";
/* Http Call */
var Http_Unknown = "The browser could not connect to the server. An unknown error occurred. Please contact a member of staff for more details. (BHT0001)";
/* Responses */
var Response_Saving_Missing_Blobs = "<p>A problem was detected while trying to save speaking data.</p><p>Please inform a staff member to restart Secure Browser. (BRP0001)</p>";
var Response_Saving_Server_Call = "<p>A problem was detected while trying to communicate with the test.</p><p>Please inform a member of staff to resolve this issue.</p>";
/* Test Navigation */
var Navigation_Response_Saving = "Responses could not be saved. An unknown error occurred. Please contact a member of staff for more details. (BTN0001)";
//# sourceMappingURL=constants.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/services/base-http.service.ts
var base_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var base_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};









var base_http_service_BaseHttpService = BaseHttpService_1 = (function () {
    function BaseHttpService(http, httpClient, store, loggerService, authService) {
        this.http = http;
        this.httpClient = httpClient;
        this.store = store;
        this.loggerService = loggerService;
        this.authService = authService;
        this.testContentServerApiUrl = _paragonConfig.testContentServerApiUrl;
        this.testServerApiUrl = _paragonConfig.testServerApiUrl;
    }
    BaseHttpService.prototype.request = function (options, isFormData) {
        if (isFormData === void 0) { isFormData = false; }
        return this.createRequest(options, isFormData)
            .map(function (response) {
            try {
                return response.json();
            }
            catch (error) {
                return null;
            }
        })
            .catch(this.handleError);
    };
    BaseHttpService.prototype.requestForBlob = function (options) {
        options.responseType = http_es5["f" /* ResponseContentType */].Blob;
        return this.createRequest(options, false)
            .map(function (response) {
            try {
                return response.blob();
            }
            catch (error) {
                console.log(error);
                return null;
            }
        })
            .catch(this.handleError);
    };
    BaseHttpService.prototype.requestForText = function (options) {
        return this.createRequest(options, false)
            .map(function (response) {
            try {
                return response.text();
            }
            catch (error) {
                console.log(error);
                return null;
            }
        })
            .catch(this.handleError);
    };
    BaseHttpService.prototype.requestWithProgress = function (url, method, body) {
        if (body === void 0) { body = {}; }
        var req = new common_http_es5["d" /* HttpRequest */](method, url, body, {
            headers: this.getHttpHeaders(),
            reportProgress: true
        });
        return this.httpClient.request(req);
    };
    BaseHttpService.prototype.createRequest = function (options, isFormData) {
        this.injectCustomHeaders(options, isFormData);
        return this.http.request(new http_es5["d" /* Request */](options));
    };
    BaseHttpService.prototype.injectCustomHeaders = function (options, isFormData) {
        if (options) {
            if (!options.headers) {
                options.headers = new http_es5["a" /* Headers */]();
            }
            var accessToken = this.authService.getAccessToken();
            if (accessToken && accessToken.length > 0) {
                options.headers.append('Authorization', "Bearer " + accessToken);
            }
            if (options.body && typeof options.body !== 'string' && !isFormData) {
                options.body = JSON.stringify(options.body);
                options.headers.append("Content-Type", "application/json");
            }
        }
    };
    BaseHttpService.prototype.getHttpHeaders = function () {
        var headers = new common_http_es5["c" /* HttpHeaders */]();
        var accessToken = this.authService.getAccessToken();
        if (accessToken && accessToken.length > 0) {
            headers.append('Authorization', "Bearer " + accessToken);
        }
        return headers;
    };
    BaseHttpService.prototype.handleError = function (error) {
        console.log(error);
        if (this.loggerService) {
            this.loggerService.reportError(BaseHttpService_1.name, error);
        }
        if (this.store) {
            this.store.dispatch(new app_ui_action_namespaceObject.HideLoadingOverlay());
        }
        if (error.status == 401) {
            if (this.store) {
                this.store.dispatch(new app_ui_action_namespaceObject.ShowGenericPage("Unauthorized", "Access denied.", true));
            }
            return Observable["Observable"].throw("Unauthorized.");
        }
        if (error.status == 403) {
            if (this.store) {
                this.store.dispatch(new app_ui_action_namespaceObject.ShowGenericPage("Forbidden", "Access denied.", true));
            }
            return Observable["Observable"].throw("Forbidden.");
        }
        if (error.headers.has("Content-Type") && error.headers.get("Content-Type").indexOf("application/json") > -1) {
            var msg = Http_Unknown;
            var errorObj = error.json();
            if (errorObj.Reasons && errorObj.Reasons.length > 0) {
                msg = errorObj.Reasons[0].ErrorMessage;
            }
            return Observable["Observable"].throw(msg + " Please restart Secure Browser.");
        }
        return Observable["Observable"].empty();
    };
    return BaseHttpService;
}());
base_http_service_BaseHttpService = BaseHttpService_1 = base_http_service___decorate([
    Object(core_es5["C" /* Injectable */])(),
    base_http_service___metadata("design:paramtypes", [typeof (base_http_service__a = typeof http_es5["b" /* Http */] !== "undefined" && http_es5["b" /* Http */]) === "function" && base_http_service__a || Object, typeof (base_http_service__b = typeof common_http_es5["a" /* HttpClient */] !== "undefined" && common_http_es5["a" /* HttpClient */]) === "function" && base_http_service__b || Object, typeof (base_http_service__c = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && base_http_service__c || Object, typeof (_d = typeof LoggerService !== "undefined" && LoggerService) === "function" && _d || Object, typeof (_e = typeof auth_service_AuthService !== "undefined" && auth_service_AuthService) === "function" && _e || Object])
], base_http_service_BaseHttpService);

var BaseHttpService_1, base_http_service__a, base_http_service__b, base_http_service__c, _d, _e;
//# sourceMappingURL=base-http.service.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/services/test-taker.service.ts
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var test_taker_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var test_taker_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};










var test_taker_service_TestTakerService = (function (_super) {
    __extends(TestTakerService, _super);
    function TestTakerService(http, httpClient, store, loggerService, authService) {
        var _this = _super.call(this, http, httpClient, store, loggerService, authService) || this;
        _this.testTakerSubscription = store.select(reducers_getTestTakerInfo).subscribe(function (testTakerInfo) {
            _this.testTakerInfo = testTakerInfo;
        });
        _this.testNavigation$ = store.select(reducers_getTestNavigation);
        _this.testNavigationSubscription = _this.testNavigation$.subscribe(function (testNavigation) {
            _this.testNavigation = testNavigation;
        });
        return _this;
    }
    TestTakerService.prototype.ngOnDestroy = function () {
        this.testTakerSubscription.unsubscribe();
        this.testNavigationSubscription.unsubscribe();
    };
    TestTakerService.prototype.getStationAssignmentWebDelivery = function (webDeliveryAuth) {
        var url = this.testServerApiUrl + "/api/info/station";
        return this.request({
            method: http_es5["e" /* RequestMethod */].Post,
            url: url,
            body: {
                authData: webDeliveryAuth
            }
        });
    };
    TestTakerService.prototype.getStationAssignment = function (stationNumber) {
        var url = this.testServerApiUrl + "/api/info/station/" + stationNumber;
        return this.request({
            method: http_es5["e" /* RequestMethod */].Get,
            url: url
        });
    };
    TestTakerService.prototype.getBlankTestTakerPhotoUrl = function () {
        return this.testContentServerApiUrl + "/assets/img/paragon-icon.png";
    };
    TestTakerService.prototype.getTestTakerPhotoUrl = function (brandName, siteCode, regId) {
        return this.testServerApiUrl + "/api/info/test-taker/" + brandName + "/" + siteCode + "/" + regId;
    };
    TestTakerService.prototype.getWebDeliveryTestTakerPhotoUrl = function (clientApplicationSessionId, regId) {
        return this.testServerApiUrl + "/api/info/test-taker/" + clientApplicationSessionId + "/" + regId;
    };
    TestTakerService.prototype.saveTestTakerResponse = function (testTakerResponse, speakingBlobData) {
        var url = this.testServerApiUrl + "/api/test-taker/save-response/" + this.testTakerInfo.TestTakerId + "/" + this.testTakerInfo.StationNumber;
        this.loggerService.reportDebugInfo("TestTakerService", {
            name: "saveTestTakerResponse",
            testTakerId: this.testTakerInfo.TestTakerId,
            step: "StartSaving"
        });
        for (var i = 0; i < testTakerResponse.InteractionResponses.length; i++) {
            this.loggerService.reportDebugInfo("TestTakerService", {
                name: "saveTestTakerResponse",
                testTakerId: this.testTakerInfo.TestTakerId,
                step: "InteractionResponse",
                interactionId: testTakerResponse.InteractionResponses[i].InteractionId
            });
        }
        var formData = new FormData();
        formData.append("TestTakerResponse", JSON.stringify(testTakerResponse));
        if (speakingBlobData) {
            this.loggerService.reportDebugInfo("TestTakerService", {
                name: "saveTestTakerResponse",
                testTakerId: this.testTakerInfo.TestTakerId,
                step: "SpeakingInteractionResponse",
                interactionId: speakingBlobData.interactionId.toString(),
                speakingBlobDataSize: speakingBlobData.blob != null ? speakingBlobData.blob.size : 0
            });
            formData.append("speakingBlobData", speakingBlobData.blob, speakingBlobData.interactionId.toString());
        }
        return this.request({
            method: http_es5["e" /* RequestMethod */].Post,
            url: url,
            body: formData
        }, true);
    };
    TestTakerService.prototype.saveTestTakerKeyboardActivity = function (interactionId, keyboardActivityFile) {
        var url = this.testServerApiUrl + "/api/test-taker/save-keyboard-activity/" + this.testTakerInfo.TestTakerId + "/" + this.testTakerInfo.StationNumber;
        this.loggerService.reportDebugInfo("TestTakerService", {
            name: "saveTestTakerKeyboardActivtity",
            testTakerId: this.testTakerInfo.TestTakerId,
            step: "StartSaving"
        });
        var formData = new FormData();
        formData.append("InteractionId", interactionId.toString());
        formData.append("keyboardData", keyboardActivityFile, interactionId.toString());
        return this.request({
            method: http_es5["e" /* RequestMethod */].Post,
            url: url,
            body: formData
        }, true);
    };
    TestTakerService.prototype.startTest = function () {
        var url = this.testServerApiUrl + "/api/start-test";
        if (config_helper_ConfigHelper.isTdpMode(true)) {
            var systemInformation = {
                userHostAddress: "",
                userAgent: navigator.userAgent,
                screenWidth: window.screen.width,
                screenHeight: window.screen.height,
                browserWidth: window.innerWidth,
                browserHeight: window.innerHeight
            };
            return this.request({
                method: http_es5["e" /* RequestMethod */].Post,
                url: url,
                body: systemInformation
            });
        }
        return this.request({
            method: http_es5["e" /* RequestMethod */].Post,
            url: url
        });
    };
    TestTakerService.prototype.authenticate = function (testTakerStationAssignment, secureBrowserVersionInfo) {
        var url = this.testServerApiUrl + "/token";
        var headers = new http_es5["a" /* Headers */]();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        headers.append("ClientApplicationSessionId", testTakerStationAssignment.ClientApplicationSessionId);
        headers.append("VersionInfoClaim", secureBrowserVersionInfo);
        headers.append("TestSessionSiteCode", testTakerStationAssignment.TestSessionSiteCode);
        headers.append("BrandName", testTakerStationAssignment.BrandName);
        return this.request({
            method: http_es5["e" /* RequestMethod */].Post,
            url: url,
            headers: headers,
            body: "username=" + testTakerStationAssignment.TestTakerId + "&password=" + testTakerStationAssignment.TestSessionId + "&grant_type=password"
        });
    };
    TestTakerService.prototype.cacheTestTakerActivity = function (activityTypeId, numericValue, textValue, testletId, interactionId, itemIndex) {
        if (numericValue === void 0) { numericValue = null; }
        if (textValue === void 0) { textValue = null; }
        if (testletId === void 0) { testletId = null; }
        if (interactionId === void 0) { interactionId = null; }
        if (itemIndex === void 0) { itemIndex = null; }
        this.store.dispatch(new test_taker_action_namespaceObject.CacheTestTakerActivities([{
                ActivityTypeId: activityTypeId,
                DateCreatedUtc: new Date(),
                InteractionId: interactionId,
                ItemIndex: itemIndex,
                NumericValue: numericValue,
                TestletId: testletId,
                TextValue: textValue,
                TestPartIndex: this.testNavigation ? this.testNavigation.testPartIndex : null,
                TestletIndex: this.testNavigation ? this.testNavigation.testletIndex : null
            }]));
    };
    TestTakerService.prototype.saveTestTakerActivityWithoutCaching = function (activityTypeId, numericValue, textValue, testletId, testletVersionId, interactionId, itemIndex) {
        if (numericValue === void 0) { numericValue = null; }
        if (textValue === void 0) { textValue = null; }
        if (testletId === void 0) { testletId = null; }
        if (testletVersionId === void 0) { testletVersionId = null; }
        if (interactionId === void 0) { interactionId = null; }
        if (itemIndex === void 0) { itemIndex = null; }
        if (config_helper_ConfigHelper.isTdpMode()) {
            try {
                var activity = {
                    ActivityTypeId: activityTypeId,
                    DateCreatedUtc: new Date(),
                    InteractionId: interactionId,
                    ItemIndex: itemIndex,
                    NumericValue: numericValue,
                    TestletId: testletId,
                    TestletVersionId: testletVersionId,
                    TextValue: textValue
                };
                this.request({
                    method: http_es5["e" /* RequestMethod */].Post,
                    url: this.testServerApiUrl + "/api/test-taker/save-activities",
                    body: [activity]
                }).subscribe();
            }
            catch (error) {
                console.error(error);
            }
        }
    };
    TestTakerService.prototype.ping = function (testTakerPing) {
        return this.request({
            method: http_es5["e" /* RequestMethod */].Post,
            url: this.testServerApiUrl + "/api/ping",
            body: testTakerPing
        });
    };
    TestTakerService.prototype.getIppTestTakerInfo = function (assessmentTestId) {
        var url = this.testServerApiUrl + "/api/test-taker/info/" + assessmentTestId;
        return this.request({
            method: http_es5["e" /* RequestMethod */].Get,
            url: url
        }, true);
    };
    TestTakerService.prototype.uploadTestTakerLog = function () {
        try {
            var url = this.testServerApiUrl + "/api/log/upload-test-taker-log";
            this.request({
                method: http_es5["e" /* RequestMethod */].Post,
                url: url
            }).subscribe();
        }
        catch (error) {
            console.error(error);
        }
    };
    TestTakerService.prototype.isNonScoredTestStarted = function () {
        var url = this.testServerApiUrl + "/api/test-taker/is-non-scored-test-started";
        return this.request({
            method: http_es5["e" /* RequestMethod */].Get,
            url: url
        });
    };
    return TestTakerService;
}(base_http_service_BaseHttpService));
test_taker_service_TestTakerService = test_taker_service___decorate([
    Object(core_es5["C" /* Injectable */])(),
    test_taker_service___metadata("design:paramtypes", [typeof (test_taker_service__a = typeof http_es5["b" /* Http */] !== "undefined" && http_es5["b" /* Http */]) === "function" && test_taker_service__a || Object, typeof (test_taker_service__b = typeof common_http_es5["a" /* HttpClient */] !== "undefined" && common_http_es5["a" /* HttpClient */]) === "function" && test_taker_service__b || Object, typeof (test_taker_service__c = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && test_taker_service__c || Object, typeof (test_taker_service__d = typeof LoggerService !== "undefined" && LoggerService) === "function" && test_taker_service__d || Object, typeof (test_taker_service__e = typeof auth_service_AuthService !== "undefined" && auth_service_AuthService) === "function" && test_taker_service__e || Object])
], test_taker_service_TestTakerService);

var test_taker_service__a, test_taker_service__b, test_taker_service__c, test_taker_service__d, test_taker_service__e;
//# sourceMappingURL=test-taker.service.js.map
// EXTERNAL MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/node_modules/rxjs/Rx.js
var Rx = __webpack_require__("Dqrr");
var Rx_default = /*#__PURE__*/__webpack_require__.n(Rx);

// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/services/html.service.ts
var html_service___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var html_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var html_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};











var html_service_HtmlService = (function (_super) {
    html_service___extends(HtmlService, _super);
    function HtmlService(http, httpClient, store, loggerService, authService, domSanitizer) {
        var _this = _super.call(this, http, httpClient, store, loggerService, authService) || this;
        _this.domSanitizer = domSanitizer;
        _this.preloadedResources = [];
        _this.testTakerInfoSubscription = _this.store.select(reducers_getTestTakerInfo).subscribe(function (ippTestTakerInfo) {
            _this.testTakerInfo = ippTestTakerInfo;
        });
        _this.highlightSubscription = _this.store.select(reducers_getStoredHighlights).subscribe(function (highlights) {
            _this.serializedHighlights = highlights;
        });
        return _this;
    }
    HtmlService.prototype.ngOnDestroy = function () {
        this.testTakerInfoSubscription.unsubscribe();
        this.highlightSubscription.unsubscribe();
    };
    HtmlService.prototype.replaceInteractionPlaceHolders = function (html) {
        return html.replace(/{i(\d+)}/ig, "<interaction [interaction]=\"getInteraction($1)\"></interaction>");
    };
    HtmlService.prototype.replaceResourcePlaceHolders = function (html) {
        html = this.replaceCustomTags(html);
        html = this.replaceIppCustomTags(html);
        html = html.replace(/{r(\d+):(picture|video|audio|html|pdf):?(.*)}/ig, "<resource [type]=\"'$2'\" [id]=\"$1\" [attr]=\"'$3'\"></resource>");
        return html;
    };
    HtmlService.prototype.replaceCustomTags = function (html) {
        var tabHtml = this.transformTabs(html);
        if (tabHtml && tabHtml.length > 0) {
            html = html.replace(/<tab [\s\S]*<\/tab>/igm, tabHtml);
        }
        var slideDeckPictures = this.getSlideDeckPictures(html);
        if (slideDeckPictures.length > 0) {
            html = html.replace(/<slides>([\s\S]*?)<\/slides>/igm, "<slide-deck [pics]=\"[" + slideDeckPictures + "]\"></slide-deck>");
        }
        html = html.replace(/<auto-skip-timer>(\d+)<\/auto-skip-timer>/igm, "<auto-skip-timer [time]=\"$1\"></auto-skip-timer>");
        html = html.replace(/<auto-play-resource\s*time="(\d+)"\s*(?:reviewTime="\d+")?\s*>\s*{r(\d+):(audio|video)}\s*<\/auto-play-resource>/igm, "<auto-play-resource [time]=\"$1\" [resourceId]=\"$2\" [type]=\"'$3'\"></auto-play-resource>");
        html = html.replace(/<end-of-test>{r(\d+):picture}<\/end-of-test>/igm, '<end-of-test [pictureResourceId]="$1"></end-of-test>');
        html = html.replace(/<hidden-resources>[^]*?<\/hidden-resources>/igm, '');
        return html;
    };
    HtmlService.prototype.replaceIppCustomTags = function (html) {
        html = html.replace(/<ipp-writing-sample-response title="([\s\S]*?)">{r(\d+):html}<\/ipp-writing-sample-response>/igm, "<ipp-writing-sample-response [title]=\"'$1'\" [resourceId]=\"$2\"></ipp-writing-sample-response>");
        html = html.replace(/<ipp-speaking-sample-response title="([\s\S]*?)">{r(\d+):audio}<\/ipp-speaking-sample-response>/igm, "<ipp-speaking-sample-response [title]=\"'$1'\" [resourceId]=\"$2\"></ipp-speaking-sample-response>");
        html = html.replace(/<ipp-transcript title="([\s\S]*?)">{r(\d+):(audio|video)}<\/ipp-transcript>/igm, "<ipp-transcript [title]=\"'$1'\" [resourceId]=\"$2\"></ipp-transcript>");
        html = html.replace(/<ipp-landing-page image="{r(\d+):picture}">{r(\d+):html}<\/ipp-landing-page>/igm, "<ipp-landing-page [htmlResourceId]=\"$2\" [pictureResourceId]=\"$1\"></ipp-landing-page>");
        html = html.replace(/<ipp-scoring-page>{r(\d+):html}<\/ipp-scoring-page>/igm, '<ipp-scoring-page [htmlResourceId]="$1"></ipp-scoring-page>');
        html = html.replace(/<ipp-feedback-page ready="{r(\d+):html}" almostReady="{r(\d+):html}" notReady="{r(\d+):html}">{r(\d+):html}<\/ipp-feedback-page>/igm, '<ipp-feedback-page [disclaimerResourceId]="$4" [readyResourceId]="$1" [almostReadyResourceId]="$2" [notReadyResourceId]="$3"></ipp-feedback-page>');
        html = html.replace(/<ipp-end-of-test>{r(\d+):html}<\/ipp-end-of-test>/igm, '<ipp-end-of-test [htmlResourceId]="$1"></ipp-end-of-test>');
        html = html.replace(/<ipp-download-response title="([\s\S]*?)"><\/ipp-download-response>/igm, "<ipp-download-response [title]=\"'$1'\"></ipp-download-response>");
        return html;
    };
    HtmlService.prototype.getSlideDeckPictures = function (html) {
        var regex = /<slide>{r(\d+):picture}<\/slide>/ig;
        var matchedArray;
        var resultHtml = "";
        while ((matchedArray = regex.exec(html)) != null) {
            resultHtml += matchedArray[1] + ",";
        }
        return resultHtml.substring(0, resultHtml.length - 1);
    };
    HtmlService.prototype.transformTabs = function (html) {
        var regex = /<tab title="([\s\S]*?)">([\s\S]*?)<\/tab>/ig;
        var tabNameRegex = /<tab title="([\s\S]*?)"/i;
        var matchedArray;
        var tabIndex = 1;
        var tabHeaderHtml = "";
        var tabContentHtml = "";
        while ((matchedArray = regex.exec(html)) != null) {
            var matchedTabNameArray = tabNameRegex.exec(matchedArray[0]);
            if (matchedTabNameArray) {
                var tabName = ('_' + matchedTabNameArray[1].replace(/[\W]/g, "")).toLowerCase();
                var activeCssClass = tabIndex == 1 ? " active" : "";
                var tabTransformRegex = /<tab title="([\s\S]*?)">([\s\S]*?)<\/tab>/ig;
                tabHeaderHtml += matchedArray[0].replace(tabTransformRegex, "<li class=\"" + activeCssClass + "\"><a href=\"#" + tabName + "\" role=\"tab\" data-toggle=\"tab\" class=\"testlet-tab-header\">$1</a></li>");
                tabContentHtml += matchedArray[0].replace(tabTransformRegex, "<div role=\"tabpanel\" class=\"tab-pane " + activeCssClass + "\" id=\"" + tabName + "\">$2</div>");
                tabIndex++;
            }
        }
        if (tabHeaderHtml.length > 0) {
            return "<ul class=\"nav nav-tabs\" role=\"tablist\">" + tabHeaderHtml + "</ul><div class=\"tab-content\">" + tabContentHtml + "</div>";
        }
        return null;
    };
    HtmlService.prototype.replaceAllPlaceHolders = function (html) {
        return this.replaceResourcePlaceHolders(this.replaceInteractionPlaceHolders(html));
    };
    HtmlService.prototype.replaceImageResourcePlaceHoldersWithTags = function (html) {
        if (config_helper_ConfigHelper.isTdpMode()) {
            if (config_helper_ConfigHelper.isTdpMode(true)) {
                return html.replace(/{r(\d+):picture}/ig, "<img src=\"" + _paragonConfig.testContentServerApiUrl + "/api/resource/file/" + this.testTakerInfo.ClientApplicationSessionId + "/$1\" />");
            }
            else {
                return html.replace(/{r(\d+):picture}/ig, "<img src=\"" + _paragonConfig.testContentServerApiUrl + "/api/resource/file/" + this.testTakerInfo.BrandName + "/" + this.testTakerInfo.TestSessionSiteCode + "/$1\" />");
            }
        }
        else {
            return html.replace(/{r(\d+):picture}/ig, "<img src=\"" + _paragonConfig.testContentServerApiUrl + "/api/resource/file/$1\" />");
        }
    };
    HtmlService.prototype.getResourceUrl = function (id) {
        if (id) {
            var preloadedResource_1 = this.preloadedResources.find(function (x) { return x.resourceId == id; });
            if (preloadedResource_1) {
                this.preloadedResources = this.preloadedResources.filter(function (x) { return x.resourceId !== preloadedResource_1.resourceId; });
                return preloadedResource_1.objectURL;
            }
            switch (_paragonConfig.mode) {
                case "tdp":
                    return _paragonConfig.testContentServerApiUrl + "/api/resource/file/" + this.testTakerInfo.BrandName + "/" + this.testTakerInfo.TestSessionSiteCode + "/" + id;
                case "tdp_web_delivey":
                    return _paragonConfig.testContentServerApiUrl + "/api/resource/file/" + this.testTakerInfo.ClientApplicationSessionId + "/" + id;
                case "preview":
                    return _paragonConfig.testContentServerApiUrl + "/api/resource/file/" + id + "/";
                case "ipp":
                    return _paragonConfig.testContentServerApiUrl + "/api/resource/file/" + id + "/" + this.testTakerInfo.AssessmentTestId;
                default:
                    return null;
            }
        }
        return null;
    };
    HtmlService.prototype.getHtmlResource = function (id) {
        return this.requestForText({
            method: http_es5["e" /* RequestMethod */].Get,
            url: this.getResourceUrl(id)
        });
    };
    HtmlService.prototype.getResourceTranscript = function (id) {
        var url;
        switch (_paragonConfig.mode) {
            case "preview":
                url = _paragonConfig.testContentServerApiUrl + "/api/resource/transcript/" + id;
                break;
            case "ipp":
                url = _paragonConfig.testContentServerApiUrl + "/api/resource/transcript/" + id + "/" + this.testTakerInfo.AssessmentTestId;
                break;
            default:
                return null;
        }
        return this.request({
            method: http_es5["e" /* RequestMethod */].Get,
            url: url
        });
    };
    HtmlService.prototype.getSerializedHighlights = function (resourceId) {
        return this.serializedHighlights.find(function (x) { return x.ResourceId === resourceId; });
    };
    HtmlService.prototype.setSerializedHighlights = function (highlightDto) {
        this.store.dispatch(new test_taker_action_namespaceObject.SetStoredHighlights(highlightDto));
    };
    HtmlService.prototype.getSafeHtml = function (html) {
        // eliminate script tag. source: https://github.com/jquery/jquery/blob/1.7.2/src/ajax.js#L14
        var scriptTagRegex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
        return this.domSanitizer.bypassSecurityTrustHtml(html.replace(scriptTagRegex, ""));
    };
    return HtmlService;
}(base_http_service_BaseHttpService));
html_service_HtmlService = html_service___decorate([
    Object(core_es5["C" /* Injectable */])(),
    html_service___metadata("design:paramtypes", [typeof (html_service__a = typeof http_es5["b" /* Http */] !== "undefined" && http_es5["b" /* Http */]) === "function" && html_service__a || Object, typeof (html_service__b = typeof common_http_es5["a" /* HttpClient */] !== "undefined" && common_http_es5["a" /* HttpClient */]) === "function" && html_service__b || Object, typeof (html_service__c = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && html_service__c || Object, typeof (html_service__d = typeof LoggerService !== "undefined" && LoggerService) === "function" && html_service__d || Object, typeof (html_service__e = typeof auth_service_AuthService !== "undefined" && auth_service_AuthService) === "function" && html_service__e || Object, typeof (_f = typeof platform_browser_es5["b" /* DomSanitizer */] !== "undefined" && platform_browser_es5["b" /* DomSanitizer */]) === "function" && _f || Object])
], html_service_HtmlService);

var html_service__a, html_service__b, html_service__c, html_service__d, html_service__e, _f;
//# sourceMappingURL=html.service.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/services/test-content.service.ts
var test_content_service___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var test_content_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var test_content_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};











var test_content_service_TestContentService = (function (_super) {
    test_content_service___extends(TestContentService, _super);
    function TestContentService(http, httpClient, store, loggerService, authService, htmlService) {
        var _this = _super.call(this, http, httpClient, store, loggerService, authService) || this;
        _this.htmlService = htmlService;
        _this.testletId$ = _this.store.select(reducers_getCurrentTestletId);
        _this.assessmentItemSubscription = _this.store.select(reducers_getAssessmentItem).subscribe(function (assessmentItem) {
            _this.activeAssessmentItem = assessmentItem;
        });
        _this.testletSubscription = _this.store.select(reducers_getTestlet).subscribe(function (testlet) {
            _this.activeTestlet = testlet;
        });
        _this.testletIdSubscription = _this.testletId$.subscribe(function (testletId) {
            _this.activeTestletId = testletId;
        });
        return _this;
    }
    TestContentService.prototype.ngOnDestroy = function () {
        this.assessmentItemSubscription.unsubscribe();
        this.testletSubscription.unsubscribe();
        this.testletIdSubscription.unsubscribe();
    };
    TestContentService.prototype.downloadTestContentFile = function (brandName, siteCode, stationNumber) {
        return this.request({
            method: http_es5["e" /* RequestMethod */].Post,
            url: this.testContentServerApiUrl + "/api/download-test-session-content-file/" + brandName + "/" + siteCode + "/" + stationNumber,
            body: {},
        });
    };
    TestContentService.prototype.downloadTestContentFileWithProgress = function (brandName, siteCode, stationNumber) {
        var url = this.testContentServerApiUrl + "/api/download-test-session-content-file/" + brandName + "/" + siteCode + "/" + stationNumber;
        return this.requestWithProgress(url, "POST");
    };
    TestContentService.prototype.getTestlet = function (testletId, assessmentTestId) {
        var _this = this;
        return this.request({
            method: http_es5["e" /* RequestMethod */].Get,
            url: this.testContentServerApiUrl + "/api/testlet/preview/testlet/" + testletId + "/" + assessmentTestId
        })
            .flatMap(function (testlet) {
            if (config_helper_ConfigHelper.isIppMode()) {
                return Rx["Observable"].of(testlet);
            }
            var html = testlet.AssessmentItems.map(function (assessmentItem) {
                return assessmentItem.ItemBody.ItemBodyPanels.map(function (body) { return body.Html; });
            }).join("");
            var resourceIds = [];
            var regex = /{r(\d+):(video|audio)}/ig;
            var matchedArray;
            while ((matchedArray = regex.exec(html)) != null) {
                resourceIds.push(parseInt(matchedArray[1]));
            }
            resourceIds = Array.from(new Set(resourceIds));
            var loadedResources = _this.htmlService.preloadedResources.map(function (x) { return x.resourceId; });
            //removes things that has been loaded
            resourceIds = resourceIds.filter(function (e) {
                return this.indexOf(e) < 0;
            }, loadedResources);
            if (resourceIds.length > 0) {
                var observableBatch = resourceIds.map(function (resourceId) {
                    return _this.requestForBlob({
                        method: http_es5["e" /* RequestMethod */].Get,
                        url: _this.htmlService.getResourceUrl(resourceId)
                    })
                        .map(function (responseBlob) {
                        return URL.createObjectURL(responseBlob);
                    });
                });
                return Rx["Observable"].forkJoin(observableBatch).map(function (allUrls) {
                    allUrls.forEach(function (url, index) {
                        _this.htmlService.preloadedResources.push({
                            resourceId: resourceIds[index],
                            objectURL: url
                        });
                    });
                    return testlet;
                });
            }
            else {
                return Rx["Observable"].of(testlet);
            }
        });
    };
    TestContentService.prototype.getCurrentTestletHasVideoAudio = function (html) {
        var regex = /{r(\d+):(video|audio)}/ig;
        var matchedArray;
        if ((matchedArray = regex.exec(html)) != null) {
            return true;
        }
        else {
            return false;
        }
    };
    TestContentService.prototype.getCurrentTestletHasInteraction = function () {
        if (this.activeTestlet && this.activeTestlet.AssessmentItems) {
            if (this.activeTestlet.AssessmentItems.some(function (x) { return x.Interactions.length > 0; })) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    };
    TestContentService.prototype.useTestletTimeAdjustment = function () {
        var html = this.activeTestlet.AssessmentItems.map(function (assessmentItem) {
            return assessmentItem.ItemBody.ItemBodyPanels.map(function (body) { return body.Html; });
        }).join("");
        return !this.getCurrentTestletHasVideoAudio(html) && this.getCurrentTestletHasInteraction();
    };
    TestContentService.prototype.getTestlets = function (testletIds, assessmentTestId) {
        return this.request({
            method: http_es5["e" /* RequestMethod */].Post,
            url: this.testContentServerApiUrl + "/api/testlet/preview/get-testlets-by-ids/" + assessmentTestId,
            body: testletIds
        });
    };
    TestContentService.prototype.getTestletVersion = function (testletVersionId) {
        return this.request({
            method: http_es5["e" /* RequestMethod */].Get,
            url: this.testContentServerApiUrl + "/api/testlet/preview/testletversion/" + testletVersionId
        });
    };
    TestContentService.prototype.getSnapshotTestlet = function (snapshotId) {
        return this.request({
            method: http_es5["e" /* RequestMethod */].Get,
            url: this.testContentServerApiUrl + "/api/testlet/testlet-snapshot-get?sessionToken=" + snapshotId
        });
    };
    TestContentService.prototype.getAssessmentTestByTestFormId = function (testFormId) {
        return this.request({
            method: http_es5["e" /* RequestMethod */].Get,
            url: this.testContentServerApiUrl + "/api/testform/preview/" + testFormId
        });
    };
    TestContentService.prototype.getAssessmentTest = function (assessmentTestId) {
        return this.request({
            method: http_es5["e" /* RequestMethod */].Get,
            url: this.testContentServerApiUrl + "/api/assessment-test/" + assessmentTestId
        });
    };
    TestContentService.prototype.getReferencedInteractions = function (item) {
        var interactionRefNums = [];
        var regex = /{i(\d.*?)}/ig;
        var matchedArray;
        var html = item.ItemBody.ItemBodyPanels.map(function (x) { return x.Html; }).join("");
        while ((matchedArray = regex.exec(html)) != null) {
            interactionRefNums.push(parseInt(matchedArray[1]));
        }
        return interactionRefNums.map(function (x) { return item.Interactions.find(function (i) { return i.InteractionRefNum == x; }); });
    };
    TestContentService.prototype.getReferencedInteractionsByTestlet = function (testlet) {
        var _this = this;
        var interactions = [];
        if (testlet) {
            testlet.AssessmentItems.forEach(function (i) {
                interactions = interactions.concat(_this.getReferencedInteractions(i));
            });
        }
        return interactions;
    };
    TestContentService.prototype.getReferencedInteractionsByItemGroup = function (testlet, groupNumber) {
        var _this = this;
        var interactions = [];
        if (testlet) {
            testlet.AssessmentItems.filter(function (x) { return x.GroupNumber == groupNumber; }).forEach(function (i) {
                interactions = interactions.concat(_this.getReferencedInteractions(i));
            });
        }
        return interactions;
    };
    TestContentService.prototype.getPreviewResponseScores = function (responses, snapshotSessionToken) {
        if (snapshotSessionToken === void 0) { snapshotSessionToken = null; }
        return this.request({
            method: http_es5["e" /* RequestMethod */].Post,
            url: this.testContentServerApiUrl + "/api/testlet/response-scores",
            body: { SnapshotSessionToken: snapshotSessionToken, TestTakerResponses: responses }
        });
    };
    TestContentService.prototype.getIppAssessmentTest = function (ippAssessmentTestId) {
        return this.request({
            method: http_es5["e" /* RequestMethod */].Get,
            url: this.testContentServerApiUrl + "/api/IppAssessmentTest/get-ipp-assessment-test-by-id/" + ippAssessmentTestId
        });
    };
    TestContentService.prototype.getIppAssessmentTestByProductId = function (productId) {
        return this.request({
            method: http_es5["e" /* RequestMethod */].Get,
            url: this.testContentServerApiUrl + "/api/IppAssessmentTest/get-ipp-assessment-test-by-product-id/" + productId
        });
    };
    TestContentService.prototype.getProductInfo = function (ippAssessmentTestId) {
        return this.request({
            method: http_es5["e" /* RequestMethod */].Get,
            url: this.testContentServerApiUrl + "/api/IppAssessmentTest/get-product-name-by-ipp-assessment-test-id/" + ippAssessmentTestId
        });
    };
    TestContentService.prototype.sendTestFormValidationResultEmail = function (testFormId, testletIds, errorMessages, recipientEmail) {
        return this.request({
            method: http_es5["e" /* RequestMethod */].Post,
            url: this.testContentServerApiUrl + "/api/testform/validate-test-form-email",
            body: {
                RecipientEmail: recipientEmail,
                TestFormId: testFormId,
                TestletIds: testletIds,
                ErrorMessages: errorMessages
            }
        });
    };
    return TestContentService;
}(base_http_service_BaseHttpService));
test_content_service_TestContentService = test_content_service___decorate([
    Object(core_es5["C" /* Injectable */])(),
    test_content_service___metadata("design:paramtypes", [typeof (test_content_service__a = typeof http_es5["b" /* Http */] !== "undefined" && http_es5["b" /* Http */]) === "function" && test_content_service__a || Object, typeof (test_content_service__b = typeof common_http_es5["a" /* HttpClient */] !== "undefined" && common_http_es5["a" /* HttpClient */]) === "function" && test_content_service__b || Object, typeof (test_content_service__c = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && test_content_service__c || Object, typeof (test_content_service__d = typeof LoggerService !== "undefined" && LoggerService) === "function" && test_content_service__d || Object, typeof (test_content_service__e = typeof auth_service_AuthService !== "undefined" && auth_service_AuthService) === "function" && test_content_service__e || Object, typeof (test_content_service__f = typeof html_service_HtmlService !== "undefined" && html_service_HtmlService) === "function" && test_content_service__f || Object])
], test_content_service_TestContentService);

var test_content_service__a, test_content_service__b, test_content_service__c, test_content_service__d, test_content_service__e, test_content_service__f;
//# sourceMappingURL=test-content.service.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/services/timer.service.ts
var timer_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var timer_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var timer_service_TimerService = (function () {
    function TimerService(store) {
        var _this = this;
        this.store = store;
        this.timer$ = store.select(reducers_getTimer);
        this.timerSubscription = this.timer$.subscribe(function (timer) {
            _this.timer = timer;
        });
        this.timerVisibilitySubscription = store.select(reducers_getTimerVisibility).subscribe(function (visibility) {
            _this.isTimerVisible = visibility;
        });
    }
    TimerService.prototype.ngOnDestroy = function () {
        if (this.timerSubscription) {
            this.timerSubscription.unsubscribe();
        }
        if (this.timerVisibilitySubscription) {
            this.timerVisibilitySubscription.unsubscribe();
        }
    };
    TimerService.prototype.getTimeLeft = function () {
        var timeLeft = 0;
        if (this.timer.timeLimits.MaxTime) {
            var elapsedTimeInSeconds = this.getElapsedTimeInSeconds();
            timeLeft = this.timer.timeLimits.MaxTime - elapsedTimeInSeconds;
            if (timeLeft < 0) {
                timeLeft = 0;
            }
        }
        return timeLeft;
    };
    TimerService.prototype.getDisplayString = function (timeLeft) {
        var displayString = null;
        if (timeLeft > 0) {
            var duration = moment["duration"](timeLeft * 1000);
            var hours = duration.hours();
            var minutes = duration.minutes();
            var seconds = duration.seconds();
            if (hours > 0) {
                displayString = this.getHourString(hours) + " " + this.getMinuteString(minutes);
            }
            else {
                if (minutes < 3) {
                    if (minutes > 0) {
                        displayString = this.getMinuteString(minutes) + " " + this.getSecondString(seconds);
                    }
                    else {
                        displayString = this.getSecondString(seconds);
                    }
                }
                else {
                    displayString = this.getMinuteString(minutes);
                }
            }
        }
        return displayString;
    };
    TimerService.prototype.canGoNext = function () {
        if (this.timer.timeLimits.MinTime) {
            var elapsedTimeInSeconds = this.getElapsedTimeInSeconds();
            return elapsedTimeInSeconds >= this.timer.timeLimits.MinTime;
        }
        return true;
    };
    TimerService.prototype.getElapsedTimeInSeconds = function () {
        if (!this.timer.startedAt) {
            return 0;
        }
        else {
            var stoppedAt = this.timer.stoppedAt ? this.timer.stoppedAt : new Date().getTime();
            return Math.round((stoppedAt - this.timer.startedAt) / 1000) + this.timer.previouslyUsedTimeInSeconds;
        }
    };
    TimerService.prototype.pauseTimer = function () {
        this.store.dispatch(new test_taker_action_namespaceObject.PauseTimer());
    };
    TimerService.prototype.unpauseTimer = function () {
        this.store.dispatch(new test_taker_action_namespaceObject.UnpauseTimer());
    };
    TimerService.prototype.isPaused = function () {
        return this.timer.pausedAt != null;
    };
    TimerService.prototype.toggleTimerVisibility = function (visible) {
        this.store.dispatch(new test_taker_action_namespaceObject.ToggleTimerVisibility(visible));
    };
    TimerService.prototype.startTimer = function (timeLimits, speakingPreparationTime, speakingRecordingTime, timerVisibility, timesUpCallback, showTimesUpWarning, multiplier, timeAlreadyUsed) {
        this.store.dispatch(new test_taker_action_namespaceObject.StartTimer(timeLimits, speakingPreparationTime, speakingRecordingTime, timerVisibility, timesUpCallback, showTimesUpWarning, multiplier, timeAlreadyUsed));
    };
    //TDP Web Use Session Storage
    TimerService.prototype.saveTimeUsedOnTestlet = function (testletId) {
        sessionStorage.setItem("TESTLET" + testletId.toString(), this.getElapsedTimeInSeconds().toString());
    };
    TimerService.prototype.getTimeUsedOnTestlet = function (testletId) {
        var value = sessionStorage.getItem("TESTLET" + testletId.toString());
        if (value) {
            return parseInt(value, 10);
        }
        else {
            return 0;
        }
    };
    //Private Helpers
    TimerService.prototype.getHourString = function (hours) {
        if (hours == 1) {
            return hours + " hour";
        }
        else if (hours > 1) {
            return hours + " hours";
        }
        return "";
    };
    TimerService.prototype.getSecondString = function (seconds) {
        if (seconds == 1) {
            return seconds + " second";
        }
        else if (seconds > 1) {
            return seconds + " seconds";
        }
        return "";
    };
    TimerService.prototype.getMinuteString = function (minutes) {
        if (minutes == 1) {
            return minutes + " minute";
        }
        else if (minutes > 1) {
            return minutes + " minutes";
        }
        return "";
    };
    return TimerService;
}());
timer_service_TimerService = timer_service___decorate([
    Object(core_es5["C" /* Injectable */])(),
    timer_service___metadata("design:paramtypes", [typeof (timer_service__a = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && timer_service__a || Object])
], timer_service_TimerService);

var timer_service__a;
//# sourceMappingURL=timer.service.js.map
// EXTERNAL MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/node_modules/jszip/lib/index.js
var lib = __webpack_require__("a0UF");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/services/keyboard-activity.service.ts
var keyboard_activity_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var keyboard_activity_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var keyboard_activity_service_KeyboardActivityService = (function () {
    function KeyboardActivityService() {
        this.maxKeyEvents = 20000;
        this.keyEvents = [];
        this.isInitialized = false;
        this.state = "pending";
        this.recordingSessionId = null;
        this.jsZip = new lib();
    }
    KeyboardActivityService.prototype.ngOnDestroy = function () {
        // unsubscribe to events. 
    };
    KeyboardActivityService.prototype.startRecording = function (recordingSessionId) {
        this.recordingSessionId = recordingSessionId;
        if (this.isInitialized == false) {
            this.initializeKeyCapturing();
        }
        this.state = "recording";
        this.keyEvents = [];
    };
    KeyboardActivityService.prototype.getRecordingSessionId = function () {
        return this.recordingSessionId;
    };
    KeyboardActivityService.prototype.stopRecording = function () {
        this.state = "stopped";
        // unsubcribe and set the initialized back to false
    };
    KeyboardActivityService.prototype.isRecording = function () {
        return this.state == "recording";
    };
    KeyboardActivityService.prototype.processKeyboardDataFile = function (onCompressedFile) {
        this.establishKeyboardZipFile(true, onCompressedFile);
    };
    KeyboardActivityService.prototype.initializeKeyCapturing = function () {
        var _this = this;
        this.isInitialized = true;
        document.addEventListener("keydown", function (e) { _this.onkeydown(e); });
        document.addEventListener("keyup", function (e) { _this.onkeyup(e); });
    };
    KeyboardActivityService.prototype.onkeydown = function (e) {
        if (this.state == "recording") {
            if (this.keyEvents.length >= this.maxKeyEvents) {
                this.keyEvents.shift();
            }
            this.keyEvents.push({ type: "keydown", keyCode: e.keyCode, key: e.key, timeStamp: e.timeStamp });
        }
    };
    KeyboardActivityService.prototype.onkeyup = function (e) {
        if (this.state == "recording") {
            if (this.keyEvents.length >= this.maxKeyEvents) {
                this.keyEvents.shift();
            }
            this.keyEvents.push({ type: "keyup", keyCode: e.keyCode, key: e.key, timeStamp: e.timeStamp });
        }
    };
    KeyboardActivityService.prototype.clearKeyboardActivity = function () {
        this.keyEvents = [];
    };
    KeyboardActivityService.prototype.getCSVRepresentation = function () {
        if (this.keyEvents.length > 0) {
            var fields = Object.keys(this.keyEvents[0]);
            var replacer = function (key, value) { return value === null ? '' : value; };
            var csv = this.keyEvents.map(function (row) {
                return fields.map(function (fieldName) {
                    return JSON.stringify(row[fieldName], replacer);
                }).join(',');
            });
            csv.unshift(fields.join(',')); // add header column
            return csv.join('\r\n');
        }
        else {
            // TO BE DETERMINED
            return "";
        }
    };
    KeyboardActivityService.prototype.establishKeyboardZipFile = function (compress, onCompressedFile) {
        var _this = this;
        this.jsZip.file("KeyboardActivity.csv", this.getCSVRepresentation());
        var promise = null;
        var options = (compress == true) ? {
            type: "blob",
            compression: "DEFLATE",
            compressionOptions: {
                level: 9
            }
        }
            :
                {
                    type: "blob"
                };
        this.jsZip.generateAsync(options)
            .then(function (blob) {
            _this.clearKeyboardActivity();
            onCompressedFile(blob);
        });
    };
    return KeyboardActivityService;
}());
keyboard_activity_service_KeyboardActivityService = keyboard_activity_service___decorate([
    Object(core_es5["C" /* Injectable */])(),
    keyboard_activity_service___metadata("design:paramtypes", [])
], keyboard_activity_service_KeyboardActivityService);

//# sourceMappingURL=keyboard-activity.service.js.map
// EXTERNAL MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/node_modules/@angular/common/@angular/common.es5.js
var common_es5 = __webpack_require__("qbdv");

// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/common/my-modal/my-modal.component.ts
var my_modal_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var my_modal_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var my_modal_component_MyModal = (function () {
    function MyModal(componentFactoryResolver, app, domSanitizer, compiler) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.app = app;
        this.domSanitizer = domSanitizer;
        this.compiler = compiler;
    }
    MyModal.prototype.setRootViewContainerRef = function (vRef) {
        this.vRef = vRef;
    };
    MyModal.prototype.showRegularDlg = function (title, message, buttons) {
        if (buttons === void 0) { buttons = [{ label: "Close", style: "btn-default" }]; }
        return this.show(title, message, "regular", buttons, null);
    };
    MyModal.prototype.showTimesUpDlg = function (timesUpCallback) {
        return this.show("Time is up", "", "times-up", [{ label: "Next", style: "btn-default btn-times-up-next" }], timesUpCallback);
    };
    MyModal.prototype.show = function (title, message, mode, buttons, timesUpCallback) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var type = _this.createNewComponent(title, mode, _this.domSanitizer.bypassSecurityTrustHtml(message), buttons);
            var module = _this.createComponentModule(type);
            _this.compiler
                .compileModuleAndAllComponentsAsync(module)
                .then(function (moduleWithFactories) {
                var factory = lodash["find"](moduleWithFactories.componentFactories, { componentType: type });
                var componentRef = _this.vRef.createComponent(factory, 0);
                componentRef.instance.cref = componentRef;
                componentRef.instance.result = resolve;
                componentRef.instance.timesUpCallback = timesUpCallback;
            });
        });
    };
    MyModal.prototype.createComponentModule = function (componentType) {
        var MyModalComponentModule = (function () {
            function MyModalComponentModule() {
            }
            return MyModalComponentModule;
        }());
        MyModalComponentModule = my_modal_component___decorate([
            Object(core_es5["M" /* NgModule */])({
                imports: [
                    common_es5["b" /* CommonModule */]
                ],
                declarations: [componentType],
            })
        ], MyModalComponentModule);
        return MyModalComponentModule;
    };
    MyModal.prototype.createNewComponent = function (title, mode, message, buttons) {
        var MyModalComponent = (function () {
            function MyModalComponent(store, elementRef) {
                this.store = store;
                this.elementRef = elementRef;
                this.title = title;
                this.mode = mode;
                this.message = message;
                this.buttons = buttons;
                this.timesUpCountDown = 5;
            }
            MyModalComponent.prototype.ngAfterViewInit = function () {
                var _this = this;
                var clickObservables = [];
                var elems = this.elementRef.nativeElement.getElementsByClassName("btn-modal");
                for (var i = 0; i < elems.length; i++) {
                    clickObservables.push(Rx["Observable"].fromEvent(elems[i], "click"));
                }
                this.buttonClickSubscription = Rx["Observable"].merge.apply(Rx["Observable"], clickObservables).take(1)
                    .do(function (mouseEvent) {
                    var btn = (mouseEvent.target);
                    _this.onClick(btn.innerText);
                })
                    .delay(600)
                    .repeat()
                    .subscribe();
                if (this.mode == "times-up") {
                    this.initTimesUpMode();
                }
            };
            MyModalComponent.prototype.ngOnDestroy = function () {
                if (this.buttonClickSubscription) {
                    this.buttonClickSubscription.unsubscribe();
                }
            };
            MyModalComponent.prototype.onClick = function (label) {
                this.cref.destroy();
                this.result(label);
                if (this.mode == "times-up" && this.timesUpSubscription != null) {
                    this.timesUpSubscription.unsubscribe();
                    this.timesUpCallback();
                }
            };
            MyModalComponent.prototype.initTimesUpMode = function () {
                var _this = this;
                var btns = this.elementRef.nativeElement.getElementsByClassName("btn-times-up-next");
                var btnNext = null;
                if (btns.length == 1) {
                    btnNext = btns[0];
                }
                this.timesUpSubscription = Rx["Observable"].interval(1000)
                    .take(5)
                    .subscribe(function (counter) {
                    _this.timesUpCountDown -= 1;
                    btnNext.disabled = _this.timesUpCountDown <= 2;
                }, null, function () {
                    _this.timesUpCallback();
                    _this.cref.destroy();
                });
            };
            return MyModalComponent;
        }());
        my_modal_component___decorate([
            Object(core_es5["F" /* Input */])(),
            my_modal_component___metadata("design:type", typeof (_a = typeof core_es5["r" /* ComponentRef */] !== "undefined" && core_es5["r" /* ComponentRef */]) === "function" && _a || Object)
        ], MyModalComponent.prototype, "cref", void 0);
        my_modal_component___decorate([
            Object(core_es5["F" /* Input */])(),
            my_modal_component___metadata("design:type", Object)
        ], MyModalComponent.prototype, "result", void 0);
        my_modal_component___decorate([
            Object(core_es5["F" /* Input */])(),
            my_modal_component___metadata("design:type", Object)
        ], MyModalComponent.prototype, "timesUpCallback", void 0);
        MyModalComponent = my_modal_component___decorate([
            Object(core_es5["o" /* Component */])({
                selector: 'modal',
                template: __webpack_require__("orLx")
            }),
            my_modal_component___metadata("design:paramtypes", [typeof (_b = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && _b || Object, typeof (_c = typeof core_es5["v" /* ElementRef */] !== "undefined" && core_es5["v" /* ElementRef */]) === "function" && _c || Object])
        ], MyModalComponent);
        return MyModalComponent;
        var _a, _b, _c;
    };
    return MyModal;
}());
my_modal_component_MyModal = my_modal_component___decorate([
    Object(core_es5["C" /* Injectable */])(),
    my_modal_component___metadata("design:paramtypes", [typeof (my_modal_component__a = typeof core_es5["q" /* ComponentFactoryResolver */] !== "undefined" && core_es5["q" /* ComponentFactoryResolver */]) === "function" && my_modal_component__a || Object, typeof (my_modal_component__b = typeof core_es5["g" /* ApplicationRef */] !== "undefined" && core_es5["g" /* ApplicationRef */]) === "function" && my_modal_component__b || Object, typeof (my_modal_component__c = typeof platform_browser_es5["b" /* DomSanitizer */] !== "undefined" && platform_browser_es5["b" /* DomSanitizer */]) === "function" && my_modal_component__c || Object, typeof (my_modal_component__d = typeof core_es5["m" /* Compiler */] !== "undefined" && core_es5["m" /* Compiler */]) === "function" && my_modal_component__d || Object])
], my_modal_component_MyModal);

var my_modal_component__a, my_modal_component__b, my_modal_component__c, my_modal_component__d;
//# sourceMappingURL=my-modal.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/services/response.service.ts
var response_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var response_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};














var response_service_ResponseService = ResponseService_1 = (function () {
    function ResponseService(store, myModal, loggerService, testTakerService, testContentService, keyboardActivityService, timerService) {
        var _this = this;
        this.store = store;
        this.myModal = myModal;
        this.loggerService = loggerService;
        this.testTakerService = testTakerService;
        this.testContentService = testContentService;
        this.keyboardActivityService = keyboardActivityService;
        this.timerService = timerService;
        this.speakingBlobData = null;
        this.flushIntervalInMilliseconds = 30000;
        this.pingIntervalInMilliseconds = 60000;
        this.responses$ = this.store.select(reducers_getResponses);
        this.responsesSubscription = this.responses$.subscribe(function (responses) {
            _this.responses = responses;
        });
        this.testTakerActivities$ = this.store.select(reducers_getTestTakerActivitiesCache);
        this.testTakerActivitiesSubscription = this.testTakerActivities$.subscribe(function (testTakerActivities) {
            _this.testTakerActivities = testTakerActivities;
        });
        this.endOfTestSubscription = this.store.select(reducers_getTestNavigation).subscribe(function (testNavigation) {
            if (testNavigation.isEndOfTest) {
                _this.clearIntervalSubscriptions();
            }
        });
        this.flushPayloadSubscription = this.store.select(reducers_getFlushPayload).subscribe(function (flushPayload) {
            if (_this.testTakerService.testTakerInfo && flushPayload && (flushPayload.TestTakerActivities.length > 0 || !flushPayload.triggeredByInterval) && !_this.timerService.isPaused()) {
                if (JSON.stringify(flushPayload) != JSON.stringify(_this.previouslyFlushedPayload)) {
                    if (config_helper_ConfigHelper.isTdpMode() && _this.speakingBlobData != null && (_this.speakingBlobData.blob == null || _this.speakingBlobData.blob.size == 0)) {
                        _this.loggerService.reportFatalError(ResponseService_1.name, "Speaking blob data is missing.");
                        _this.store.dispatch(new app_ui_action_namespaceObject.ShowGenericPage("Recording Error", Response_Saving_Missing_Blobs, true));
                        return;
                    }
                    _this.previouslyFlushedPayload = flushPayload;
                    _this.clearTestTakerActivities();
                    _this.testTakerService.saveTestTakerResponse(flushPayload, _this.speakingBlobData)
                        .retryWhen(function (errors) {
                        return errors
                            .delay(2000)
                            .scan(function (errorCount, err) {
                            if (errorCount > 3) {
                                throw err;
                            }
                            return errorCount + 1;
                        }, 0);
                    })
                        .take(1)
                        .subscribe(function (success) {
                        _this.clearSpeakingBlobData();
                        _this.store.dispatch(new test_taker_action_namespaceObject.FlushPayloadSuccess(!flushPayload.triggeredByInterval));
                    }, function (error) {
                        _this.loggerService.reportFatalError(ResponseService_1.name, error);
                        var title = "";
                        var message = "";
                        if (config_helper_ConfigHelper.isIppMode()) {
                            title = "Error";
                            message = "<p>Please refresh to start the test again.</p>";
                        }
                        else {
                            title = "Communication Error";
                            message = Response_Saving_Server_Call;
                        }
                        _this.store.dispatch(new app_ui_action_namespaceObject.ShowGenericPage(title, message, true));
                    });
                }
            }
        });
        if (config_helper_ConfigHelper.isTdpMode()) {
            this.flushIntervalSubscription = Rx["Observable"].interval(this.flushIntervalInMilliseconds)
                .subscribe(function (x) {
                _this.flush(true);
            });
            this.pingIntervalSubscription = Rx["Observable"].interval(this.pingIntervalInMilliseconds)
                .subscribe(function (x) {
                if (_this.testContentService.activeTestlet) {
                    _this.testTakerService.ping({
                        ClientApplicationSessionId: _this.testTakerService.testTakerInfo.ClientApplicationSessionId,
                        StationNumber: _this.testTakerService.testTakerInfo.StationNumber,
                        TestSessionId: _this.testTakerService.testTakerInfo.TestSessionId,
                        TestTakerId: _this.testTakerService.testTakerInfo.TestTakerId
                    }).subscribe();
                }
            }, function (error) {
                _this.loggerService.reportError(ResponseService_1.name, error);
            });
        }
    }
    ResponseService.prototype.clearIntervalSubscriptions = function () {
        if (this.flushIntervalSubscription) {
            this.flushIntervalSubscription.unsubscribe();
        }
        if (this.pingIntervalSubscription) {
            this.pingIntervalSubscription.unsubscribe();
        }
    };
    ResponseService.prototype.ngOnDestroy = function () {
        this.responsesSubscription.unsubscribe();
        this.testTakerActivitiesSubscription.unsubscribe();
        this.flushPayloadSubscription.unsubscribe();
        this.endOfTestSubscription.unsubscribe();
    };
    ResponseService.prototype.flush = function (triggeredByInterval) {
        if ((config_helper_ConfigHelper.isTdpMode() || config_helper_ConfigHelper.isIppMode()) && this.testContentService.activeTestlet && !this.timerService.isPaused()) {
            var interactions = this.testContentService.getReferencedInteractionsByTestlet(this.testContentService.activeTestlet);
            if (triggeredByInterval) {
                interactions = interactions.filter(function (i) { return i.SpeakingInteraction == null; });
            }
            else {
                try {
                    this.persistKeyboardActivity(interactions);
                }
                catch (err) {
                    this.loggerService.reportFatalError("Failed to persist keyboard data", err);
                }
            }
            var testTakerResponse = this.getTestTakerResponse(interactions.map(function (i) { return i.InteractionId; }), triggeredByInterval);
            this.store.dispatch(new test_taker_action_namespaceObject.SetFlushPayload(testTakerResponse));
        }
        return Promise.resolve();
    };
    ResponseService.prototype.persistKeyboardActivity = function (interactions) {
        var _this = this;
        if (interactions) {
            var matchingInterations = interactions.filter(function (i) { return i.InteractionId == _this.keyboardActivityService.getRecordingSessionId(); });
            if (matchingInterations.length > 0) {
                var interactionId = this.keyboardActivityService.getRecordingSessionId();
                this.keyboardActivityService.stopRecording();
                this.keyboardActivityService.processKeyboardDataFile(function (blob) {
                    _this.testTakerService.saveTestTakerKeyboardActivity(interactionId, blob).subscribe(function (success) {
                    }, function (error) {
                    });
                    ;
                });
            }
        }
    };
    ResponseService.prototype.clearInteractionResponses = function (interactionId) {
        this.store.dispatch(new test_taker_action_namespaceObject.ClearResponses(interactionId));
    };
    ResponseService.prototype.setResponse = function (interaction, key, value, text, hasMultiItems, choiceDisplayOrder) {
        var response = this.getResponse(interaction);
        if (!response) {
            response = {
                InteractionId: interaction.InteractionId,
                Items: []
            };
        }
        if (hasMultiItems == true) {
            response.Items = response.Items.filter(function (i) { return i.Value != value; }).concat([{
                    Key: key,
                    Value: value,
                    Text: text,
                    ChoiceDisplayOrder: choiceDisplayOrder
                }]);
        }
        else {
            response.Items = [{
                    Key: key,
                    Value: value,
                    Text: text,
                    ChoiceDisplayOrder: choiceDisplayOrder
                }];
        }
        this.store.dispatch(new test_taker_action_namespaceObject.SetResponse(response));
        this.testTakerService.cacheTestTakerActivity(TestTakerActivityTypeEnum.SetResponse, null, value, null, interaction.InteractionId, null);
    };
    ResponseService.prototype.setSpeakingBlobData = function (interactionId, blob) {
        this.speakingBlobData = {
            interactionId: interactionId,
            blob: blob
        };
    };
    ResponseService.prototype.clearSpeakingBlobData = function () {
        this.speakingBlobData = null;
    };
    ResponseService.prototype.removeResponseItem = function (interactionId, value) {
        this.store.dispatch(new test_taker_action_namespaceObject.RemoveResponseItem(interactionId, value));
    };
    ResponseService.prototype.getResponse = function (interaction) {
        return this.responses.find(function (x) { return interaction.InteractionId == x.InteractionId; });
    };
    ResponseService.prototype.hasResponseItem = function (interactionId, value) {
        var response = this.responses.find(function (x) { return x.InteractionId == interactionId; });
        return response && response.Items.findIndex(function (x) { return x.Value == value; }) >= 0;
    };
    ResponseService.prototype.isInteractionFullyAnswered = function (interaction) {
        var response = this.getResponse(interaction);
        switch (interaction.InteractionTypeId) {
            case InteractionTypeEnum.Choice:
                return response && response.Items.length >= interaction.ChoiceInteraction.MinChoices;
            case InteractionTypeEnum.InlineChoice:
                return response && response.Items.length > 0;
            case InteractionTypeEnum.TextEntry:
                if (response && response.Items.length > 0) {
                    var responseItem = response.Items[0];
                    return responseItem.Value && responseItem.Value.length > 0;
                }
                return false;
            case InteractionTypeEnum.ExtendedText:
                return this.meetMinWordCountRequirement(interaction.ExtendedTextInteraction, response);
            case InteractionTypeEnum.Hotspot:
                return response && response.Items.length >= interaction.HotspotInteraction.MinChoices;
            case InteractionTypeEnum.Match:
                if (response && interaction.MatchInteraction.SimpleMatchSets && interaction.MatchInteraction.SimpleMatchSets.length >= 2) {
                    return interaction.MatchInteraction.SimpleMatchSets[0].SimpleAssociableChoices.length == response.Items.length;
                }
                return false;
            case InteractionTypeEnum.Order:
            case InteractionTypeEnum.Speaking:
                return true;
            case InteractionTypeEnum.Associate:
                if (response) {
                    return interaction.AssociateInteraction.SimpleAssociableChoices.length == response.Items.length;
                }
                return false;
            default:
                break;
        }
        return false;
    };
    ResponseService.prototype.getTestTakerResponse = function (interactionIds, triggeredByInterval) {
        var responses = this.responses.filter(function (x) { return interactionIds.findIndex(function (interactionId) { return interactionId == x.InteractionId; }) >= 0; });
        // insert blank responses for unanswered interactions
        interactionIds.forEach(function (interactionId) {
            var response = responses.find(function (r) { return r.InteractionId == interactionId; });
            if (!response) {
                responses.push({ InteractionId: interactionId, Items: [] });
            }
        });
        var testTakerResponse = {
            ClientApplicationSessionId: this.testTakerService.testTakerInfo.ClientApplicationSessionId,
            CurrentTestletUsedSeconds: this.timerService.getElapsedTimeInSeconds(),
            InteractionResponses: responses,
            TestSessionId: this.testTakerService.testTakerInfo.TestSessionId,
            TestTakerActivities: this.testTakerActivities,
            TestTakerId: this.testTakerService.testTakerInfo.TestTakerId,
            triggeredByInterval: triggeredByInterval
        };
        return testTakerResponse;
    };
    ResponseService.prototype.clearTestTakerActivities = function () {
        this.store.dispatch(new test_taker_action_namespaceObject.ClearTestTakerActivities());
    };
    ResponseService.prototype.getUnansweredInteractionCountInAssessmentItem = function (item) {
        var _this = this;
        var referencedInteractions = this.testContentService.getReferencedInteractions(item);
        var unAnsweredCount = 0;
        referencedInteractions.forEach(function (interaction) {
            if (!_this.isInteractionFullyAnswered(interaction)) {
                unAnsweredCount++;
            }
        });
        return unAnsweredCount;
    };
    ResponseService.prototype.getUnansweredInteractionCountInTestlet = function (testlet) {
        var _this = this;
        var unAnsweredCount = 0;
        testlet.AssessmentItems.forEach(function (item) {
            unAnsweredCount += _this.getUnansweredInteractionCountInAssessmentItem(item);
        });
        return unAnsweredCount;
    };
    ResponseService.prototype.getUnansweredInteractionCountInItemGroup = function (testlet, groupNumber) {
        var _this = this;
        var unAnsweredCount = 0;
        testlet.AssessmentItems.filter(function (x) { return x.GroupNumber == groupNumber; }).forEach(function (item) {
            unAnsweredCount += _this.getUnansweredInteractionCountInAssessmentItem(item);
        });
        return unAnsweredCount;
    };
    ResponseService.prototype.meetMinWordCountRequirement = function (extendedTextInteraction, response) {
        if (!extendedTextInteraction.MinStrings) {
            return true;
        }
        if (response && response.Items.length > 0) {
            var responseText = this.stripHtmlTags(response.Items[0].Text);
            var responseWordCount = this.getWordCount(responseText);
            return responseWordCount >= extendedTextInteraction.MinStrings;
        }
        return false;
    };
    ResponseService.prototype.stripHtmlTags = function (textWithHtml) {
        if (textWithHtml) {
            return textWithHtml.replace(/(<([^>]+)>)/ig, " ");
        }
        return "";
    };
    ResponseService.prototype.getWordCount = function (text) {
        var regex = /\s+/gi;
        return (text && text.trim().length > 0) ? text.trim().replace(regex, ' ').split(' ').length : 0;
    };
    return ResponseService;
}());
response_service_ResponseService = ResponseService_1 = response_service___decorate([
    Object(core_es5["C" /* Injectable */])(),
    response_service___metadata("design:paramtypes", [typeof (response_service__a = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && response_service__a || Object, typeof (response_service__b = typeof my_modal_component_MyModal !== "undefined" && my_modal_component_MyModal) === "function" && response_service__b || Object, typeof (response_service__c = typeof LoggerService !== "undefined" && LoggerService) === "function" && response_service__c || Object, typeof (response_service__d = typeof test_taker_service_TestTakerService !== "undefined" && test_taker_service_TestTakerService) === "function" && response_service__d || Object, typeof (response_service__e = typeof test_content_service_TestContentService !== "undefined" && test_content_service_TestContentService) === "function" && response_service__e || Object, typeof (response_service__f = typeof keyboard_activity_service_KeyboardActivityService !== "undefined" && keyboard_activity_service_KeyboardActivityService) === "function" && response_service__f || Object, typeof (_g = typeof timer_service_TimerService !== "undefined" && timer_service_TimerService) === "function" && _g || Object])
], response_service_ResponseService);

var ResponseService_1, response_service__a, response_service__b, response_service__c, response_service__d, response_service__e, response_service__f, _g;
//# sourceMappingURL=response.service.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/services/test-navigation.service.ts
var test_navigation_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var test_navigation_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};















var test_navigation_service_TestNavigationService = (function () {
    function TestNavigationService(store, myModal, testTakerService, responseService, testContentService, timerService, loggerService) {
        var _this = this;
        this.store = store;
        this.myModal = myModal;
        this.testTakerService = testTakerService;
        this.responseService = responseService;
        this.testContentService = testContentService;
        this.timerService = timerService;
        this.loggerService = loggerService;
        this.navigationInProgress = false;
        this.shouldGoToNextTestlet$ = this.store.select(reducers_shouldGoToNextTestlet);
        this.shouldGoToNextTestletSubscription = this.shouldGoToNextTestlet$.subscribe(function (shouldGoToNextTestlet) {
            if (shouldGoToNextTestlet) {
                _this.store.dispatch(new test_taker_action_namespaceObject.ShouldGoToNextTestlet(false));
                _this.dispatchTestNavigationNextAction();
            }
            _this.store.dispatch(new app_ui_action_namespaceObject.HideLoadingOverlay());
        });
        this.navigationInProgress$ = this.store.select(reducers_getIsNavigatingInProgress);
        this.navigationInProgressSubscription = this.navigationInProgress$.subscribe(function (navigationInProgress) {
            _this.navigationInProgress = false;
        });
        this.testNavigationSubscription = store.select(reducers_getTestNavigation).subscribe(function (testNavigation) { return _this.testNavigation = testNavigation; });
        this.testletHistorySubscription = store.select(reducers_getTestletHistory).subscribe(function (testletHistory) { return _this.testletHistory = testletHistory; });
    }
    TestNavigationService.prototype.ngOnDestroy = function () {
        if (this.shouldGoToNextTestletSubscription) {
            this.shouldGoToNextTestletSubscription.unsubscribe();
        }
        if (this.testNavigationSubscription) {
            this.testNavigationSubscription.unsubscribe();
        }
        if (this.testletHistorySubscription) {
            this.testletHistorySubscription.unsubscribe();
        }
        if (this.navigationInProgressSubscription) {
            this.navigationInProgressSubscription.unsubscribe();
        }
    };
    TestNavigationService.prototype.goNext = function (shouldValidateResponses) {
        var _this = this;
        this.store.dispatch(new app_ui_action_namespaceObject.HideLoadingOverlay());
        var nextItemIndex = this.getItemIndexInNextGroup();
        if (nextItemIndex) {
            var nextAction = function () { return _this.changeAssessmentItem(nextItemIndex); };
            if (shouldValidateResponses) {
                this.checkMinWordCountRequirement(nextAction);
            }
            else {
                nextAction();
            }
        }
        else {
            var nextAction = function () {
                if (!config_helper_ConfigHelper.isPreviewMode()) {
                    if (config_helper_ConfigHelper.isIppMode() && _this.interactionComponentWithPreFlushProcessing) {
                        _this.interactionComponentWithPreFlushProcessing.runPreFlushProcessing();
                    }
                    _this.responseService.flush(false)
                        .catch(function () {
                        _this.store.dispatch(new app_ui_action_namespaceObject.HideLoadingOverlay());
                        _this.myModal.showRegularDlg("Error", Navigation_Response_Saving);
                    });
                }
                else {
                    _this.dispatchTestNavigationNextAction();
                }
            };
            if (shouldValidateResponses) {
                this.checkMinWordCountRequirement(nextAction);
            }
            else {
                nextAction();
            }
        }
    };
    TestNavigationService.prototype.getTestlets = function (assessmentTest) {
        return [].concat.apply([], assessmentTest.TestParts.map(function (p, testPartIndex) { return p.AssessmentSectionRefs.map(function (x, testletIndex) {
            return {
                name: x.Href,
                testletId: x.TestletId,
                title: x.PageHeader ? x.PageHeader : x.Href,
                testNavigation: {
                    dateAdded: new Date(),
                    testPartIndex: testPartIndex,
                    testletIndex: testletIndex,
                    canGoNext: true,
                    isEndOfTest: false
                },
                isSelected: testPartIndex === 0 && testletIndex === 0
            };
        }); }));
    };
    TestNavigationService.prototype.getTestletsByTestPart = function (testPart, testPartIndex) {
        return [].concat.apply([], testPart.AssessmentSectionRefs.map(function (x, testletIndex) {
            return {
                name: x.Href,
                testletId: x.TestletId,
                title: x.PageHeader ? x.PageHeader : x.Href,
                testNavigation: {
                    testPartIndex: testPartIndex,
                    testletIndex: testletIndex,
                    canGoNext: true,
                    isEndOfTest: false
                },
                isSelected: testPartIndex === 0 && testletIndex === 0
            };
        }));
    };
    TestNavigationService.prototype.checkMinWordCountRequirement = function (executeNextCallback) {
        var _this = this;
        var meetMinWordCountRequirement = true;
        var activeAssessmentItem = this.testContentService.activeAssessmentItem;
        var referencedInteractions = this.testContentService.getReferencedInteractionsByItemGroup(this.testContentService.activeTestlet, activeAssessmentItem.GroupNumber);
        var extendedTextInteraction = referencedInteractions.find(function (x) { return x.ExtendedTextInteraction != null; });
        if (extendedTextInteraction) {
            var response = this.responseService.getResponse(extendedTextInteraction);
            meetMinWordCountRequirement = this.responseService.meetMinWordCountRequirement(extendedTextInteraction.ExtendedTextInteraction, response);
        }
        if (!meetMinWordCountRequirement) {
            var keepWorkingLabel = "Keep working";
            this.myModal.showRegularDlg("Confirmation", "You have not written the minimum recommended number of words. Would you like to move on?", [
                { label: "No", style: 'btn-success' },
                { label: "Yes", style: '' }
            ])
                .then(function (button) {
                if (button != "No") {
                    _this.testTakerService.cacheTestTakerActivity(TestTakerActivityTypeEnum.IgnoreMinWordCountWarningYes, null, null, _this.testContentService.activeTestletId);
                    if (referencedInteractions.length == 1) {
                        _this.dispatchTestNavigationNextAction();
                    }
                    else {
                        _this.checkForUnansweredInteractions(executeNextCallback);
                    }
                }
                else {
                    _this.testTakerService.cacheTestTakerActivity(TestTakerActivityTypeEnum.IgnoreMinWordCountWarningNo, null, null, _this.testContentService.activeTestletId);
                }
            });
        }
        else {
            if (extendedTextInteraction != null) {
                this.showConfirmationDialog(executeNextCallback);
            }
            else {
                this.checkForUnansweredInteractions(executeNextCallback);
            }
        }
    };
    TestNavigationService.prototype.showConfirmationDialog = function (executeNextCallback) {
        var _this = this;
        var skipLabel = "Skip and go to the next page";
        this.myModal.showRegularDlg("Confirmation", "Make sure you have completed this task as you cannot come back after going to the next page.", [
            { label: "Keep working", style: 'btn-success' },
            { label: skipLabel, style: '' }
        ])
            .then(function (button) {
            if (button == skipLabel) {
                _this.checkForUnansweredInteractions(executeNextCallback);
            }
        });
    };
    TestNavigationService.prototype.checkForUnansweredInteractions = function (executeNextCallback) {
        var _this = this;
        var unansweredInteractionCount = this.responseService.getUnansweredInteractionCountInItemGroup(this.testContentService.activeTestlet, this.testContentService.activeAssessmentItem.GroupNumber);
        if (unansweredInteractionCount > 0) {
            var keepWorkingLabel_1 = "Keep working";
            this.myModal.showRegularDlg("Confirmation", "You have not answered all the questions. If you go to the next page, you will no longer be able to answer these questions.", [
                { label: keepWorkingLabel_1, style: 'btn-success' },
                { label: 'Skip and go to the next page', style: '' }
            ])
                .then(function (button) {
                if (button != keepWorkingLabel_1) {
                    _this.testTakerService.cacheTestTakerActivity(TestTakerActivityTypeEnum.IgnoreUnansweredInteractionWarningYes, null, null, _this.testContentService.activeTestletId);
                    executeNextCallback();
                }
                else {
                    _this.testTakerService.cacheTestTakerActivity(TestTakerActivityTypeEnum.IgnoreUnansweredInteractionWarningNo, null, null, _this.testContentService.activeTestletId);
                }
            });
        }
        else {
            executeNextCallback();
        }
    };
    TestNavigationService.prototype.changeAssessmentItem = function (index) {
        this.store.dispatch(new test_taker_action_namespaceObject.ToggleTimerVisibility(true));
        this.store.dispatch(new test_taker_action_namespaceObject.SetItemIndex(index));
    };
    TestNavigationService.prototype.getItemIndexInNextGroup = function () {
        var currentTestlet = this.testContentService.activeTestlet;
        var activeAssessmentItem = this.testContentService.activeAssessmentItem;
        if (activeAssessmentItem && !this.isLastAssessmentItemGroup(activeAssessmentItem.GroupNumber, currentTestlet)) {
            return activeAssessmentItem.ItemIndex + 1;
        }
        return null;
    };
    TestNavigationService.prototype.setCanGoNext = function (canGoNext) {
        var testTakerInfo = this.testTakerService.testTakerInfo;
        if (config_helper_ConfigHelper.shouldAlwaysHideNextButton()) {
            this.store.dispatch(new test_taker_action_namespaceObject.SetCanGoNext(false));
        }
        else {
            this.store.dispatch(new test_taker_action_namespaceObject.SetCanGoNext(canGoNext));
        }
    };
    TestNavigationService.prototype.indicateEndOfTest = function (testletId) {
        this.testTakerService.saveTestTakerActivityWithoutCaching(TestTakerActivityTypeEnum.LeaveTestlet, null, null, testletId);
        this.testTakerService.saveTestTakerActivityWithoutCaching(TestTakerActivityTypeEnum.TestEnd);
        this.store.dispatch(new test_taker_action_namespaceObject.IndicateEndOfTest());
    };
    TestNavigationService.prototype.isLastAssessmentItemGroup = function (groupNumber, testlet) {
        return groupNumber >= lodash["max"](testlet.AssessmentItems.map(function (x) { return x.GroupNumber; }));
    };
    TestNavigationService.prototype.dispatchTestNavigationNextAction = function () {
        if (this.shouldDiscardNavigationNextAction()) {
            return;
        }
        this.navigationInProgress = true;
        if (!this.timerService.isPaused()) {
            this.timerService.pauseTimer();
        }
        var testPartIndex = this.testNavigation ? this.testNavigation.testPartIndex : 0;
        var testletIndex = this.testNavigation ? this.testNavigation.testletIndex : 0;
        this.store.dispatch(new test_taker_action_namespaceObject.TestNavigationNext(testPartIndex, testletIndex));
    };
    TestNavigationService.prototype.shouldDiscardNavigationNextAction = function () {
        if (config_helper_ConfigHelper.isTdpMode()) {
            var now = moment(new Date());
            var testNavigationDateAdded = moment(this.testNavigation.dateAdded);
            var duration = moment["duration"](now.diff(testNavigationDateAdded)).asSeconds();
            return this.navigationInProgress || duration < 15;
        }
        else {
            return this.navigationInProgress;
        }
    };
    TestNavigationService.prototype.onUnload = function (event) {
        event.preventDefault();
        event.returnValue = '';
    };
    TestNavigationService.prototype.enableWindowUnloadingWarning = function () {
        window.addEventListener('beforeunload', this.onUnload);
    };
    TestNavigationService.prototype.disableWindowUnloadingWarning = function () {
        window.removeEventListener('beforeunload', this.onUnload);
    };
    return TestNavigationService;
}());
test_navigation_service_TestNavigationService = test_navigation_service___decorate([
    Object(core_es5["C" /* Injectable */])(),
    test_navigation_service___metadata("design:paramtypes", [typeof (test_navigation_service__a = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && test_navigation_service__a || Object, typeof (test_navigation_service__b = typeof my_modal_component_MyModal !== "undefined" && my_modal_component_MyModal) === "function" && test_navigation_service__b || Object, typeof (test_navigation_service__c = typeof test_taker_service_TestTakerService !== "undefined" && test_taker_service_TestTakerService) === "function" && test_navigation_service__c || Object, typeof (test_navigation_service__d = typeof response_service_ResponseService !== "undefined" && response_service_ResponseService) === "function" && test_navigation_service__d || Object, typeof (test_navigation_service__e = typeof test_content_service_TestContentService !== "undefined" && test_content_service_TestContentService) === "function" && test_navigation_service__e || Object, typeof (test_navigation_service__f = typeof timer_service_TimerService !== "undefined" && timer_service_TimerService) === "function" && test_navigation_service__f || Object, typeof (test_navigation_service__g = typeof LoggerService !== "undefined" && LoggerService) === "function" && test_navigation_service__g || Object])
], test_navigation_service_TestNavigationService);

var test_navigation_service__a, test_navigation_service__b, test_navigation_service__c, test_navigation_service__d, test_navigation_service__e, test_navigation_service__f, test_navigation_service__g;
//# sourceMappingURL=test-navigation.service.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/services/repeatable-random-generator.service.ts
//source: http://www.honeylocust.com/javascript/randomizer.html
var repeatable_random_generator_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var repeatable_random_generator_service_RepeatableRandomGeneratorService = (function () {
    function RepeatableRandomGeneratorService() {
        this.initialSeed = 1;
        this.seed = 1;
    }
    RepeatableRandomGeneratorService.prototype.setSeed = function (seed) {
        this.initialSeed = seed;
        this.seed = seed;
    };
    RepeatableRandomGeneratorService.prototype.getRandomNumber = function (min, max) {
        this.seed = (this.seed * 9301 + 49297) % 233280;
        var rnd = this.seed / 233280;
        return min + rnd * (max - min);
    };
    RepeatableRandomGeneratorService.prototype.randomizeArray = function (list) {
        this.seed = this.initialSeed;
        for (var index = 0; index < list.length; index++) {
            var element = list[index];
            element._randomizeSortOrder = this.getRandomNumber(0, 1000);
        }
        var sortedList = lodash["sortBy"](list, "_randomizeSortOrder");
        for (var index = 0; index < sortedList.length; index++) {
            var element = sortedList[index];
            delete element._randomizeSortOrder;
        }
        return sortedList;
    };
    return RepeatableRandomGeneratorService;
}());
repeatable_random_generator_service_RepeatableRandomGeneratorService = repeatable_random_generator_service___decorate([
    Object(core_es5["C" /* Injectable */])()
], repeatable_random_generator_service_RepeatableRandomGeneratorService);

//# sourceMappingURL=repeatable-random-generator.service.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/common/loading-overlay/loading-overlay.component.ts
var loading_overlay_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var loading_overlay_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var LoadingOverlayComponent = (function () {
    function LoadingOverlayComponent() {
    }
    return LoadingOverlayComponent;
}());
loading_overlay_component___decorate([
    Object(core_es5["F" /* Input */])(),
    loading_overlay_component___metadata("design:type", Boolean)
], LoadingOverlayComponent.prototype, "loading", void 0);
LoadingOverlayComponent = loading_overlay_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'loading-overlay',
        template: __webpack_require__("ZWZZ"),
        changeDetection: core_es5["k" /* ChangeDetectionStrategy */].OnPush
    })
], LoadingOverlayComponent);

//# sourceMappingURL=loading-overlay.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/common/info-box/info-box.component.ts
var info_box_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var info_box_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var InfoBoxComponent = (function () {
    function InfoBoxComponent() {
        this.iconCover = 100;
    }
    return InfoBoxComponent;
}());
info_box_component___decorate([
    Object(core_es5["F" /* Input */])(),
    info_box_component___metadata("design:type", Boolean)
], InfoBoxComponent.prototype, "visible", void 0);
info_box_component___decorate([
    Object(core_es5["F" /* Input */])(),
    info_box_component___metadata("design:type", String)
], InfoBoxComponent.prototype, "text", void 0);
info_box_component___decorate([
    Object(core_es5["F" /* Input */])(),
    info_box_component___metadata("design:type", String)
], InfoBoxComponent.prototype, "counterText", void 0);
info_box_component___decorate([
    Object(core_es5["F" /* Input */])(),
    info_box_component___metadata("design:type", String)
], InfoBoxComponent.prototype, "iconCssClass", void 0);
info_box_component___decorate([
    Object(core_es5["F" /* Input */])(),
    info_box_component___metadata("design:type", Number)
], InfoBoxComponent.prototype, "progressPercentage", void 0);
info_box_component___decorate([
    Object(core_es5["F" /* Input */])(),
    info_box_component___metadata("design:type", Number)
], InfoBoxComponent.prototype, "iconCover", void 0);
info_box_component___decorate([
    Object(core_es5["F" /* Input */])(),
    info_box_component___metadata("design:type", String)
], InfoBoxComponent.prototype, "mode", void 0);
info_box_component___decorate([
    Object(core_es5["F" /* Input */])(),
    info_box_component___metadata("design:type", Boolean)
], InfoBoxComponent.prototype, "forMicrophoneCheck", void 0);
InfoBoxComponent = info_box_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'info-box',
        template: __webpack_require__("25aa")
    })
], InfoBoxComponent);

//# sourceMappingURL=info-box.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/common/generic-page/generic-page.component.ts
var generic_page_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var generic_page_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var generic_page_component_GenericPageComponent = (function () {
    function GenericPageComponent(store, changeDetectorRef, timerService) {
        this.store = store;
        this.changeDetectorRef = changeDetectorRef;
        this.timerService = timerService;
    }
    GenericPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.genericPageDataSubscription = this.store.select(reducers_getGenericPage).subscribe(function (genericPage) {
            _this.title = genericPage.title;
            _this.content = genericPage.content;
            _this.visible = genericPage.visible;
            if (genericPage.redirectUrl) {
                setTimeout(function () { window.location.href = genericPage.redirectUrl; }, 1000);
            }
            if (genericPage.isNonRecoverable) {
                _this.timerService.pauseTimer();
            }
            _this.changeDetectorRef.markForCheck();
        });
    };
    GenericPageComponent.prototype.ngOnDestroy = function () {
        this.genericPageDataSubscription.unsubscribe();
    };
    return GenericPageComponent;
}());
generic_page_component_GenericPageComponent = generic_page_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'generic-page',
        template: __webpack_require__("m/j0"),
        changeDetection: core_es5["k" /* ChangeDetectionStrategy */].OnPush
    }),
    generic_page_component___metadata("design:paramtypes", [typeof (generic_page_component__a = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && generic_page_component__a || Object, typeof (generic_page_component__b = typeof core_es5["l" /* ChangeDetectorRef */] !== "undefined" && core_es5["l" /* ChangeDetectorRef */]) === "function" && generic_page_component__b || Object, typeof (generic_page_component__c = typeof timer_service_TimerService !== "undefined" && timer_service_TimerService) === "function" && generic_page_component__c || Object])
], generic_page_component_GenericPageComponent);

var generic_page_component__a, generic_page_component__b, generic_page_component__c;
//# sourceMappingURL=generic-page.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/common/audio-recording/pg-recorder.ts
var PgRecorder = (function () {
    function PgRecorder(stream) {
        var _this = this;
        this.recordingChunks = [];
        this.mediaRecorder = new MediaRecorder(stream);
        this.mediaRecorder.ondataavailable = function (e) {
            _this.recordingChunks.push(e.data);
        };
        this.context = new AudioContext();
        this.audioInput = this.context.createMediaStreamSource(stream);
        this.recorder = this.context.createScriptProcessor(4096, 1, 1);
        this.analyser = this.context.createAnalyser();
        this.analyser.smoothingTimeConstant = 0.3;
        this.analyser.fftSize = 1024;
    }
    PgRecorder.create = function (loggerService) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                //log available devices
                navigator.mediaDevices.enumerateDevices()
                    .then(function (devices) {
                    devices.forEach(function (device) {
                        loggerService.reportDebugInfo("enumerateDevices", device.kind + ": " + device.label + " id = " + device.deviceId);
                    });
                })
                    .catch(function (e) {
                    loggerService.reportError("enumerateDevices", {
                        name: e.name,
                        message: e.message
                    });
                });
                //todo: remove casting to Promise<MediaStream> after typescript 2.1 fix this issue
                //https://github.com/Microsoft/TypeScript/issues/10242
                navigator.mediaDevices.getUserMedia({ audio: true })
                    .then(function (stream) {
                    if (loggerService) {
                        loggerService.reportDebugInfo(PgRecorder.name, "getUserMedia: MediaStream Id: " + stream.id);
                    }
                    resolve(new PgRecorder(stream));
                })
                    .catch(function (e) {
                    reject(e);
                    if (loggerService) {
                        loggerService.reportError(PgRecorder.name, {
                            name: e.name,
                            message: e.message
                        });
                    }
                });
            }, 400);
        });
    };
    PgRecorder.prototype.start = function (onStopCallback) {
        var _this = this;
        this.audioInput.connect(this.analyser);
        this.analyser.connect(this.recorder);
        this.audioInput.connect(this.recorder);
        this.recorder.connect(this.context.destination);
        this.onStopCallback = onStopCallback;
        this.mediaRecorder.onstop = function () {
            if (_this.onStopCallback) {
                _this.onStopCallback();
            }
        };
        this.mediaRecorder.start(1000);
    };
    PgRecorder.prototype.stop = function () {
        this.analyser.disconnect();
        this.audioInput.disconnect();
        this.recorder.disconnect();
        this.mediaRecorder.stop();
    };
    PgRecorder.prototype.getBlob = function () {
        var blob = new Blob(this.recordingChunks);
        this.recordingChunks = [];
        return blob;
    };
    PgRecorder.prototype.play = function (audio) {
        audio.src = window.URL.createObjectURL(this.getBlob());
    };
    PgRecorder.prototype.export = function (callback) {
        var url = window.URL.createObjectURL(this.getBlob());
        callback(url);
    };
    PgRecorder.prototype.getInputActivityLevel = function () {
        var array = new Uint8Array(this.analyser.frequencyBinCount);
        this.analyser.getByteFrequencyData(array);
        var values = 0;
        var length = array.length;
        for (var i = 0; i < length; i++) {
            values += array[i];
        }
        var average = values / length;
        return average;
    };
    return PgRecorder;
}());

//# sourceMappingURL=pg-recorder.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/common/microphone-check/microphone-check.component.ts
var microphone_check_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var microphone_check_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var microphone_check_component_MicrophoneCheckComponent = (function () {
    function MicrophoneCheckComponent(elementRef, myModal, loggerService, ngZone) {
        var _this = this;
        this.elementRef = elementRef;
        this.myModal = myModal;
        this.loggerService = loggerService;
        this.ngZone = ngZone;
        this.microphoneCheckCompleted = new core_es5["x" /* EventEmitter */]();
        this.step = 1;
        this.playRecording = function () {
            _this.ngZone.run(function () {
                _this.step = 3;
                _this.currentProgress = 0;
                _this.infoBoxVisible = true;
                _this.infoBoxText = "Playing...";
                _this.infoBoxMode = "ProgressBar";
                _this.iconCssClass = 'play-icon';
                _this.playbackSubscription = Rx["Observable"].interval(1000)
                    .take(_this.recordingTime + 1)
                    .subscribe(function (x) {
                    var timeElapsed = x + 1;
                    _this.currentProgress = _this.setProgress(timeElapsed, _this.recordingTime);
                }, null, function () {
                    _this.step = 4;
                    _this.infoBoxVisible = false;
                });
                var audio = document.getElementById('audio-player');
                _this.recorder.play(audio);
            });
        };
        this.isWebDelivery = config_helper_ConfigHelper.isTdpMode(true);
    }
    MicrophoneCheckComponent.prototype.ngOnInit = function () {
        this.recordingTime = 25;
    };
    MicrophoneCheckComponent.prototype.ngOnDestroy = function () {
        if (this.recordingSubscription) {
            this.recordingSubscription.unsubscribe();
        }
        if (this.playbackSubscription) {
            this.playbackSubscription.unsubscribe();
        }
        if (this.inputActivitySubscription) {
            this.inputActivitySubscription.unsubscribe();
        }
    };
    MicrophoneCheckComponent.prototype.ngAfterViewInit = function () {
        this.silentClipAudio = this.createAudioElement("silent_clip.mp3");
    };
    MicrophoneCheckComponent.prototype.createAudioElement = function (src) {
        var elem = this.elementRef.nativeElement;
        var audioElem = document.createElement("audio");
        audioElem.autoplay = false;
        audioElem.controls = false;
        audioElem.autoplay = false;
        audioElem.src = config_helper_ConfigHelper.getAudioAssetUrl() + "/" + src;
        elem.appendChild(audioElem);
        return audioElem;
    };
    MicrophoneCheckComponent.prototype.startRecording = function () {
        var _this = this;
        this.silentClipAudio.play();
        PgRecorder.create(this.loggerService)
            .then(function (recorder) {
            _this.recorder = recorder;
            _this.step = 2;
            _this.currentProgress = 0;
            _this.recorder.start(_this.playRecording);
            _this.infoBoxVisible = true;
            _this.infoBoxText = "Recording...";
            _this.infoBoxMode = "ProgressBar";
            _this.iconCssClass = 'rec-icon';
            _this.recordingSubscription = Rx["Observable"].interval(1000)
                .take(_this.recordingTime)
                .subscribe(function (x) {
                var timeElapsed = x + 1;
                _this.currentProgress = _this.setProgress(timeElapsed, _this.recordingTime);
                if (timeElapsed >= _this.recordingTime) {
                    _this.stopRecording();
                }
            });
            _this.inputActivitySubscription = Rx["Observable"].interval(200)
                .subscribe(function (x) {
                _this.inputActivityLevel = 100 - _this.recorder.getInputActivityLevel();
            });
        })
            .catch(function (error) {
            var retry = "Retry";
            var cancel = "Cancel";
            var options = [{ label: retry, style: "btn-primary" }];
            if (config_helper_ConfigHelper.canSkipMicrophoneCheck()) {
                options.push({ label: cancel, style: "btn-secondary" });
            }
            _this.myModal.showRegularDlg("Error", config_helper_ConfigHelper.isTdpMode() ? Microphone_Check_With_Code : Microphone_Check, options)
                .then(function (x) {
                switch (x) {
                    case cancel:
                        break;
                    case retry:
                        _this.startRecording();
                        break;
                }
            });
        });
    };
    MicrophoneCheckComponent.prototype.stopRecording = function () {
        if (this.recordingSubscription) {
            this.recordingSubscription.unsubscribe();
        }
        if (this.inputActivitySubscription) {
            this.inputActivitySubscription.unsubscribe();
        }
        this.inputActivityLevel = 100;
        this.recorder.stop();
    };
    MicrophoneCheckComponent.prototype.setProgress = function (current, totalTime) {
        return (current / totalTime) * 100;
    };
    MicrophoneCheckComponent.prototype.badRecording = function () {
        var _this = this;
        this.ngZone.run(function () {
            _this.step = 5;
        });
    };
    MicrophoneCheckComponent.prototype.goodRecording = function () {
        this.microphoneCheckCompleted.emit("done");
    };
    return MicrophoneCheckComponent;
}());
microphone_check_component___decorate([
    Object(core_es5["U" /* Output */])(),
    microphone_check_component___metadata("design:type", typeof (microphone_check_component__a = typeof core_es5["x" /* EventEmitter */] !== "undefined" && core_es5["x" /* EventEmitter */]) === "function" && microphone_check_component__a || Object)
], microphone_check_component_MicrophoneCheckComponent.prototype, "microphoneCheckCompleted", void 0);
microphone_check_component_MicrophoneCheckComponent = microphone_check_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'microphone-check',
        template: __webpack_require__("kmoa")
    }),
    microphone_check_component___metadata("design:paramtypes", [typeof (microphone_check_component__b = typeof core_es5["v" /* ElementRef */] !== "undefined" && core_es5["v" /* ElementRef */]) === "function" && microphone_check_component__b || Object, typeof (microphone_check_component__c = typeof my_modal_component_MyModal !== "undefined" && my_modal_component_MyModal) === "function" && microphone_check_component__c || Object, typeof (microphone_check_component__d = typeof LoggerService !== "undefined" && LoggerService) === "function" && microphone_check_component__d || Object, typeof (microphone_check_component__e = typeof core_es5["R" /* NgZone */] !== "undefined" && core_es5["R" /* NgZone */]) === "function" && microphone_check_component__e || Object])
], microphone_check_component_MicrophoneCheckComponent);

var microphone_check_component__a, microphone_check_component__b, microphone_check_component__c, microphone_check_component__d, microphone_check_component__e;
//# sourceMappingURL=microphone-check.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/common/start-screen/start-screen-photo.component.ts
var start_screen_photo_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var start_screen_photo_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var start_screen_photo_component_StartScreenPhotoComponent = (function () {
    function StartScreenPhotoComponent() {
        this.showLocalLanguageNames = false;
        this.label = "STATION";
    }
    Object.defineProperty(StartScreenPhotoComponent.prototype, "testTakerInfo", {
        set: function (value) {
            this._testTakerInfo = value;
            if ((this._testTakerInfo.FirstNameLocalLanguage != null && this._testTakerInfo.FirstNameLocalLanguage !== '') || (this._testTakerInfo.LastNameLocalLanguage != null && this._testTakerInfo.LastNameLocalLanguage !== '')) {
                this.showLocalLanguageNames = true;
            }
        },
        enumerable: true,
        configurable: true
    });
    StartScreenPhotoComponent.prototype.ngOnInit = function () {
        if (config_helper_ConfigHelper.isTdpMode(true)) {
            this.label = "Registration Number";
        }
    };
    return StartScreenPhotoComponent;
}());
start_screen_photo_component___decorate([
    Object(core_es5["F" /* Input */])(),
    start_screen_photo_component___metadata("design:type", Number)
], start_screen_photo_component_StartScreenPhotoComponent.prototype, "stationNumber", void 0);
start_screen_photo_component___decorate([
    Object(core_es5["F" /* Input */])(),
    start_screen_photo_component___metadata("design:type", String)
], start_screen_photo_component_StartScreenPhotoComponent.prototype, "testTakerPhotoUrl", void 0);
start_screen_photo_component___decorate([
    Object(core_es5["F" /* Input */])(),
    start_screen_photo_component___metadata("design:type", Object),
    start_screen_photo_component___metadata("design:paramtypes", [Object])
], start_screen_photo_component_StartScreenPhotoComponent.prototype, "testTakerInfo", null);
start_screen_photo_component_StartScreenPhotoComponent = start_screen_photo_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'start-screen-photo',
        template: __webpack_require__("qAGO")
    })
], start_screen_photo_component_StartScreenPhotoComponent);

//# sourceMappingURL=start-screen-photo.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/common/shared.module.ts
var shared_module___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var SharedModule = (function () {
    function SharedModule() {
    }
    return SharedModule;
}());
SharedModule = shared_module___decorate([
    Object(core_es5["M" /* NgModule */])({
        imports: [
            platform_browser_es5["a" /* BrowserModule */]
        ],
        declarations: [
            LoadingOverlayComponent,
            InfoBoxComponent,
            generic_page_component_GenericPageComponent,
            microphone_check_component_MicrophoneCheckComponent,
            start_screen_photo_component_StartScreenPhotoComponent
        ],
        exports: [
            LoadingOverlayComponent,
            InfoBoxComponent,
            generic_page_component_GenericPageComponent,
            microphone_check_component_MicrophoneCheckComponent,
            start_screen_photo_component_StartScreenPhotoComponent
        ]
    })
], SharedModule);

//# sourceMappingURL=shared.module.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/resource/resource.component.ts
var resource_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var resource_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var ResourceComponent = (function () {
    function ResourceComponent() {
        this.autoplay = true;
        this.hidepdf = false;
    }
    ResourceComponent.prototype.ngOnInit = function () {
        if (this.attr) {
            if (this.attr.indexOf("no-autoplay") >= 0) {
                this.autoplay = false;
            }
            if (this.attr.indexOf("hide-pdf") >= 0) {
                this.hidepdf = true;
            }
        }
    };
    return ResourceComponent;
}());
resource_component___decorate([
    Object(core_es5["F" /* Input */])(),
    resource_component___metadata("design:type", String)
], ResourceComponent.prototype, "type", void 0);
resource_component___decorate([
    Object(core_es5["F" /* Input */])(),
    resource_component___metadata("design:type", Number)
], ResourceComponent.prototype, "id", void 0);
resource_component___decorate([
    Object(core_es5["F" /* Input */])(),
    resource_component___metadata("design:type", String)
], ResourceComponent.prototype, "attr", void 0);
ResourceComponent = resource_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'resource',
        template: __webpack_require__("k4W2")
    })
], ResourceComponent);

//# sourceMappingURL=resource.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/resource/slide-deck/slide-deck.component.ts
var slide_deck_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var slide_deck_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var SlideDeckComponent = (function () {
    function SlideDeckComponent(htmlService) {
        this.htmlService = htmlService;
    }
    SlideDeckComponent.prototype.ngOnChanges = function () {
        this.currentIndex = 0;
        this.updatePicUrl();
    };
    SlideDeckComponent.prototype.prev = function () {
        if (this.currentIndex >= 1) {
            this.currentIndex--;
            this.updatePicUrl();
        }
    };
    SlideDeckComponent.prototype.next = function () {
        if (this.currentIndex < this.pics.length - 1) {
            this.currentIndex++;
            this.updatePicUrl();
        }
    };
    SlideDeckComponent.prototype.updatePicUrl = function () {
        if (this.pics && this.currentIndex < this.pics.length) {
            this.picUrl = this.htmlService.getResourceUrl(this.pics[this.currentIndex]);
        }
    };
    return SlideDeckComponent;
}());
slide_deck_component___decorate([
    Object(core_es5["F" /* Input */])(),
    slide_deck_component___metadata("design:type", Array)
], SlideDeckComponent.prototype, "pics", void 0);
SlideDeckComponent = slide_deck_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'slide-deck',
        template: __webpack_require__("SCeK"),
    }),
    slide_deck_component___metadata("design:paramtypes", [typeof (slide_deck_component__a = typeof html_service_HtmlService !== "undefined" && html_service_HtmlService) === "function" && slide_deck_component__a || Object])
], SlideDeckComponent);

var slide_deck_component__a;
//# sourceMappingURL=slide-deck.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/resource/picture-resource/picture-resource.component.ts
var picture_resource_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var picture_resource_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var PictureResourceComponent = (function () {
    function PictureResourceComponent(htmlService) {
        this.htmlService = htmlService;
    }
    PictureResourceComponent.prototype.ngOnChanges = function () {
        this.srcUrl = this.htmlService.getResourceUrl(this.id);
    };
    return PictureResourceComponent;
}());
picture_resource_component___decorate([
    Object(core_es5["F" /* Input */])(),
    picture_resource_component___metadata("design:type", Number)
], PictureResourceComponent.prototype, "id", void 0);
PictureResourceComponent = picture_resource_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'picture-resource',
        template: __webpack_require__("I4J1"),
    }),
    picture_resource_component___metadata("design:paramtypes", [typeof (picture_resource_component__a = typeof html_service_HtmlService !== "undefined" && html_service_HtmlService) === "function" && picture_resource_component__a || Object])
], PictureResourceComponent);

var picture_resource_component__a;
//# sourceMappingURL=picture-resource.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/resource/media-resource/media-resource.component.ts
var media_resource_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var media_resource_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var media_resource_component_MediaResourceComponent = (function () {
    function MediaResourceComponent(store, htmlService, loggerService, domSanitizer) {
        this.store = store;
        this.htmlService = htmlService;
        this.loggerService = loggerService;
        this.domSanitizer = domSanitizer;
        this.isPaused = false;
    }
    MediaResourceComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.srcUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(this.htmlService.getResourceUrl(this.id));
        this.infoBoxVisible = false;
        this.isExitScreenVisibleSubscription = this.store.select(reducers_getIsExitScreenVisible).subscribe(function (isExitScreenVisible) {
            if (isExitScreenVisible) {
                _this.isPaused = isExitScreenVisible;
                _this.mediaElement.pause();
            }
            else if (_this.isPaused) {
                _this.isPaused = isExitScreenVisible;
                _this.mediaElement.play();
            }
        });
        this.performanceNow = performance.now();
    };
    MediaResourceComponent.prototype.ngOnDestroy = function () {
        if (this.mediaElement && !this.mediaElement.ended) {
            this.mediaElement.pause();
        }
        if (this.isExitScreenVisibleSubscription) {
            this.isExitScreenVisibleSubscription.unsubscribe();
        }
    };
    MediaResourceComponent.prototype.onPlay = function (e) {
        this.mediaElement = e.target;
        if (config_helper_ConfigHelper.isTdpMode()) {
            this.mediaElement.controls = false;
        }
        this.infoBoxText = "Playing...";
        if (this.type == "audio" && this.autoplay) {
            this.infoBoxVisible = true;
        }
        this.setProgress(e);
    };
    MediaResourceComponent.prototype.onEnded = function (e) {
        this.infoBoxText = "Playback finished.";
        this.setProgress(e);
        var timeElapsed = performance.now() - this.performanceNow;
        this.loggerService.reportDebugInfo("MediaResourceComponent", "Duration: " + this.mediaElement.duration + " TimeTaken: " + timeElapsed);
    };
    MediaResourceComponent.prototype.onTimeupdate = function (e) {
        this.setProgress(e);
    };
    MediaResourceComponent.prototype.onLoadeddata = function (e) {
        if (!this.autoplay) {
            var media = e.target;
            media.pause();
            if (this.audioWrapper) {
                this.infoBoxVisible = false;
                this.audioWrapper.nativeElement.classList.remove("hidden");
            }
        }
    };
    MediaResourceComponent.prototype.setProgress = function (e) {
        var media = e.target;
        if (media.currentTime === 0 || media.duration === 0) {
            return 0;
        }
        var newProgress = Math.round((media.currentTime / media.duration) * 100);
        if (newProgress != this.currentProgress) {
            this.currentProgress = newProgress;
        }
    };
    return MediaResourceComponent;
}());
media_resource_component___decorate([
    Object(core_es5["F" /* Input */])(),
    media_resource_component___metadata("design:type", Number)
], media_resource_component_MediaResourceComponent.prototype, "id", void 0);
media_resource_component___decorate([
    Object(core_es5["F" /* Input */])(),
    media_resource_component___metadata("design:type", String)
], media_resource_component_MediaResourceComponent.prototype, "type", void 0);
media_resource_component___decorate([
    Object(core_es5["F" /* Input */])(),
    media_resource_component___metadata("design:type", Boolean)
], media_resource_component_MediaResourceComponent.prototype, "autoplay", void 0);
media_resource_component___decorate([
    Object(core_es5["_17" /* ViewChild */])('audioWrapper'),
    media_resource_component___metadata("design:type", typeof (media_resource_component__a = typeof core_es5["v" /* ElementRef */] !== "undefined" && core_es5["v" /* ElementRef */]) === "function" && media_resource_component__a || Object)
], media_resource_component_MediaResourceComponent.prototype, "audioWrapper", void 0);
media_resource_component_MediaResourceComponent = media_resource_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'media-resource',
        template: __webpack_require__("8h0P")
    }),
    media_resource_component___metadata("design:paramtypes", [typeof (media_resource_component__b = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && media_resource_component__b || Object, typeof (media_resource_component__c = typeof html_service_HtmlService !== "undefined" && html_service_HtmlService) === "function" && media_resource_component__c || Object, typeof (media_resource_component__d = typeof LoggerService !== "undefined" && LoggerService) === "function" && media_resource_component__d || Object, typeof (media_resource_component__e = typeof platform_browser_es5["b" /* DomSanitizer */] !== "undefined" && platform_browser_es5["b" /* DomSanitizer */]) === "function" && media_resource_component__e || Object])
], media_resource_component_MediaResourceComponent);

var media_resource_component__a, media_resource_component__b, media_resource_component__c, media_resource_component__d, media_resource_component__e;
//# sourceMappingURL=media-resource.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/resource/pdf-resource/pdf-resource.component.ts
var pdf_resource_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var pdf_resource_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var PDFResourceComponent = (function () {
    function PDFResourceComponent(htmlService, domSanitizer) {
        this.htmlService = htmlService;
        this.domSanitizer = domSanitizer;
    }
    PDFResourceComponent.prototype.ngOnChanges = function () {
        var _this = this;
        var url = this.htmlService.getResourceUrl(this.id);
        this.srcUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
        this.htmlService.getResourceTranscript(this.id).subscribe(function (resourceDto) {
            if (!_this.hidepdf) {
                if (resourceDto.Name.includes('notoolbar')) {
                    url += '#toolbar=0';
                    _this.srcUrl = _this.domSanitizer.bypassSecurityTrustResourceUrl(url);
                }
            }
            else {
                _this.label = resourceDto.Name;
            }
        });
    };
    return PDFResourceComponent;
}());
pdf_resource_component___decorate([
    Object(core_es5["F" /* Input */])(),
    pdf_resource_component___metadata("design:type", Number)
], PDFResourceComponent.prototype, "id", void 0);
pdf_resource_component___decorate([
    Object(core_es5["F" /* Input */])(),
    pdf_resource_component___metadata("design:type", Boolean)
], PDFResourceComponent.prototype, "hidepdf", void 0);
PDFResourceComponent = pdf_resource_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'pdf-resource',
        template: __webpack_require__("6wyb"),
    }),
    pdf_resource_component___metadata("design:paramtypes", [typeof (pdf_resource_component__a = typeof html_service_HtmlService !== "undefined" && html_service_HtmlService) === "function" && pdf_resource_component__a || Object, typeof (pdf_resource_component__b = typeof platform_browser_es5["b" /* DomSanitizer */] !== "undefined" && platform_browser_es5["b" /* DomSanitizer */]) === "function" && pdf_resource_component__b || Object])
], PDFResourceComponent);

var pdf_resource_component__a, pdf_resource_component__b;
//# sourceMappingURL=pdf-resource.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/resource/html-resource/html-resource.component.ts
var html_resource_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var html_resource_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var HtmlResourceComponent = (function () {
    function HtmlResourceComponent(htmlService, elemRef) {
        this.htmlService = htmlService;
        this.elemRef = elemRef;
        this.elemRef = elemRef;
    }
    HtmlResourceComponent.prototype.ngOnChanges = function () {
        var _this = this;
        this.htmlService.getHtmlResource(this.id).subscribe(function (x) {
            _this.html = x;
            _this.initHighlighter();
            var previousHighlights = _this.htmlService.getSerializedHighlights(_this.id);
            if (previousHighlights) {
                setTimeout(function () {
                    _this.highlighter.deserializeHighlights(previousHighlights.HighlightedText);
                }, 500);
            }
        });
    };
    HtmlResourceComponent.prototype.ngOnDestroy = function () {
        if (this.highlighter) {
            this.highlighter.destroy();
        }
    };
    HtmlResourceComponent.prototype.initHighlighter = function () {
        var _this = this;
        if (this.highlighter) {
            this.highlighter.destroy();
        }
        var sandbox = this.elemRef.nativeElement;
        this.highlighter = new TextHighlighter(sandbox, {
            onBeforeHighlight: function (range) {
                if (range) {
                    // wait for commonAncestorContainer to be initialised
                    setTimeout(function () {
                        if (range.commonAncestorContainer.className === "highlighted") {
                            if (range.endContainer.data && range.endContainer.data.trim() == "") {
                                return false;
                            }
                            _this.highlighter.removeHighlights(range.commonAncestorContainer);
                            return false;
                        }
                    }, 100);
                    return true;
                }
            },
            onAfterHighlight: function (range, hlts) {
                // update state: save highlights (triggered on remove as well)
                // 0.5s delay to allow highlighter to refresh currently highlighted text
                setTimeout(function () {
                    var dto = {
                        ResourceId: _this.id,
                        HighlightedText: _this.highlighter.serializeHighlights()
                    };
                    _this.htmlService.setSerializedHighlights(dto);
                }, 500);
            }
        });
        this.highlighter.setColor('#FFFF7B');
    };
    return HtmlResourceComponent;
}());
html_resource_component___decorate([
    Object(core_es5["F" /* Input */])(),
    html_resource_component___metadata("design:type", Number)
], HtmlResourceComponent.prototype, "id", void 0);
HtmlResourceComponent = html_resource_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'html-resource',
        template: __webpack_require__("Oa82"),
    }),
    html_resource_component___metadata("design:paramtypes", [typeof (html_resource_component__a = typeof html_service_HtmlService !== "undefined" && html_service_HtmlService) === "function" && html_resource_component__a || Object, typeof (html_resource_component__b = typeof core_es5["v" /* ElementRef */] !== "undefined" && core_es5["v" /* ElementRef */]) === "function" && html_resource_component__b || Object])
], HtmlResourceComponent);

var html_resource_component__a, html_resource_component__b;
//# sourceMappingURL=html-resource.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/resource/auto-play-resource/auto-play-resource.component.ts
var auto_play_resource_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var auto_play_resource_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var auto_play_resource_component_AutoPlayResourceComponent = (function () {
    function AutoPlayResourceComponent(timerService) {
        this.timerService = timerService;
        this.resourceVisible = false;
        this.skipHotKeyPressed = false;
    }
    AutoPlayResourceComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.time *= this.timerService.timer.multiplier;
        this.timeLeft = this.time.toString();
        if (_paragonConfig.shortcutsEnabled === true) {
            this.keyDownSubscription = Rx["Observable"].fromEvent(document, "keydown")
                .filter(function (x) { return x.keyCode == 114; })
                .subscribe(function (x) { return _this.skipHotKeyPressed = true; });
        }
        this.intervalSubscription = Rx["Observable"].interval(1000)
            .take(this.time)
            .subscribe(function (secondsElapsed) {
            if (_this.skipHotKeyPressed) {
                _this.skipHotKeyPressed = false;
                _this.intervalSubscription.unsubscribe();
                _this.resourceVisible = true;
            }
            else {
                var timeLeft = _this.time - secondsElapsed - 1;
                _this.timeLeft = timeLeft.toString();
            }
        }, function (error) { return console.log(error); }, function () {
            _this.resourceVisible = true;
        });
    };
    AutoPlayResourceComponent.prototype.ngOnDestroy = function () {
        if (this.keyDownSubscription) {
            this.keyDownSubscription.unsubscribe();
        }
        if (this.intervalSubscription) {
            this.intervalSubscription.unsubscribe();
        }
    };
    return AutoPlayResourceComponent;
}());
auto_play_resource_component___decorate([
    Object(core_es5["F" /* Input */])(),
    auto_play_resource_component___metadata("design:type", String)
], auto_play_resource_component_AutoPlayResourceComponent.prototype, "type", void 0);
auto_play_resource_component___decorate([
    Object(core_es5["F" /* Input */])(),
    auto_play_resource_component___metadata("design:type", Number)
], auto_play_resource_component_AutoPlayResourceComponent.prototype, "resourceId", void 0);
auto_play_resource_component___decorate([
    Object(core_es5["F" /* Input */])(),
    auto_play_resource_component___metadata("design:type", Number)
], auto_play_resource_component_AutoPlayResourceComponent.prototype, "time", void 0);
auto_play_resource_component_AutoPlayResourceComponent = auto_play_resource_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'auto-play-resource',
        template: __webpack_require__("5f4n"),
    }),
    auto_play_resource_component___metadata("design:paramtypes", [typeof (auto_play_resource_component__a = typeof timer_service_TimerService !== "undefined" && timer_service_TimerService) === "function" && auto_play_resource_component__a || Object])
], auto_play_resource_component_AutoPlayResourceComponent);

var auto_play_resource_component__a;
//# sourceMappingURL=auto-play-resource.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/interaction/interaction.component.ts
var interaction_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var interaction_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var InteractionComponent = (function () {
    function InteractionComponent() {
    }
    return InteractionComponent;
}());
interaction_component___decorate([
    Object(core_es5["F" /* Input */])(),
    interaction_component___metadata("design:type", Object)
], InteractionComponent.prototype, "interaction", void 0);
InteractionComponent = interaction_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'interaction',
        template: __webpack_require__("jfyd")
    })
], InteractionComponent);

//# sourceMappingURL=interaction.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/interaction/choice-interaction/choice-interaction.component.ts
var choice_interaction_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var choice_interaction_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var ChoiceInteractionComponent = ChoiceInteractionComponent_1 = (function () {
    function ChoiceInteractionComponent(responseService, htmlService, repeatableRandomGeneratorService, loggerService, myModal) {
        this.responseService = responseService;
        this.htmlService = htmlService;
        this.repeatableRandomGeneratorService = repeatableRandomGeneratorService;
        this.loggerService = loggerService;
        this.myModal = myModal;
    }
    ChoiceInteractionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.selectedChoices = [];
        this.choiceInteraction = Object.assign({}, this.interaction.ChoiceInteraction);
        if (this.choiceInteraction.Shuffle == true) {
            this.choiceInteraction.SimpleChoices = this.repeatableRandomGeneratorService.randomizeArray(this.choiceInteraction.SimpleChoices);
        }
        for (var index = 0; index < this.choiceInteraction.SimpleChoices.length; index++) {
            this.choiceInteraction.SimpleChoices[index].ChoiceDisplayOrder = index + 1;
        }
        this.responsesSubscription = this.responseService.responses$
            .flatMap(function (r) { return r; })
            .filter(function (r) { return r.InteractionId == _this.interaction.InteractionId; })
            .subscribe(function (response) {
            _this.selectedChoices = response.Items.map(function (r) { return r.Value; });
        });
    };
    ChoiceInteractionComponent.prototype.ngOnDestroy = function () {
        if (this.responsesSubscription) {
            this.responsesSubscription.unsubscribe();
        }
    };
    ChoiceInteractionComponent.prototype.setResponse = function (identifier) {
        this.loggerService.reportDebugInfo(ChoiceInteractionComponent_1.name, {
            name: "setResponse",
            identifier: identifier
        });
        var hasMultipleItems = this.choiceInteraction.MaxChoices > 1;
        var choice = this.interaction.ChoiceInteraction.SimpleChoices.find(function (x) { return x.Identifier == identifier; });
        var choiceDisplayOrder = null;
        ;
        if (choice) {
            choiceDisplayOrder = choice.ChoiceDisplayOrder;
        }
        if (hasMultipleItems) {
            if (this.selectedChoices.indexOf(identifier) >= 0) {
                this.responseService.removeResponseItem(this.interaction.InteractionId, identifier);
            }
            else {
                if (this.selectedChoices.length >= this.choiceInteraction.MaxChoices) {
                    this.myModal.showRegularDlg("Warning", "You may only select " + this.choiceInteraction.MaxChoices + " choices. Please deselect an existing choice to continue.");
                    return;
                }
                this.responseService.setResponse(this.interaction, null, identifier, null, true, choiceDisplayOrder);
            }
        }
        else {
            this.responseService.setResponse(this.interaction, null, identifier, null, false, choiceDisplayOrder);
        }
    };
    ChoiceInteractionComponent.prototype.replaceImageResourcePlaceHoldersWithTags = function (html) {
        return this.htmlService.replaceImageResourcePlaceHoldersWithTags(html);
    };
    return ChoiceInteractionComponent;
}());
choice_interaction_component___decorate([
    Object(core_es5["F" /* Input */])(),
    choice_interaction_component___metadata("design:type", Object)
], ChoiceInteractionComponent.prototype, "interaction", void 0);
ChoiceInteractionComponent = ChoiceInteractionComponent_1 = choice_interaction_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'choice-interaction',
        template: __webpack_require__("rp94"),
    }),
    choice_interaction_component___metadata("design:paramtypes", [typeof (choice_interaction_component__a = typeof response_service_ResponseService !== "undefined" && response_service_ResponseService) === "function" && choice_interaction_component__a || Object, typeof (choice_interaction_component__b = typeof html_service_HtmlService !== "undefined" && html_service_HtmlService) === "function" && choice_interaction_component__b || Object, typeof (choice_interaction_component__c = typeof repeatable_random_generator_service_RepeatableRandomGeneratorService !== "undefined" && repeatable_random_generator_service_RepeatableRandomGeneratorService) === "function" && choice_interaction_component__c || Object, typeof (choice_interaction_component__d = typeof LoggerService !== "undefined" && LoggerService) === "function" && choice_interaction_component__d || Object, typeof (choice_interaction_component__e = typeof my_modal_component_MyModal !== "undefined" && my_modal_component_MyModal) === "function" && choice_interaction_component__e || Object])
], ChoiceInteractionComponent);

var ChoiceInteractionComponent_1, choice_interaction_component__a, choice_interaction_component__b, choice_interaction_component__c, choice_interaction_component__d, choice_interaction_component__e;
//# sourceMappingURL=choice-interaction.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/interaction/inline-choice-interaction/inline-choice-interaction.component.ts
var inline_choice_interaction_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var inline_choice_interaction_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var InlineChoiceInteractionComponent = (function () {
    function InlineChoiceInteractionComponent(responseService, elementRef, repeatableRandomGeneratorService) {
        var _this = this;
        this.responseService = responseService;
        this.elementRef = elementRef;
        this.repeatableRandomGeneratorService = repeatableRandomGeneratorService;
        this.handleOutsideClick = function (event) {
            var clickedComponent = event.target;
            while (clickedComponent) {
                if (clickedComponent === _this.elementRef.nativeElement) {
                    return;
                }
                clickedComponent = clickedComponent.parentNode;
            }
            _this.isToggleOn = false;
        };
        this.isToggleOn = false;
        this.answerText = "";
    }
    InlineChoiceInteractionComponent.prototype.ngOnInit = function () {
        this.inlineChoiceInteraction = Object.assign({}, this.interaction.InlineChoiceInteraction);
        this.repopulateSelections();
        window.document.addEventListener("click", this.handleOutsideClick);
        if (this.inlineChoiceInteraction.Shuffle == true) {
            this.inlineChoiceInteraction.InlineChoices = this.repeatableRandomGeneratorService.randomizeArray(this.inlineChoiceInteraction.InlineChoices);
        }
        for (var index = 0; index < this.inlineChoiceInteraction.InlineChoices.length; index++) {
            this.inlineChoiceInteraction.InlineChoices[index].ChoiceDisplayOrder = index + 1;
        }
    };
    InlineChoiceInteractionComponent.prototype.ngOnDestroy = function () {
        window.document.removeEventListener("click", this.handleOutsideClick);
    };
    InlineChoiceInteractionComponent.prototype.inlineOnToggle = function (menuElement) {
        this.isToggleOn = !this.isToggleOn;
        var elem = this.elementRef.nativeElement;
        if (elem.offsetTop > 450) {
            var parentElement = elem.parentElement;
            while (parentElement) {
                parentElement = parentElement.parentElement;
                if (parentElement.classList.contains("pane-content")) {
                    break;
                }
            }
            if (parentElement) {
                $(parentElement).css("scroll-behavior", "smooth");
                parentElement.scrollTop = elem.offsetTop - 10;
            }
        }
        if (this.isToggleOn) {
            this.getMenuOffsets(menuElement.parentElement);
        }
    };
    InlineChoiceInteractionComponent.prototype.selectChoice = function (index, text) {
        this.answerText = text;
        this.isToggleOn = false;
    };
    InlineChoiceInteractionComponent.prototype.setResponse = function (identifier, text) {
        var choice = this.interaction.InlineChoiceInteraction.InlineChoices.find(function (x) { return x.Identifier == identifier; });
        var choiceDisplayOrder = null;
        if (choice) {
            choiceDisplayOrder = choice.ChoiceDisplayOrder;
        }
        this.responseService.setResponse(this.interaction, null, identifier, null, false, choiceDisplayOrder);
        this.selectChoice(identifier, text);
    };
    InlineChoiceInteractionComponent.prototype.repopulateSelections = function () {
        var response = this.responseService.getResponse(this.interaction);
        if (response && response.Items.length > 0) {
            var item_1 = response.Items[0];
            var choice = this.interaction.InlineChoiceInteraction.InlineChoices.find(function (x) { return x.Identifier == item_1.Value; });
            if (choice) {
                this.selectChoice(item_1.Value, choice.Html);
            }
        }
    };
    InlineChoiceInteractionComponent.prototype.getMenuOffsets = function (divElement) {
        var paneDomRect;
        if (!document.getElementsByClassName("rightpane")[0]) {
            paneDomRect = document.getElementsByClassName("singlePane")[0].getBoundingClientRect();
        }
        else {
            paneDomRect = document.getElementsByClassName("rightpane")[0].getBoundingClientRect();
        }
        var leftDivider = paneDomRect.left + (5.70 * paneDomRect.width / 16);
        var rightDivider = paneDomRect.left + (10.30 * paneDomRect.width / 16);
        var subElems = Array.from(divElement.children);
        var toggleDomRect = subElems[0].getBoundingClientRect();
        var toggleMid = toggleDomRect.left + (toggleDomRect.width / 2);
        var menuDomRect = subElems[1].getBoundingClientRect();
        if (toggleMid <= leftDivider) {
            subElems[1].setAttribute("style", "left:0;");
        }
        else if ((leftDivider < toggleMid) && (toggleMid < rightDivider)) {
            subElems[1].setAttribute("style", "left:-" + ((menuDomRect.right - toggleDomRect.right) / 2).toString() + "px;");
        }
        else if (toggleMid > rightDivider) {
            subElems[1].setAttribute("style", "left:-" + ((toggleMid - rightDivider) / 2).toString() + "px;");
        }
        else {
            subElems[1].setAttribute("style", "left:-" + (menuDomRect.right - toggleDomRect.right) + "px;");
        }
    };
    return InlineChoiceInteractionComponent;
}());
inline_choice_interaction_component___decorate([
    Object(core_es5["F" /* Input */])(),
    inline_choice_interaction_component___metadata("design:type", Object)
], InlineChoiceInteractionComponent.prototype, "interaction", void 0);
InlineChoiceInteractionComponent = inline_choice_interaction_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'inline-choice-interaction',
        template: __webpack_require__("8I1P")
    }),
    inline_choice_interaction_component___metadata("design:paramtypes", [typeof (inline_choice_interaction_component__a = typeof response_service_ResponseService !== "undefined" && response_service_ResponseService) === "function" && inline_choice_interaction_component__a || Object, typeof (inline_choice_interaction_component__b = typeof core_es5["v" /* ElementRef */] !== "undefined" && core_es5["v" /* ElementRef */]) === "function" && inline_choice_interaction_component__b || Object, typeof (inline_choice_interaction_component__c = typeof repeatable_random_generator_service_RepeatableRandomGeneratorService !== "undefined" && repeatable_random_generator_service_RepeatableRandomGeneratorService) === "function" && inline_choice_interaction_component__c || Object])
], InlineChoiceInteractionComponent);

var inline_choice_interaction_component__a, inline_choice_interaction_component__b, inline_choice_interaction_component__c;
//# sourceMappingURL=inline-choice-interaction.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/interaction/speaking-interaction/speaking-interaction.component.ts
var speaking_interaction_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var speaking_interaction_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};














var speaking_interaction_component_SpeakingInteractionComponent = SpeakingInteractionComponent_1 = (function () {
    function SpeakingInteractionComponent(responseService, loggerService, testNavigationService, testTakerService, myModal, store, elementRef, ngZone, timerService) {
        var _this = this;
        this.responseService = responseService;
        this.loggerService = loggerService;
        this.testNavigationService = testNavigationService;
        this.testTakerService = testTakerService;
        this.myModal = myModal;
        this.store = store;
        this.elementRef = elementRef;
        this.ngZone = ngZone;
        this.timerService = timerService;
        this.requiredSpikeCount = 2;
        this.requiredSpikeThreshold = 10;
        this.skipHotKeyPressed = false;
        this.isDummyRecordingMode = false;
        this.stopRecordingCallback = function () {
            _this.ngZone.run(function () {
                _this.timeIsUpAudio.play();
                if (_this.skipHotKeyPressed == true || _this.isRecordingAcceptable()) {
                    _this.infoBoxText = "Finished recording.";
                    if (config_helper_ConfigHelper.isIppMode()) {
                        _this.responseService.setResponse(_this.interaction, null, null, null, false, null);
                    }
                    // ignore the speaking blob if the timer is paused since the test taker will be given another recording attempt once the timer is unpaused
                    if (!_this.timerService.isPaused()) {
                        _this.responseService.setSpeakingBlobData(_this.interaction.InteractionId, _this.recorder.getBlob());
                    }
                    var timesUpCallback_1 = function () {
                        _this.testNavigationService.goNext(false);
                    };
                    if (config_helper_ConfigHelper.shouldShowTimesUpDlgForSpeaking(_this.testTypeId) === true) {
                        _this.myModal.showTimesUpDlg(timesUpCallback_1);
                    }
                    else {
                        setTimeout(function () {
                            timesUpCallback_1();
                        }, 3000);
                    }
                }
                else {
                    _this.store.dispatch(new app_ui_action_namespaceObject.ShowGenericPage("Unacceptable Recording", SpeakingInteraction_Times_Up, true));
                }
            });
        };
    }
    SpeakingInteractionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.speakingInteraction = this.interaction.SpeakingInteraction;
        this.loggerService.reportDebugInfo(SpeakingInteractionComponent_1.name, {
            name: "ngOnInit",
            interactionId: this.interaction.InteractionId,
            preparationTime: this.speakingInteraction.PreparationTime,
            recordingTime: this.speakingInteraction.RecordingTime
        });
        this.prompt = this.speakingInteraction.Prompt;
        var extendPrep = this.speakingInteraction.ExtendPrepTime;
        var extendRecord = this.speakingInteraction.ExtendSpeakingTime;
        this.preparationTime = extendPrep ? this.speakingInteraction.PreparationTime * this.timerService.timer.multiplier : this.speakingInteraction.PreparationTime;
        this.recordingTime = extendRecord ? this.speakingInteraction.RecordingTime * this.timerService.timer.multiplier : this.speakingInteraction.RecordingTime;
        this.volumeSpikes = [];
        this.testTypeId = config_helper_ConfigHelper.getTestTypeId();
        this.testNavigationService.setCanGoNext(false);
        this.startPreparation();
        this.initAudioClips();
        if (_paragonConfig.shortcutsEnabled === true) {
            this.keyDownSubscription = Rx["Observable"].fromEvent(document, "keydown")
                .filter(function (x) { return x.keyCode == 114; })
                .subscribe(function (x) { return _this.skipHotKeyPressed = true; });
        }
        this.testNavigationService.interactionComponentWithPreFlushProcessing = this;
    };
    SpeakingInteractionComponent.prototype.ngOnDestroy = function () {
        this.testNavigationService.interactionComponentWithPreFlushProcessing = null;
        if (this.keyDownSubscription) {
            this.keyDownSubscription.unsubscribe();
        }
        if (this.preparationSubscription) {
            this.preparationSubscription.unsubscribe();
        }
        if (this.recordingSubscription) {
            this.recordingSubscription.unsubscribe();
        }
        if (this.inputActivitySubscription) {
            this.inputActivitySubscription.unsubscribe();
        }
    };
    SpeakingInteractionComponent.prototype.ngOnChanges = function () {
        this.infoBoxVisible = false;
    };
    SpeakingInteractionComponent.prototype.runPreFlushProcessing = function () {
        if (this.recorder && this.recorder.mediaRecorder.state == "recording") {
            this.recorder.onStopCallback = function () { null; };
            this.responseService.setResponse(this.interaction, null, null, null, false, null);
            this.responseService.setSpeakingBlobData(this.interaction.InteractionId, this.recorder.getBlob());
            this.stopRecording();
        }
    };
    SpeakingInteractionComponent.prototype.initAudioClips = function () {
        var startSpeakingFile = "start_speaking.mp3";
        var timeIsUpFile = "time_is_up.mp3";
        if (config_helper_ConfigHelper.shouldUseBeepAudioClipForSpeaking(this.testTypeId)) {
            startSpeakingFile = "olt_start_speaking.mp3";
            timeIsUpFile = "olt_time_is_up.mp3";
        }
        this.silentClipAudio = this.createAudioElement("silent_clip.mp3");
        this.startSpeakingAudio = this.createAudioElement(startSpeakingFile);
        this.timeIsUpAudio = this.createAudioElement(timeIsUpFile);
    };
    SpeakingInteractionComponent.prototype.startPreparation = function () {
        var _this = this;
        this.loggerService.reportDebugInfo(SpeakingInteractionComponent_1.name, {
            name: "startPreparation"
        });
        this.infoBoxVisible = true;
        this.infoBoxText = "Preparation Time";
        this.infoBoxMode = "CountDownTimer";
        this.iconCssClass = 'clock-icon';
        this.counterText = this.preparationTime.toString();
        this.inputActivityLevel = 100;
        this.preparationSubscription = Rx["Observable"]
            .interval(1000)
            .switchMap(function () { return _this.timerService.isPaused() ? Rx["Observable"].of(false) : Rx["Observable"].of(true); })
            .scan(function (acc, isPaused) { return isPaused ? acc - 1 : acc; }, this.preparationTime)
            .takeWhile(function (currPrepTime) { return currPrepTime >= 0; })
            .subscribe(function (timeLeft) {
            _this.counterText = timeLeft > 0 ? timeLeft.toString() : "--";
            if (_this.skipHotKeyPressed == true || timeLeft <= 0) {
                _this.skipHotKeyPressed = false;
                _this.startRecording(true);
            }
        });
    };
    SpeakingInteractionComponent.prototype.startRecording = function (useRecordingDevice) {
        var _this = this;
        this.isDummyRecordingMode = !useRecordingDevice;
        this.infoBoxMode = "TextOnly";
        this.infoBoxText = "";
        this.silentClipAudio.play();
        if (useRecordingDevice) {
            PgRecorder.create(this.loggerService)
                .then(function (recorder) {
                _this.recorder = recorder;
                _this.startSpeakingAudio.play();
                _this.initializeRecordingDisplay();
                _this.recorder.start(_this.stopRecordingCallback);
                _this.recordingSubscription = Rx["Observable"].interval(1000)
                    .take(_this.recordingTime)
                    .subscribe(function (x) {
                    var timeElapsed = x + 1;
                    _this.currentProgress = _this.setProgress(timeElapsed, _this.recordingTime);
                    if (_this.skipHotKeyPressed == true || timeElapsed >= _this.recordingTime) {
                        _this.stopRecording();
                    }
                });
                _this.testTakerService.cacheTestTakerActivity(TestTakerActivityTypeEnum.StartSpeaking, null, null, null, _this.interaction.InteractionId, null);
                _this.inputActivitySubscription = Rx["Observable"].interval(200)
                    .subscribe(function (x) {
                    var inputActivityLevel = _this.recorder.getInputActivityLevel();
                    _this.inputActivityLevel = 100 - inputActivityLevel;
                    if (_this.volumeSpikes.length < _this.requiredSpikeCount && inputActivityLevel >= _this.requiredSpikeThreshold) {
                        _this.volumeSpikes.push(inputActivityLevel);
                    }
                });
            })
                .catch(function (error) {
                _this.loggerService.reportError(SpeakingInteractionComponent_1.name, error);
                if (config_helper_ConfigHelper.isIppMode()) {
                    _this.startRecording(false);
                }
                else {
                    _this.myModal.showRegularDlg("Error", config_helper_ConfigHelper.isTdpMode() ? SpeakingInteraction_Recorder_Start_With_Code : SpeakingInteraction_Recorder_Start, [{ label: "Retry", style: "btn-primary" }])
                        .then(function (x) { return _this.startRecording(true); });
                }
            });
        }
        else {
            this.startDummyRecording();
        }
    };
    SpeakingInteractionComponent.prototype.initializeRecordingDisplay = function () {
        if (this.preparationSubscription) {
            this.preparationSubscription.unsubscribe();
        }
        if (this.recordingSubscription) {
            this.recordingSubscription.unsubscribe();
        }
        if (this.inputActivitySubscription) {
            this.inputActivitySubscription.unsubscribe();
        }
        this.loggerService.reportDebugInfo(SpeakingInteractionComponent_1.name, {
            name: "startRecording"
        });
        this.infoBoxVisible = true;
        this.infoBoxText = "Recording...";
        this.infoBoxMode = "ProgressBar";
        this.iconCssClass = 'rec-icon';
        this.currentProgress = 0;
    };
    SpeakingInteractionComponent.prototype.startDummyRecording = function () {
        var _this = this;
        this.startSpeakingAudio.play();
        this.initializeRecordingDisplay();
        this.recordingSubscription = Rx["Observable"].interval(1000)
            .take(this.recordingTime)
            .subscribe(function (x) {
            var timeElapsed = x + 1;
            _this.currentProgress = _this.setProgress(timeElapsed, _this.recordingTime);
            if (_this.skipHotKeyPressed == true || timeElapsed >= _this.recordingTime) {
                _this.stopRecording();
            }
        });
    };
    SpeakingInteractionComponent.prototype.stopRecording = function () {
        this.loggerService.reportDebugInfo(SpeakingInteractionComponent_1.name, {
            name: "stopRecording"
        });
        if (this.recordingSubscription) {
            this.recordingSubscription.unsubscribe();
        }
        if (this.inputActivitySubscription) {
            this.inputActivitySubscription.unsubscribe();
        }
        this.inputActivityLevel = 100;
        if (this.isDummyRecordingMode == true) {
            this.stopDummyRecording();
        }
        else {
            this.recorder.stop();
        }
    };
    SpeakingInteractionComponent.prototype.stopDummyRecording = function () {
        var _this = this;
        this.ngZone.run(function () {
            _this.timeIsUpAudio.play();
            _this.infoBoxText = "Finished recording.";
            var timesUpCallback = function () { return _this.testNavigationService.goNext(false); };
            _this.myModal.showTimesUpDlg(timesUpCallback);
        });
    };
    SpeakingInteractionComponent.prototype.setProgress = function (current, totalTime) {
        return (current / totalTime) * 100;
    };
    SpeakingInteractionComponent.prototype.isRecordingAcceptable = function () {
        if (config_helper_ConfigHelper.shouldCheckForUnacceptableRecording(this.testTypeId) && !this.timerService.isPaused()) {
            return this.volumeSpikes.length >= this.requiredSpikeCount;
        }
        return true;
    };
    SpeakingInteractionComponent.prototype.createAudioElement = function (src) {
        var elem = this.elementRef.nativeElement;
        var audioElem = document.createElement("audio");
        audioElem.autoplay = false;
        audioElem.controls = false;
        audioElem.autoplay = false;
        audioElem.src = config_helper_ConfigHelper.getAudioAssetUrl() + "/" + src;
        elem.appendChild(audioElem);
        return audioElem;
    };
    return SpeakingInteractionComponent;
}());
speaking_interaction_component___decorate([
    Object(core_es5["F" /* Input */])(),
    speaking_interaction_component___metadata("design:type", Object)
], speaking_interaction_component_SpeakingInteractionComponent.prototype, "interaction", void 0);
speaking_interaction_component_SpeakingInteractionComponent = SpeakingInteractionComponent_1 = speaking_interaction_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'speaking-interaction',
        template: __webpack_require__("jEjm")
    }),
    speaking_interaction_component___metadata("design:paramtypes", [typeof (speaking_interaction_component__a = typeof response_service_ResponseService !== "undefined" && response_service_ResponseService) === "function" && speaking_interaction_component__a || Object, typeof (speaking_interaction_component__b = typeof LoggerService !== "undefined" && LoggerService) === "function" && speaking_interaction_component__b || Object, typeof (speaking_interaction_component__c = typeof test_navigation_service_TestNavigationService !== "undefined" && test_navigation_service_TestNavigationService) === "function" && speaking_interaction_component__c || Object, typeof (speaking_interaction_component__d = typeof test_taker_service_TestTakerService !== "undefined" && test_taker_service_TestTakerService) === "function" && speaking_interaction_component__d || Object, typeof (speaking_interaction_component__e = typeof my_modal_component_MyModal !== "undefined" && my_modal_component_MyModal) === "function" && speaking_interaction_component__e || Object, typeof (speaking_interaction_component__f = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && speaking_interaction_component__f || Object, typeof (speaking_interaction_component__g = typeof core_es5["v" /* ElementRef */] !== "undefined" && core_es5["v" /* ElementRef */]) === "function" && speaking_interaction_component__g || Object, typeof (_h = typeof core_es5["R" /* NgZone */] !== "undefined" && core_es5["R" /* NgZone */]) === "function" && _h || Object, typeof (_j = typeof timer_service_TimerService !== "undefined" && timer_service_TimerService) === "function" && _j || Object])
], speaking_interaction_component_SpeakingInteractionComponent);

var SpeakingInteractionComponent_1, speaking_interaction_component__a, speaking_interaction_component__b, speaking_interaction_component__c, speaking_interaction_component__d, speaking_interaction_component__e, speaking_interaction_component__f, speaking_interaction_component__g, _h, _j;
//# sourceMappingURL=speaking-interaction.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/interaction/extended-text-interaction/extended-text-interaction.component.ts
var extended_text_interaction_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var extended_text_interaction_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};









var extended_text_interaction_component_ExtendedTextInteractionComponent = ExtendedTextInteractionComponent_1 = (function () {
    function ExtendedTextInteractionComponent(store, myModal, responseService, keyboardActivityService, elementRef) {
        this.store = store;
        this.myModal = myModal;
        this.responseService = responseService;
        this.keyboardActivityService = keyboardActivityService;
        this.elementRef = elementRef;
        this.isFocus = false;
        this.isReady = false;
        this.wordCount = 0;
        this.editorHeight = 300;
        this.mode = _paragonConfig.mode;
    }
    ExtendedTextInteractionComponent.prototype.ngOnInit = function () {
        this.extendedTextInteraction = this.interaction.ExtendedTextInteraction;
        this.domId = "#editor-container";
        if (!config_helper_ConfigHelper.isTdpMode()) {
            $(this.domId).attr("placeholder", this.extendedTextInteraction.PlaceHolderText);
        }
        this.setEditorHeight();
        $(".rightpane").css("padding-bottom", "0");
        this.keyboardActivityService.startRecording(this.interaction.InteractionId);
    };
    ExtendedTextInteractionComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.setEditorHeight();
        this.editorElement = $(this.domId, this.elementRef.nativeElement)[0];
        this.editorElement.spellcheck = this.extendedTextInteraction.SpellCheckActive;
        if (ExtendedTextInteractionComponent_1.globalFocusExist === false) {
            this.editorElement.focus();
            ExtendedTextInteractionComponent_1.globalFocusExist = true;
            this.isFocus = true;
        }
        if (!config_helper_ConfigHelper.isTdpMode()) {
            this.editorElement.innerHTML = null;
        }
        var response = this.responseService.getResponse(this.interaction);
        if (response && response.Items.length > 0) {
            this.editorElement.innerHTML = response.Items[0].Text;
        }
        this.editorKeyUpSubscription = Rx["Observable"].fromEvent(this.editorElement, "keyup")
            .do(function (x) { return _this.wordCount = _this.responseService.getWordCount(_this.editorElement.innerText); })
            .debounceTime(3000)
            .subscribe(function (x) { return _this.setResponse(); });
        this.editorBlurSubscription = Rx["Observable"].fromEvent(this.editorElement, "blur")
            .do(function (x) { return _this.wordCount = _this.responseService.getWordCount(_this.editorElement.innerText); })
            .subscribe(function (x) { return _this.setResponse(); });
        this.editorCopySubscription = Rx["Observable"].fromEvent(this.editorElement, "copy")
            .subscribe(function (x) { return _this.clipboardData = _this.getSelectionHtml(); });
        this.editorCopySubscription = Rx["Observable"].fromEvent(this.editorElement, "cut")
            .subscribe(function (x) { return _this.clipboardData = _this.getSelectionHtml(); });
        setTimeout(function () {
            _this.wordCount = _this.responseService.getWordCount(_this.editorElement.innerText);
            _this.isReady = true;
        }, 500);
    };
    ExtendedTextInteractionComponent.prototype.ngOnDestroy = function () {
        var _this = this;
        this.keyboardActivityService.stopRecording();
        this.responseService.flush(false)
            .catch(function () {
            _this.store.dispatch(new app_ui_action_namespaceObject.HideLoadingOverlay());
            _this.myModal.showRegularDlg("Error", Navigation_Response_Saving);
        });
        if (this.editorKeyUpSubscription) {
            this.editorKeyUpSubscription.unsubscribe();
        }
        if (this.editorBlurSubscription) {
            this.editorBlurSubscription.unsubscribe();
        }
        if (this.editorCopySubscription) {
            this.editorCopySubscription.unsubscribe();
        }
        if (this.editorCutSubscription) {
            this.editorCutSubscription.unsubscribe();
        }
        if (this.isFocus) {
            ExtendedTextInteractionComponent_1.globalFocusExist = false;
        }
    };
    ExtendedTextInteractionComponent.prototype.pasteHtmlAtCaret = function (html, selectPastedContent) {
        if (selectPastedContent === void 0) { selectPastedContent = false; }
        if (window.getSelection) {
            var sel = window.getSelection();
            if (sel.getRangeAt && sel.rangeCount) {
                var range = sel.getRangeAt(0);
                range.deleteContents();
                // Range.createContextualFragment() would be useful here but is
                // only relatively recently standardized and is not supported in
                // some browsers (IE9, for one)
                var el = document.createElement("div");
                el.innerHTML = html;
                var frag = document.createDocumentFragment();
                var node = void 0, lastNode = void 0;
                while ((node = el.firstChild)) {
                    lastNode = frag.appendChild(node);
                }
                var firstNode = frag.firstChild;
                range.insertNode(frag);
                // Preserve the selection
                if (lastNode) {
                    range = range.cloneRange();
                    range.setStartAfter(lastNode);
                    if (selectPastedContent) {
                        range.setStartBefore(firstNode);
                    }
                    else {
                        range.collapse(true);
                    }
                    sel.removeAllRanges();
                    sel.addRange(range);
                }
            }
        }
    };
    ExtendedTextInteractionComponent.prototype.getSelectionHtml = function () {
        var html = "";
        if (typeof window.getSelection != "undefined") {
            var sel = window.getSelection();
            if (sel.rangeCount) {
                var container = document.createElement("div");
                for (var i = 0, len = sel.rangeCount; i < len; ++i) {
                    container.appendChild(sel.getRangeAt(i).cloneContents());
                }
                html = container.innerHTML;
            }
        }
        return html;
    };
    ExtendedTextInteractionComponent.prototype.setEditorHeight = function () {
        if (this.extendedTextInteraction.FillRestPanelSpace == true) {
            var paneContent = $(".pane-content");
            if (paneContent.length > 0) {
                var panelHeight = $(".pane-content")[0].clientHeight;
                this.editorHeight = panelHeight - $(this.domId)[0].offsetTop - 90;
            }
        }
        else if (this.extendedTextInteraction.ExpectedLines > 0) {
            if (this.extendedTextInteraction.ExpectedLines < 5) {
                this.editorHeight = this.extendedTextInteraction.ExpectedLines * 40;
            }
            else {
                this.editorHeight = this.extendedTextInteraction.ExpectedLines * 30;
            }
        }
    };
    ExtendedTextInteractionComponent.prototype.setResponse = function () {
        var responseText = this.editorElement.innerHTML;
        if (responseText && responseText.length > 0) {
            this.responseService.setResponse(this.interaction, null, null, responseText, false, null);
        }
    };
    ExtendedTextInteractionComponent.prototype.execCommand = function (command) {
        document.execCommand(command, false, null);
        this.setResponse();
    };
    ExtendedTextInteractionComponent.prototype.paste = function () {
        this.pasteHtmlAtCaret(this.clipboardData, false);
        this.setResponse();
    };
    ExtendedTextInteractionComponent.prototype.downloadWrittenResponse = function (filename, elId) {
        var elHtml = document.getElementById(elId).innerText;
        var link = document.createElement('a');
        link.setAttribute('download', filename);
        link.setAttribute('href', 'data:' + 'text/doc' + ';charset=utf-8,' + encodeURIComponent(elHtml));
        link.click();
    };
    return ExtendedTextInteractionComponent;
}());
extended_text_interaction_component_ExtendedTextInteractionComponent.globalFocusExist = false;
extended_text_interaction_component___decorate([
    Object(core_es5["F" /* Input */])(),
    extended_text_interaction_component___metadata("design:type", Object)
], extended_text_interaction_component_ExtendedTextInteractionComponent.prototype, "interaction", void 0);
extended_text_interaction_component_ExtendedTextInteractionComponent = ExtendedTextInteractionComponent_1 = extended_text_interaction_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'extended-text-interaction',
        template: __webpack_require__("xPNa"),
    }),
    extended_text_interaction_component___metadata("design:paramtypes", [typeof (extended_text_interaction_component__a = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && extended_text_interaction_component__a || Object, typeof (extended_text_interaction_component__b = typeof my_modal_component_MyModal !== "undefined" && my_modal_component_MyModal) === "function" && extended_text_interaction_component__b || Object, typeof (extended_text_interaction_component__c = typeof response_service_ResponseService !== "undefined" && response_service_ResponseService) === "function" && extended_text_interaction_component__c || Object, typeof (extended_text_interaction_component__d = typeof keyboard_activity_service_KeyboardActivityService !== "undefined" && keyboard_activity_service_KeyboardActivityService) === "function" && extended_text_interaction_component__d || Object, typeof (extended_text_interaction_component__e = typeof core_es5["v" /* ElementRef */] !== "undefined" && core_es5["v" /* ElementRef */]) === "function" && extended_text_interaction_component__e || Object])
], extended_text_interaction_component_ExtendedTextInteractionComponent);

var ExtendedTextInteractionComponent_1, extended_text_interaction_component__a, extended_text_interaction_component__b, extended_text_interaction_component__c, extended_text_interaction_component__d, extended_text_interaction_component__e;
//# sourceMappingURL=extended-text-interaction.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/interaction/text-entry-interaction/text-entry-interaction.component.ts
var text_entry_interaction_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var text_entry_interaction_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var text_entry_interaction_component_TextEntryInteractionComponent = (function () {
    function TextEntryInteractionComponent(responseService) {
        this.responseService = responseService;
        this.width = 10;
        this.maxChar = 150;
        this.inputType = "text";
        this.placeHolderText = "";
        this.textEntryControl = new forms_es5["a" /* FormControl */]("");
    }
    TextEntryInteractionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.textEntryInteraction = this.interaction.TextEntryInteraction;
        if (this.textEntryInteraction.ExpectedLength) {
            this.width = this.textEntryInteraction.ExpectedLength;
        }
        if (this.textEntryInteraction.PlaceHolderText) {
            this.placeHolderText = this.textEntryInteraction.PlaceHolderText;
        }
        var response = this.responseService.getResponse(this.interaction);
        if (response && response.Items.length > 0) {
            this.textEntryControl.setValue(response.Items[0].Value);
        }
        else {
            this.responseService.setResponse(this.interaction, null, null, null, false, null);
        }
        if (this.textEntryInteraction.ResponseDeclaration && (this.textEntryInteraction.ResponseDeclaration.BaseType.toString() === BaseTypeEnum.Float.toString() || this.textEntryInteraction.ResponseDeclaration.BaseType.toString() === BaseTypeEnum.Integer.toString())) {
            this.inputType = "number";
        }
        this.textEntryControlSubscription = this.textEntryControl.valueChanges
            .debounceTime(1000)
            .distinctUntilChanged().subscribe(function (val) {
            _this.responseService.setResponse(_this.interaction, null, val, null, false, null);
        });
    };
    TextEntryInteractionComponent.prototype.ngOnDestroy = function () {
        this.responseService.setResponse(this.interaction, null, this.textEntryControl.value, null, false, null);
        if (this.textEntryControlSubscription) {
            this.textEntryControlSubscription.unsubscribe();
        }
    };
    return TextEntryInteractionComponent;
}());
text_entry_interaction_component___decorate([
    Object(core_es5["F" /* Input */])(),
    text_entry_interaction_component___metadata("design:type", Object)
], text_entry_interaction_component_TextEntryInteractionComponent.prototype, "interaction", void 0);
text_entry_interaction_component_TextEntryInteractionComponent = text_entry_interaction_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'text-entry-interaction',
        template: __webpack_require__("wadJ")
    }),
    text_entry_interaction_component___metadata("design:paramtypes", [typeof (text_entry_interaction_component__a = typeof response_service_ResponseService !== "undefined" && response_service_ResponseService) === "function" && text_entry_interaction_component__a || Object])
], text_entry_interaction_component_TextEntryInteractionComponent);

var text_entry_interaction_component__a;
//# sourceMappingURL=text-entry-interaction.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/interaction/hotspot-interaction/hotspot-interaction.component.ts
var hotspot_interaction_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var hotspot_interaction_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var HotspotComponent = (function () {
    function HotspotComponent(responseService, htmlService, myModal) {
        this.responseService = responseService;
        this.htmlService = htmlService;
        this.myModal = myModal;
    }
    HotspotComponent.prototype.ngOnInit = function () {
        this.hotspotInteraction = this.interaction.HotspotInteraction;
        this.srcUrl = this.htmlService.getResourceUrl(this.hotspotInteraction.ResourceObject.ResourceId);
    };
    HotspotComponent.prototype.toggleHotspot = function (hotspotChoice) {
        var isHotspotCurrentlySelected = this.isSelected(hotspotChoice);
        if (!isHotspotCurrentlySelected && this.hotspotInteraction.MaxChoices > 1) {
            var response = this.responseService.getResponse(this.interaction);
            if (response) {
                if (response.Items.length >= this.hotspotInteraction.MaxChoices) {
                    this.myModal.showRegularDlg("Warning", "You may only select " + this.hotspotInteraction.MaxChoices + " choices. Please deselect an existing choice to continue.");
                    return;
                }
            }
        }
        if (this.isSelected(hotspotChoice)) {
            this.responseService.removeResponseItem(this.interaction.InteractionId, hotspotChoice.Identifier);
        }
        else {
            this.responseService.setResponse(this.interaction, null, hotspotChoice.Identifier, null, this.hotspotInteraction.MaxChoices > 1, null);
        }
    };
    HotspotComponent.prototype.isSelected = function (hotspotChoice) {
        return this.responseService.hasResponseItem(this.interaction.InteractionId, hotspotChoice.Identifier);
    };
    return HotspotComponent;
}());
hotspot_interaction_component___decorate([
    Object(core_es5["F" /* Input */])(),
    hotspot_interaction_component___metadata("design:type", Object)
], HotspotComponent.prototype, "interaction", void 0);
HotspotComponent = hotspot_interaction_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'hotspot-interaction',
        template: __webpack_require__("soNa")
    }),
    hotspot_interaction_component___metadata("design:paramtypes", [typeof (hotspot_interaction_component__a = typeof response_service_ResponseService !== "undefined" && response_service_ResponseService) === "function" && hotspot_interaction_component__a || Object, typeof (hotspot_interaction_component__b = typeof html_service_HtmlService !== "undefined" && html_service_HtmlService) === "function" && hotspot_interaction_component__b || Object, typeof (hotspot_interaction_component__c = typeof my_modal_component_MyModal !== "undefined" && my_modal_component_MyModal) === "function" && hotspot_interaction_component__c || Object])
], HotspotComponent);

var hotspot_interaction_component__a, hotspot_interaction_component__b, hotspot_interaction_component__c;
//# sourceMappingURL=hotspot-interaction.component.js.map
// EXTERNAL MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("S4Bb");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/interaction/order-interaction/order-interaction.component.ts
var order_interaction_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var order_interaction_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


__webpack_require__("eA9H");
__webpack_require__("xXxb");
__webpack_require__("vpxm");



var order_interaction_component_OrderInteractionComponent = (function () {
    function OrderInteractionComponent(responseService, repeatableRandomGeneratorService, loggerService) {
        this.responseService = responseService;
        this.repeatableRandomGeneratorService = repeatableRandomGeneratorService;
        this.loggerService = loggerService;
    }
    OrderInteractionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.orderInteraction = Object.assign({}, this.interaction.OrderInteraction);
        var response = this.responseService.getResponse(this.interaction);
        if (!response) {
            this.choices = this.repeatableRandomGeneratorService.randomizeArray(this.orderInteraction.SimpleChoices);
        }
        else {
            this.choices = [];
            response.Items.forEach(function (r) {
                var choice = _this.orderInteraction.SimpleChoices.find(function (c) { return c.Identifier == r.Value; });
                _this.choices.push({
                    Identifier: choice.Identifier,
                    Html: choice.Html,
                    ChoiceDisplayOrder: null
                });
            });
        }
    };
    OrderInteractionComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        try {
            var jqOrderInteraction = jquery("#order-interaction-" + this.interaction.InteractionId);
            jqOrderInteraction.sortable();
            jqOrderInteraction.disableSelection();
            jqOrderInteraction.on("sortstop", function (event) {
                _this.responseService.clearInteractionResponses(_this.interaction.InteractionId);
                jquery(event.target).find("li").each(function (index, element) {
                    _this.responseService.setResponse(_this.interaction, null, element.id, null, _this.choices.length > 1, null);
                });
            });
        }
        catch (error) {
            this.loggerService.reportFatalError("OrderInteractionComponent", error);
        }
    };
    return OrderInteractionComponent;
}());
order_interaction_component___decorate([
    Object(core_es5["F" /* Input */])(),
    order_interaction_component___metadata("design:type", Object)
], order_interaction_component_OrderInteractionComponent.prototype, "interaction", void 0);
order_interaction_component_OrderInteractionComponent = order_interaction_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'order-interaction',
        template: __webpack_require__("sVWc"),
    }),
    order_interaction_component___metadata("design:paramtypes", [typeof (order_interaction_component__a = typeof response_service_ResponseService !== "undefined" && response_service_ResponseService) === "function" && order_interaction_component__a || Object, typeof (order_interaction_component__b = typeof repeatable_random_generator_service_RepeatableRandomGeneratorService !== "undefined" && repeatable_random_generator_service_RepeatableRandomGeneratorService) === "function" && order_interaction_component__b || Object, typeof (order_interaction_component__c = typeof LoggerService !== "undefined" && LoggerService) === "function" && order_interaction_component__c || Object])
], order_interaction_component_OrderInteractionComponent);

var order_interaction_component__a, order_interaction_component__b, order_interaction_component__c;
//# sourceMappingURL=order-interaction.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/interaction/associate-interaction/associate-interaction.component.ts
var associate_interaction_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var associate_interaction_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



__webpack_require__("eA9H");
__webpack_require__("zMfh");
__webpack_require__("aYn/");

var associate_interaction_component_AssociateInteractionComponent = (function () {
    function AssociateInteractionComponent(responseService, domSanitizer) {
        this.responseService = responseService;
        this.domSanitizer = domSanitizer;
    }
    AssociateInteractionComponent.prototype.ngOnInit = function () {
        this.associateInteraction = this.interaction.AssociateInteraction;
        var response = this.responseService.getResponse(this.interaction);
        if (response) {
            this.availableChoices = this.interaction.AssociateInteraction.SimpleAssociableChoices.filter(function (c) { return response.Items.findIndex(function (x) { return x.Value == c.Identifier; }) < 0; });
        }
        else {
            this.availableChoices = this.interaction.AssociateInteraction.SimpleAssociableChoices;
        }
        this.placeholderPair = [];
        for (var index = 0; index < this.associateInteraction.MinAssociations; index++) {
            this.placeholderPair.push(this.getPlaceholderPair(response, index));
        }
    };
    AssociateInteractionComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        jquery(".associate-interaction-" + this.interaction.InteractionId + " .draggable").draggable({
            revert: "invalid",
            helper: "clone"
        });
        jquery(".associate-interaction-" + this.interaction.InteractionId + " .choice-container").droppable({
            over: function (event, ui) {
                var dropTarget = jquery(event.target);
                if (_this.haveSameParentId(dropTarget, ui.draggable)) {
                    dropTarget.addClass("allow-drop");
                }
            },
            out: function (event, ui) {
                var dropTarget = jquery(event.target);
                dropTarget.removeClass("no-drop allow-drop");
            },
            drop: function (event, ui) {
                var dropTarget = jquery(event.target);
                if (_this.haveSameParentId(dropTarget, ui.draggable)) {
                    dropTarget.append(ui.draggable);
                    dropTarget.removeClass("no-drop allow-drop");
                    var id = ui.draggable.attr("id");
                    _this.removeResponse(id);
                }
            }
        });
        jquery(".associate-interaction-" + this.interaction.InteractionId + " .placeholder").droppable({
            over: function (event, ui) {
                var dropTarget = jquery(event.target);
                if (_this.haveSameParentId(dropTarget, ui.draggable)) {
                    var existingDraggable = dropTarget.find(".draggable");
                    if (existingDraggable.length > 0) {
                        if (existingDraggable[0].innerHTML == ui.draggable.html()) {
                            dropTarget.addClass("allow-drop");
                        }
                        else {
                            dropTarget.addClass("no-drop");
                        }
                    }
                    else {
                        dropTarget.addClass("allow-drop");
                    }
                }
            },
            out: function (event, ui) {
                var dropTarget = jquery(event.target);
                dropTarget.removeClass("no-drop allow-drop");
            },
            drop: function (event, ui) {
                var dropTarget = jquery(event.target);
                if (_this.haveSameParentId(dropTarget, ui.draggable)) {
                    if (dropTarget.find(".draggable").length < 1) {
                        dropTarget.append(ui.draggable);
                        var id = ui.draggable.attr("id");
                        _this.removeResponse(id);
                        _this.setResponse(dropTarget.attr("id"), id);
                    }
                }
                dropTarget.removeClass("no-drop allow-drop");
            }
        });
    };
    AssociateInteractionComponent.prototype.haveSameParentId = function (elem1, elem2) {
        return elem1.data("parentId") == elem2.data("parentId");
    };
    AssociateInteractionComponent.prototype.setResponse = function (key, identifier) {
        this.responseService.setResponse(this.interaction, key, identifier, null, true, null);
    };
    AssociateInteractionComponent.prototype.removeResponse = function (identifier) {
        this.responseService.removeResponseItem(this.interaction.InteractionId, identifier);
    };
    AssociateInteractionComponent.prototype.getResponse = function (mapEntry, mapEntryIndex, responseIndex) {
        var response = this.responseService.getResponse(this.interaction);
        var keys = mapEntry.MapKey.split(" ");
        var choice = this.associateInteraction.SimpleAssociableChoices.find(function (c) { return c.Identifier == keys[responseIndex]; });
        if (response && choice) {
            var item = response.Items.find(function (r) { return r.Key == mapEntryIndex.toString() && r.Value == choice.Identifier; });
            if (item) {
                return this.domSanitizer.bypassSecurityTrustHtml("<span class=\"draggable\" data-id=\"" + choice.Identifier + "\" data-parent-id=\"" + this.interaction.InteractionId + "\">" + choice.Html + "</span>");
            }
        }
        return "";
    };
    AssociateInteractionComponent.prototype.getPlaceholderPair = function (response, index) {
        var _this = this;
        var placeholder1, placeholder2;
        if (response) {
            var placeholderItems = response.Items.filter(function (x) { return x.Key == index.toString(); });
            placeholderItems.forEach(function (r, rIndex) {
                var choice = _this.associateInteraction.SimpleAssociableChoices.find(function (c) { return c.Identifier == r.Value; });
                if (choice) {
                    if (rIndex == 0) {
                        placeholder1 = {
                            Identifier: choice.Identifier,
                            Html: choice.Html
                        };
                    }
                    else if (rIndex == 1) {
                        placeholder2 = {
                            Identifier: choice.Identifier,
                            Html: choice.Html
                        };
                    }
                }
            });
        }
        return {
            SubKey: index.toString(),
            Placeholder1: placeholder1,
            Placeholder2: placeholder2,
        };
    };
    return AssociateInteractionComponent;
}());
associate_interaction_component___decorate([
    Object(core_es5["F" /* Input */])(),
    associate_interaction_component___metadata("design:type", Object)
], associate_interaction_component_AssociateInteractionComponent.prototype, "interaction", void 0);
associate_interaction_component_AssociateInteractionComponent = associate_interaction_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'associate-interaction',
        template: __webpack_require__("fxQu"),
    }),
    associate_interaction_component___metadata("design:paramtypes", [typeof (associate_interaction_component__a = typeof response_service_ResponseService !== "undefined" && response_service_ResponseService) === "function" && associate_interaction_component__a || Object, typeof (associate_interaction_component__b = typeof platform_browser_es5["b" /* DomSanitizer */] !== "undefined" && platform_browser_es5["b" /* DomSanitizer */]) === "function" && associate_interaction_component__b || Object])
], associate_interaction_component_AssociateInteractionComponent);

var associate_interaction_component__a, associate_interaction_component__b;
//# sourceMappingURL=associate-interaction.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/interaction/match-interaction/match-interaction.component.ts
var match_interaction_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var match_interaction_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


__webpack_require__("eA9H");
__webpack_require__("zMfh");
__webpack_require__("aYn/");

var match_interaction_component_MatchInteractionComponent = (function () {
    function MatchInteractionComponent(responseService) {
        this.responseService = responseService;
    }
    MatchInteractionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.matchInteraction = this.interaction.MatchInteraction;
        this.response = this.responseService.getResponse(this.interaction);
        if (this.response) {
            this.availableChoices = this.matchInteraction.SimpleMatchSets[0].SimpleAssociableChoices.filter(function (x) { return _this.response.Items.findIndex(function (r) { return r.Value == x.Identifier; }) < 0; });
        }
        else {
            this.availableChoices = this.matchInteraction.SimpleMatchSets[0].SimpleAssociableChoices;
        }
        this.groups = this.matchInteraction.SimpleMatchSets[1].SimpleAssociableChoices;
    };
    MatchInteractionComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        jquery(".interaction-" + this.interaction.InteractionId + " .draggable").draggable({
            revert: "invalid",
            helper: "clone",
            containment: jquery(".view-container")
        });
        jquery(".interaction-" + this.interaction.InteractionId + " .choice-container").droppable({
            over: function (event, ui) {
                var dropTarget = jquery(event.target);
                if (_this.haveSameParentId(dropTarget, ui.draggable)) {
                    dropTarget.addClass("allow-drop");
                }
            },
            out: function (event, ui) {
                var dropTarget = jquery(event.target);
                dropTarget.removeClass("no-drop allow-drop");
            },
            drop: function (event, ui) {
                var dropTarget = jquery(event.target);
                if (_this.haveSameParentId(dropTarget, ui.draggable)) {
                    dropTarget.append(ui.draggable);
                    dropTarget.removeClass("no-drop allow-drop");
                    var id = ui.draggable.attr("id");
                    _this.removeResponse(id);
                }
                else {
                    dropTarget.removeClass("no-drop allow-drop");
                }
            }
        });
        jquery(".interaction-" + this.interaction.InteractionId + " .placeholder").droppable({
            over: function (event, ui) {
                var dropTarget = jquery(event.target);
                var matchMax = parseInt(dropTarget.data("matchMax"));
                var existingDraggable = dropTarget.find(".draggable");
                if (existingDraggable.length < matchMax) {
                    dropTarget.addClass("allow-drop");
                }
                else {
                    dropTarget.addClass("no-drop");
                }
            },
            out: function (event, ui) {
                var dropTarget = jquery(event.target);
                dropTarget.removeClass("no-drop allow-drop");
            },
            drop: function (event, ui) {
                var dropTarget = jquery(event.target);
                if (_this.haveSameParentId(dropTarget, ui.draggable)) {
                    var matchMax = parseInt(dropTarget.data("matchMax"));
                    if (dropTarget.find(".draggable").length < matchMax) {
                        dropTarget.append(ui.draggable);
                        var id = ui.draggable.attr("id");
                        _this.removeResponse(id);
                        _this.setResponse(dropTarget.attr("id"), id);
                    }
                    dropTarget.removeClass("no-drop allow-drop");
                }
                else {
                    dropTarget.removeClass("no-drop allow-drop");
                }
            }
        });
    };
    MatchInteractionComponent.prototype.haveSameParentId = function (elem1, elem2) {
        return elem1.data("parentId") == elem2.data("parentId");
    };
    MatchInteractionComponent.prototype.setResponse = function (key, identifier) {
        this.responseService.setResponse(this.interaction, key, identifier, null, true, null);
    };
    MatchInteractionComponent.prototype.removeResponse = function (identifier) {
        this.responseService.removeResponseItem(this.interaction.InteractionId, identifier);
    };
    MatchInteractionComponent.prototype.getGroupChoices = function (groupIdentifier) {
        var _this = this;
        if (this.response) {
            return this.response.Items
                .filter(function (r) { return r.Key == groupIdentifier; })
                .map(function (r) { return _this.matchInteraction.SimpleMatchSets[0].SimpleAssociableChoices.find(function (c) { return c.Identifier == r.Value; }); });
        }
        else {
            return [];
        }
    };
    return MatchInteractionComponent;
}());
match_interaction_component___decorate([
    Object(core_es5["F" /* Input */])(),
    match_interaction_component___metadata("design:type", Object)
], match_interaction_component_MatchInteractionComponent.prototype, "interaction", void 0);
match_interaction_component_MatchInteractionComponent = match_interaction_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'match-interaction',
        template: __webpack_require__("KaX3"),
    }),
    match_interaction_component___metadata("design:paramtypes", [typeof (match_interaction_component__a = typeof response_service_ResponseService !== "undefined" && response_service_ResponseService) === "function" && match_interaction_component__a || Object])
], match_interaction_component_MatchInteractionComponent);

var match_interaction_component__a;
//# sourceMappingURL=match-interaction.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/interaction/index.ts











//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/misc/auto-skip-timer/auto-skip-timer.component.ts
var auto_skip_timer_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var auto_skip_timer_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var AutoSkipTimerComponent = (function () {
    function AutoSkipTimerComponent(testNavigationService, timerService) {
        this.testNavigationService = testNavigationService;
        this.timerService = timerService;
    }
    AutoSkipTimerComponent.prototype.ngOnInit = function () {
        this.counter = this.time;
    };
    AutoSkipTimerComponent.prototype.ngOnDestroy = function () {
    };
    return AutoSkipTimerComponent;
}());
auto_skip_timer_component___decorate([
    Object(core_es5["F" /* Input */])(),
    auto_skip_timer_component___metadata("design:type", Number)
], AutoSkipTimerComponent.prototype, "time", void 0);
AutoSkipTimerComponent = auto_skip_timer_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'auto-skip-timer',
        template: __webpack_require__("8Byu"),
    }),
    auto_skip_timer_component___metadata("design:paramtypes", [typeof (auto_skip_timer_component__a = typeof test_navigation_service_TestNavigationService !== "undefined" && test_navigation_service_TestNavigationService) === "function" && auto_skip_timer_component__a || Object, typeof (auto_skip_timer_component__b = typeof timer_service_TimerService !== "undefined" && timer_service_TimerService) === "function" && auto_skip_timer_component__b || Object])
], AutoSkipTimerComponent);

var auto_skip_timer_component__a, auto_skip_timer_component__b;
//# sourceMappingURL=auto-skip-timer.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/misc/end-of-test/end-of-test.component.ts
var end_of_test_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var end_of_test_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var end_of_test_component_EndOfTestComponent = (function () {
    function EndOfTestComponent(store, testNavigationService, testTakerService, htmlService, changeDetectorRef) {
        this.store = store;
        this.testNavigationService = testNavigationService;
        this.testTakerService = testTakerService;
        this.htmlService = htmlService;
        this.changeDetectorRef = changeDetectorRef;
        this.testTypeName = "[TestTypeName]";
        this.endOfTestEventName = "tdp:end-of-test";
        this.isWebDelivery = config_helper_ConfigHelper.isTdpMode(true);
    }
    EndOfTestComponent.prototype.ngOnInit = function () {
        if (config_helper_ConfigHelper.isTdpMode(true)) {
            this.testNavigationService.disableWindowUnloadingWarning();
            setTimeout(function () {
                window.location.href = "about:blank#end";
            }, 45000);
        }
        this.testTakerService.uploadTestTakerLog();
    };
    EndOfTestComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.testLogoImageData = this.htmlService.getResourceUrl(this.pictureResourceId);
        this.testTakerPhotoUrl = this.testTakerService.getBlankTestTakerPhotoUrl();
        this.testTakerInfoSubscription = this.store.select(reducers_getTestTakerInfo).subscribe(function (testTakerInfo) {
            if (testTakerInfo) {
                _this.testTakerPhotoUrl = _this.testTakerService.getTestTakerPhotoUrl(testTakerInfo.BrandName, testTakerInfo.TestSessionSiteCode, testTakerInfo.TestTakerId);
                _this.testTypeName = testTakerInfo.TestTypeName;
                _this.changeDetectorRef.markForCheck();
                _this.sendEndOfTestEventToSecureBrowser();
            }
        });
        this.testletIdSubscription = this.store.select(reducers_getCurrentTestletId).subscribe(function (currentTestletId) {
            _this.testNavigationService.indicateEndOfTest(currentTestletId);
        });
    };
    EndOfTestComponent.prototype.ngDestroy = function () {
        this.testletIdSubscription.unsubscribe();
        this.testTakerInfoSubscription.unsubscribe();
    };
    EndOfTestComponent.prototype.sendEndOfTestEventToSecureBrowser = function () {
        var event = new MessageEvent(this.endOfTestEventName, {
            bubbles: true,
            cancelable: false,
            data: ''
        });
        document.dispatchEvent(event);
    };
    return EndOfTestComponent;
}());
end_of_test_component___decorate([
    Object(core_es5["F" /* Input */])(),
    end_of_test_component___metadata("design:type", Number)
], end_of_test_component_EndOfTestComponent.prototype, "pictureResourceId", void 0);
end_of_test_component_EndOfTestComponent = end_of_test_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'end-of-test',
        template: __webpack_require__("37O9"),
    }),
    end_of_test_component___metadata("design:paramtypes", [typeof (end_of_test_component__a = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && end_of_test_component__a || Object, typeof (end_of_test_component__b = typeof test_navigation_service_TestNavigationService !== "undefined" && test_navigation_service_TestNavigationService) === "function" && end_of_test_component__b || Object, typeof (end_of_test_component__c = typeof test_taker_service_TestTakerService !== "undefined" && test_taker_service_TestTakerService) === "function" && end_of_test_component__c || Object, typeof (end_of_test_component__d = typeof html_service_HtmlService !== "undefined" && html_service_HtmlService) === "function" && end_of_test_component__d || Object, typeof (end_of_test_component__e = typeof core_es5["l" /* ChangeDetectorRef */] !== "undefined" && core_es5["l" /* ChangeDetectorRef */]) === "function" && end_of_test_component__e || Object])
], end_of_test_component_EndOfTestComponent);

var end_of_test_component__a, end_of_test_component__b, end_of_test_component__c, end_of_test_component__d, end_of_test_component__e;
//# sourceMappingURL=end-of-test.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/ipp/ipp-writing-sample-response/ipp-writing-sample-response.component.ts
var ipp_writing_sample_response_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ipp_writing_sample_response_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var IppWritingSampleResponseComponent = (function () {
    function IppWritingSampleResponseComponent(myModal, htmlService) {
        this.myModal = myModal;
        this.htmlService = htmlService;
    }
    IppWritingSampleResponseComponent.prototype.showDialog = function () {
        var _this = this;
        this.htmlService.getHtmlResource(this.resourceId).subscribe(function (html) {
            _this.myModal.showRegularDlg(_this.title, html, [
                { label: "Close", style: "btn-primary" }
            ]);
        });
    };
    return IppWritingSampleResponseComponent;
}());
ipp_writing_sample_response_component___decorate([
    Object(core_es5["F" /* Input */])(),
    ipp_writing_sample_response_component___metadata("design:type", String)
], IppWritingSampleResponseComponent.prototype, "title", void 0);
ipp_writing_sample_response_component___decorate([
    Object(core_es5["F" /* Input */])(),
    ipp_writing_sample_response_component___metadata("design:type", Number)
], IppWritingSampleResponseComponent.prototype, "resourceId", void 0);
IppWritingSampleResponseComponent = ipp_writing_sample_response_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'ipp-writing-sample-response',
        template: __webpack_require__("Wzg8")
    }),
    ipp_writing_sample_response_component___metadata("design:paramtypes", [typeof (ipp_writing_sample_response_component__a = typeof my_modal_component_MyModal !== "undefined" && my_modal_component_MyModal) === "function" && ipp_writing_sample_response_component__a || Object, typeof (ipp_writing_sample_response_component__b = typeof html_service_HtmlService !== "undefined" && html_service_HtmlService) === "function" && ipp_writing_sample_response_component__b || Object])
], IppWritingSampleResponseComponent);

var ipp_writing_sample_response_component__a, ipp_writing_sample_response_component__b;
//# sourceMappingURL=ipp-writing-sample-response.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/ipp/ipp-landing-page/ipp-landing-page.component.ts
var ipp_landing_page_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ipp_landing_page_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};









var ipp_landing_page_component_IppLandingPageComponent = (function () {
    function IppLandingPageComponent(store, htmlService, testNavigationService, testTakerService, testContentService, myModal) {
        var _this = this;
        this.store = store;
        this.htmlService = htmlService;
        this.testNavigationService = testNavigationService;
        this.testTakerService = testTakerService;
        this.testContentService = testContentService;
        this.myModal = myModal;
        this.tests = [];
        this.imageReady = false;
        this.associatedAssessmentTests$ = store.select(reducers_getAssociatedAssessmentTests);
        this.associatedAssessmentTestsSubscription = this.associatedAssessmentTests$.subscribe(function (associatedAssessmentTestIds) {
            _this.associatedAssessmentTestIds = associatedAssessmentTestIds;
        });
        this.testNavigationService.setCanGoNext(false);
    }
    IppLandingPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.associatedAssessmentTestIds.length != 0) {
            this.testContentService.getProductInfo(this.associatedAssessmentTestIds[0].toString()).subscribe(function (dto) {
                if (dto != null) {
                    _this.productName = dto.Name;
                }
            });
        }
        if (_paragonConfig.mode === "ipp") {
            this.testTakerService.getIppTestTakerInfo(this.associatedAssessmentTestIds[0]).subscribe(function (ippTestTakerInfo) {
                _this.store.dispatch(new test_taker_action_namespaceObject.SetTestTakerInfo(ippTestTakerInfo));
                _this.imageData = _this.htmlService.getResourceUrl(_this.pictureResourceId);
                _this.getPreTestDescription();
            });
        }
        else {
            this.imageData = this.htmlService.getResourceUrl(this.pictureResourceId);
            this.getPreTestDescription();
        }
        this.changeLandingPageCss(true);
        this.getAvailableIppAssessmentTests();
        this.isModalVisible = false;
    };
    IppLandingPageComponent.prototype.changeLandingPageCss = function (shouldAdd) {
        if (shouldAdd) {
            $("top-nav").addClass("landing-page");
            $("div.view-container").addClass("landing-page");
        }
        else {
            $("top-nav").removeClass("landing-page");
            $("div.view-container").removeClass("landing-page");
        }
    };
    // if there is more than 1 test form associated with product, show list of test forms
    // otherwise, just start up the session
    IppLandingPageComponent.prototype.chooseIppTest = function () {
        if (this.associatedAssessmentTestIds.length > 1 && _paragonConfig.mode == "ipp") {
            this.isModalVisible = true;
        }
        else {
            this.changeLandingPageCss(false);
            this.testNavigationService.setCanGoNext(true);
            this.testNavigationService.goNext(true);
        }
    };
    // start up the session using the selected test form
    IppLandingPageComponent.prototype.startIppTest = function (ippAssessmentTestId) {
        var _this = this;
        this.changeLandingPageCss(false);
        this.store.dispatch(new test_taker_action_namespaceObject.LoadIppAssessmentTest(ippAssessmentTestId));
        this.testTakerService.getIppTestTakerInfo(ippAssessmentTestId).subscribe(function (ippTestTakerInfo) {
            _this.store.dispatch(new test_taker_action_namespaceObject.SetTestTakerInfo(ippTestTakerInfo));
        });
        this.loadTestletsAndNavigateToFirstTestlet(ippAssessmentTestId);
    };
    IppLandingPageComponent.prototype.loadTestletsAndNavigateToFirstTestlet = function (assessmentTestId) {
        var _this = this;
        this.testContentService.getIppAssessmentTest(assessmentTestId).subscribe(function (ippAssessmentTestDto) {
            _this.testNavigationService.getTestlets(ippAssessmentTestDto.IppAssessmentTest).forEach(function (t) {
                _this.store.dispatch(new test_taker_action_namespaceObject.LoadTestlet(t.testletId, ippAssessmentTestDto.IppAssessmentTest));
            });
            var firstTestlet = _this.testNavigationService.getTestlets(ippAssessmentTestDto.IppAssessmentTest)[1];
            var landingPageNavigation = firstTestlet.testNavigation;
            _this.store.dispatch(new test_taker_action_namespaceObject.SetTestNavigation(landingPageNavigation));
        }, function (error) {
            _this.myModal.showRegularDlg("Error", error);
        });
    };
    IppLandingPageComponent.prototype.getAvailableIppAssessmentTests = function () {
        var _this = this;
        this.associatedAssessmentTestIds.forEach(function (id) {
            _this.testContentService.getIppAssessmentTest(id).subscribe(function (ippAssessmentTest) {
                _this.tests.push(ippAssessmentTest);
            });
        });
    };
    IppLandingPageComponent.prototype.getPreTestDescription = function () {
        var _this = this;
        this.htmlService.getHtmlResource(this.htmlResourceId).subscribe(function (html) {
            var regex = /<div id="popup" title="([\s\S]*?)">([\s\S]*?)<\/div>/igm;
            var matchedArray;
            if ((matchedArray = regex.exec(html)) != null) {
                if (_this.imageReady) {
                    _this.myModal.showRegularDlg(matchedArray[1], matchedArray[2]);
                }
                else {
                    // Delay dialog
                    var cb_1 = _this.onImageReady;
                    _this.onImageReady = function () {
                        _this.myModal.showRegularDlg(matchedArray[1], matchedArray[2]);
                        cb_1.apply(_this);
                    };
                }
            }
            html = html.replace(regex, "");
            html = html.replace(/<p id="warning" title="([\s\S]*?)">([\s\S]*?)<\/p>/igm, "<p id=\"warning\" class=\"alert alert-block alert-info\"\"><span class=\"badge badge-important\">$1</span> $2</p>");
            _this.preTestDescription = _this.htmlService.getSafeHtml(html);
        });
    };
    IppLandingPageComponent.prototype.onImageReady = function () {
        this.imageReady = true;
    };
    IppLandingPageComponent.prototype.closeModal = function () {
        this.isModalVisible = false;
    };
    return IppLandingPageComponent;
}());
ipp_landing_page_component___decorate([
    Object(core_es5["F" /* Input */])(),
    ipp_landing_page_component___metadata("design:type", Number)
], ipp_landing_page_component_IppLandingPageComponent.prototype, "htmlResourceId", void 0);
ipp_landing_page_component___decorate([
    Object(core_es5["F" /* Input */])(),
    ipp_landing_page_component___metadata("design:type", Number)
], ipp_landing_page_component_IppLandingPageComponent.prototype, "pictureResourceId", void 0);
ipp_landing_page_component_IppLandingPageComponent = ipp_landing_page_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'ipp-landing-page',
        template: __webpack_require__("iioE")
    }),
    ipp_landing_page_component___metadata("design:paramtypes", [typeof (ipp_landing_page_component__a = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && ipp_landing_page_component__a || Object, typeof (ipp_landing_page_component__b = typeof html_service_HtmlService !== "undefined" && html_service_HtmlService) === "function" && ipp_landing_page_component__b || Object, typeof (ipp_landing_page_component__c = typeof test_navigation_service_TestNavigationService !== "undefined" && test_navigation_service_TestNavigationService) === "function" && ipp_landing_page_component__c || Object, typeof (ipp_landing_page_component__d = typeof test_taker_service_TestTakerService !== "undefined" && test_taker_service_TestTakerService) === "function" && ipp_landing_page_component__d || Object, typeof (ipp_landing_page_component__e = typeof test_content_service_TestContentService !== "undefined" && test_content_service_TestContentService) === "function" && ipp_landing_page_component__e || Object, typeof (ipp_landing_page_component__f = typeof my_modal_component_MyModal !== "undefined" && my_modal_component_MyModal) === "function" && ipp_landing_page_component__f || Object])
], ipp_landing_page_component_IppLandingPageComponent);

var ipp_landing_page_component__a, ipp_landing_page_component__b, ipp_landing_page_component__c, ipp_landing_page_component__d, ipp_landing_page_component__e, ipp_landing_page_component__f;
//# sourceMappingURL=ipp-landing-page.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/ipp/ipp-speaking-sample-response/ipp-speaking-sample-response.component.ts
var ipp_speaking_sample_response_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ipp_speaking_sample_response_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var IppSpeakingSampleResponseComponent = (function () {
    function IppSpeakingSampleResponseComponent(myModal, htmlService) {
        this.myModal = myModal;
        this.htmlService = htmlService;
        this.modalContent = '<div class="speaking-sample-response"><audio controls><source src="{{srcUrl}}" type="video/mp4">Your browser does not support the audio element.</audio></div>';
    }
    IppSpeakingSampleResponseComponent.prototype.showDialog = function () {
        var srcUrl = this.htmlService.getResourceUrl(this.resourceId);
        this.modalContent = this.modalContent.replace("{{srcUrl}}", "" + srcUrl);
        this.myModal.showRegularDlg(this.title, this.modalContent, [
            { label: "Close", style: "btn-primary" }
        ]);
    };
    return IppSpeakingSampleResponseComponent;
}());
ipp_speaking_sample_response_component___decorate([
    Object(core_es5["F" /* Input */])(),
    ipp_speaking_sample_response_component___metadata("design:type", String)
], IppSpeakingSampleResponseComponent.prototype, "title", void 0);
ipp_speaking_sample_response_component___decorate([
    Object(core_es5["F" /* Input */])(),
    ipp_speaking_sample_response_component___metadata("design:type", Number)
], IppSpeakingSampleResponseComponent.prototype, "resourceId", void 0);
IppSpeakingSampleResponseComponent = ipp_speaking_sample_response_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'ipp-speaking-sample-response',
        template: __webpack_require__("cGR7")
    }),
    ipp_speaking_sample_response_component___metadata("design:paramtypes", [typeof (ipp_speaking_sample_response_component__a = typeof my_modal_component_MyModal !== "undefined" && my_modal_component_MyModal) === "function" && ipp_speaking_sample_response_component__a || Object, typeof (ipp_speaking_sample_response_component__b = typeof html_service_HtmlService !== "undefined" && html_service_HtmlService) === "function" && ipp_speaking_sample_response_component__b || Object])
], IppSpeakingSampleResponseComponent);

var ipp_speaking_sample_response_component__a, ipp_speaking_sample_response_component__b;
//# sourceMappingURL=ipp-speaking-sample-response.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/ipp/ipp-transcript/ipp-transcript.component.ts
var ipp_transcript_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ipp_transcript_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var IppTranscriptComponent = (function () {
    function IppTranscriptComponent(myModal, htmlService) {
        this.myModal = myModal;
        this.htmlService = htmlService;
    }
    IppTranscriptComponent.prototype.showDialog = function () {
        var _this = this;
        this.htmlService.getResourceTranscript(this.resourceId).subscribe(function (resourceDto) {
            _this.myModal.showRegularDlg(_this.title, "<div class=\"transcript-modal\">" + resourceDto.Transcript + "</div>", [
                { label: "Close", style: "btn-primary" }
            ]);
        });
    };
    return IppTranscriptComponent;
}());
ipp_transcript_component___decorate([
    Object(core_es5["F" /* Input */])(),
    ipp_transcript_component___metadata("design:type", String)
], IppTranscriptComponent.prototype, "title", void 0);
ipp_transcript_component___decorate([
    Object(core_es5["F" /* Input */])(),
    ipp_transcript_component___metadata("design:type", Number)
], IppTranscriptComponent.prototype, "resourceId", void 0);
IppTranscriptComponent = ipp_transcript_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'ipp-transcript',
        template: __webpack_require__("5XV9")
    }),
    ipp_transcript_component___metadata("design:paramtypes", [typeof (ipp_transcript_component__a = typeof my_modal_component_MyModal !== "undefined" && my_modal_component_MyModal) === "function" && ipp_transcript_component__a || Object, typeof (ipp_transcript_component__b = typeof html_service_HtmlService !== "undefined" && html_service_HtmlService) === "function" && ipp_transcript_component__b || Object])
], IppTranscriptComponent);

var ipp_transcript_component__a, ipp_transcript_component__b;
//# sourceMappingURL=ipp-transcript.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/services/preview.service.ts
var preview_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var preview_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var preview_service_PreviewService = (function () {
    function PreviewService(testTakerService) {
        this.testTakerService = testTakerService;
    }
    PreviewService.prototype.getPreviewResponsesHtml = function (interactions, responseService, responseScores) {
        var _this = this;
        var html = "";
        interactions.forEach(function (interaction) {
            var response = responseService.getResponse(interaction);
            var responseScore = responseScores.ResponseScores.find(function (r) { return r.InteractionId == interaction.InteractionId; });
            html += _this.createRowHtml(interaction, response, responseScore);
        });
        return "\n        <table class=\"table table-bordered preview-response\">\n            <tr>\n                <th class=\"text-center\">Ref #</th>\n                <th class=\"text-center\">Score(s)</th>\n                <th>Your Response(s)</th>\n                <th>Answer(s)</th>\n            </tr>\n            " + html + "\n        </table>\n        ";
    };
    PreviewService.prototype.createRowHtml = function (interaction, response, responseScore) {
        var userResponseHtml = "";
        if (response) {
            userResponseHtml = this.createUserResponseHtml(interaction, response);
        }
        var correctAnswerHtml = this.createCorrectAnswerHtml(interaction);
        return "\n        <tr>\n            <td class=\"text-center\">" + interaction.InteractionRefNum + "</td>\n            <td class=\"text-center\">" + ((responseScore && responseScore.Score != null) ? responseScore.Score : '') + "</td>\n            <td>" + userResponseHtml + "</td>\n            <td>" + correctAnswerHtml + "</td>\n        </tr>\n        ";
    };
    PreviewService.prototype.createUserResponseHtml = function (interaction, response) {
        var html = "";
        if (!response) {
            return html;
        }
        switch (interaction.InteractionTypeId) {
            case InteractionTypeEnum.Speaking: {
                if (config_helper_ConfigHelper.isIppMode()) {
                    var sourcePath = config_helper_ConfigHelper.testContentServerApiUrl() + "/api/resource/audio/" + this.testTakerService.testTakerInfo.TestTakerId + "/" + this.testTakerService.testTakerInfo.TestSessionId + "/" + response.InteractionId;
                    html = "<audio src='" + sourcePath + "' controls=''></audio>";
                }
                break;
            }
            case InteractionTypeEnum.Choice: {
                interaction.ChoiceInteraction.SimpleChoices.forEach(function (choice) {
                    var item = response.Items.find(function (x) { return x.Value == choice.Identifier; });
                    if (item) {
                        html += choice.Html + "<br>";
                    }
                });
                break;
            }
            case InteractionTypeEnum.InlineChoice: {
                interaction.InlineChoiceInteraction.InlineChoices.forEach(function (choice) {
                    var item = response.Items.find(function (x) { return x.Value == choice.Identifier; });
                    if (item) {
                        html += choice.Html + "<br>";
                    }
                });
                break;
            }
            case InteractionTypeEnum.Hotspot: {
                response.Items.forEach(function (item) {
                    if (item.Value) {
                        html += item.Value + "<br>";
                    }
                });
                break;
            }
            case InteractionTypeEnum.Order: {
                response.Items.forEach(function (item) {
                    var choice = interaction.OrderInteraction.SimpleChoices.find(function (c) { return c.Identifier == item.Value; });
                    if (choice) {
                        html += choice.Html + "<br>";
                    }
                });
                break;
            }
            case InteractionTypeEnum.ExtendedText: {
                response.Items.forEach(function (item) {
                    if (item.Text) {
                        html += "" + item.Text;
                    }
                });
                break;
            }
            case InteractionTypeEnum.TextEntry: {
                response.Items.forEach(function (item) {
                    if (item.Value) {
                        html += "" + item.Value;
                    }
                });
                break;
            }
            case InteractionTypeEnum.Associate: {
                var tempHtml_1;
                interaction.AssociateInteraction.ResponseDeclaration.Mapping.MapEntries.forEach(function (entry, entryIndex) {
                    tempHtml_1 = "";
                    var pairedItems = response.Items.filter(function (x) { return x.Key == entryIndex.toString(); });
                    pairedItems.forEach(function (item, itemIndex) {
                        var choice = interaction.AssociateInteraction.SimpleAssociableChoices.find(function (x) { return x.Identifier == item.Value; });
                        if (choice) {
                            tempHtml_1 += "" + choice.Html;
                            if (itemIndex < pairedItems.length - 1) {
                                tempHtml_1 += " : ";
                            }
                        }
                    });
                    if (tempHtml_1.length > 0) {
                        html += tempHtml_1 + "<br>";
                    }
                });
                break;
            }
            case InteractionTypeEnum.Match: {
                var matchInteraction = interaction.MatchInteraction;
                var groups = matchInteraction.SimpleMatchSets[1].SimpleAssociableChoices;
                var choices_1 = matchInteraction.SimpleMatchSets[0].SimpleAssociableChoices;
                groups.forEach(function (group) {
                    html += "<strong>" + group.Html + "</strong><br>";
                    var groupItems = response.Items.filter(function (x) { return x.Key == group.Identifier; });
                    groupItems.forEach(function (groupResponse) {
                        var choice = choices_1.find(function (c) { return groupResponse.Value == c.Identifier; });
                        if (choice) {
                            html += "- " + choice.Html + " <br>";
                        }
                    });
                    html += "<br>";
                });
                break;
            }
            default:
                break;
        }
        return html;
    };
    PreviewService.prototype.createCorrectAnswerHtml = function (interaction) {
        var html = "";
        switch (interaction.InteractionTypeId) {
            case InteractionTypeEnum.Choice: {
                var choiceInteraction_1 = interaction.ChoiceInteraction;
                if (choiceInteraction_1.ResponseDeclaration.AllowPartialScoring === true) {
                    choiceInteraction_1.ResponseDeclaration.Mapping.MapEntries
                        .filter(function (x) { return x && x.MappedValue != 0; })
                        .map(function (x) {
                        var choice = choiceInteraction_1.SimpleChoices.find(function (c) { return c.Identifier == x.MapKey; });
                        if (choice) {
                            html += choice.Html + " (Weight: " + x.MappedValue + ")<br>";
                        }
                    });
                }
                else {
                    choiceInteraction_1.ResponseDeclaration.CorrectResponse.Values.forEach(function (x) {
                        var choice = choiceInteraction_1.SimpleChoices.find(function (c) { return c.Identifier == x.DataValue; });
                        if (choice) {
                            html += choice.Html + "<br>";
                        }
                    });
                }
                break;
            }
            case InteractionTypeEnum.InlineChoice: {
                var inlineChoiceInteraction_1 = interaction.InlineChoiceInteraction;
                inlineChoiceInteraction_1.ResponseDeclaration.CorrectResponse.Values.forEach(function (x) {
                    var choice = inlineChoiceInteraction_1.InlineChoices.find(function (c) { return c.Identifier == x.DataValue; });
                    if (choice) {
                        html += choice.Html + "<br>";
                    }
                });
                break;
            }
            case InteractionTypeEnum.Hotspot: {
                var hotspotInteraction = interaction.HotspotInteraction;
                if (hotspotInteraction.ResponseDeclaration.AllowPartialScoring === true) {
                    hotspotInteraction.ResponseDeclaration.Mapping.MapEntries
                        .filter(function (x) { return x && x.MappedValue != 0; })
                        .map(function (x) { return html += x.MapKey + " (Weight: " + x.MappedValue + ")<br>"; });
                }
                else {
                    hotspotInteraction.ResponseDeclaration.CorrectResponse.Values.forEach(function (x) { return html += x.DataValue + "<br>"; });
                }
                break;
            }
            case InteractionTypeEnum.Order: {
                var orderInteraction = interaction.OrderInteraction;
                orderInteraction.SimpleChoices.forEach(function (choice) {
                    html += choice.Html + "<br>";
                });
                break;
            }
            case InteractionTypeEnum.Associate: {
                var tempHtml_2;
                interaction.AssociateInteraction.ResponseDeclaration.Mapping.MapEntries.forEach(function (entry, entryIndex) {
                    tempHtml_2 = "";
                    var keys = entry.MapKey.split(" ");
                    keys.forEach(function (key, keyIndex) {
                        var choice = interaction.AssociateInteraction.SimpleAssociableChoices.find(function (x) { return x.Identifier == key; });
                        if (choice) {
                            tempHtml_2 += "" + choice.Html;
                            if (keyIndex == 0) {
                                tempHtml_2 += " : ";
                            }
                        }
                    });
                    if (tempHtml_2.length > 0) {
                        html += tempHtml_2 + "<br>";
                    }
                });
                break;
            }
            case InteractionTypeEnum.Match: {
                var matchInteraction_1 = interaction.MatchInteraction;
                var groups = matchInteraction_1.SimpleMatchSets[1].SimpleAssociableChoices;
                var choices_2 = matchInteraction_1.SimpleMatchSets[0].SimpleAssociableChoices;
                groups.forEach(function (group) {
                    html += "<strong>" + group.Html + "</strong><br>";
                    var groupChoices = matchInteraction_1.ResponseDeclaration.Mapping.MapEntries
                        .filter(function (entry) { return entry.MapKey.indexOf(group.Identifier) >= 0; })
                        .forEach(function (entry) {
                        var choice = choices_2.find(function (c) { return entry.MapKey.indexOf(c.Identifier) >= 0; });
                        if (choice) {
                            html += "- " + choice.Html + " <br>";
                        }
                    });
                    html += "<br>";
                });
                break;
            }
            case InteractionTypeEnum.TextEntry: {
                var textEntryInteraction = interaction.TextEntryInteraction;
                if (textEntryInteraction.ResponseRatingType == RatingTypeEnum.MachineScored) {
                    html += textEntryInteraction.ResponseDeclaration.Mapping.MapEntries
                        .map(function (entry) { return "" + entry.MapKey + (entry.MappedValue != 1 ? " (" + entry.MappedValue + ")" : ""); })
                        .join(', ');
                }
                break;
            }
            default:
                break;
        }
        return html.trim();
    };
    return PreviewService;
}());
preview_service_PreviewService = preview_service___decorate([
    Object(core_es5["C" /* Injectable */])(),
    preview_service___metadata("design:paramtypes", [typeof (preview_service__a = typeof test_taker_service_TestTakerService !== "undefined" && test_taker_service_TestTakerService) === "function" && preview_service__a || Object])
], preview_service_PreviewService);

var preview_service__a;
//# sourceMappingURL=preview.service.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/services/answerkey.service.ts
var answerkey_service___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var answerkey_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var answerkey_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var answerkey_service_AnswerKeyService = (function (_super) {
    answerkey_service___extends(AnswerKeyService, _super);
    function AnswerKeyService(http, httpClient, store, loggerService, authService) {
        return _super.call(this, http, httpClient, store, loggerService, authService) || this;
    }
    AnswerKeyService.prototype.ngOnDestroy = function () {
    };
    AnswerKeyService.prototype.getAnswerKeys = function (responses) {
        return this.request({
            method: http_es5["e" /* RequestMethod */].Post,
            url: this.testContentServerApiUrl + "/api/testlet/preview/answerkey",
            body: responses
        });
    };
    return AnswerKeyService;
}(base_http_service_BaseHttpService));
answerkey_service_AnswerKeyService = answerkey_service___decorate([
    Object(core_es5["C" /* Injectable */])(),
    answerkey_service___metadata("design:paramtypes", [typeof (answerkey_service__a = typeof http_es5["b" /* Http */] !== "undefined" && http_es5["b" /* Http */]) === "function" && answerkey_service__a || Object, typeof (answerkey_service__b = typeof common_http_es5["a" /* HttpClient */] !== "undefined" && common_http_es5["a" /* HttpClient */]) === "function" && answerkey_service__b || Object, typeof (answerkey_service__c = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && answerkey_service__c || Object, typeof (answerkey_service__d = typeof LoggerService !== "undefined" && LoggerService) === "function" && answerkey_service__d || Object, typeof (answerkey_service__e = typeof auth_service_AuthService !== "undefined" && auth_service_AuthService) === "function" && answerkey_service__e || Object])
], answerkey_service_AnswerKeyService);

var answerkey_service__a, answerkey_service__b, answerkey_service__c, answerkey_service__d, answerkey_service__e;
//# sourceMappingURL=answerkey.service.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/ipp/ipp-answerkey/ipp-answerkey.component.ts
var ipp_answerkey_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ipp_answerkey_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};









var ipp_answerkey_component_IppAnswerkeyComponent = (function () {
    function IppAnswerkeyComponent(store, responseService, answerKeyService, previewService, testNavigationService, testContentService) {
        var _this = this;
        this.store = store;
        this.responseService = responseService;
        this.answerKeyService = answerKeyService;
        this.previewService = previewService;
        this.testNavigationService = testNavigationService;
        this.testContentService = testContentService;
        this.testlets = [];
        this.answerKeys = [];
        this.answerKeyReady = false;
        this.isFOST = true;
        this.getInteractionResponses = function (answerKeyDtos) {
            var interactionIds = [].concat.apply([], answerKeyDtos.map(function (a) { return a.InteractionDefinitions.map(function (i) { return i.InteractionId; }); }));
            return _this.responseService.responses.filter(function (x) { return interactionIds.indexOf(x.InteractionId) >= 0; });
        };
        this.testNavigationSubscription = store.select(reducers_getTestNavigation).subscribe(function (testNavigation) {
            _this.testNavigation = testNavigation;
            _this.answerKeys = [];
            _this.answerKeyUpdate(_this.testNavigation, _this.assessmentTest);
        });
        this.assessmentTestSubscription = store.select(reducers_getAssessmentTest).subscribe(function (assessmentTest) {
            _this.assessmentTest = assessmentTest;
            _this.answerKeys = [];
            _this.answerKeyUpdate(_this.testNavigation, _this.assessmentTest);
        });
    }
    IppAnswerkeyComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.testContentService.getProductInfo(this.assessmentTest.Identifier).subscribe(function (productDto) {
            _this.isFOST = !productDto.NeedsPurchase;
        });
    };
    IppAnswerkeyComponent.prototype.ngAfterViewInit = function () {
    };
    IppAnswerkeyComponent.prototype.ngOnDestroy = function () {
        if (this.testNavigationSubscription) {
            this.testNavigationSubscription.unsubscribe();
        }
        if (this.assessmentTestSubscription) {
            this.assessmentTestSubscription.unsubscribe();
        }
    };
    IppAnswerkeyComponent.prototype.answerKeyUpdate = function (testNavigation, assessmentTest) {
        var _this = this;
        if (testNavigation && assessmentTest) {
            this.answerKeyReady = false;
            var testPartIndex = testNavigation.testPartIndex;
            this.testlets = this.testNavigationService.getTestletsByTestPart(assessmentTest.TestParts[testPartIndex], testPartIndex);
            var answerKeyDtos_1 = [];
            var interactionResponses_1 = [];
            var testletIds = this.testlets.map(function (t) { return t.testletId; });
            this.answerKeyService
                .getAnswerKeys(testletIds)
                .map(function (dtos) {
                answerKeyDtos_1 = dtos;
                interactionResponses_1 = _this.getInteractionResponses(dtos);
                return interactionResponses_1;
            })
                .flatMap(function (interactionResponses) { return _this.testContentService.getPreviewResponseScores(interactionResponses); })
                .subscribe(function (responseScoreDto) {
                var _loop_1 = function () {
                    var testlet = _this.testlets[i];
                    var testletAnswerKey = {
                        TestletId: testlet.testletId,
                        TestletTitle: testlet.title,
                        InteractionAnswers: []
                    };
                    var answerKey = answerKeyDtos_1.find(function (a) { return a.TestletId == testlet.testletId; });
                    var _loop_2 = function () {
                        var interaction = answerKey.InteractionDefinitions[j];
                        var interactionAnswer = {
                            ItemIndex: interaction.ItemIndex,
                            InteractionType: interaction.InteractionTypeName,
                            CorrectResponses: _this.previewService.createCorrectAnswerHtml(interaction),
                            UserResponses: _this.previewService.createUserResponseHtml(interaction, interactionResponses_1.find(function (r) { return r.InteractionId == interaction.InteractionId; })),
                            IsCorrect: _this.isCorrect(interaction, responseScoreDto.ResponseScores.find(function (r) { return r.InteractionId == interaction.InteractionId; }))
                        };
                        testletAnswerKey.InteractionAnswers.push(interactionAnswer);
                    };
                    for (var j = 0; j < answerKey.InteractionDefinitions.length; j++) {
                        _loop_2();
                    }
                    if (testletAnswerKey.InteractionAnswers.length > 0) {
                        _this.answerKeys.push(testletAnswerKey);
                    }
                };
                for (var i = 0; i < _this.testlets.length; i++) {
                    _loop_1();
                }
                _this.answerKeyReady = true;
            });
        }
    };
    IppAnswerkeyComponent.prototype.isCorrect = function (interaction, responseScore) {
        switch (interaction.InteractionTypeId) {
            case InteractionTypeEnum.Choice:
            case InteractionTypeEnum.InlineChoice:
            case InteractionTypeEnum.TextEntry:
            case InteractionTypeEnum.Order:
            case InteractionTypeEnum.Associate:
            case InteractionTypeEnum.Match:
            case InteractionTypeEnum.Hotspot:
                return responseScore != null && responseScore.Score > 0;
            case InteractionTypeEnum.ExtendedText:
            case InteractionTypeEnum.Speaking:
                return null;
        }
    };
    return IppAnswerkeyComponent;
}());
ipp_answerkey_component___decorate([
    Object(core_es5["F" /* Input */])(),
    ipp_answerkey_component___metadata("design:type", String)
], ipp_answerkey_component_IppAnswerkeyComponent.prototype, "title", void 0);
ipp_answerkey_component___decorate([
    Object(core_es5["F" /* Input */])(),
    ipp_answerkey_component___metadata("design:type", Number)
], ipp_answerkey_component_IppAnswerkeyComponent.prototype, "resourceId", void 0);
ipp_answerkey_component_IppAnswerkeyComponent = ipp_answerkey_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'ipp-answerkey',
        template: __webpack_require__("FuR7"),
        changeDetection: core_es5["k" /* ChangeDetectionStrategy */].Default
    }),
    ipp_answerkey_component___metadata("design:paramtypes", [typeof (ipp_answerkey_component__a = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && ipp_answerkey_component__a || Object, typeof (ipp_answerkey_component__b = typeof response_service_ResponseService !== "undefined" && response_service_ResponseService) === "function" && ipp_answerkey_component__b || Object, typeof (ipp_answerkey_component__c = typeof answerkey_service_AnswerKeyService !== "undefined" && answerkey_service_AnswerKeyService) === "function" && ipp_answerkey_component__c || Object, typeof (ipp_answerkey_component__d = typeof preview_service_PreviewService !== "undefined" && preview_service_PreviewService) === "function" && ipp_answerkey_component__d || Object, typeof (ipp_answerkey_component__e = typeof test_navigation_service_TestNavigationService !== "undefined" && test_navigation_service_TestNavigationService) === "function" && ipp_answerkey_component__e || Object, typeof (ipp_answerkey_component__f = typeof test_content_service_TestContentService !== "undefined" && test_content_service_TestContentService) === "function" && ipp_answerkey_component__f || Object])
], ipp_answerkey_component_IppAnswerkeyComponent);

var ipp_answerkey_component__a, ipp_answerkey_component__b, ipp_answerkey_component__c, ipp_answerkey_component__d, ipp_answerkey_component__e, ipp_answerkey_component__f;
//# sourceMappingURL=ipp-answerkey.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/services/scoring-page.service.ts
var scoring_page_service___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var scoring_page_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var scoring_page_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var ScoringPageService = (function (_super) {
    scoring_page_service___extends(ScoringPageService, _super);
    function ScoringPageService(http, httpClient, store, loggerService, authService) {
        return _super.call(this, http, httpClient, store, loggerService, authService) || this;
    }
    ScoringPageService.prototype.ngOnDestroy = function () {
    };
    return ScoringPageService;
}(base_http_service_BaseHttpService));
ScoringPageService = scoring_page_service___decorate([
    Object(core_es5["C" /* Injectable */])(),
    scoring_page_service___metadata("design:paramtypes", [typeof (scoring_page_service__a = typeof http_es5["b" /* Http */] !== "undefined" && http_es5["b" /* Http */]) === "function" && scoring_page_service__a || Object, typeof (scoring_page_service__b = typeof common_http_es5["a" /* HttpClient */] !== "undefined" && common_http_es5["a" /* HttpClient */]) === "function" && scoring_page_service__b || Object, typeof (scoring_page_service__c = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && scoring_page_service__c || Object, typeof (scoring_page_service__d = typeof LoggerService !== "undefined" && LoggerService) === "function" && scoring_page_service__d || Object, typeof (scoring_page_service__e = typeof auth_service_AuthService !== "undefined" && auth_service_AuthService) === "function" && scoring_page_service__e || Object])
], ScoringPageService);

var scoring_page_service__a, scoring_page_service__b, scoring_page_service__c, scoring_page_service__d, scoring_page_service__e;
//# sourceMappingURL=scoring-page.service.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/ipp/ipp-scoring-page/ipp-scoring-page.component.ts
var ipp_scoring_page_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ipp_scoring_page_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};











var ipp_scoring_page_component_IppScoringPageComponent = (function () {
    function IppScoringPageComponent(store, responseService, testContentService, scoringPageService, previewService, testNavigationService, htmlService, route) {
        var _this = this;
        this.store = store;
        this.responseService = responseService;
        this.testContentService = testContentService;
        this.scoringPageService = scoringPageService;
        this.previewService = previewService;
        this.testNavigationService = testNavigationService;
        this.htmlService = htmlService;
        this.route = route;
        this.testlets = [];
        this.questionsDto = { SectionQuestions: [] };
        this.scoresDto = { SectionScores: [] };
        this.totalQuestions = 0;
        this.totalScore = 0;
        this.totalReadingQuestions = 0;
        this.totalListeningQuestions = 0;
        this.totalReadingScore = 0;
        this.totalListeningScore = 0;
        this.disclaimerText = "";
        this.scoresReady = true;
        this.isLastScoresPage = false;
        this.testNavigationSubscription = store.select(reducers_getTestNavigation).subscribe(function (testNavigation) {
            _this.testNavigation = testNavigation;
            _this.questionsDto = { SectionQuestions: [] };
            _this.scoresDto = { SectionScores: [] };
            _this.scoringPageUpdate(_this.testNavigation, _this.assessmentTest);
        });
        this.assessmentTestSubscription = store.select(reducers_getAssessmentTest).subscribe(function (assessmentTest) {
            _this.assessmentTest = assessmentTest;
            _this.questionsDto = { SectionQuestions: [] };
            _this.scoresDto = { SectionScores: [] };
            _this.scoringPageUpdate(_this.testNavigation, _this.assessmentTest);
        });
    }
    IppScoringPageComponent.prototype.ngOnInit = function () {
        this.getDisclaimerText();
    };
    IppScoringPageComponent.prototype.ngAfterViewInit = function () {
    };
    IppScoringPageComponent.prototype.ngOnDestroy = function () {
        if (this.testNavigationSubscription) {
            this.testNavigationSubscription.unsubscribe();
        }
        if (this.assessmentTestSubscription) {
            this.assessmentTestSubscription.unsubscribe();
        }
    };
    IppScoringPageComponent.prototype.scoringPageUpdate = function (testNavigation, assessmentTest) {
        if (testNavigation && assessmentTest) {
            this.scoresReady = false;
            this.isLastScoresPage = this.testNavigation.testPartIndex === this.assessmentTest.TestParts.length - 2;
            var testPartIndex = testNavigation.testPartIndex;
            this.testlets = this.testNavigationService.getTestletsByTestPart(assessmentTest.TestParts[testPartIndex], testPartIndex);
            // if this is the last scoring page, fetch the scores for the entire test (split into test parts)
            if (this.isLastScoresPage === true) {
                for (var i = 1; i < this.assessmentTest.TestParts.length - 2; i++) {
                    // the first test part is the landing page, the last two test parts are the scoring/feedback pages and end of test page
                    var sectionTestlets = this.testNavigationService.getTestletsByTestPart(this.assessmentTest.TestParts[i], i);
                    this.getSectionScores(sectionTestlets, i);
                }
            }
            else {
                this.getSectionScores(this.testlets, this.testNavigation.testPartIndex);
            }
        }
    };
    IppScoringPageComponent.prototype.clearCounters = function () {
        this.totalListeningQuestions = 0;
        this.totalReadingQuestions = 0;
        this.totalListeningScore = 0;
        this.totalReadingScore = 0;
    };
    IppScoringPageComponent.prototype.getSectionScores = function (sectionTestlets, i) {
        var _this = this;
        this.clearCounters();
        var testletIds = [];
        var interactions = [];
        var testletDefs = [];
        var numListeningQuestions = [];
        var numReadingQuestions = [];
        sectionTestlets.forEach(function (t) {
            testletIds.push(t.testletId);
        });
        this.testContentService.getTestlets(testletIds, this.assessmentTest.Identifier).subscribe(function (testletDefs) {
            // get all interactions belonging to the testlets in this test part
            testletDefs.forEach(function (t) {
                var testletInteractions = _this.testContentService.getReferencedInteractionsByTestlet(t);
                if (testletInteractions.length >= 1) {
                    if (interactions.length >= 1) {
                        interactions = interactions.concat(testletInteractions);
                    }
                    else
                        interactions = testletInteractions;
                }
            });
            var numQuestions = 0;
            interactions.forEach(function (i) {
                if (i.InteractionTypeName != "Speaking") {
                    numQuestions++;
                }
            });
            interactions.forEach(function (i) {
                if (i.ComponentTypeId == ComponentTypeEnum.Listening) {
                    numListeningQuestions.push(i.InteractionId);
                }
            });
            interactions.forEach(function (i) {
                if (i.ComponentTypeId == ComponentTypeEnum.Reading) {
                    numReadingQuestions.push(i.InteractionId);
                }
            });
            var x = {
                NumQuestions: numQuestions,
                TestPartIndex: i
            };
            _this.questionsDto.SectionQuestions.push(x);
            _this.totalListeningQuestions += numListeningQuestions.length;
            _this.totalReadingQuestions += numReadingQuestions.length;
            // fetch all the responses associated with the interactions in this test part
            var responses = _this.responseService.responses.filter(function (x) { return interactions.findIndex(function (i) { return i.InteractionId == x.InteractionId; }) >= 0; });
            // fetch scores
            var totalScore = 0;
            _this.testContentService.getPreviewResponseScores(responses).subscribe(function (responseScores) {
                responseScores.ResponseScores.forEach(function (s) {
                    totalScore += s.Score;
                    if (numListeningQuestions.includes(s.InteractionId)) {
                        _this.totalListeningScore += s.Score;
                    }
                    if (numReadingQuestions.includes(s.InteractionId)) {
                        _this.totalReadingScore += s.Score;
                    }
                });
                var y = {
                    Score: totalScore,
                    TestPartIndex: i
                };
                _this.scoresDto.SectionScores.push(y);
                // on last scores page, if all test part scores have been fetched, sort by TestPartIndex and set the summary values, then set scoresReady to true
                // the -3 is to exclude the test parts containing the landing page, last scoring page, and end of test testlets
                if (_this.isLastScoresPage === true && _this.scoresDto.SectionScores.length === _this.assessmentTest.TestParts.length - 3) {
                    _this.questionsDto.SectionQuestions.sort(function (a, b) { return a.TestPartIndex - b.TestPartIndex; });
                    _this.scoresDto.SectionScores.sort(function (a, b) { return a.TestPartIndex - b.TestPartIndex; });
                    var questions = _this.questionsDto.SectionQuestions.map(function (i) { return i.NumQuestions; });
                    _this.totalQuestions = questions.reduce(function (x, y) { return x + y; }, 0);
                    var scores = _this.scoresDto.SectionScores.map(function (i) { return i.Score; });
                    _this.totalScore = scores.reduce(function (x, y) { return x + y; }, 0);
                    _this.scoresReady = true;
                }
                else {
                    // if this is NOT the last scoring page, then set scoresReady to true
                    _this.scoresReady = !(_this.isLastScoresPage === true);
                }
            });
        });
    };
    IppScoringPageComponent.prototype.getDisclaimerText = function () {
        var _this = this;
        this.htmlService.getHtmlResource(this.htmlResourceId).subscribe(function (html) {
            _this.disclaimerText = html;
        });
    };
    return IppScoringPageComponent;
}());
ipp_scoring_page_component___decorate([
    Object(core_es5["F" /* Input */])(),
    ipp_scoring_page_component___metadata("design:type", String)
], ipp_scoring_page_component_IppScoringPageComponent.prototype, "title", void 0);
ipp_scoring_page_component___decorate([
    Object(core_es5["F" /* Input */])(),
    ipp_scoring_page_component___metadata("design:type", Number)
], ipp_scoring_page_component_IppScoringPageComponent.prototype, "htmlResourceId", void 0);
ipp_scoring_page_component_IppScoringPageComponent = ipp_scoring_page_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'ipp-scoring-page',
        template: __webpack_require__("OQQx"),
        changeDetection: core_es5["k" /* ChangeDetectionStrategy */].Default
    }),
    ipp_scoring_page_component___metadata("design:paramtypes", [typeof (ipp_scoring_page_component__a = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && ipp_scoring_page_component__a || Object, typeof (ipp_scoring_page_component__b = typeof response_service_ResponseService !== "undefined" && response_service_ResponseService) === "function" && ipp_scoring_page_component__b || Object, typeof (ipp_scoring_page_component__c = typeof test_content_service_TestContentService !== "undefined" && test_content_service_TestContentService) === "function" && ipp_scoring_page_component__c || Object, typeof (ipp_scoring_page_component__d = typeof ScoringPageService !== "undefined" && ScoringPageService) === "function" && ipp_scoring_page_component__d || Object, typeof (ipp_scoring_page_component__e = typeof preview_service_PreviewService !== "undefined" && preview_service_PreviewService) === "function" && ipp_scoring_page_component__e || Object, typeof (ipp_scoring_page_component__f = typeof test_navigation_service_TestNavigationService !== "undefined" && test_navigation_service_TestNavigationService) === "function" && ipp_scoring_page_component__f || Object, typeof (ipp_scoring_page_component__g = typeof html_service_HtmlService !== "undefined" && html_service_HtmlService) === "function" && ipp_scoring_page_component__g || Object, typeof (ipp_scoring_page_component__h = typeof router_es5["a" /* ActivatedRoute */] !== "undefined" && router_es5["a" /* ActivatedRoute */]) === "function" && ipp_scoring_page_component__h || Object])
], ipp_scoring_page_component_IppScoringPageComponent);

var ipp_scoring_page_component__a, ipp_scoring_page_component__b, ipp_scoring_page_component__c, ipp_scoring_page_component__d, ipp_scoring_page_component__e, ipp_scoring_page_component__f, ipp_scoring_page_component__g, ipp_scoring_page_component__h;
//# sourceMappingURL=ipp-scoring-page.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/ipp/ipp-feedback-page/ipp-feedback-page.component.ts
var ipp_feedback_page_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ipp_feedback_page_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};












var ipp_feedback_page_component_IppFeedbackPageComponent = (function () {
    function IppFeedbackPageComponent(store, responseService, testContentService, scoringPageService, previewService, testNavigationService, htmlService, route) {
        var _this = this;
        this.store = store;
        this.responseService = responseService;
        this.testContentService = testContentService;
        this.scoringPageService = scoringPageService;
        this.previewService = previewService;
        this.testNavigationService = testNavigationService;
        this.htmlService = htmlService;
        this.route = route;
        this.testlets = [];
        this.interactions = [];
        this.scoreSummary = { Components: [] };
        this.disclaimerText = "";
        this.bandReady = true;
        this.testNavigationSubscription = store.select(reducers_getTestNavigation).subscribe(function (testNavigation) {
            _this.testNavigation = testNavigation;
            _this.feedbackPageUpdate(_this.testNavigation, _this.assessmentTest);
        });
        this.assessmentTestSubscription = store.select(reducers_getAssessmentTest).subscribe(function (assessmentTest) {
            _this.assessmentTest = assessmentTest;
            _this.feedbackPageUpdate(_this.testNavigation, _this.assessmentTest);
        });
    }
    IppFeedbackPageComponent.prototype.feedbackPageUpdate = function (testNavigation, assessmentTest) {
        if (testNavigation && assessmentTest) {
            var testPartIndex = testNavigation.testPartIndex;
            this.testlets = this.testNavigationService.getTestletsByTestPart(assessmentTest.TestParts[testPartIndex], testPartIndex);
        }
    };
    IppFeedbackPageComponent.prototype.ngOnInit = function () {
        this.bandReady = false;
        this.getDisclaimerText();
    };
    IppFeedbackPageComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.interactions = [];
        this.setupScoreSummaries(ComponentTypeEnum.Listening, "Listening");
        this.setupScoreSummaries(ComponentTypeEnum.Reading, "Reading");
        // fetch the scores for the entire test (split into test parts)
        var sectionScoreObservable = [];
        for (var i = 1; i < this.assessmentTest.TestParts.length - 2; i++) {
            // the first test part is the landing page, the last two test parts are the scoring/feedback pages and end of test page
            var sectionTestlets = this.testNavigationService.getTestletsByTestPart(this.assessmentTest.TestParts[i], i);
            sectionScoreObservable.push(this.getSectionScores(sectionTestlets, i));
        }
        Rx["Observable"].zip.apply(Rx["Observable"], sectionScoreObservable).subscribe(function (value) {
            _this.scoreSummary.Components.forEach(function (scoreSummaryComponent) {
                scoreSummaryComponent.PercentScore = scoreSummaryComponent.TotalScore * 100 / scoreSummaryComponent.TotalQuestions;
                if (isNaN(scoreSummaryComponent.PercentScore) || scoreSummaryComponent.PercentScore < 50) {
                    scoreSummaryComponent.BandName = "Not Ready";
                }
                else if (scoreSummaryComponent.PercentScore < 67) {
                    scoreSummaryComponent.BandName = "Almost Ready";
                }
                else {
                    scoreSummaryComponent.BandName = "Ready";
                }
                _this.setBandDescription(scoreSummaryComponent);
            });
        });
    };
    IppFeedbackPageComponent.prototype.ngOnDestroy = function () {
        if (this.testNavigationSubscription) {
            this.testNavigationSubscription.unsubscribe();
        }
        if (this.assessmentTestSubscription) {
            this.assessmentTestSubscription.unsubscribe();
        }
    };
    IppFeedbackPageComponent.prototype.getSectionScores = function (sectionTestlets, testPartIndex) {
        var _this = this;
        var testletIds = sectionTestlets.map(function (s) { return s.testletId; });
        return this.testContentService
            .getTestlets(testletIds, this.assessmentTest.Identifier)
            .map(function (testletDefs) { return _this.processTestlets(testletDefs); })
            .mergeMap(function (responses) { return _this.testContentService.getPreviewResponseScores(responses); })
            .map(function (responseScores) { return _this.processResponseScores(responseScores); });
    };
    IppFeedbackPageComponent.prototype.getInteractionsFromInteractionDefinitions = function (testletDefs) {
        var _this = this;
        // get all interactions belonging to the testlets in this test part
        var interactions = [];
        testletDefs.forEach(function (t) {
            var testletInteractions = _this.testContentService.getReferencedInteractionsByTestlet(t);
            if (testletInteractions.length >= 1) {
                if (interactions.length >= 1) {
                    interactions = interactions.concat(testletInteractions);
                }
                else
                    interactions = testletInteractions;
            }
        });
        return interactions;
    };
    IppFeedbackPageComponent.prototype.setupScoreSummaries = function (componentTypeId, componentTypeName) {
        var scoreSummaryComponent = {
            ComponentTypeId: componentTypeId,
            ComponentName: componentTypeName,
            TotalQuestions: 0,
            TotalScore: 0,
            PercentScore: 0,
            BandName: "",
            BandDescription: ""
        };
        this.scoreSummary.Components.push(scoreSummaryComponent);
        return scoreSummaryComponent;
    };
    IppFeedbackPageComponent.prototype.processTestlets = function (testletDefs) {
        // Grab Summary for Components        
        var listeningSummaryComponent = this.scoreSummary.Components.find(function (c) { return c.ComponentTypeId == ComponentTypeEnum.Listening; });
        var readingSummaryComponent = this.scoreSummary.Components.find(function (c) { return c.ComponentTypeId == ComponentTypeEnum.Reading; });
        // Grab Interactions
        var interactionsInPart = this.getInteractionsFromInteractionDefinitions(testletDefs);
        this.interactions = this.interactions.concat(interactionsInPart);
        // Grab number of Questions
        interactionsInPart.forEach(function (i) {
            if (i.ComponentTypeId == 1) {
                listeningSummaryComponent.TotalQuestions++;
            }
            else if (i.ComponentTypeId == 2) {
                readingSummaryComponent.TotalQuestions++;
            }
        });
        // Grab all Responses in this Test Part
        return this.responseService.responses.filter(function (x) { return interactionsInPart.findIndex(function (i) { return i.InteractionId == x.InteractionId; }) >= 0; });
    };
    IppFeedbackPageComponent.prototype.processResponseScores = function (responseScores) {
        var _this = this;
        var listeningSummaryComponent = this.scoreSummary.Components.find(function (c) { return c.ComponentTypeId == ComponentTypeEnum.Listening; });
        var readingSummaryComponent = this.scoreSummary.Components.find(function (c) { return c.ComponentTypeId == ComponentTypeEnum.Reading; });
        responseScores.ResponseScores.forEach(function (s) {
            var interaction = _this.interactions.find(function (i) { return i.InteractionId === s.InteractionId; });
            if (interaction && interaction.ComponentTypeId == 1) {
                listeningSummaryComponent.TotalScore += s.Score;
            }
            else if (interaction && interaction.ComponentTypeId == 2) {
                readingSummaryComponent.TotalScore += s.Score;
            }
        });
        return;
    };
    IppFeedbackPageComponent.prototype.setBandDescription = function (scoreSummaryComponent) {
        switch (scoreSummaryComponent.BandName) {
            case "Ready":
                this.htmlService.getHtmlResource(this.readyResourceId).subscribe(function (html) {
                    scoreSummaryComponent.BandDescription = html;
                });
                break;
            case "Almost Ready":
                this.htmlService.getHtmlResource(this.almostReadyResourceId).subscribe(function (html) {
                    scoreSummaryComponent.BandDescription = html;
                });
                break;
            case "Not Ready":
                this.htmlService.getHtmlResource(this.notReadyResourceId).subscribe(function (html) {
                    scoreSummaryComponent.BandDescription = html;
                });
                break;
            default:
                break;
        }
        this.bandReady = true;
    };
    IppFeedbackPageComponent.prototype.getDisclaimerText = function () {
        var _this = this;
        this.htmlService.getHtmlResource(this.disclaimerResourceId).subscribe(function (html) {
            _this.disclaimerText = html;
        });
    };
    return IppFeedbackPageComponent;
}());
ipp_feedback_page_component___decorate([
    Object(core_es5["F" /* Input */])(),
    ipp_feedback_page_component___metadata("design:type", String)
], ipp_feedback_page_component_IppFeedbackPageComponent.prototype, "title", void 0);
ipp_feedback_page_component___decorate([
    Object(core_es5["F" /* Input */])(),
    ipp_feedback_page_component___metadata("design:type", Number)
], ipp_feedback_page_component_IppFeedbackPageComponent.prototype, "disclaimerResourceId", void 0);
ipp_feedback_page_component___decorate([
    Object(core_es5["F" /* Input */])(),
    ipp_feedback_page_component___metadata("design:type", Number)
], ipp_feedback_page_component_IppFeedbackPageComponent.prototype, "readyResourceId", void 0);
ipp_feedback_page_component___decorate([
    Object(core_es5["F" /* Input */])(),
    ipp_feedback_page_component___metadata("design:type", Number)
], ipp_feedback_page_component_IppFeedbackPageComponent.prototype, "almostReadyResourceId", void 0);
ipp_feedback_page_component___decorate([
    Object(core_es5["F" /* Input */])(),
    ipp_feedback_page_component___metadata("design:type", Number)
], ipp_feedback_page_component_IppFeedbackPageComponent.prototype, "notReadyResourceId", void 0);
ipp_feedback_page_component_IppFeedbackPageComponent = ipp_feedback_page_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'ipp-feedback-page',
        template: __webpack_require__("riDj"),
        changeDetection: core_es5["k" /* ChangeDetectionStrategy */].Default
    }),
    ipp_feedback_page_component___metadata("design:paramtypes", [typeof (ipp_feedback_page_component__a = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && ipp_feedback_page_component__a || Object, typeof (ipp_feedback_page_component__b = typeof response_service_ResponseService !== "undefined" && response_service_ResponseService) === "function" && ipp_feedback_page_component__b || Object, typeof (ipp_feedback_page_component__c = typeof test_content_service_TestContentService !== "undefined" && test_content_service_TestContentService) === "function" && ipp_feedback_page_component__c || Object, typeof (ipp_feedback_page_component__d = typeof ScoringPageService !== "undefined" && ScoringPageService) === "function" && ipp_feedback_page_component__d || Object, typeof (ipp_feedback_page_component__e = typeof preview_service_PreviewService !== "undefined" && preview_service_PreviewService) === "function" && ipp_feedback_page_component__e || Object, typeof (ipp_feedback_page_component__f = typeof test_navigation_service_TestNavigationService !== "undefined" && test_navigation_service_TestNavigationService) === "function" && ipp_feedback_page_component__f || Object, typeof (ipp_feedback_page_component__g = typeof html_service_HtmlService !== "undefined" && html_service_HtmlService) === "function" && ipp_feedback_page_component__g || Object, typeof (ipp_feedback_page_component__h = typeof router_es5["a" /* ActivatedRoute */] !== "undefined" && router_es5["a" /* ActivatedRoute */]) === "function" && ipp_feedback_page_component__h || Object])
], ipp_feedback_page_component_IppFeedbackPageComponent);

var ipp_feedback_page_component__a, ipp_feedback_page_component__b, ipp_feedback_page_component__c, ipp_feedback_page_component__d, ipp_feedback_page_component__e, ipp_feedback_page_component__f, ipp_feedback_page_component__g, ipp_feedback_page_component__h;
//# sourceMappingURL=ipp-feedback-page.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/ipp/ipp-end-of-test/ipp-end-of-test.component.ts
var ipp_end_of_test_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ipp_end_of_test_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};











var ipp_end_of_test_component_IppEndOfTestComponent = (function () {
    function IppEndOfTestComponent(store, htmlService, testNavigationService, testTakerService, testContentService, responseService, myModal, sanitizer) {
        var _this = this;
        this.store = store;
        this.htmlService = htmlService;
        this.testNavigationService = testNavigationService;
        this.testTakerService = testTakerService;
        this.testContentService = testContentService;
        this.responseService = responseService;
        this.myModal = myModal;
        this.sanitizer = sanitizer;
        this.htmlContentReady = false;
        this.assessmentTest$ = store.select(reducers_getAssessmentTest);
        this.assessmentTestSubscription = this.assessmentTest$.subscribe(function (assessmentTest) {
            _this.assessmentTest = assessmentTest;
        });
        this.associatedAssessmentTests$ = store.select(reducers_getAssociatedAssessmentTests);
        this.associatedAssessmentTestsSubscription = this.associatedAssessmentTests$.subscribe(function (associatedAssessmentTests) {
            _this.associatedAssessmentTests = associatedAssessmentTests;
        });
        this.testNavigationService.setCanGoNext(false);
    }
    IppEndOfTestComponent.prototype.ngOnInit = function () {
        this.testName = this.assessmentTest.Title;
        this.getPostTestDescription();
        this.htmlContentReady = false;
    };
    IppEndOfTestComponent.prototype.resetTest = function () {
        var landingPageTestlet = this.testNavigationService.getTestlets(this.assessmentTest)[0];
        var landingPageNavigation = landingPageTestlet.testNavigation;
        this.store.dispatch(new test_taker_action_namespaceObject.SetTestNavigation(landingPageNavigation));
        this.resetInteractions();
    };
    IppEndOfTestComponent.prototype.resetInteractions = function () {
        var _this = this;
        var testletIds = [];
        var interactions = [];
        var testletDefs = [];
        this.testNavigationService.getTestlets(this.assessmentTest).forEach(function (t) {
            testletIds.push(t.testletId);
        });
        this.testContentService.getTestlets(testletIds, this.assessmentTest.Identifier).subscribe(function (testletDefs) {
            testletDefs.forEach(function (t) {
                var testletInteractions = _this.testContentService.getReferencedInteractionsByTestlet(t);
                testletInteractions.forEach(function (i) {
                    _this.responseService.clearInteractionResponses(i.InteractionId);
                });
            });
        });
    };
    IppEndOfTestComponent.prototype.getPostTestDescription = function () {
        var _this = this;
        this.htmlService.getHtmlResource(this.htmlResourceId).subscribe(function (html) {
            _this.endOfTestDescription = _this.sanitizer.bypassSecurityTrustHtml(html);
            _this.htmlContentReady = true;
        });
    };
    return IppEndOfTestComponent;
}());
ipp_end_of_test_component___decorate([
    Object(core_es5["F" /* Input */])(),
    ipp_end_of_test_component___metadata("design:type", Number)
], ipp_end_of_test_component_IppEndOfTestComponent.prototype, "htmlResourceId", void 0);
ipp_end_of_test_component_IppEndOfTestComponent = ipp_end_of_test_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'ipp-end-of-test',
        template: __webpack_require__("mB9l")
    }),
    ipp_end_of_test_component___metadata("design:paramtypes", [typeof (ipp_end_of_test_component__a = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && ipp_end_of_test_component__a || Object, typeof (ipp_end_of_test_component__b = typeof html_service_HtmlService !== "undefined" && html_service_HtmlService) === "function" && ipp_end_of_test_component__b || Object, typeof (ipp_end_of_test_component__c = typeof test_navigation_service_TestNavigationService !== "undefined" && test_navigation_service_TestNavigationService) === "function" && ipp_end_of_test_component__c || Object, typeof (ipp_end_of_test_component__d = typeof test_taker_service_TestTakerService !== "undefined" && test_taker_service_TestTakerService) === "function" && ipp_end_of_test_component__d || Object, typeof (ipp_end_of_test_component__e = typeof test_content_service_TestContentService !== "undefined" && test_content_service_TestContentService) === "function" && ipp_end_of_test_component__e || Object, typeof (ipp_end_of_test_component__f = typeof response_service_ResponseService !== "undefined" && response_service_ResponseService) === "function" && ipp_end_of_test_component__f || Object, typeof (ipp_end_of_test_component__g = typeof my_modal_component_MyModal !== "undefined" && my_modal_component_MyModal) === "function" && ipp_end_of_test_component__g || Object, typeof (ipp_end_of_test_component__h = typeof platform_browser_es5["b" /* DomSanitizer */] !== "undefined" && platform_browser_es5["b" /* DomSanitizer */]) === "function" && ipp_end_of_test_component__h || Object])
], ipp_end_of_test_component_IppEndOfTestComponent);

var ipp_end_of_test_component__a, ipp_end_of_test_component__b, ipp_end_of_test_component__c, ipp_end_of_test_component__d, ipp_end_of_test_component__e, ipp_end_of_test_component__f, ipp_end_of_test_component__g, ipp_end_of_test_component__h;
//# sourceMappingURL=ipp-end-of-test.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/ipp/ipp-microphone-check/ipp-microphone-check.component.ts
var ipp_microphone_check_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ipp_microphone_check_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var IppMicrophoneCheckComponent = (function () {
    function IppMicrophoneCheckComponent(testNavigationService) {
        this.testNavigationService = testNavigationService;
        this.testTakerInfo = {};
    }
    IppMicrophoneCheckComponent.prototype.ngOnInit = function () {
        this.stationNumber = 1;
        this.testTakerPhotoUrl = this.renderPhoto();
        this.testTakerInfo.FirstName = "";
        this.testTakerInfo.LastName = "";
    };
    IppMicrophoneCheckComponent.prototype.audioCheckCompleted = function () {
        this.testNavigationService.goNext(true);
    };
    IppMicrophoneCheckComponent.prototype.renderPhoto = function () {
        var canvas = document.createElement('canvas');
        canvas.width = 300;
        canvas.height = 300;
        var context = canvas.getContext("2d");
        context.font = "bold 20px 'Trebuchet MS'";
        context.textAlign = "center";
        context.textBaseline = "middle";
        context.fillText("Your Photo Will Appear Here", canvas.width / 2, canvas.height / 2);
        return canvas.toDataURL();
    };
    return IppMicrophoneCheckComponent;
}());
IppMicrophoneCheckComponent = ipp_microphone_check_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'ipp-microphone-check',
        template: __webpack_require__("C1qz")
    }),
    ipp_microphone_check_component___metadata("design:paramtypes", [typeof (ipp_microphone_check_component__a = typeof test_navigation_service_TestNavigationService !== "undefined" && test_navigation_service_TestNavigationService) === "function" && ipp_microphone_check_component__a || Object])
], IppMicrophoneCheckComponent);

var ipp_microphone_check_component__a;
//# sourceMappingURL=ipp-microphone-check.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/ipp/ipp-download-response/ipp-download-response.component.ts
var ipp_download_response_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ipp_download_response_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var IppDownloadResponseComponent = (function () {
    function IppDownloadResponseComponent() {
    }
    IppDownloadResponseComponent.prototype.downloadResponses = function () {
        var elHtml = '';
        var textEntryInteractions = document.getElementsByTagName("text-entry-interaction");
        var extendedTextInteractions = document.getElementsByTagName('extended-text-interaction');
        elHtml = this.createTextEntryInteractionOutput(textEntryInteractions, elHtml);
        elHtml = this.createExtendedTextInteractionOutput(extendedTextInteractions, elHtml);
        var link = document.createElement('a');
        link.setAttribute('download', 'my-response.doc');
        link.setAttribute('href', 'data:' + 'text/doc' + ';charset=utf-8,' + encodeURIComponent(elHtml));
        link.click();
    };
    IppDownloadResponseComponent.prototype.createTextEntryInteractionOutput = function (textEntryInteractions, elHtml) {
        var i = 0;
        for (i = 0; i < textEntryInteractions.length; i++) {
            var textEntryInput = textEntryInteractions[i].children[0];
            if (i == 0) {
                var moreThanOneInput = textEntryInteractions.length > 1;
                var addAdditionalInputHeader = moreThanOneInput ? "\nPrompt 2: " : "\n\n";
                elHtml = elHtml + "Prompt 1: " + textEntryInput.value + addAdditionalInputHeader;
            }
            else if (i == textEntryInteractions.length - 1) {
                elHtml = elHtml + textEntryInput.value + "\n\n";
            }
            else {
                elHtml = elHtml + textEntryInput.value + "\nPrompt " + (i + 2) + ": ";
            }
        }
        return elHtml;
    };
    IppDownloadResponseComponent.prototype.createExtendedTextInteractionOutput = function (extendedTextInteractions, elHtml) {
        var i = 0;
        for (i = 0; i < extendedTextInteractions.length; i++) {
            var extendedTextDiv = extendedTextInteractions[i].getElementsByClassName('extended-text');
            var editorContainer = extendedTextDiv[0].getElementsByClassName('editor-container text-area');
            var element = editorContainer[0];
            if (i == 0) {
                var moreThanOneEditorContainer = extendedTextInteractions.length > 1;
                var addAdditionalTextResponseHeader = moreThanOneEditorContainer ? "\n\nShort Response 2:\n\n" : "";
                elHtml = elHtml + "Short Response 1:\n\n" + element.innerText + addAdditionalTextResponseHeader;
            }
            else if (i == extendedTextInteractions.length - 1) {
                elHtml = elHtml + element.innerText;
            }
            else {
                elHtml = elHtml + element.innerText + "\n\nShort Response " + (i + 2) + ":\n\n";
            }
        }
        return elHtml;
    };
    return IppDownloadResponseComponent;
}());
ipp_download_response_component___decorate([
    Object(core_es5["F" /* Input */])(),
    ipp_download_response_component___metadata("design:type", String)
], IppDownloadResponseComponent.prototype, "title", void 0);
IppDownloadResponseComponent = ipp_download_response_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'ipp-download-response',
        template: __webpack_require__("mZgk")
    }),
    ipp_download_response_component___metadata("design:paramtypes", [])
], IppDownloadResponseComponent);

//# sourceMappingURL=ipp-download-response.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/ipp/ipp-voice-recorder/ipp-voice-recorder.component.ts
var ipp_voice_recorder_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ipp_voice_recorder_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var ipp_voice_recorder_component_IppVoiceRecorderComponent = (function () {
    function IppVoiceRecorderComponent(elementRef, myModal, loggerService, zone) {
        var _this = this;
        this.elementRef = elementRef;
        this.myModal = myModal;
        this.loggerService = loggerService;
        this.zone = zone;
        this.step = 1;
        this.showPlayButton = function () {
            _this.zone.run(function () {
                _this.step = 3;
                _this.infoBoxVisible = false;
                _this.audioPlayer.src = "";
                if (_this.playbackSubscription) {
                    _this.playbackSubscription.unsubscribe();
                }
            });
        };
        this.playRecording = function () {
            _this.audioPlayer.src = window.URL.createObjectURL(_this.blob);
        };
    }
    IppVoiceRecorderComponent.prototype.ngOnInit = function () {
    };
    IppVoiceRecorderComponent.prototype.ngOnDestroy = function () {
        if (this.recordingSubscription) {
            this.recordingSubscription.unsubscribe();
        }
        if (this.playbackSubscription) {
            this.playbackSubscription.unsubscribe();
        }
        if (this.inputActivitySubscription) {
            this.inputActivitySubscription.unsubscribe();
        }
        if (this.preparationSubscription) {
            this.preparationSubscription.unsubscribe();
        }
    };
    IppVoiceRecorderComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.audioPlayer = this.audioWrapper.nativeElement;
        this.audioPlayer.onended = function () {
            setTimeout(function () {
                _this.showPlayButton();
            }, 1000);
        };
        this.audioPlayer.onloadeddata = function () {
            _this.step = 4;
            _this.currentProgress = 0;
            _this.infoBoxVisible = true;
            _this.infoBoxText = "Playing...";
            _this.infoBoxMode = "ProgressBar";
            _this.iconCssClass = 'play-icon';
            _this.audioPlayer.play();
            var duration = _this.recordTime + 1;
            _this.playbackSubscription = Rx["Observable"].interval(1000)
                .take(duration)
                .subscribe(function (x) {
                var timeElapsed = x + 1;
                _this.currentProgress = _this.setProgress(timeElapsed, _this.recordTime);
            });
        };
    };
    IppVoiceRecorderComponent.prototype.start = function () {
        if (this.prepTime > 0) {
            this.startPreparation();
        }
        else {
            this.startRecording();
        }
    };
    IppVoiceRecorderComponent.prototype.startPreparation = function () {
        var _this = this;
        this.step = 2;
        this.infoBoxVisible = true;
        this.infoBoxText = "Preparation Time";
        this.infoBoxMode = "CountDownTimer";
        this.iconCssClass = 'clock-icon';
        this.counterText = this.prepTime.toString();
        this.inputActivityLevel = 100;
        this.preparationSubscription = Rx["Observable"]
            .interval(1000)
            .take(this.prepTime)
            .subscribe(function (x) {
            var timeElapsed = x + 1;
            var timeLeft = _this.prepTime - timeElapsed;
            _this.counterText = timeLeft >= 0 ? timeLeft.toString() : "--";
            if (timeLeft <= 0) {
                _this.startRecording();
            }
        });
    };
    IppVoiceRecorderComponent.prototype.startRecording = function () {
        var _this = this;
        PgRecorder.create(this.loggerService)
            .then(function (recorder) {
            _this.recorder = recorder;
            _this.step = 2;
            _this.currentProgress = 0;
            _this.recorder.start(_this.showPlayButton);
            _this.infoBoxVisible = true;
            _this.infoBoxText = "Recording...";
            _this.infoBoxMode = "ProgressBar";
            _this.iconCssClass = 'rec-icon';
            _this.recordingSubscription = Rx["Observable"].interval(1000)
                .take(_this.recordTime)
                .subscribe(function (x) {
                var timeElapsed = x + 1;
                _this.currentProgress = _this.setProgress(timeElapsed, _this.recordTime);
                if (timeElapsed >= _this.recordTime) {
                    _this.stopRecording();
                }
            });
            _this.inputActivitySubscription = Rx["Observable"].interval(200)
                .subscribe(function (x) {
                _this.inputActivityLevel = 100 - _this.recorder.getInputActivityLevel();
            });
        })
            .catch(function (error) {
            var retry = "Retry";
            var cancel = "Cancel";
            var options = [{ label: retry, style: "btn-primary" }];
            if (config_helper_ConfigHelper.canSkipMicrophoneCheck()) {
                options.push({ label: cancel, style: "btn-secondary" });
            }
            _this.myModal.showRegularDlg("Error", config_helper_ConfigHelper.isTdpMode() ? Microphone_Check_With_Code : Microphone_Check, options)
                .then(function (x) {
                switch (x) {
                    case cancel:
                        break;
                    case retry:
                        _this.startRecording();
                        break;
                }
            });
        });
    };
    IppVoiceRecorderComponent.prototype.stopRecording = function () {
        if (this.recordingSubscription) {
            this.recordingSubscription.unsubscribe();
        }
        if (this.inputActivitySubscription) {
            this.inputActivitySubscription.unsubscribe();
        }
        this.inputActivityLevel = 100;
        this.recorder.stop();
        this.blob = this.recorder.getBlob();
    };
    IppVoiceRecorderComponent.prototype.setProgress = function (current, totalTime) {
        return (current / totalTime) * 100;
    };
    return IppVoiceRecorderComponent;
}());
ipp_voice_recorder_component___decorate([
    Object(core_es5["F" /* Input */])(),
    ipp_voice_recorder_component___metadata("design:type", Number)
], ipp_voice_recorder_component_IppVoiceRecorderComponent.prototype, "recordTime", void 0);
ipp_voice_recorder_component___decorate([
    Object(core_es5["F" /* Input */])(),
    ipp_voice_recorder_component___metadata("design:type", Number)
], ipp_voice_recorder_component_IppVoiceRecorderComponent.prototype, "prepTime", void 0);
ipp_voice_recorder_component___decorate([
    Object(core_es5["_17" /* ViewChild */])('audioWrapper'),
    ipp_voice_recorder_component___metadata("design:type", typeof (ipp_voice_recorder_component__a = typeof core_es5["v" /* ElementRef */] !== "undefined" && core_es5["v" /* ElementRef */]) === "function" && ipp_voice_recorder_component__a || Object)
], ipp_voice_recorder_component_IppVoiceRecorderComponent.prototype, "audioWrapper", void 0);
ipp_voice_recorder_component_IppVoiceRecorderComponent = ipp_voice_recorder_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'ipp-voice-recorder',
        template: __webpack_require__("X16k")
    }),
    ipp_voice_recorder_component___metadata("design:paramtypes", [typeof (ipp_voice_recorder_component__b = typeof core_es5["v" /* ElementRef */] !== "undefined" && core_es5["v" /* ElementRef */]) === "function" && ipp_voice_recorder_component__b || Object, typeof (ipp_voice_recorder_component__c = typeof my_modal_component_MyModal !== "undefined" && my_modal_component_MyModal) === "function" && ipp_voice_recorder_component__c || Object, typeof (ipp_voice_recorder_component__d = typeof LoggerService !== "undefined" && LoggerService) === "function" && ipp_voice_recorder_component__d || Object, typeof (ipp_voice_recorder_component__e = typeof core_es5["R" /* NgZone */] !== "undefined" && core_es5["R" /* NgZone */]) === "function" && ipp_voice_recorder_component__e || Object])
], ipp_voice_recorder_component_IppVoiceRecorderComponent);

var ipp_voice_recorder_component__a, ipp_voice_recorder_component__b, ipp_voice_recorder_component__c, ipp_voice_recorder_component__d, ipp_voice_recorder_component__e;
//# sourceMappingURL=ipp-voice-recorder.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/dynamic-component-module.ts
var dynamic_component_module___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

























var DYNAMIC_DIRECTIVES = [
    Object(core_es5["_25" /* forwardRef */])(function () { return InteractionComponent; }),
    Object(core_es5["_25" /* forwardRef */])(function () { return ResourceComponent; }),
    Object(core_es5["_25" /* forwardRef */])(function () { return SlideDeckComponent; }),
    Object(core_es5["_25" /* forwardRef */])(function () { return PictureResourceComponent; }),
    Object(core_es5["_25" /* forwardRef */])(function () { return media_resource_component_MediaResourceComponent; }),
    Object(core_es5["_25" /* forwardRef */])(function () { return PDFResourceComponent; }),
    Object(core_es5["_25" /* forwardRef */])(function () { return HtmlResourceComponent; }),
    Object(core_es5["_25" /* forwardRef */])(function () { return auto_play_resource_component_AutoPlayResourceComponent; }),
    Object(core_es5["_25" /* forwardRef */])(function () { return ChoiceInteractionComponent; }),
    Object(core_es5["_25" /* forwardRef */])(function () { return InlineChoiceInteractionComponent; }),
    Object(core_es5["_25" /* forwardRef */])(function () { return speaking_interaction_component_SpeakingInteractionComponent; }),
    Object(core_es5["_25" /* forwardRef */])(function () { return extended_text_interaction_component_ExtendedTextInteractionComponent; }),
    Object(core_es5["_25" /* forwardRef */])(function () { return text_entry_interaction_component_TextEntryInteractionComponent; }),
    Object(core_es5["_25" /* forwardRef */])(function () { return HotspotComponent; }),
    Object(core_es5["_25" /* forwardRef */])(function () { return ResourceComponent; }),
    Object(core_es5["_25" /* forwardRef */])(function () { return order_interaction_component_OrderInteractionComponent; }),
    Object(core_es5["_25" /* forwardRef */])(function () { return associate_interaction_component_AssociateInteractionComponent; }),
    Object(core_es5["_25" /* forwardRef */])(function () { return match_interaction_component_MatchInteractionComponent; }),
    Object(core_es5["_25" /* forwardRef */])(function () { return AutoSkipTimerComponent; }),
    Object(core_es5["_25" /* forwardRef */])(function () { return end_of_test_component_EndOfTestComponent; }),
    Object(core_es5["_25" /* forwardRef */])(function () { return ipp_landing_page_component_IppLandingPageComponent; }),
    Object(core_es5["_25" /* forwardRef */])(function () { return IppWritingSampleResponseComponent; }),
    Object(core_es5["_25" /* forwardRef */])(function () { return IppSpeakingSampleResponseComponent; }),
    Object(core_es5["_25" /* forwardRef */])(function () { return IppTranscriptComponent; }),
    Object(core_es5["_25" /* forwardRef */])(function () { return ipp_answerkey_component_IppAnswerkeyComponent; }),
    Object(core_es5["_25" /* forwardRef */])(function () { return ipp_scoring_page_component_IppScoringPageComponent; }),
    Object(core_es5["_25" /* forwardRef */])(function () { return ipp_feedback_page_component_IppFeedbackPageComponent; }),
    Object(core_es5["_25" /* forwardRef */])(function () { return ipp_end_of_test_component_IppEndOfTestComponent; }),
    Object(core_es5["_25" /* forwardRef */])(function () { return IppMicrophoneCheckComponent; }),
    Object(core_es5["_25" /* forwardRef */])(function () { return IppDownloadResponseComponent; }),
    Object(core_es5["_25" /* forwardRef */])(function () { return ipp_voice_recorder_component_IppVoiceRecorderComponent; })
];
var DynamicComponentModule = (function () {
    function DynamicComponentModule() {
    }
    return DynamicComponentModule;
}());
DynamicComponentModule = dynamic_component_module___decorate([
    Object(core_es5["M" /* NgModule */])({
        imports: [
            common_es5["b" /* CommonModule */],
            forms_es5["b" /* FormsModule */],
            forms_es5["c" /* ReactiveFormsModule */],
            SharedModule
        ],
        declarations: [
            DYNAMIC_DIRECTIVES
        ],
        exports: [
            DYNAMIC_DIRECTIVES
        ]
    })
], DynamicComponentModule);

//# sourceMappingURL=dynamic-component-module.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/services/dynamic-component.service.ts
var dynamic_component_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var dynamic_component_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var dynamic_component_service_DynamicComponentService = (function () {
    function DynamicComponentService(loggerService, compiler, htmlService) {
        this.loggerService = loggerService;
        this.compiler = compiler;
        this.htmlService = htmlService;
    }
    DynamicComponentService.prototype.createNewComponent = function (template) {
        var CustomDynamicComponent = (function () {
            function CustomDynamicComponent() {
            }
            CustomDynamicComponent.prototype.ngOnDestroy = function () {
                console.log('ngOnDestroy');
            };
            CustomDynamicComponent.prototype.getInteraction = function (interactionRefNum) {
                return this.interactions.find(function (x) { return x.InteractionRefNum == interactionRefNum; });
            };
            return CustomDynamicComponent;
        }());
        dynamic_component_service___decorate([
            Object(core_es5["F" /* Input */])(),
            dynamic_component_service___metadata("design:type", Array)
        ], CustomDynamicComponent.prototype, "interactions", void 0);
        dynamic_component_service___decorate([
            Object(core_es5["F" /* Input */])(),
            dynamic_component_service___metadata("design:type", Object)
        ], CustomDynamicComponent.prototype, "itemBodyPanel", void 0);
        CustomDynamicComponent = dynamic_component_service___decorate([
            Object(core_es5["o" /* Component */])({
                selector: 'dummy-place-holder',
                template: template,
            })
        ], CustomDynamicComponent);
        ;
        return CustomDynamicComponent;
    };
    DynamicComponentService.prototype.createComponentModule = function (componentType) {
        var RuntimeComponentModule = (function () {
            function RuntimeComponentModule() {
            }
            return RuntimeComponentModule;
        }());
        RuntimeComponentModule = dynamic_component_service___decorate([
            Object(core_es5["M" /* NgModule */])({
                imports: [
                    SharedModule,
                    DynamicComponentModule
                ],
                declarations: [componentType],
            })
        ], RuntimeComponentModule);
        // a module for just this Type
        return RuntimeComponentModule;
    };
    DynamicComponentService.prototype.getComponentRef = function (viewContainerRef, srcHtml) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var html = _this.htmlService.replaceAllPlaceHolders(srcHtml);
            var type = _this.createNewComponent(html);
            var module = _this.createComponentModule(type);
            _this.compiler
                .compileModuleAndAllComponentsAsync(module)
                .then(function (moduleWithFactories) {
                var factory = lodash["find"](moduleWithFactories.componentFactories, { componentType: type });
                resolve(viewContainerRef.createComponent(factory, 0));
            });
        });
    };
    return DynamicComponentService;
}());
dynamic_component_service_DynamicComponentService = dynamic_component_service___decorate([
    Object(core_es5["C" /* Injectable */])(),
    dynamic_component_service___metadata("design:paramtypes", [typeof (dynamic_component_service__a = typeof LoggerService !== "undefined" && LoggerService) === "function" && dynamic_component_service__a || Object, typeof (dynamic_component_service__b = typeof core_es5["m" /* Compiler */] !== "undefined" && core_es5["m" /* Compiler */]) === "function" && dynamic_component_service__b || Object, typeof (dynamic_component_service__c = typeof html_service_HtmlService !== "undefined" && html_service_HtmlService) === "function" && dynamic_component_service__c || Object])
], dynamic_component_service_DynamicComponentService);

var dynamic_component_service__a, dynamic_component_service__b, dynamic_component_service__c;
//# sourceMappingURL=dynamic-component.service.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/test-form-validation/test-form-validation.component.ts
var test_form_validation_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var test_form_validation_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};






var test_form_validation_component_TestFormValidationComponent = (function () {
    function TestFormValidationComponent(testNavigationService, testContentService, myModal, dynamicComponentService) {
        this.testNavigationService = testNavigationService;
        this.testContentService = testContentService;
        this.myModal = myModal;
        this.dynamicComponentService = dynamicComponentService;
        this.visible = false;
        this.validating = false;
    }
    TestFormValidationComponent.prototype.showTestForm = function (viewContainerRef, testFormId) {
        this.viewContainerRef = viewContainerRef;
        this.testFormId = testFormId;
        this.visible = true;
    };
    TestFormValidationComponent.prototype.show = function (viewContainerRef, bulkTestFormIds) {
        this.viewContainerRef = viewContainerRef;
        this.bulkTestFormIds = bulkTestFormIds;
        this.visible = true;
    };
    TestFormValidationComponent.prototype.hide = function () {
        this.visible = false;
    };
    TestFormValidationComponent.prototype.validate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var displayErrors, testletIds, errorMessages, testlets, testFormIdList, _loop_1, index, distinct, componentRef;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.validating = true;
                        displayErrors = [];
                        testletIds = [];
                        errorMessages = [];
                        testlets = [];
                        testFormIdList = [];
                        testFormIdList = this.bulkTestFormIds.split(",");
                        _loop_1 = function (index) {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, new Promise(function (resolve, reject) {
                                            _this.testContentService.getAssessmentTestByTestFormId(testFormIdList[index]).subscribe(function (assessmentTest) {
                                                var testlet = _this.testNavigationService.getTestlets(assessmentTest);
                                                testlet.forEach(function (element) {
                                                    testlets.push(element);
                                                });
                                                resolve();
                                            });
                                        })];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        };
                        index = 0;
                        _a.label = 1;
                    case 1:
                        if (!(index < testFormIdList.length)) return [3 /*break*/, 4];
                        return [5 /*yield**/, _loop_1(index)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        index++;
                        return [3 /*break*/, 1];
                    case 4:
                        distinct = testlets.filter(function (testlet, index, self) { return self.findIndex(function (t) { return t.name === testlet.name; }) === index; });
                        Rx["Observable"].interval(3000)
                            .startWith(0)
                            .take(distinct.length)
                            .subscribe(function (interval) {
                            if (componentRef) {
                                componentRef.destroy();
                            }
                            _this.testContentService.getTestlet(distinct[interval].testletId, "0").subscribe(function (testlet) {
                                testlet.AssessmentItems.forEach(function (assessmentItem, assessmentItemIdx) {
                                    var html = "";
                                    assessmentItem.ItemBody.ItemBodyPanels.forEach(function (panel) {
                                        html += panel.Html;
                                    });
                                    _this.dynamicComponentService.getComponentRef(_this.viewContainerRef, html)
                                        .then(function (newComponentRef) {
                                        componentRef = newComponentRef;
                                        componentRef.instance.interactions = testlet.AssessmentItems[assessmentItemIdx].Interactions;
                                    })
                                        .catch(function (reason) {
                                        testletIds.push(distinct[interval].testletId);
                                        errorMessages.push(reason.message);
                                        displayErrors.push("<h5>Testlet ID: " + distinct[interval].testletId + ", Page: " + (assessmentItemIdx + 1) + "</h5><div style=\"font-size: 0.9em; color: #777\">" + reason + "</div>");
                                    });
                                });
                            });
                        }, function (error) { return console.log(error); }, function () {
                            if (componentRef) {
                                componentRef.destroy();
                            }
                            _this.hide();
                            if (displayErrors.length > 0) {
                                _this.myModal.showRegularDlg("The following testlets failed to validate:", displayErrors.join("<hr>"));
                            }
                            else {
                                _this.myModal.showRegularDlg("Info", "Validation passed.");
                            }
                            for (var i = 0; i < testFormIdList.length; i++) {
                                _this.testContentService.sendTestFormValidationResultEmail(testFormIdList[i], testletIds, errorMessages, _this.email).subscribe();
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    return TestFormValidationComponent;
}());
test_form_validation_component_TestFormValidationComponent = test_form_validation_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'test-form-validation',
        template: __webpack_require__("cb1k")
    }),
    test_form_validation_component___metadata("design:paramtypes", [typeof (test_form_validation_component__a = typeof test_navigation_service_TestNavigationService !== "undefined" && test_navigation_service_TestNavigationService) === "function" && test_form_validation_component__a || Object, typeof (test_form_validation_component__b = typeof test_content_service_TestContentService !== "undefined" && test_content_service_TestContentService) === "function" && test_form_validation_component__b || Object, typeof (test_form_validation_component__c = typeof my_modal_component_MyModal !== "undefined" && my_modal_component_MyModal) === "function" && test_form_validation_component__c || Object, typeof (test_form_validation_component__d = typeof dynamic_component_service_DynamicComponentService !== "undefined" && dynamic_component_service_DynamicComponentService) === "function" && test_form_validation_component__d || Object])
], test_form_validation_component_TestFormValidationComponent);

var test_form_validation_component__a, test_form_validation_component__b, test_form_validation_component__c, test_form_validation_component__d;
//# sourceMappingURL=test-form-validation.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/services/signalR.service.ts
var signalR_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var signalR_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var signalR_service_SignalRService = (function () {
    function SignalRService(signalR) {
        this.signalR = signalR;
        this.onFreeze$ = new ng2_signalr["a" /* BroadcastEventListener */]('onFreeze');
        this.onUnFreeze$ = new ng2_signalr["a" /* BroadcastEventListener */]('onUnFreeze');
        this.onNewConnectionEstablished$ = new Rx["Subject"]();
    }
    SignalRService.prototype.initializeConnection = function () {
        var _this = this;
        Rx["Observable"]
            .defer(function () { return _this.signalR.connect(); })
            .retryWhen(function (errors) { return errors.delay(20000); })
            .subscribe(function (connection) {
            _this.signalRConnection = connection;
            _this.signalRConnection.listen(_this.onFreeze$);
            _this.signalRConnection.listen(_this.onUnFreeze$);
            _this.onNewConnectionEstablished$.next();
            connection.status
                .subscribe(function (status) {
                // disconnected
                if (status.value === 4) {
                    _this.initializeConnection();
                }
            });
        });
    };
    return SignalRService;
}());
signalR_service_SignalRService = signalR_service___decorate([
    Object(core_es5["C" /* Injectable */])(),
    signalR_service___metadata("design:paramtypes", [typeof (signalR_service__a = typeof ng2_signalr["c" /* SignalR */] !== "undefined" && ng2_signalr["c" /* SignalR */]) === "function" && signalR_service__a || Object])
], signalR_service_SignalRService);

var signalR_service__a;
//# sourceMappingURL=signalR.service.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/services/fullscreen.service.ts
var fullscreen_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var fullscreen_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var FullscreenService = (function () {
    function FullscreenService(loggerService, myModal, store) {
        this.loggerService = loggerService;
        this.myModal = myModal;
        this.store = store;
    }
    FullscreenService.prototype.tryFullScreen = function () {
        return document.body.requestFullscreen();
    };
    FullscreenService.prototype.tryExitFullScreen = function () {
        return document.exitFullscreen();
    };
    FullscreenService.prototype.showFullScreenErrorDlg = function (err) {
        this.myModal.showRegularDlg("Error", "Error attempting to enable full-screen mode: ${err.message} (${err.name}) \nTesting cannot proceed without fullscreen enabled");
    };
    return FullscreenService;
}());
FullscreenService = fullscreen_service___decorate([
    Object(core_es5["C" /* Injectable */])(),
    fullscreen_service___metadata("design:paramtypes", [typeof (fullscreen_service__a = typeof LoggerService !== "undefined" && LoggerService) === "function" && fullscreen_service__a || Object, typeof (fullscreen_service__b = typeof my_modal_component_MyModal !== "undefined" && my_modal_component_MyModal) === "function" && fullscreen_service__b || Object, typeof (fullscreen_service__c = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && fullscreen_service__c || Object])
], FullscreenService);

var fullscreen_service__a, fullscreen_service__b, fullscreen_service__c;
//# sourceMappingURL=fullscreen.service.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/pg-renderer.component.ts
var pg_renderer_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var pg_renderer_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
















var pg_renderer_component_PgRendererComponent = (function () {
    function PgRendererComponent(route, store, repeatableRandomGeneratorService, testTakerService, testContentService, viewContainerRef, testNavigationService, signalRService, authService, router, myModal, fullScreenService) {
        this.route = route;
        this.store = store;
        this.repeatableRandomGeneratorService = repeatableRandomGeneratorService;
        this.testTakerService = testTakerService;
        this.testContentService = testContentService;
        this.viewContainerRef = viewContainerRef;
        this.testNavigationService = testNavigationService;
        this.signalRService = signalRService;
        this.authService = authService;
        this.router = router;
        this.myModal = myModal;
        this.fullScreenService = fullScreenService;
        this.currentTestletId = null;
        this.shouldSendAssessmentTest = true;
        this.isIppMode = false;
        this.testlet$ = store.select(reducers_getTestlet);
        this.itemIndex$ = store.select(reducers_getItemIndex);
        this.assessmentItem$ = store.select(reducers_getAssessmentItem);
        this.assessmentTest$ = store.select(reducers_getAssessmentTest);
        this.testNavigation$ = store.select(reducers_getTestNavigation);
    }
    PgRendererComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.assessmentItemSubscription = this.assessmentItem$.subscribe(function (assessmentItem) {
            if (assessmentItem) {
                _this.testTakerService.cacheTestTakerActivity(TestTakerActivityTypeEnum.SetAssessmentItemIndex, null, null, _this.currentTestletId, null, assessmentItem.ItemIndex + 1);
            }
        });
        this.assessmentTestSubscription = this.assessmentTest$.subscribe(function (assessmentTest) {
            _this.assessmentTest = assessmentTest;
            _this.isIppMode = config_helper_ConfigHelper.isIppMode();
            var d = new Date();
            _this.currentYear = d.getFullYear();
        });
        this.testletIdSubscription = this.store.select(reducers_getCurrentTestletId).subscribe(function (testletId) {
            if (testletId) {
                if (_this.currentTestletId) {
                    _this.testTakerService.cacheTestTakerActivity(TestTakerActivityTypeEnum.LeaveTestlet, null, null, _this.currentTestletId);
                }
                _this.testTakerService.cacheTestTakerActivity(TestTakerActivityTypeEnum.EnterTestlet, null, null, testletId);
                _this.currentTestletId = testletId;
                _this.store.dispatch(new test_taker_action_namespaceObject.LoadTestlet(testletId, _this.shouldSendAssessmentTest ? _this.assessmentTest : null));
            }
        });
        this.preloadTestletIdSubscription = this.store.select(reducers_getNextTestletId).subscribe(function (preloadtestletId) {
            if (preloadtestletId) {
                _this.store.dispatch(new test_taker_action_namespaceObject.PreloadTestlet(preloadtestletId, _this.shouldSendAssessmentTest ? _this.assessmentTest : null));
            }
        });
        this.testTakerInfoSubscription = this.store.select(reducers_getTestTakerInfo).subscribe(function (testTakerInfo) {
            if (testTakerInfo) {
                _this.repeatableRandomGeneratorService.setSeed(testTakerInfo.TestTakerId);
            }
        });
        if (config_helper_ConfigHelper.isTdpMode(false)) {
            var testTakerInfo_1 = this.testTakerService.testTakerInfo;
            this.signalRService.onNewConnectionEstablished$.subscribe(function (x) {
                _this.signalRService.onFreeze$.subscribe(function (testTakers) {
                    if (_this.hasTestTaker(testTakers, testTakerInfo_1.BrandName, testTakerInfo_1.TestSessionSiteCode, testTakerInfo_1.TestTakerId)) {
                        _this.store.dispatch(new app_ui_action_namespaceObject.ShowPauseScreen());
                    }
                });
                _this.signalRService.onUnFreeze$.subscribe(function (testTakers) {
                    if (_this.hasTestTaker(testTakers, testTakerInfo_1.BrandName, testTakerInfo_1.TestSessionSiteCode, testTakerInfo_1.TestTakerId)) {
                        _this.store.dispatch(new app_ui_action_namespaceObject.HidePauseScreen());
                        _this.store.dispatch(new test_taker_action_namespaceObject.ResumeTest());
                        _this.store.dispatch(new test_taker_action_namespaceObject.LoadTestlet(_this.currentTestletId, _this.shouldSendAssessmentTest ? _this.assessmentTest : null));
                    }
                });
            });
            this.signalRService.initializeConnection();
        }
    };
    PgRendererComponent.prototype.hasTestTaker = function (testTakers, brandName, siteCode, testTakerId) {
        return testTakers.findIndex(function (tt) { return tt.BrandName == brandName && tt.SiteCode == siteCode && tt.TestTakerId == testTakerId; }) >= 0;
    };
    PgRendererComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (config_helper_ConfigHelper.isTdpMode(true)) {
            var accessToken = this.authService.getAccessToken();
            if (!accessToken) {
                var webDeliveryAuth = this.authService.getWebDeliveryAuth();
                if (webDeliveryAuth) {
                    this.router.navigateByUrl('/start-screen-web/' + encodeURIComponent(webDeliveryAuth));
                    return;
                }
                this.myModal.showRegularDlg("Error", "Information missing. Please restart the web test from the 'My Account' page.");
            }
            else {
                this.testNavigationService.enableWindowUnloadingWarning();
                window.history.pushState(null, "", window.location.href);
                window.onpopstate = function () {
                    window.history.pushState(null, "", window.location.href);
                };
                this.endOfTestSubscription = this.testNavigation$.subscribe(function (testNavigation) {
                    if (testNavigation.isEndOfTest) {
                        _this.fullScreenService.tryExitFullScreen();
                        _this.endOfTestSubscription.unsubscribe();
                    }
                });
            }
        }
        this.routeParamsSubscription = this.route.params.subscribe(function (params) {
            var testTypeId = _this.route.snapshot.queryParams['test-type'];
            if (testTypeId) {
                config_helper_ConfigHelper.setTestTypeId(testTypeId);
            }
            if (params) {
                if (params['id']) {
                    document.title = "Preview Testlet";
                    _this.store.dispatch(new test_taker_action_namespaceObject.LoadTestlet(params['id'], null));
                }
                else if (params['snapshot-id']) {
                    document.title = "Preview Snapshot";
                    _this.store.dispatch(new test_taker_action_namespaceObject.LoadSnapshotTestlet(params['snapshot-id']));
                }
                else if (params['test-form-id']) {
                    document.title = "Preview Test Form";
                    _this.store.dispatch(new test_taker_action_namespaceObject.LoadAssessmentTestByTestForm(params['test-form-id']));
                }
                else if (params['bulk-test-form-ids']) {
                    document.title = "Preview Test Forms";
                    if (params['validate']) {
                        _this.testFormValidation.show(_this.viewContainerRef, params['bulk-test-form-ids']);
                    }
                    else {
                        _this.store.dispatch(new test_taker_action_namespaceObject.LoadAssessmentTestByTestForm(params['bulk-test-form-ids']));
                    }
                }
                else if (params['assessment-test-id']) {
                    document.title = "Assessment Test";
                    var assessmentTestId = params['assessment-test-id'];
                    _this.store.dispatch(new test_taker_action_namespaceObject.LoadAssessmentTest(assessmentTestId));
                }
                else if (params['testlet-version-id']) {
                    document.title = "Preview Testlet Version";
                    _this.store.dispatch(new test_taker_action_namespaceObject.LoadTestletVersion(params['testlet-version-id']));
                }
                else if (params['ipp-assessment-test-id']) {
                    document.title = "IPP Test Form";
                    _this.store.dispatch(new test_taker_action_namespaceObject.LoadIppAssessmentTest(params['ipp-assessment-test-id']));
                }
                else if (params['ipp-assessment-test-id-for-latest']) {
                    document.title = "IPP Test Form";
                    _this.shouldSendAssessmentTest = false;
                    _this.store.dispatch(new test_taker_action_namespaceObject.LoadLatestIppAssessmentTest(params['ipp-assessment-test-id-for-latest']));
                }
                else if (params['ipp-product-id']) {
                    document.title = "Instructional Products";
                    _this.store.dispatch(new test_taker_action_namespaceObject.LoadIppProduct(params['ipp-product-id']));
                }
            }
        });
    };
    PgRendererComponent.prototype.ngOnDestroy = function () {
        if (this.assessmentItemSubscription) {
            this.assessmentItemSubscription.unsubscribe();
        }
        if (this.testletIdSubscription) {
            this.testletIdSubscription.unsubscribe();
        }
        if (this.preloadTestletIdSubscription) {
            this.preloadTestletIdSubscription.unsubscribe();
        }
        if (this.routeParamsSubscription) {
            this.routeParamsSubscription.unsubscribe();
        }
        if (this.endOfTestSubscription) {
            this.endOfTestSubscription.unsubscribe();
        }
    };
    return PgRendererComponent;
}());
pg_renderer_component___decorate([
    Object(core_es5["_17" /* ViewChild */])('testFormValidation'),
    pg_renderer_component___metadata("design:type", typeof (pg_renderer_component__a = typeof test_form_validation_component_TestFormValidationComponent !== "undefined" && test_form_validation_component_TestFormValidationComponent) === "function" && pg_renderer_component__a || Object)
], pg_renderer_component_PgRendererComponent.prototype, "testFormValidation", void 0);
pg_renderer_component_PgRendererComponent = pg_renderer_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'pg-renderer',
        template: __webpack_require__("+2Ou")
    }),
    pg_renderer_component___metadata("design:paramtypes", [typeof (pg_renderer_component__b = typeof router_es5["a" /* ActivatedRoute */] !== "undefined" && router_es5["a" /* ActivatedRoute */]) === "function" && pg_renderer_component__b || Object, typeof (pg_renderer_component__c = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && pg_renderer_component__c || Object, typeof (pg_renderer_component__d = typeof repeatable_random_generator_service_RepeatableRandomGeneratorService !== "undefined" && repeatable_random_generator_service_RepeatableRandomGeneratorService) === "function" && pg_renderer_component__d || Object, typeof (pg_renderer_component__e = typeof test_taker_service_TestTakerService !== "undefined" && test_taker_service_TestTakerService) === "function" && pg_renderer_component__e || Object, typeof (pg_renderer_component__f = typeof test_content_service_TestContentService !== "undefined" && test_content_service_TestContentService) === "function" && pg_renderer_component__f || Object, typeof (pg_renderer_component__g = typeof core_es5["_19" /* ViewContainerRef */] !== "undefined" && core_es5["_19" /* ViewContainerRef */]) === "function" && pg_renderer_component__g || Object, typeof (pg_renderer_component__h = typeof test_navigation_service_TestNavigationService !== "undefined" && test_navigation_service_TestNavigationService) === "function" && pg_renderer_component__h || Object, typeof (pg_renderer_component__j = typeof signalR_service_SignalRService !== "undefined" && signalR_service_SignalRService) === "function" && pg_renderer_component__j || Object, typeof (_k = typeof auth_service_AuthService !== "undefined" && auth_service_AuthService) === "function" && _k || Object, typeof (_l = typeof router_es5["b" /* Router */] !== "undefined" && router_es5["b" /* Router */]) === "function" && _l || Object, typeof (_m = typeof my_modal_component_MyModal !== "undefined" && my_modal_component_MyModal) === "function" && _m || Object, typeof (_o = typeof FullscreenService !== "undefined" && FullscreenService) === "function" && _o || Object])
], pg_renderer_component_PgRendererComponent);

var pg_renderer_component__a, pg_renderer_component__b, pg_renderer_component__c, pg_renderer_component__d, pg_renderer_component__e, pg_renderer_component__f, pg_renderer_component__g, pg_renderer_component__h, pg_renderer_component__j, _k, _l, _m, _o;
//# sourceMappingURL=pg-renderer.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/blank.component.ts
var blank_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var blank_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var BlankComponent = (function () {
    function BlankComponent(router) {
        this.router = router;
    }
    return BlankComponent;
}());
BlankComponent = blank_component___decorate([
    Object(core_es5["o" /* Component */])({
        template: ""
    }),
    blank_component___metadata("design:paramtypes", [typeof (blank_component__a = typeof router_es5["b" /* Router */] !== "undefined" && router_es5["b" /* Router */]) === "function" && blank_component__a || Object])
], BlankComponent);

var blank_component__a;
//# sourceMappingURL=blank.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/tdp/start-screen/start-screen-pending.component.ts
var start_screen_pending_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var start_screen_pending_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};










var start_screen_pending_component_StartScreenPendingComponent = (function () {
    function StartScreenPendingComponent(router, route, testTakerService, testContentService, store, myModal, authService) {
        this.router = router;
        this.route = route;
        this.testTakerService = testTakerService;
        this.testContentService = testContentService;
        this.store = store;
        this.myModal = myModal;
        this.authService = authService;
        this.defaultMessage = "Waiting for station assignment.";
        this.message = this.defaultMessage;
        this.testTakerInfo = {};
    }
    StartScreenPendingComponent.prototype.pollForTestTakerInfo = function () {
        var _this = this;
        Rx["Observable"].interval(10000)
            .startWith(1)
            .flatMap(function (x) { return _this.testTakerService.getStationAssignment(_this.stationNumber); })
            .filter(function (x) { return x != null; })
            .take(1)
            .retryWhen(function (errors) { return errors.delay(60000); })
            .subscribe(function (testTakerInfo) {
            _this.onStationAssignmentReceived(testTakerInfo);
        });
    };
    StartScreenPendingComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.testTakerPhotoUrl = this.testTakerService.getBlankTestTakerPhotoUrl();
        this.routeParamsSubscription = this.route.params.subscribe(function (params) {
            if (params) {
                var stationNumber = params['station-number'];
                _this.stationNumber = stationNumber;
                _this.pollForTestTakerInfo();
            }
        });
    };
    StartScreenPendingComponent.prototype.ngOnDestroy = function () {
        this.routeParamsSubscription.unsubscribe();
    };
    StartScreenPendingComponent.prototype.onStationAssignmentReceived = function (testTakerInfo) {
        var _this = this;
        if (_paragonConfig.useLocalTestContentServer) {
            this.message = "Downloading...";
            this.testContentService.downloadTestContentFile(testTakerInfo.BrandName, testTakerInfo.TestSessionSiteCode, testTakerInfo.StationNumber).subscribe(function (success) {
                _this.showStationAssignment(testTakerInfo);
            }, function (error) {
                _this.message = _this.defaultMessage;
                _this.myModal.showRegularDlg("Error", error);
            });
        }
        else {
            this.showStationAssignment(testTakerInfo);
        }
    };
    StartScreenPendingComponent.prototype.showStationAssignment = function (testTakerInfo) {
        this.testTakerInfo = testTakerInfo;
        this.store.dispatch(new test_taker_action_namespaceObject.SetTestTakerInfo(testTakerInfo));
        config_helper_ConfigHelper.setTestTypeId(testTakerInfo.TestTypeId);
        this.testTakerPhotoUrl = this.testTakerService.getTestTakerPhotoUrl(testTakerInfo.BrandName, testTakerInfo.TestSessionSiteCode, testTakerInfo.TestTakerId);
        this.router.navigate(["start-screen/" + testTakerInfo.StationNumber + "/pin"]);
    };
    StartScreenPendingComponent.prototype.clearErrorMsg = function () {
        this.errorMsg = "";
    };
    return StartScreenPendingComponent;
}());
start_screen_pending_component_StartScreenPendingComponent = start_screen_pending_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'start-screen-pending',
        template: __webpack_require__("zLVS")
    }),
    start_screen_pending_component___metadata("design:paramtypes", [typeof (start_screen_pending_component__a = typeof router_es5["b" /* Router */] !== "undefined" && router_es5["b" /* Router */]) === "function" && start_screen_pending_component__a || Object, typeof (start_screen_pending_component__b = typeof router_es5["a" /* ActivatedRoute */] !== "undefined" && router_es5["a" /* ActivatedRoute */]) === "function" && start_screen_pending_component__b || Object, typeof (start_screen_pending_component__c = typeof test_taker_service_TestTakerService !== "undefined" && test_taker_service_TestTakerService) === "function" && start_screen_pending_component__c || Object, typeof (start_screen_pending_component__d = typeof test_content_service_TestContentService !== "undefined" && test_content_service_TestContentService) === "function" && start_screen_pending_component__d || Object, typeof (start_screen_pending_component__e = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && start_screen_pending_component__e || Object, typeof (start_screen_pending_component__f = typeof my_modal_component_MyModal !== "undefined" && my_modal_component_MyModal) === "function" && start_screen_pending_component__f || Object, typeof (start_screen_pending_component__g = typeof auth_service_AuthService !== "undefined" && auth_service_AuthService) === "function" && start_screen_pending_component__g || Object])
], start_screen_pending_component_StartScreenPendingComponent);

var start_screen_pending_component__a, start_screen_pending_component__b, start_screen_pending_component__c, start_screen_pending_component__d, start_screen_pending_component__e, start_screen_pending_component__f, start_screen_pending_component__g;
//# sourceMappingURL=start-screen-pending.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/tdp/start-screen/start-screen-pin.component.ts
var start_screen_pin_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var start_screen_pin_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};










var start_screen_pin_component_StartScreenPinComponent = (function () {
    function StartScreenPinComponent(router, route, testTakerService, testContentService, store, myModal, authService) {
        this.router = router;
        this.route = route;
        this.testTakerService = testTakerService;
        this.testContentService = testContentService;
        this.store = store;
        this.myModal = myModal;
        this.authService = authService;
        this.testTakerInfo = {};
    }
    StartScreenPinComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeParamsSubscription = this.route.params.subscribe(function (params) {
            if (params) {
                var stationNumber = params['station-number'];
                if (!_this.testTakerService.testTakerInfo) {
                    _this.router.navigate(["start-screen/" + stationNumber + "/pending"]);
                }
                else {
                    _this.stationNumber = stationNumber;
                    _this.testTakerInfo = _this.testTakerService.testTakerInfo;
                    _this.testTakerPhotoUrl = _this.testTakerService.getTestTakerPhotoUrl(_this.testTakerInfo.BrandName, _this.testTakerInfo.TestSessionSiteCode, _this.testTakerInfo.TestTakerId);
                }
                if (_this.testTakerInfo.IsNonScored === true) {
                    _this.testTakerService.authenticate(_this.testTakerInfo, _paragonConfig.version).subscribe(function (authSuccessResult) {
                        _this.authService.setAccessToken(authSuccessResult.access_token);
                        Rx["Observable"].interval(5000)
                            .startWith(1)
                            .flatMap(function (x) { return _this.testTakerService.isNonScoredTestStarted(); })
                            .filter(function (x) { return x === true; })
                            .take(1)
                            .retryWhen(function (errors) { return errors.delay(60000); })
                            .subscribe(function (x) {
                            _this.onNonScoredTestStarted();
                        });
                    });
                }
            }
        });
    };
    StartScreenPinComponent.prototype.onNonScoredTestStarted = function () {
        var _this = this;
        this.testTakerService.startTest().subscribe(function (success) {
            _this.store.dispatch(new test_taker_action_namespaceObject.SetTestInitializationInfo(success));
            _this.testTakerService.saveTestTakerActivityWithoutCaching(TestTakerActivityTypeEnum.StartCodeCorrectInput);
            _this.router.navigate(["assessment-test/" + _this.testTakerInfo.AssessmentTestId]);
        }, function (error) {
            _this.myModal.showRegularDlg("Error", error);
            setTimeout(function () {
                window.location.reload(true);
            }, 90000);
        });
    };
    StartScreenPinComponent.prototype.ngOnDestroy = function () {
        this.routeParamsSubscription.unsubscribe();
    };
    StartScreenPinComponent.prototype.txtPinKeyDown = function (event, pin) {
        this.clearErrorMsg();
        if (event.keyCode == 13) {
            this.onVerifyPin(pin);
        }
    };
    StartScreenPinComponent.prototype.clearErrorMsg = function () {
        this.errorMsg = "";
    };
    StartScreenPinComponent.prototype.onVerifyPin = function (pin) {
        var _this = this;
        if (this.authService.getAccessToken()) {
            this.verifyPin(pin);
        }
        else {
            this.testTakerService.authenticate(this.testTakerInfo, _paragonConfig.version).subscribe(function (authSuccessResult) {
                _this.authService.setAccessToken(authSuccessResult.access_token);
                _this.verifyPin(pin);
            });
        }
    };
    StartScreenPinComponent.prototype.verifyPin = function (pin) {
        if (pin != this.testTakerInfo.PIN) {
            this.errorMsg = "Invalid PIN.";
            this.testTakerService.saveTestTakerActivityWithoutCaching(TestTakerActivityTypeEnum.PinWrongInput);
        }
        else {
            this.testTakerService.saveTestTakerActivityWithoutCaching(TestTakerActivityTypeEnum.PinCorrectInput);
            if (_paragonConfig.audioTestEnabled === true) {
                this.router.navigate(["start-screen/" + this.stationNumber + "/audio-check"]);
            }
            else {
                this.router.navigate(["start-screen/" + this.stationNumber + "/start-code"]);
            }
        }
    };
    return StartScreenPinComponent;
}());
start_screen_pin_component_StartScreenPinComponent = start_screen_pin_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'start-screen-pin',
        template: __webpack_require__("Z8TH")
    }),
    start_screen_pin_component___metadata("design:paramtypes", [typeof (start_screen_pin_component__a = typeof router_es5["b" /* Router */] !== "undefined" && router_es5["b" /* Router */]) === "function" && start_screen_pin_component__a || Object, typeof (start_screen_pin_component__b = typeof router_es5["a" /* ActivatedRoute */] !== "undefined" && router_es5["a" /* ActivatedRoute */]) === "function" && start_screen_pin_component__b || Object, typeof (start_screen_pin_component__c = typeof test_taker_service_TestTakerService !== "undefined" && test_taker_service_TestTakerService) === "function" && start_screen_pin_component__c || Object, typeof (start_screen_pin_component__d = typeof test_content_service_TestContentService !== "undefined" && test_content_service_TestContentService) === "function" && start_screen_pin_component__d || Object, typeof (start_screen_pin_component__e = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && start_screen_pin_component__e || Object, typeof (start_screen_pin_component__f = typeof my_modal_component_MyModal !== "undefined" && my_modal_component_MyModal) === "function" && start_screen_pin_component__f || Object, typeof (start_screen_pin_component__g = typeof auth_service_AuthService !== "undefined" && auth_service_AuthService) === "function" && start_screen_pin_component__g || Object])
], start_screen_pin_component_StartScreenPinComponent);

var start_screen_pin_component__a, start_screen_pin_component__b, start_screen_pin_component__c, start_screen_pin_component__d, start_screen_pin_component__e, start_screen_pin_component__f, start_screen_pin_component__g;
//# sourceMappingURL=start-screen-pin.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/tdp/start-screen/start-screen-audio-check.component.ts
var start_screen_audio_check_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var start_screen_audio_check_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var start_screen_audio_check_component_StartScreenAudioCheckComponent = (function () {
    function StartScreenAudioCheckComponent(router, route, testTakerService, testContentService, store, myModal, authService) {
        this.router = router;
        this.route = route;
        this.testTakerService = testTakerService;
        this.testContentService = testContentService;
        this.store = store;
        this.myModal = myModal;
        this.authService = authService;
        this.testTakerInfo = {};
    }
    StartScreenAudioCheckComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeParamsSubscription = this.route.params.subscribe(function (params) {
            if (params) {
                var stationNumber = params['station-number'];
                if (!_this.testTakerService.testTakerInfo) {
                    if (!config_helper_ConfigHelper.isTdpMode(true)) {
                        _this.router.navigate(["start-screen/" + stationNumber + "/pending"]);
                    }
                    else {
                        var accessToken = _this.authService.getAccessToken();
                        if (!(accessToken && accessToken.length > 0)) {
                            var webDeliveryAuth = _this.authService.getWebDeliveryAuth();
                            if (!webDeliveryAuth) {
                                _this.myModal.showRegularDlg("Error", "Information missing, please restart the test from the 'My Account' page.");
                            }
                            else {
                                _this.router.navigateByUrl('/start-screen-web/' + encodeURIComponent(webDeliveryAuth));
                            }
                        }
                    }
                }
                else {
                    _this.stationNumber = stationNumber;
                    _this.testTakerInfo = _this.testTakerService.testTakerInfo;
                    if (config_helper_ConfigHelper.isTdpMode(true)) {
                        _this.testTakerPhotoUrl = _this.testTakerService.getWebDeliveryTestTakerPhotoUrl(_this.testTakerInfo.ClientApplicationSessionId, _this.testTakerInfo.TestTakerId);
                    }
                    else {
                        _this.testTakerPhotoUrl = _this.testTakerService.getTestTakerPhotoUrl(_this.testTakerInfo.BrandName, _this.testTakerInfo.TestSessionSiteCode, _this.testTakerInfo.TestTakerId);
                    }
                }
            }
        });
    };
    StartScreenAudioCheckComponent.prototype.ngOnDestroy = function () {
        if (this.routeParamsSubscription) {
            this.routeParamsSubscription.unsubscribe();
        }
    };
    StartScreenAudioCheckComponent.prototype.clearErrorMsg = function () {
        this.errorMsg = "";
    };
    StartScreenAudioCheckComponent.prototype.audioCheckCompleted = function () {
        this.router.navigate(["start-screen/" + this.stationNumber + "/microphone-check"]);
    };
    return StartScreenAudioCheckComponent;
}());
start_screen_audio_check_component_StartScreenAudioCheckComponent = start_screen_audio_check_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'start-screen-audio-check',
        template: __webpack_require__("Coua")
    }),
    start_screen_audio_check_component___metadata("design:paramtypes", [typeof (start_screen_audio_check_component__a = typeof router_es5["b" /* Router */] !== "undefined" && router_es5["b" /* Router */]) === "function" && start_screen_audio_check_component__a || Object, typeof (start_screen_audio_check_component__b = typeof router_es5["a" /* ActivatedRoute */] !== "undefined" && router_es5["a" /* ActivatedRoute */]) === "function" && start_screen_audio_check_component__b || Object, typeof (start_screen_audio_check_component__c = typeof test_taker_service_TestTakerService !== "undefined" && test_taker_service_TestTakerService) === "function" && start_screen_audio_check_component__c || Object, typeof (start_screen_audio_check_component__d = typeof test_content_service_TestContentService !== "undefined" && test_content_service_TestContentService) === "function" && start_screen_audio_check_component__d || Object, typeof (start_screen_audio_check_component__e = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && start_screen_audio_check_component__e || Object, typeof (start_screen_audio_check_component__f = typeof my_modal_component_MyModal !== "undefined" && my_modal_component_MyModal) === "function" && start_screen_audio_check_component__f || Object, typeof (start_screen_audio_check_component__g = typeof auth_service_AuthService !== "undefined" && auth_service_AuthService) === "function" && start_screen_audio_check_component__g || Object])
], start_screen_audio_check_component_StartScreenAudioCheckComponent);

var start_screen_audio_check_component__a, start_screen_audio_check_component__b, start_screen_audio_check_component__c, start_screen_audio_check_component__d, start_screen_audio_check_component__e, start_screen_audio_check_component__f, start_screen_audio_check_component__g;
//# sourceMappingURL=start-screen-audio-check.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/tdp/start-screen/start-screen-microphone-check.component.ts
var start_screen_microphone_check_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var start_screen_microphone_check_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};










var start_screen_microphone_check_component_StartScreenMicrophoneCheckComponent = (function () {
    function StartScreenMicrophoneCheckComponent(router, route, testTakerService, testContentService, store, myModal, authService) {
        this.router = router;
        this.route = route;
        this.testTakerService = testTakerService;
        this.testContentService = testContentService;
        this.store = store;
        this.myModal = myModal;
        this.authService = authService;
        this.testTakerInfo = {};
    }
    StartScreenMicrophoneCheckComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeParamsSubscription = this.route.params.subscribe(function (params) {
            if (params) {
                var stationNumber = params['station-number'];
                if (!_this.testTakerService.testTakerInfo) {
                    if (!config_helper_ConfigHelper.isTdpMode(true)) {
                        _this.router.navigate(["start-screen/" + stationNumber + "/pending"]);
                    }
                    else {
                        var accessToken = _this.authService.getAccessToken();
                        if (!(accessToken && accessToken.length > 0)) {
                            var webDeliveryAuth = _this.authService.getWebDeliveryAuth();
                            if (!webDeliveryAuth) {
                                _this.myModal.showRegularDlg("Error", "Information missing, please restart the test from the 'My Account' page.");
                            }
                            else {
                                _this.router.navigateByUrl('/start-screen-web/' + encodeURIComponent(webDeliveryAuth));
                            }
                        }
                    }
                }
                else {
                    _this.stationNumber = stationNumber;
                    _this.testTakerInfo = _this.testTakerService.testTakerInfo;
                    if (config_helper_ConfigHelper.isTdpMode(true)) {
                        _this.testTakerPhotoUrl = _this.testTakerService.getWebDeliveryTestTakerPhotoUrl(_this.testTakerInfo.ClientApplicationSessionId, _this.testTakerInfo.TestTakerId);
                    }
                    else {
                        _this.testTakerPhotoUrl = _this.testTakerService.getTestTakerPhotoUrl(_this.testTakerInfo.BrandName, _this.testTakerInfo.TestSessionSiteCode, _this.testTakerInfo.TestTakerId);
                    }
                }
            }
        });
    };
    StartScreenMicrophoneCheckComponent.prototype.ngOnDestroy = function () {
        if (this.routeParamsSubscription) {
            this.routeParamsSubscription.unsubscribe();
        }
    };
    StartScreenMicrophoneCheckComponent.prototype.clearErrorMsg = function () {
        this.errorMsg = "";
    };
    StartScreenMicrophoneCheckComponent.prototype.audioCheckCompleted = function () {
        if (config_helper_ConfigHelper.isTdpMode(true)) {
            this.startTest();
        }
        else {
            this.router.navigate(["start-screen/" + this.stationNumber + "/start-code"]);
        }
    };
    StartScreenMicrophoneCheckComponent.prototype.startTest = function () {
        var _this = this;
        this.testTakerService.startTest().subscribe(function (success) {
            _this.store.dispatch(new test_taker_action_namespaceObject.SetTestInitializationInfo(success));
            _this.testTakerService.saveTestTakerActivityWithoutCaching(TestTakerActivityTypeEnum.StartCodeCorrectInput);
            _this.router.navigate(["assessment-test/" + _this.testTakerInfo.AssessmentTestId]);
        }, function (error) {
            _this.myModal.showRegularDlg("Error", error);
        });
    };
    return StartScreenMicrophoneCheckComponent;
}());
start_screen_microphone_check_component_StartScreenMicrophoneCheckComponent = start_screen_microphone_check_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'start-screen-microphone-check',
        template: __webpack_require__("626h")
    }),
    start_screen_microphone_check_component___metadata("design:paramtypes", [typeof (start_screen_microphone_check_component__a = typeof router_es5["b" /* Router */] !== "undefined" && router_es5["b" /* Router */]) === "function" && start_screen_microphone_check_component__a || Object, typeof (start_screen_microphone_check_component__b = typeof router_es5["a" /* ActivatedRoute */] !== "undefined" && router_es5["a" /* ActivatedRoute */]) === "function" && start_screen_microphone_check_component__b || Object, typeof (start_screen_microphone_check_component__c = typeof test_taker_service_TestTakerService !== "undefined" && test_taker_service_TestTakerService) === "function" && start_screen_microphone_check_component__c || Object, typeof (start_screen_microphone_check_component__d = typeof test_content_service_TestContentService !== "undefined" && test_content_service_TestContentService) === "function" && start_screen_microphone_check_component__d || Object, typeof (start_screen_microphone_check_component__e = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && start_screen_microphone_check_component__e || Object, typeof (start_screen_microphone_check_component__f = typeof my_modal_component_MyModal !== "undefined" && my_modal_component_MyModal) === "function" && start_screen_microphone_check_component__f || Object, typeof (start_screen_microphone_check_component__g = typeof auth_service_AuthService !== "undefined" && auth_service_AuthService) === "function" && start_screen_microphone_check_component__g || Object])
], start_screen_microphone_check_component_StartScreenMicrophoneCheckComponent);

var start_screen_microphone_check_component__a, start_screen_microphone_check_component__b, start_screen_microphone_check_component__c, start_screen_microphone_check_component__d, start_screen_microphone_check_component__e, start_screen_microphone_check_component__f, start_screen_microphone_check_component__g;
//# sourceMappingURL=start-screen-microphone-check.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/tdp/start-screen/start-screen-start-code.component.ts
var start_screen_start_code_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var start_screen_start_code_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var start_screen_start_code_component_StartScreenStartCodeComponent = (function () {
    function StartScreenStartCodeComponent(router, route, testTakerService, testContentService, store, myModal) {
        this.router = router;
        this.route = route;
        this.testTakerService = testTakerService;
        this.testContentService = testContentService;
        this.store = store;
        this.myModal = myModal;
        this.testTakerInfo = {};
    }
    StartScreenStartCodeComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeParamsSubscription = this.route.params.subscribe(function (params) {
            if (params) {
                var stationNumber = params['station-number'];
                if (!_this.testTakerService.testTakerInfo) {
                    _this.router.navigate(["start-screen/" + stationNumber + "/pending"]);
                }
                else {
                    _this.stationNumber = stationNumber;
                    _this.testTakerInfo = _this.testTakerService.testTakerInfo;
                    _this.testTakerPhotoUrl = _this.testTakerService.getTestTakerPhotoUrl(_this.testTakerInfo.BrandName, _this.testTakerInfo.TestSessionSiteCode, _this.testTakerInfo.TestTakerId);
                }
            }
        });
    };
    StartScreenStartCodeComponent.prototype.ngOnDestroy = function () {
        this.routeParamsSubscription.unsubscribe();
    };
    StartScreenStartCodeComponent.prototype.clearErrorMsg = function () {
        this.errorMsg = "";
    };
    StartScreenStartCodeComponent.prototype.verifyStartCodeAndBeginTest = function (startCode) {
        var _this = this;
        if (startCode != this.testTakerInfo.StartCode) {
            this.errorMsg = "Invalid Start Code.";
            this.testTakerService.saveTestTakerActivityWithoutCaching(TestTakerActivityTypeEnum.StartCodeWrongInput);
        }
        else {
            this.testTakerService.startTest().subscribe(function (success) {
                _this.store.dispatch(new test_taker_action_namespaceObject.SetTestInitializationInfo(success));
                _this.testTakerService.saveTestTakerActivityWithoutCaching(TestTakerActivityTypeEnum.StartCodeCorrectInput);
                _this.router.navigate(["assessment-test/" + _this.testTakerInfo.AssessmentTestId]);
            }, function (error) {
                _this.myModal.showRegularDlg("Error", error);
            });
        }
    };
    StartScreenStartCodeComponent.prototype.txtStartCodeKeyDown = function (event, startCode) {
        this.clearErrorMsg();
        if (event.keyCode == 13) {
            this.verifyStartCodeAndBeginTest(startCode);
        }
    };
    return StartScreenStartCodeComponent;
}());
start_screen_start_code_component_StartScreenStartCodeComponent = start_screen_start_code_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'start-screen-start-code',
        template: __webpack_require__("7sRl")
    }),
    start_screen_start_code_component___metadata("design:paramtypes", [typeof (start_screen_start_code_component__a = typeof router_es5["b" /* Router */] !== "undefined" && router_es5["b" /* Router */]) === "function" && start_screen_start_code_component__a || Object, typeof (start_screen_start_code_component__b = typeof router_es5["a" /* ActivatedRoute */] !== "undefined" && router_es5["a" /* ActivatedRoute */]) === "function" && start_screen_start_code_component__b || Object, typeof (start_screen_start_code_component__c = typeof test_taker_service_TestTakerService !== "undefined" && test_taker_service_TestTakerService) === "function" && start_screen_start_code_component__c || Object, typeof (start_screen_start_code_component__d = typeof test_content_service_TestContentService !== "undefined" && test_content_service_TestContentService) === "function" && start_screen_start_code_component__d || Object, typeof (start_screen_start_code_component__e = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && start_screen_start_code_component__e || Object, typeof (start_screen_start_code_component__f = typeof my_modal_component_MyModal !== "undefined" && my_modal_component_MyModal) === "function" && start_screen_start_code_component__f || Object])
], start_screen_start_code_component_StartScreenStartCodeComponent);

var start_screen_start_code_component__a, start_screen_start_code_component__b, start_screen_start_code_component__c, start_screen_start_code_component__d, start_screen_start_code_component__e, start_screen_start_code_component__f;
//# sourceMappingURL=start-screen-start-code.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/tdp/start-screen/start-screen-web.component.ts
var start_screen_web_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var start_screen_web_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};











var start_screen_web_component_StartScreenWebComponent = (function () {
    function StartScreenWebComponent(router, route, testTakerService, store, authService, myModal, fullScreenService) {
        this.router = router;
        this.route = route;
        this.testTakerService = testTakerService;
        this.store = store;
        this.authService = authService;
        this.myModal = myModal;
        this.fullScreenService = fullScreenService;
    }
    StartScreenWebComponent.prototype.pollForTestTakerInfo = function () {
        var _this = this;
        Rx["Observable"].interval(10000)
            .startWith(1)
            .flatMap(function (x) { return _this.testTakerService.getStationAssignmentWebDelivery(_this.webDeliveryAuth); })
            .filter(function (x) { return x != null; })
            .take(1)
            .retryWhen(function (errors) { return errors.delay(60000); })
            .subscribe(function (testTakerInfo) {
            _this.onStationAssignmentReceived(testTakerInfo);
        });
    };
    StartScreenWebComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeParamsSubscription = this.route.params.subscribe(function (params) {
            if (params) {
                _this.webDeliveryAuth = params['web-delivery-auth'];
                _this.pollForTestTakerInfo();
                _this.authService.setWebDeliveryAuth(_this.webDeliveryAuth.toString());
            }
        });
    };
    StartScreenWebComponent.prototype.ngOnDestroy = function () {
        this.routeParamsSubscription.unsubscribe();
    };
    StartScreenWebComponent.prototype.onStationAssignmentReceived = function (testTakerInfo) {
        this.testTakerInfo = testTakerInfo;
        this.regId = this.testTakerInfo.TestTakerId;
        this.testTakerPhotoUrl = this.testTakerService.getWebDeliveryTestTakerPhotoUrl(this.testTakerInfo.ClientApplicationSessionId, this.testTakerInfo.TestTakerId);
        this.store.dispatch(new test_taker_action_namespaceObject.SetTestTakerInfo(testTakerInfo));
        config_helper_ConfigHelper.setTestTypeId(testTakerInfo.TestTypeId);
        this.authService.setAccessToken(testTakerInfo.Token);
    };
    StartScreenWebComponent.prototype.clearErrorMsg = function () {
        this.errorMsg = "";
    };
    StartScreenWebComponent.prototype.onStartTest = function () {
        var _this = this;
        this.fullScreenService.tryFullScreen().
            then(function (resolve) { _this.proceedToNextStep(); }, function (err) { _this.myModal.showRegularDlg("Error", "Error attempting to enable full-screen mode: ${err.message} (${err.name}) \nTesting cannot proceed without fullscreen enabled"); });
    };
    StartScreenWebComponent.prototype.proceedToNextStep = function () {
        var _this = this;
        if (_paragonConfig.audioTestEnabled === true) {
            this.router.navigate(["start-screen/" + this.testTakerInfo.TestTakerId + "/audio-check"]);
        }
        else {
            this.testTakerService.startTest().subscribe(function (success) {
                _this.store.dispatch(new test_taker_action_namespaceObject.SetTestInitializationInfo(success));
                _this.testTakerService.saveTestTakerActivityWithoutCaching(TestTakerActivityTypeEnum.StartCodeCorrectInput);
                _this.router.navigate(["assessment-test/" + _this.testTakerInfo.AssessmentTestId]);
            }, function (error) {
                _this.myModal.showRegularDlg("Error", error);
            });
        }
    };
    return StartScreenWebComponent;
}());
start_screen_web_component_StartScreenWebComponent = start_screen_web_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'start-screen-web',
        template: __webpack_require__("+01a")
    }),
    start_screen_web_component___metadata("design:paramtypes", [typeof (start_screen_web_component__a = typeof router_es5["b" /* Router */] !== "undefined" && router_es5["b" /* Router */]) === "function" && start_screen_web_component__a || Object, typeof (start_screen_web_component__b = typeof router_es5["a" /* ActivatedRoute */] !== "undefined" && router_es5["a" /* ActivatedRoute */]) === "function" && start_screen_web_component__b || Object, typeof (start_screen_web_component__c = typeof test_taker_service_TestTakerService !== "undefined" && test_taker_service_TestTakerService) === "function" && start_screen_web_component__c || Object, typeof (start_screen_web_component__d = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && start_screen_web_component__d || Object, typeof (start_screen_web_component__e = typeof auth_service_AuthService !== "undefined" && auth_service_AuthService) === "function" && start_screen_web_component__e || Object, typeof (start_screen_web_component__f = typeof my_modal_component_MyModal !== "undefined" && my_modal_component_MyModal) === "function" && start_screen_web_component__f || Object, typeof (start_screen_web_component__g = typeof FullscreenService !== "undefined" && FullscreenService) === "function" && start_screen_web_component__g || Object])
], start_screen_web_component_StartScreenWebComponent);

var start_screen_web_component__a, start_screen_web_component__b, start_screen_web_component__c, start_screen_web_component__d, start_screen_web_component__e, start_screen_web_component__f, start_screen_web_component__g;
//# sourceMappingURL=start-screen-web.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/app.routing.ts









var appRoutes = [
    { path: '', component: BlankComponent },
    { path: 'start-screen/:station-number/pending', component: start_screen_pending_component_StartScreenPendingComponent },
    { path: 'start-screen/:station-number/pin', component: start_screen_pin_component_StartScreenPinComponent },
    { path: 'start-screen/:station-number/audio-check', component: start_screen_audio_check_component_StartScreenAudioCheckComponent },
    { path: 'start-screen/:station-number/microphone-check', component: start_screen_microphone_check_component_StartScreenMicrophoneCheckComponent },
    { path: 'start-screen/:station-number/start-code', component: start_screen_start_code_component_StartScreenStartCodeComponent },
    { path: 'testlet/:id', component: pg_renderer_component_PgRendererComponent },
    { path: 'testlet/snapshot/:snapshot-id', component: pg_renderer_component_PgRendererComponent },
    { path: 'testform/:test-form-id', component: pg_renderer_component_PgRendererComponent },
    { path: 'testforms/:bulk-test-form-ids', component: pg_renderer_component_PgRendererComponent },
    { path: 'testforms/:bulk-test-form-ids/:validate', component: pg_renderer_component_PgRendererComponent },
    { path: 'testletversion/:testlet-version-id', component: pg_renderer_component_PgRendererComponent },
    { path: 'assessment-test/:assessment-test-id', component: pg_renderer_component_PgRendererComponent },
    { path: 'ipp-assessment-test/:ipp-assessment-test-id', component: pg_renderer_component_PgRendererComponent },
    { path: 'ipp-assessment-test/latest/:ipp-assessment-test-id-for-latest', component: pg_renderer_component_PgRendererComponent },
    { path: 'opt/:ipp-product-id', component: pg_renderer_component_PgRendererComponent },
    { path: 'start-screen-web/:web-delivery-auth', component: start_screen_web_component_StartScreenWebComponent },
];
var appRouting = router_es5["c" /* RouterModule */].forRoot(appRoutes, { useHash: true });
//# sourceMappingURL=app.routing.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/app.component.ts
var app_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var app_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};










var app_component_AppComponent = (function () {
    function AppComponent(store, changeDetectorRef, testTakerService, testContentService, vcRef, myModal, signalRService) {
        this.store = store;
        this.changeDetectorRef = changeDetectorRef;
        this.testTakerService = testTakerService;
        this.testContentService = testContentService;
        this.vcRef = vcRef;
        this.myModal = myModal;
        this.signalRService = signalRService;
        myModal.setRootViewContainerRef(vcRef);
    }
    AppComponent.prototype.ngOnInit = function () {
        this.loading$ = this.store.select(reducers_getIsLoading);
        this.isPauseScreenVisible$ = this.store.select(reducers_getIsPauseScreenVisible);
        this.isExitScreenVisible$ = this.store.select(reducers_getIsExitScreenVisible);
        this.isLockScreenVisible$ = this.store.select(reducers_getIsLockScreenVisible);
        this.bindHotKeys();
        this.bindTabClickEvent();
        if (config_helper_ConfigHelper.isTdpMode(true)) {
            // disable context menu
            window.addEventListener("contextmenu", function (e) {
                e.preventDefault();
            }, false);
        }
    };
    AppComponent.prototype.bindTabClickEvent = function () {
        var _this = this;
        $(document).on("click", ".testlet-tab-header", function (e) {
            if (config_helper_ConfigHelper.isTdpMode()) {
                _this.testTakerService.cacheTestTakerActivity(TestTakerActivityTypeEnum.TabClick, null, e.target.textContent, _this.testContentService.activeTestletId);
            }
            $('.pane-content').scrollTop(0);
        });
    };
    AppComponent.prototype.bindHotKeys = function () {
        var _this = this;
        $(document).keydown(function (event) {
            if (config_helper_ConfigHelper.isTdpMode(true)) {
                var forbiddenShortcuts = [
                    event.keyCode === 116,
                    event.keyCode === 117,
                    event.keyCode === 122,
                    event.keyCode === 123,
                    event.altKey && event.keyCode === 115,
                    event.ctrlKey && event.keyCode === 48,
                    event.ctrlKey && event.keyCode === 49,
                    event.ctrlKey && event.keyCode === 50,
                    event.ctrlKey && event.keyCode === 51,
                    event.ctrlKey && event.keyCode === 52,
                    event.ctrlKey && event.keyCode === 53,
                    event.ctrlKey && event.keyCode === 54,
                    event.ctrlKey && event.keyCode === 55,
                    event.ctrlKey && event.keyCode === 56,
                    event.ctrlKey && event.keyCode === 57,
                    event.ctrlKey && event.keyCode === 72,
                    event.ctrlKey && event.keyCode === 78,
                    event.ctrlKey && event.keyCode === 78,
                    event.ctrlKey && event.keyCode === 82,
                    event.ctrlKey && event.keyCode === 83,
                    event.ctrlKey && event.keyCode === 84,
                    event.ctrlKey && event.keyCode === 87,
                ];
                if (forbiddenShortcuts.indexOf(true) >= 0) {
                    event.preventDefault();
                    event.stopPropagation();
                    return;
                }
            }
            if (event.altKey && config_helper_ConfigHelper.isTdpMode(false)) {
                if (event.keyCode === 115) {
                    // alt + f4
                    _this.store.dispatch(new app_ui_action_namespaceObject.ShowExitScreen());
                    _this.changeDetectorRef.detectChanges();
                }
                else if (event.keyCode === 118) {
                    // alt + f7
                    _this.store.dispatch(new app_ui_action_namespaceObject.ShowLockScreen());
                    _this.testTakerService.saveTestTakerActivityWithoutCaching(TestTakerActivityTypeEnum.ScreenLockStart);
                    _this.changeDetectorRef.detectChanges();
                }
            }
            if (_paragonConfig.shortcutsEnabled === true) {
                if (event.keyCode === 114) {
                    // f3
                }
                else if (event.keyCode === 115) {
                    // f4
                    _this.store.dispatch(new app_ui_action_namespaceObject.ToggleNavigationModal(true));
                }
            }
        });
    };
    return AppComponent;
}());
app_component_AppComponent = app_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'app',
        template: __webpack_require__("efyd")
    }),
    app_component___metadata("design:paramtypes", [typeof (app_component__a = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && app_component__a || Object, typeof (app_component__b = typeof core_es5["l" /* ChangeDetectorRef */] !== "undefined" && core_es5["l" /* ChangeDetectorRef */]) === "function" && app_component__b || Object, typeof (app_component__c = typeof test_taker_service_TestTakerService !== "undefined" && test_taker_service_TestTakerService) === "function" && app_component__c || Object, typeof (app_component__d = typeof test_content_service_TestContentService !== "undefined" && test_content_service_TestContentService) === "function" && app_component__d || Object, typeof (app_component__e = typeof core_es5["_19" /* ViewContainerRef */] !== "undefined" && core_es5["_19" /* ViewContainerRef */]) === "function" && app_component__e || Object, typeof (app_component__f = typeof my_modal_component_MyModal !== "undefined" && my_modal_component_MyModal) === "function" && app_component__f || Object, typeof (app_component__g = typeof signalR_service_SignalRService !== "undefined" && signalR_service_SignalRService) === "function" && app_component__g || Object])
], app_component_AppComponent);

var app_component__a, app_component__b, app_component__c, app_component__d, app_component__e, app_component__f, app_component__g;
//# sourceMappingURL=app.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/store/effects/app-ui.effect.ts
var app_ui_effect___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var app_ui_effect___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var AppUiEffects = (function () {
    function AppUiEffects(store, testContentService) {
        this.store = store;
        this.testContentService = testContentService;
    }
    return AppUiEffects;
}());
AppUiEffects = app_ui_effect___decorate([
    Object(core_es5["C" /* Injectable */])(),
    app_ui_effect___metadata("design:paramtypes", [typeof (app_ui_effect__a = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && app_ui_effect__a || Object, typeof (app_ui_effect__b = typeof test_content_service_TestContentService !== "undefined" && test_content_service_TestContentService) === "function" && app_ui_effect__b || Object])
], AppUiEffects);

var app_ui_effect__a, app_ui_effect__b;
//# sourceMappingURL=app-ui.effect.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/store/effects/test-taker.effect.ts
var test_taker_effect___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var test_taker_effect___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var test_taker_effect_TestTakerEffects = (function () {
    function TestTakerEffects(store, testContentService, actions$) {
        var _this = this;
        this.store = store;
        this.testContentService = testContentService;
        this.actions$ = actions$;
        this.loadTestlet$ = this.actions$.ofType(test_taker_action_namespaceObject.LOAD_TESTLET)
            .do(function (x) { return _this.store.dispatch(new app_ui_action_namespaceObject.ShowLoadingOverlay()); })
            .map(effects_es5["d" /* toPayload */])
            .switchMap(function (payload) { return _this.testContentService.getTestlet(payload.testletId, payload.assessmentTestId)
            .map(function (testlet) { return new test_taker_action_namespaceObject.LoadTestletSuccess(testlet); }); })
            .do(function (x) { return _this.store.dispatch(new app_ui_action_namespaceObject.HideLoadingOverlay()); });
        this.preloadTestlet$ = this.actions$.ofType(test_taker_action_namespaceObject.PRELOAD_TESTLET)
            .map(effects_es5["d" /* toPayload */])
            .switchMap(function (payload) { return _this.testContentService.getTestlet(payload.testletId, payload.assessmentTestId)
            .map(function (testlet) { return new test_taker_action_namespaceObject.PreloadTestletSuccess(testlet); }); });
        this.loadSnapShotTestlet$ = this.actions$.ofType(test_taker_action_namespaceObject.LOAD_SNAPSHOT_TESTLET)
            .do(function (x) { return _this.store.dispatch(new app_ui_action_namespaceObject.ShowLoadingOverlay()); })
            .map(effects_es5["d" /* toPayload */])
            .switchMap(function (testletId) { return _this.testContentService.getSnapshotTestlet(testletId)
            .map(function (testlet) { return new test_taker_action_namespaceObject.LoadTestletSuccess(testlet.TestletDetail.TestletDefinition); }); })
            .do(function (x) { return _this.store.dispatch(new app_ui_action_namespaceObject.HideLoadingOverlay()); });
        this.loadAssessmentTestByTestForm$ = this.actions$.ofType(test_taker_action_namespaceObject.LOAD_ASSESSMENT_TEST_BY_TEST_FORM)
            .do(function (x) { return _this.store.dispatch(new app_ui_action_namespaceObject.ShowLoadingOverlay()); })
            .map(effects_es5["d" /* toPayload */])
            .switchMap(function (testFormId) { return _this.testContentService.getAssessmentTestByTestFormId(testFormId)
            .map(function (assessmentTest) { return new test_taker_action_namespaceObject.LoadAssessmentTestSuccess(assessmentTest); }); })
            .do(function (x) { return _this.store.dispatch(new app_ui_action_namespaceObject.HideLoadingOverlay()); });
        this.loadAssessmentTest$ = this.actions$.ofType(test_taker_action_namespaceObject.LOAD_ASSESSMENT_TEST)
            .do(function (x) { return _this.store.dispatch(new app_ui_action_namespaceObject.ShowLoadingOverlay()); })
            .map(effects_es5["d" /* toPayload */])
            .switchMap(function (assessmentTestId) { return _this.testContentService.getAssessmentTest(assessmentTestId)
            .map(function (assessmentTest) { return new test_taker_action_namespaceObject.LoadAssessmentTestSuccess(assessmentTest); }); })
            .do(function (x) { return _this.store.dispatch(new app_ui_action_namespaceObject.HideLoadingOverlay()); });
        this.loadTestletVersion$ = this.actions$.ofType(test_taker_action_namespaceObject.LOAD_TESTLET_VERSION)
            .do(function (x) { return _this.store.dispatch(new app_ui_action_namespaceObject.ShowLoadingOverlay()); })
            .map(effects_es5["d" /* toPayload */])
            .switchMap(function (testletVersionId) { return _this.testContentService.getTestletVersion(testletVersionId)
            .map(function (testlet) { return new test_taker_action_namespaceObject.LoadTestletSuccess(testlet); }); })
            .do(function (x) { return _this.store.dispatch(new app_ui_action_namespaceObject.HideLoadingOverlay()); });
        this.loadIppAssessmentTest$ = this.actions$.ofType(test_taker_action_namespaceObject.LOAD_IPP_ASSESSMENT_TEST)
            .do(function (x) { return _this.store.dispatch(new app_ui_action_namespaceObject.ShowLoadingOverlay()); })
            .map(effects_es5["d" /* toPayload */])
            .switchMap(function (ippAssessmentTestId) { return _this.testContentService.getIppAssessmentTest(ippAssessmentTestId)
            .map(function (ippAssessmentTest) { return new test_taker_action_namespaceObject.LoadAssessmentTestSuccess(ippAssessmentTest.IppAssessmentTest); }); })
            .do(function (x) { return _this.store.dispatch(new app_ui_action_namespaceObject.HideLoadingOverlay()); });
        this.loadLatestIppAssessmentTest$ = this.actions$.ofType(test_taker_action_namespaceObject.LOAD_LATEST_IPP_ASSESSMENT_TEST)
            .do(function (x) { return _this.store.dispatch(new app_ui_action_namespaceObject.ShowLoadingOverlay()); })
            .map(effects_es5["d" /* toPayload */])
            .switchMap(function (ippAssessmentTestId) { return _this.testContentService.getIppAssessmentTest(ippAssessmentTestId)
            .map(function (ippAssessmentTest) { return new test_taker_action_namespaceObject.LoadAssessmentTestSuccess(ippAssessmentTest.IppAssessmentTest); }); })
            .do(function (x) { return _this.store.dispatch(new app_ui_action_namespaceObject.HideLoadingOverlay()); });
        this.loadIppProduct$ = this.actions$.ofType(test_taker_action_namespaceObject.LOAD_IPP_PRODUCT)
            .do(function (x) { return _this.store.dispatch(new app_ui_action_namespaceObject.ShowLoadingOverlay()); })
            .map(effects_es5["d" /* toPayload */])
            .switchMap(function (productId) { return _this.testContentService.getIppAssessmentTestByProductId(productId)
            .mergeMap(function (dto) {
            return Observable["Observable"].from([
                new test_taker_action_namespaceObject.SetIppProductInfo(dto),
                new test_taker_action_namespaceObject.LoadAssessmentTestSuccess(dto.IppAssessmentTest)
            ]);
        }); })
            .do(function (x) { return _this.store.dispatch(new app_ui_action_namespaceObject.HideLoadingOverlay()); });
    }
    return TestTakerEffects;
}());
test_taker_effect___decorate([
    Object(effects_es5["b" /* Effect */])(),
    test_taker_effect___metadata("design:type", typeof (test_taker_effect__a = typeof Observable["Observable"] !== "undefined" && Observable["Observable"]) === "function" && test_taker_effect__a || Object)
], test_taker_effect_TestTakerEffects.prototype, "loadTestlet$", void 0);
test_taker_effect___decorate([
    Object(effects_es5["b" /* Effect */])(),
    test_taker_effect___metadata("design:type", typeof (test_taker_effect__b = typeof Observable["Observable"] !== "undefined" && Observable["Observable"]) === "function" && test_taker_effect__b || Object)
], test_taker_effect_TestTakerEffects.prototype, "preloadTestlet$", void 0);
test_taker_effect___decorate([
    Object(effects_es5["b" /* Effect */])(),
    test_taker_effect___metadata("design:type", typeof (test_taker_effect__c = typeof Observable["Observable"] !== "undefined" && Observable["Observable"]) === "function" && test_taker_effect__c || Object)
], test_taker_effect_TestTakerEffects.prototype, "loadSnapShotTestlet$", void 0);
test_taker_effect___decorate([
    Object(effects_es5["b" /* Effect */])(),
    test_taker_effect___metadata("design:type", typeof (test_taker_effect__d = typeof Observable["Observable"] !== "undefined" && Observable["Observable"]) === "function" && test_taker_effect__d || Object)
], test_taker_effect_TestTakerEffects.prototype, "loadAssessmentTestByTestForm$", void 0);
test_taker_effect___decorate([
    Object(effects_es5["b" /* Effect */])(),
    test_taker_effect___metadata("design:type", typeof (test_taker_effect__e = typeof Observable["Observable"] !== "undefined" && Observable["Observable"]) === "function" && test_taker_effect__e || Object)
], test_taker_effect_TestTakerEffects.prototype, "loadAssessmentTest$", void 0);
test_taker_effect___decorate([
    Object(effects_es5["b" /* Effect */])(),
    test_taker_effect___metadata("design:type", typeof (test_taker_effect__f = typeof Observable["Observable"] !== "undefined" && Observable["Observable"]) === "function" && test_taker_effect__f || Object)
], test_taker_effect_TestTakerEffects.prototype, "loadTestletVersion$", void 0);
test_taker_effect___decorate([
    Object(effects_es5["b" /* Effect */])(),
    test_taker_effect___metadata("design:type", typeof (test_taker_effect__g = typeof Observable["Observable"] !== "undefined" && Observable["Observable"]) === "function" && test_taker_effect__g || Object)
], test_taker_effect_TestTakerEffects.prototype, "loadIppAssessmentTest$", void 0);
test_taker_effect___decorate([
    Object(effects_es5["b" /* Effect */])(),
    test_taker_effect___metadata("design:type", typeof (test_taker_effect__h = typeof Observable["Observable"] !== "undefined" && Observable["Observable"]) === "function" && test_taker_effect__h || Object)
], test_taker_effect_TestTakerEffects.prototype, "loadLatestIppAssessmentTest$", void 0);
test_taker_effect___decorate([
    Object(effects_es5["b" /* Effect */])(),
    test_taker_effect___metadata("design:type", typeof (test_taker_effect__j = typeof Observable["Observable"] !== "undefined" && Observable["Observable"]) === "function" && test_taker_effect__j || Object)
], test_taker_effect_TestTakerEffects.prototype, "loadIppProduct$", void 0);
test_taker_effect_TestTakerEffects = test_taker_effect___decorate([
    Object(core_es5["C" /* Injectable */])(),
    test_taker_effect___metadata("design:paramtypes", [typeof (test_taker_effect__k = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && test_taker_effect__k || Object, typeof (test_taker_effect__l = typeof test_content_service_TestContentService !== "undefined" && test_content_service_TestContentService) === "function" && test_taker_effect__l || Object, typeof (test_taker_effect__m = typeof effects_es5["a" /* Actions */] !== "undefined" && effects_es5["a" /* Actions */]) === "function" && test_taker_effect__m || Object])
], test_taker_effect_TestTakerEffects);

var test_taker_effect__a, test_taker_effect__b, test_taker_effect__c, test_taker_effect__d, test_taker_effect__e, test_taker_effect__f, test_taker_effect__g, test_taker_effect__h, test_taker_effect__j, test_taker_effect__k, test_taker_effect__l, test_taker_effect__m;
//# sourceMappingURL=test-taker.effect.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/store/effects/index.ts



//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body.component.ts
var item_body_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var item_body_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var ItemBodyComponent = (function () {
    function ItemBodyComponent() {
        this.showTab = false;
    }
    ItemBodyComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.assessmentItemSubscription = this.assessmentItem$.subscribe(function (assessmentItem) {
            _this.assessmentItem = assessmentItem;
            if (_this.assessmentItem) {
                _this.leftPane = _this.assessmentItem.ItemBody.ItemBodyPanels.find(function (x) { return x.CssClass.indexOf("leftpane") >= 0; });
                _this.rightPane = _this.assessmentItem.ItemBody.ItemBodyPanels.find(function (x) { return x.CssClass.indexOf("rightpane") >= 0; });
                _this.mainPane = _this.assessmentItem.ItemBody.ItemBodyPanels.find(function (x) { return x.CssClass.indexOf("mainpane") >= 0; });
            }
            if (_this.assessmentItem && _this.assessmentItem.DisplayPageNumber) {
                _this.showTab = true;
            }
            else {
                _this.showTab = false;
            }
        });
    };
    ItemBodyComponent.prototype.ngOnDestroy = function () {
        if (this.assessmentItemSubscription) {
            this.assessmentItemSubscription.unsubscribe();
        }
    };
    return ItemBodyComponent;
}());
item_body_component___decorate([
    Object(core_es5["F" /* Input */])(),
    item_body_component___metadata("design:type", typeof (item_body_component__a = typeof Rx["Observable"] !== "undefined" && Rx["Observable"]) === "function" && item_body_component__a || Object)
], ItemBodyComponent.prototype, "assessmentItem$", void 0);
ItemBodyComponent = item_body_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'item-body',
        template: __webpack_require__("Lh+r")
    })
], ItemBodyComponent);

var item_body_component__a;
//# sourceMappingURL=item-body.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/page-nav/page-nav.component.ts
var page_nav_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var page_nav_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var page_nav_component_PageNavComponent = (function () {
    function PageNavComponent(responseService, changeDetectorRef, testContentService, testNavigationService, testTakerService) {
        this.responseService = responseService;
        this.changeDetectorRef = changeDetectorRef;
        this.testContentService = testContentService;
        this.testNavigationService = testNavigationService;
        this.testTakerService = testTakerService;
        this.pageChange = new core_es5["x" /* EventEmitter */]();
    }
    PageNavComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.responsesSubscription = this.responseService.responses$.subscribe(function (x) {
            _this.changeDetectorRef.markForCheck();
        });
        this.testletSubscription = this.testlet$.subscribe(function (testlet) {
            _this.testlet = testlet;
            _this.initAssessmentItemList();
        });
        this.itemIndexSubscription = this.itemIndex$.subscribe(function (itemIndex) {
            _this.itemIndex = itemIndex;
            _this.initAssessmentItemList();
        });
    };
    PageNavComponent.prototype.ngOnDestroy = function () {
        if (this.responsesSubscription) {
            this.responsesSubscription.unsubscribe();
        }
        if (this.testletSubscription) {
            this.testletSubscription.unsubscribe();
        }
        if (this.itemIndexSubscription) {
            this.itemIndexSubscription.unsubscribe();
        }
    };
    PageNavComponent.prototype.onPageChange = function (index) {
        this.testNavigationService.changeAssessmentItem(index);
    };
    PageNavComponent.prototype.goNext = function () {
        var activeItem = this.testlet.AssessmentItems[this.itemIndex];
        if (activeItem.DisplayPageNumber < this.assessmentItemList.length) {
            this.testTakerService.cacheTestTakerActivity(TestTakerActivityTypeEnum.PageNavigationArrowClick, null, "next", this.testContentService.activeTestletId);
            this.testNavigationService.changeAssessmentItem(this.itemIndex + 1);
        }
    };
    PageNavComponent.prototype.goPrev = function () {
        var activeItem = this.testlet.AssessmentItems[this.itemIndex];
        var minItemIndex = this.testlet.AssessmentItems.find(function (x) { return x.GroupNumber == activeItem.GroupNumber && x.DisplayPageNumber == 1; }).ItemIndex;
        if (this.itemIndex > minItemIndex) {
            this.testTakerService.cacheTestTakerActivity(TestTakerActivityTypeEnum.PageNavigationArrowClick, null, "prev", this.testContentService.activeTestletId);
            this.testNavigationService.changeAssessmentItem(this.itemIndex - 1);
        }
    };
    PageNavComponent.prototype.allInteractionsAnswered = function (item) {
        return this.responseService.getUnansweredInteractionCountInAssessmentItem(item) == 0;
    };
    PageNavComponent.prototype.initAssessmentItemList = function () {
        var activeItem = null;
        if (this.testlet) {
            activeItem = this.testlet.AssessmentItems[this.itemIndex];
        }
        if (activeItem) {
            this.assessmentItemList = this.testlet.AssessmentItems.filter(function (x) { return x.GroupNumber == activeItem.GroupNumber; });
        }
        else {
            this.assessmentItemList = [];
        }
        this.changeDetectorRef.markForCheck();
    };
    return PageNavComponent;
}());
page_nav_component___decorate([
    Object(core_es5["F" /* Input */])(),
    page_nav_component___metadata("design:type", typeof (page_nav_component__a = typeof Rx["Observable"] !== "undefined" && Rx["Observable"]) === "function" && page_nav_component__a || Object)
], page_nav_component_PageNavComponent.prototype, "testlet$", void 0);
page_nav_component___decorate([
    Object(core_es5["F" /* Input */])(),
    page_nav_component___metadata("design:type", typeof (page_nav_component__b = typeof Rx["Observable"] !== "undefined" && Rx["Observable"]) === "function" && page_nav_component__b || Object)
], page_nav_component_PageNavComponent.prototype, "itemIndex$", void 0);
page_nav_component___decorate([
    Object(core_es5["U" /* Output */])(),
    page_nav_component___metadata("design:type", typeof (page_nav_component__c = typeof core_es5["x" /* EventEmitter */] !== "undefined" && core_es5["x" /* EventEmitter */]) === "function" && page_nav_component__c || Object)
], page_nav_component_PageNavComponent.prototype, "pageChange", void 0);
page_nav_component_PageNavComponent = page_nav_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'page-nav',
        template: __webpack_require__("5SK3"),
        changeDetection: core_es5["k" /* ChangeDetectionStrategy */].OnPush,
    }),
    page_nav_component___metadata("design:paramtypes", [typeof (page_nav_component__d = typeof response_service_ResponseService !== "undefined" && response_service_ResponseService) === "function" && page_nav_component__d || Object, typeof (page_nav_component__e = typeof core_es5["l" /* ChangeDetectorRef */] !== "undefined" && core_es5["l" /* ChangeDetectorRef */]) === "function" && page_nav_component__e || Object, typeof (page_nav_component__f = typeof test_content_service_TestContentService !== "undefined" && test_content_service_TestContentService) === "function" && page_nav_component__f || Object, typeof (page_nav_component__g = typeof test_navigation_service_TestNavigationService !== "undefined" && test_navigation_service_TestNavigationService) === "function" && page_nav_component__g || Object, typeof (page_nav_component__h = typeof test_taker_service_TestTakerService !== "undefined" && test_taker_service_TestTakerService) === "function" && page_nav_component__h || Object])
], page_nav_component_PageNavComponent);

var page_nav_component__a, page_nav_component__b, page_nav_component__c, page_nav_component__d, page_nav_component__e, page_nav_component__f, page_nav_component__g, page_nav_component__h;
//# sourceMappingURL=page-nav.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/top-nav/timer/timer.component.ts
var timer_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var timer_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};









var timer_component_TimerComponent = (function () {
    function TimerComponent(timerService, testContentService, testNavigationService, testTakerService, myModal, changeDetectorRef) {
        this.timerService = timerService;
        this.testContentService = testContentService;
        this.testNavigationService = testNavigationService;
        this.testTakerService = testTakerService;
        this.myModal = myModal;
        this.changeDetectorRef = changeDetectorRef;
    }
    TimerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.assessmentItemSubscription = this.assessmentItem$.subscribe(function (assessmentItem) {
            var testlet = _this.testContentService.activeTestlet;
            if (testlet && assessmentItem) {
                var referencedInteractions = _this.testContentService.getReferencedInteractions(assessmentItem);
                var firstSpeakingInteraction = referencedInteractions.find(function (interaction) { return interaction && interaction.SpeakingInteraction != null; });
                var _a = _this.getSpeakingTimings(firstSpeakingInteraction), preparationTime = _a.preparationTime, recordingTime = _a.recordingTime;
                var timerVisibility = true;
                var differentTestlet = _this.previousTestletId !== _this.testContentService.activeTestletId;
                var differentAssessmentItemGroup = _this.previousAssessmentItem && _this.previousAssessmentItem.GroupNumber != assessmentItem.GroupNumber;
                var startTimer = differentTestlet || differentAssessmentItemGroup;
                if (startTimer) {
                    var multiplier = 1;
                    var html = assessmentItem.ItemBody.ItemBodyPanels.map(function (p) { return p.Html; }).join(" ");
                    var autoSkipTimerValue = _this.parseAutoSkipTimerValue(html);
                    var listeningTimes = _this.parseListeningTimeTimerValue(html);
                    var timeLimits = Object.assign({}, testlet.TimeLimits);
                    if (listeningTimes) {
                        timeLimits.MinTime = timeLimits.MaxTime - listeningTimes.reviewTime;
                    }
                    if (config_helper_ConfigHelper.isTdpMode()) {
                        var _b = _this.getAdditionalTime(timeLimits, assessmentItem), originalMaxTime = _b.originalMaxTime, multipliers = _b.multipliers;
                        _this.applyAdditionalTime(timeLimits, multipliers, originalMaxTime, listeningTimes);
                        if (multipliers.length > 0) {
                            multiplier = multipliers[0];
                        }
                    }
                    // only show the time's up dialog box when the testlet's time limit is 60 seconds or more
                    var showTimesUpWarning = timeLimits.MaxTime > 60 && !_this.testTakerService.testNavigation.isEndOfTest;
                    if (autoSkipTimerValue) {
                        timeLimits.MinTime = null;
                        timeLimits.MaxTime = autoSkipTimerValue;
                        showTimesUpWarning = false;
                    }
                    // find timeElapsed in this Testlet
                    var timeAlreadyUsedInTestlet = 0;
                    if (config_helper_ConfigHelper.isTdpMode(true) && _this.testContentService.activeTestletId && _this.testContentService.useTestletTimeAdjustment()) {
                        timeAlreadyUsedInTestlet = _this.timerService.getTimeUsedOnTestlet(_this.testContentService.activeTestletId);
                    }
                    _this.timerService.startTimer(timeLimits, preparationTime, recordingTime, timerVisibility, function () { return _this.testNavigationService.goNext(false); }, showTimesUpWarning, multiplier, timeAlreadyUsedInTestlet);
                    _this.previousTestletId = _this.testContentService.activeTestletId;
                }
                _this.previousAssessmentItem = assessmentItem;
            }
        });
        this.timerSubscription = this.timerService.timer$.subscribe(function (timer) {
            _this.clearTimerInterval();
            _this.visible = false;
            _this.previousCanGoNext = undefined;
            _this.runningLowOnTime = false;
            _this.processTimer();
            _this.changeDetectorRef.detectChanges();
            if (timer.timeLimits && (timer.timeLimits.MinTime || timer.timeLimits.MaxTime)) {
                _this.timerIntervalHandle = window.setInterval(function () {
                    _this.processTimer();
                }, 1000);
            }
        });
    };
    TimerComponent.prototype.ngOnDestroy = function () {
        this.clearTimerInterval();
        if (this.timerSubscription) {
            this.timerSubscription.unsubscribe();
        }
        if (this.assessmentItemSubscription) {
            this.assessmentItemSubscription.unsubscribe();
        }
    };
    TimerComponent.prototype.processTimer = function () {
        var _this = this;
        var timer = this.timerService.timer;
        if (timer) {
            if (timer.speakingPreparationTime && timer.speakingRecordingTime) {
                this.displayMode = "speaking";
                this.visible = this.timerService.isTimerVisible;
                this.speakingPreparationTime = timer.speakingPreparationTime;
                this.speakingRecordingTime = timer.speakingRecordingTime;
            }
            else if (timer.timeLimits) {
                if (config_helper_ConfigHelper.isTdpMode(true) && this.testContentService.activeTestletId) {
                    this.timerService.saveTimeUsedOnTestlet(this.testContentService.activeTestletId);
                }
                this.displayMode = "standard";
                this.visible = this.timerService.isTimerVisible && timer.timeLimits.MaxTime && timer.timeLimits.MaxTime > 0;
                var displayString = null;
                if (timer.pausedAt) {
                    displayString = "PAUSED";
                }
                else {
                    var goNextCallbackSet = false;
                    if (timer.timeLimits.MaxTime) {
                        var timeLeft = this.timerService.getTimeLeft();
                        this.runningLowOnTime = timeLeft < 180;
                        displayString = this.timerService.getDisplayString(timeLeft);
                        if (timeLeft === 0 && this.timerIntervalHandle) {
                            this.clearTimerInterval();
                            goNextCallbackSet = true;
                            var timesUpCallback_1 = timer.timesUpCallback ? timer.timesUpCallback : function () {
                                _this.testNavigationService.goNext(false);
                            };
                            if (timer.showTimesUpWarning) {
                                this.myModal.showTimesUpDlg(function () { return _this.handleTimeout(timesUpCallback_1); });
                            }
                            else {
                                this.handleTimeout(timesUpCallback_1);
                            }
                        }
                    }
                    if (!goNextCallbackSet) {
                        this.updateCanGoNext();
                    }
                }
                this.timerDisplayText = displayString;
            }
        }
    };
    TimerComponent.prototype.handleTimeout = function (timesUpCallback) {
        var currentTestlet = this.testContentService.activeTestlet;
        if (currentTestlet) {
            var assessmentItems = this.testContentService.getReferencedInteractionsByTestlet(currentTestlet);
            if (assessmentItems.length > 0) {
                this.testTakerService.cacheTestTakerActivity(TestTakerActivityTypeEnum.TestletTimeout, null, null, this.testContentService.activeTestletId);
            }
        }
        timesUpCallback();
    };
    TimerComponent.prototype.updateCanGoNext = function () {
        var canGoNext = this.timerService.canGoNext();
        //only update the store if the value has changed
        if (canGoNext != this.previousCanGoNext) {
            this.previousCanGoNext = canGoNext;
            this.testNavigationService.setCanGoNext(this.timerService.canGoNext());
        }
    };
    TimerComponent.prototype.clearTimerInterval = function () {
        if (this.timerIntervalHandle) {
            window.clearInterval(this.timerIntervalHandle);
            this.timerIntervalHandle = null;
        }
    };
    TimerComponent.prototype.parseAutoSkipTimerValue = function (html) {
        var regex = /<auto-skip-timer>(\d+)<\/auto-skip-timer>/igm;
        var matchedArray;
        if ((matchedArray = regex.exec(html)) != null) {
            return parseInt(matchedArray[1]);
        }
        return null;
    };
    TimerComponent.prototype.parseListeningTimeTimerValue = function (html) {
        var attributeRegex = /(<auto-play-resource .*<\/auto-play-resource>)/igm;
        var tagsRegex = /(time|reviewTime)="(\d+)"/igm;
        var matchedAttributeArray;
        var matchedTagsArray;
        var times = {
            time: 0,
            reviewTime: 0
        };
        var existAttributeMatchArray = (matchedAttributeArray = attributeRegex.exec(html)) != null;
        if (existAttributeMatchArray) {
            var attributeMatch = matchedAttributeArray[1].toString();
            var attributeFound = existAttributeMatchArray && attributeMatch;
            var existTagsMatchArray = (matchedTagsArray = this.captureAllTagMatches(attributeMatch, tagsRegex)) != null;
            if (attributeFound && existTagsMatchArray) {
                times = this.resolveProperListeningTimeValues(matchedTagsArray);
                return times;
            }
        }
        return null;
    };
    TimerComponent.prototype.captureAllTagMatches = function (matchedAttribute, tagsRegex) {
        var matchedTags = [];
        var match;
        while (match = tagsRegex.exec(matchedAttribute)) {
            matchedTags.push(match[1]);
            matchedTags.push(match[2]);
        }
        return matchedTags;
    };
    TimerComponent.prototype.getMatchedRegexValue = function (matchedTagsArray, name) {
        var index = matchedTagsArray.indexOf(name);
        if (index >= 0) {
            return parseInt(matchedTagsArray[index + 1]);
        }
        return null;
    };
    TimerComponent.prototype.resolveProperListeningTimeValues = function (matchedTagsArray) {
        var time = this.getMatchedRegexValue(matchedTagsArray, "time");
        var reviewTime = this.getMatchedRegexValue(matchedTagsArray, "reviewTime");
        return { time: time, reviewTime: reviewTime };
    };
    TimerComponent.prototype.stopTimer = function () {
        this.clearTimerInterval();
    };
    TimerComponent.prototype.getSpeakingTimings = function (interaction) {
        var preparationTime = interaction ? interaction.SpeakingInteraction.PreparationTime : null;
        var recordingTime = interaction ? interaction.SpeakingInteraction.RecordingTime : null;
        if (preparationTime && recordingTime) {
            if (this.assessmentTest) {
                var timeSpecification = this.assessmentTest.TimingSpecification;
                if (timeSpecification && Object.keys(timeSpecification).length > 0) {
                    var speakingTimeMultiplier = this.findSpeakingSpecification(timeSpecification);
                    if (speakingTimeMultiplier) {
                        if (interaction.SpeakingInteraction.ExtendPrepTime) {
                            preparationTime = preparationTime * speakingTimeMultiplier;
                        }
                        if (interaction.SpeakingInteraction.ExtendSpeakingTime) {
                            recordingTime = recordingTime * speakingTimeMultiplier;
                        }
                    }
                }
            }
        }
        return { preparationTime: preparationTime, recordingTime: recordingTime };
    };
    TimerComponent.prototype.findSpeakingSpecification = function (timeSpecification) {
        var timeSpecificationComponents = Object.keys(timeSpecification).map(function (value) { return parseInt(value); });
        var speakingTimeSpecification = timeSpecificationComponents.find(function (x) { return x == ComponentTypeEnum.Speaking; });
        if (speakingTimeSpecification) {
            var multiplier = parseFloat(timeSpecification[speakingTimeSpecification.toString()]);
            return multiplier;
        }
        return 1.0;
    };
    TimerComponent.prototype.getAdditionalTime = function (timeLimits, assessmentItem) {
        var multipliers = [];
        var originalMaxTime = timeLimits.MaxTime;
        if (this.assessmentTest) {
            var timeSpecification = this.assessmentTest.TimingSpecification;
            if (timeSpecification != null && Object.keys(timeSpecification).length > 0) {
                var timeSpecificationComponents = Object.keys(timeSpecification).map(function (value) { return parseInt(value); });
                var interactionDefs = this.testContentService.getReferencedInteractions(assessmentItem);
                var interactionDefComponents_1 = interactionDefs.map(function (value) { return value.ComponentTypeId; });
                var intersectingComponents = timeSpecificationComponents.filter(function (value) {
                    return interactionDefComponents_1.indexOf(value) !== -1;
                });
                var originalMaxTime_1 = timeLimits.MaxTime;
                for (var i = 0; i < intersectingComponents.length; i++) {
                    var multiplier = parseFloat(timeSpecification[intersectingComponents[i].toString()]);
                    multipliers.push(multiplier);
                }
            }
        }
        return { originalMaxTime: originalMaxTime, multipliers: multipliers };
    };
    TimerComponent.prototype.applyAdditionalTime = function (timeLimits, multipliers, originalMaxTime, listeningTimes) {
        if (multipliers) {
            for (var i = 0; i < multipliers.length; i++) {
                if (listeningTimes) {
                    var prepPlusPostTime = listeningTimes.time + listeningTimes.reviewTime;
                    var listeningIncrement = prepPlusPostTime * (multipliers[i] - 1.0);
                    timeLimits.MaxTime = originalMaxTime + listeningIncrement;
                }
                else {
                    timeLimits.MaxTime = originalMaxTime * multipliers[i];
                }
            }
        }
    };
    return TimerComponent;
}());
timer_component___decorate([
    Object(core_es5["F" /* Input */])(),
    timer_component___metadata("design:type", typeof (timer_component__a = typeof Rx["Observable"] !== "undefined" && Rx["Observable"]) === "function" && timer_component__a || Object)
], timer_component_TimerComponent.prototype, "assessmentItem$", void 0);
timer_component___decorate([
    Object(core_es5["F" /* Input */])(),
    timer_component___metadata("design:type", Object)
], timer_component_TimerComponent.prototype, "assessmentTest", void 0);
timer_component_TimerComponent = timer_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'timer',
        template: __webpack_require__("2coj")
    }),
    timer_component___metadata("design:paramtypes", [typeof (timer_component__b = typeof timer_service_TimerService !== "undefined" && timer_service_TimerService) === "function" && timer_component__b || Object, typeof (timer_component__c = typeof test_content_service_TestContentService !== "undefined" && test_content_service_TestContentService) === "function" && timer_component__c || Object, typeof (timer_component__d = typeof test_navigation_service_TestNavigationService !== "undefined" && test_navigation_service_TestNavigationService) === "function" && timer_component__d || Object, typeof (timer_component__e = typeof test_taker_service_TestTakerService !== "undefined" && test_taker_service_TestTakerService) === "function" && timer_component__e || Object, typeof (timer_component__f = typeof my_modal_component_MyModal !== "undefined" && my_modal_component_MyModal) === "function" && timer_component__f || Object, typeof (timer_component__g = typeof core_es5["l" /* ChangeDetectorRef */] !== "undefined" && core_es5["l" /* ChangeDetectorRef */]) === "function" && timer_component__g || Object])
], timer_component_TimerComponent);

var timer_component__a, timer_component__b, timer_component__c, timer_component__d, timer_component__e, timer_component__f, timer_component__g;
//# sourceMappingURL=timer.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/top-nav/top-nav.component.ts
var top_nav_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var top_nav_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};













var top_nav_component_TopNavComponent = (function () {
    function TopNavComponent(myModal, testContentService, responseService, previewService, testNavigationService, route, elementRef, store) {
        this.myModal = myModal;
        this.testContentService = testContentService;
        this.responseService = responseService;
        this.previewService = previewService;
        this.testNavigationService = testNavigationService;
        this.route = route;
        this.elementRef = elementRef;
        this.store = store;
        this.mode = _paragonConfig.mode;
    }
    TopNavComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.testletSubscription = this.testlet$.subscribe(function (testlet) {
            _this.testlet = testlet;
            _this.updateTitle();
        });
        this.testNavigationSubscription = this.store.select(reducers_getTestNavigation).subscribe(function (testNavigation) {
            _this.updateTitle(testNavigation);
        });
    };
    TopNavComponent.prototype.updateTitle = function (subscribedTestNavigation) {
        try {
            if (this.testlet && this.testNavigation && this.assessmentTest) {
                var title = null;
                if (subscribedTestNavigation != null) {
                    title = this.assessmentTest.TestParts[subscribedTestNavigation.testPartIndex].AssessmentSectionRefs[subscribedTestNavigation.testletIndex].PageHeader;
                }
                else {
                    title = this.assessmentTest.TestParts[this.testNavigation.testPartIndex].AssessmentSectionRefs[this.testNavigation.testletIndex].PageHeader;
                }
                this.title = title != null ? title : this.mode;
            }
            else {
                this.title = "";
            }
        }
        catch (error) { }
    };
    TopNavComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        var backButton = document.getElementById("btn-back");
        if (backButton) {
            this.backButtonClickSubscription = Rx["Observable"].fromEvent(backButton, "click")
                .take(1)
                .do(function (x) {
                _this.onClickBack();
            })
                .delay(600)
                .repeat()
                .subscribe();
        }
    };
    TopNavComponent.prototype.ngOnDestroy = function () {
        if (this.testletSubscription) {
            this.testletSubscription.unsubscribe();
        }
    };
    TopNavComponent.prototype.onClickNext = function () {
        if (config_helper_ConfigHelper.isIppMode() || config_helper_ConfigHelper.isPreviewMode() || this.testNavigation.canGoNext == true) {
            this.testNavigationService.goNext(true);
        }
    };
    TopNavComponent.prototype.onClickBack = function () {
        var testNavigation = Object.assign({}, this.testNavigation);
        if (testNavigation.testletIndex > 0) {
            testNavigation.testletIndex--;
        }
        else if (testNavigation.testPartIndex > 0) {
            testNavigation.testPartIndex--;
            var testlets = this.testNavigationService.getTestletsByTestPart(this.assessmentTest.TestParts[testNavigation.testPartIndex], testNavigation.testPartIndex);
            testNavigation.testletIndex = testlets.length - 1;
        }
        this.store.dispatch(new test_taker_action_namespaceObject.SetTestNavigation(testNavigation));
    };
    TopNavComponent.prototype.checkResponses = function () {
        var _this = this;
        var interactions = this.testContentService.getReferencedInteractions(this.activeAssessmentItem);
        var responses = this.responseService.responses.filter(function (x) { return interactions.findIndex(function (i) { return i.InteractionId == x.InteractionId; }) >= 0; });
        interactions.forEach(function (interaction) {
            var response = responses.find(function (r) { return r.InteractionId == interaction.InteractionId; });
            if (!response) {
                responses.push({ InteractionId: interaction.InteractionId, Items: [] });
            }
        });
        this.testContentService.getPreviewResponseScores(responses, this.route.snapshot.params["snapshot-id"]).subscribe(function (responseScores) {
            _this.myModal.showRegularDlg("Responses", _this.previewService.getPreviewResponsesHtml(interactions, _this.responseService, responseScores));
        });
    };
    return TopNavComponent;
}());
top_nav_component___decorate([
    Object(core_es5["F" /* Input */])(),
    top_nav_component___metadata("design:type", typeof (top_nav_component__a = typeof Rx["Observable"] !== "undefined" && Rx["Observable"]) === "function" && top_nav_component__a || Object)
], top_nav_component_TopNavComponent.prototype, "testlet$", void 0);
top_nav_component___decorate([
    Object(core_es5["F" /* Input */])(),
    top_nav_component___metadata("design:type", typeof (top_nav_component__b = typeof Rx["Observable"] !== "undefined" && Rx["Observable"]) === "function" && top_nav_component__b || Object)
], top_nav_component_TopNavComponent.prototype, "assessmentItem$", void 0);
top_nav_component___decorate([
    Object(core_es5["F" /* Input */])(),
    top_nav_component___metadata("design:type", Object)
], top_nav_component_TopNavComponent.prototype, "assessmentTest", void 0);
top_nav_component___decorate([
    Object(core_es5["F" /* Input */])(),
    top_nav_component___metadata("design:type", Object)
], top_nav_component_TopNavComponent.prototype, "activeAssessmentItem", void 0);
top_nav_component___decorate([
    Object(core_es5["F" /* Input */])(),
    top_nav_component___metadata("design:type", Object)
], top_nav_component_TopNavComponent.prototype, "testNavigation", void 0);
top_nav_component___decorate([
    Object(core_es5["_17" /* ViewChild */])(timer_component_TimerComponent),
    top_nav_component___metadata("design:type", typeof (top_nav_component__c = typeof timer_component_TimerComponent !== "undefined" && timer_component_TimerComponent) === "function" && top_nav_component__c || Object)
], top_nav_component_TopNavComponent.prototype, "timer", void 0);
top_nav_component_TopNavComponent = top_nav_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'top-nav',
        template: __webpack_require__("ZlpU")
    }),
    top_nav_component___metadata("design:paramtypes", [typeof (top_nav_component__d = typeof my_modal_component_MyModal !== "undefined" && my_modal_component_MyModal) === "function" && top_nav_component__d || Object, typeof (top_nav_component__e = typeof test_content_service_TestContentService !== "undefined" && test_content_service_TestContentService) === "function" && top_nav_component__e || Object, typeof (top_nav_component__f = typeof response_service_ResponseService !== "undefined" && response_service_ResponseService) === "function" && top_nav_component__f || Object, typeof (top_nav_component__g = typeof preview_service_PreviewService !== "undefined" && preview_service_PreviewService) === "function" && top_nav_component__g || Object, typeof (top_nav_component__h = typeof test_navigation_service_TestNavigationService !== "undefined" && test_navigation_service_TestNavigationService) === "function" && top_nav_component__h || Object, typeof (top_nav_component__j = typeof router_es5["a" /* ActivatedRoute */] !== "undefined" && router_es5["a" /* ActivatedRoute */]) === "function" && top_nav_component__j || Object, typeof (top_nav_component__k = typeof core_es5["v" /* ElementRef */] !== "undefined" && core_es5["v" /* ElementRef */]) === "function" && top_nav_component__k || Object, typeof (top_nav_component__l = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && top_nav_component__l || Object])
], top_nav_component_TopNavComponent);

var top_nav_component__a, top_nav_component__b, top_nav_component__c, top_nav_component__d, top_nav_component__e, top_nav_component__f, top_nav_component__g, top_nav_component__h, top_nav_component__j, top_nav_component__k, top_nav_component__l;
//# sourceMappingURL=top-nav.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/top-nav/nav-button/nav-button.component.ts
var nav_button_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var nav_button_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var nav_button_component_NavButtonComponent = (function () {
    function NavButtonComponent(store) {
        this.store = store;
    }
    NavButtonComponent.prototype.showNavigationModal = function () {
        this.store.dispatch(new app_ui_action_namespaceObject.ToggleNavigationModal(true));
    };
    return NavButtonComponent;
}());
nav_button_component___decorate([
    Object(core_es5["F" /* Input */])(),
    nav_button_component___metadata("design:type", Object)
], nav_button_component_NavButtonComponent.prototype, "assessmentTest", void 0);
nav_button_component___decorate([
    Object(core_es5["F" /* Input */])(),
    nav_button_component___metadata("design:type", String)
], nav_button_component_NavButtonComponent.prototype, "mode", void 0);
nav_button_component_NavButtonComponent = nav_button_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'nav-button',
        template: __webpack_require__("iGoV")
    }),
    nav_button_component___metadata("design:paramtypes", [typeof (nav_button_component__a = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && nav_button_component__a || Object])
], nav_button_component_NavButtonComponent);

var nav_button_component__a;
//# sourceMappingURL=nav-button.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/item-body-panel.component.ts
var item_body_panel_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var item_body_panel_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var ItemBodyPanelComponent = (function () {
    function ItemBodyPanelComponent(componentFactoryResolver, elementRef, pgRendererHtmlService, viewContainerRef, dynamicComponentService) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.elementRef = elementRef;
        this.pgRendererHtmlService = pgRendererHtmlService;
        this.viewContainerRef = viewContainerRef;
        this.dynamicComponentService = dynamicComponentService;
    }
    ItemBodyPanelComponent.prototype.ngOnChanges = function () {
        var _this = this;
        this.infoBoxVisible = false;
        this.infoBoxText = null;
        var el = this.elementRef.nativeElement;
        if (this.componentRef) {
            var currentItemBodyPanel = this.componentRef.instance.itemBodyPanel;
            if (currentItemBodyPanel.CssClass.indexOf("leftpane") >= 0 && currentItemBodyPanel.Html == this.itemBodyPanel.Html) {
                return;
            }
            this.componentRef.destroy();
            //reset scroll pos
            el.parentElement.scrollTop = 0;
        }
        var bodyDiv = el.querySelector(".body");
        this.dynamicComponentService.getComponentRef(this.viewContainerRef, this.itemBodyPanel.Html)
            .then(function (componentRef) {
            _this.componentRef = componentRef;
            _this.componentRef.instance.interactions = _this.interactions;
            _this.componentRef.instance.itemBodyPanel = _this.itemBodyPanel;
        }).catch(function (reason) {
            console.log(reason);
        });
    };
    return ItemBodyPanelComponent;
}());
item_body_panel_component___decorate([
    Object(core_es5["F" /* Input */])(),
    item_body_panel_component___metadata("design:type", Object)
], ItemBodyPanelComponent.prototype, "itemBodyPanel", void 0);
item_body_panel_component___decorate([
    Object(core_es5["F" /* Input */])(),
    item_body_panel_component___metadata("design:type", Array)
], ItemBodyPanelComponent.prototype, "interactions", void 0);
ItemBodyPanelComponent = item_body_panel_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'item-body-panel',
        template: __webpack_require__("AL60")
    }),
    item_body_panel_component___metadata("design:paramtypes", [typeof (item_body_panel_component__a = typeof core_es5["q" /* ComponentFactoryResolver */] !== "undefined" && core_es5["q" /* ComponentFactoryResolver */]) === "function" && item_body_panel_component__a || Object, typeof (item_body_panel_component__b = typeof core_es5["v" /* ElementRef */] !== "undefined" && core_es5["v" /* ElementRef */]) === "function" && item_body_panel_component__b || Object, typeof (item_body_panel_component__c = typeof html_service_HtmlService !== "undefined" && html_service_HtmlService) === "function" && item_body_panel_component__c || Object, typeof (item_body_panel_component__d = typeof core_es5["_19" /* ViewContainerRef */] !== "undefined" && core_es5["_19" /* ViewContainerRef */]) === "function" && item_body_panel_component__d || Object, typeof (item_body_panel_component__e = typeof dynamic_component_service_DynamicComponentService !== "undefined" && dynamic_component_service_DynamicComponentService) === "function" && item_body_panel_component__e || Object])
], ItemBodyPanelComponent);

var item_body_panel_component__a, item_body_panel_component__b, item_body_panel_component__c, item_body_panel_component__d, item_body_panel_component__e;
//# sourceMappingURL=item-body-panel.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/navigation-modal/navigation-modal.component.ts
var navigation_modal_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var navigation_modal_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var navigation_modal_component_NavigationModalComponent = (function () {
    function NavigationModalComponent(store, testNavigationService, changeDetectorRef) {
        var _this = this;
        this.store = store;
        this.testNavigationService = testNavigationService;
        this.changeDetectorRef = changeDetectorRef;
        this.testlets = [];
        this.isNavigationModalVisibleSubscription = store.select(reducers_getIsNavigationModalVisible).subscribe(function (isNavigationModalVisible) {
            _this.isNavigationModalVisible = isNavigationModalVisible;
            if (_this.testlets.length > 0 && _this.isNavigationModalVisible) {
                _this.changeDetectorRef.detectChanges();
            }
        });
        this.assessmentTestSubscription = store.select(reducers_getAssessmentTest).subscribe(function (assessmentTest) {
            if (assessmentTest) {
                _this.testlets = _this.testNavigationService.getTestlets(assessmentTest);
            }
        });
        this.testNavigationSubscription = store.select(reducers_getTestNavigation).subscribe(function (testNavigation) {
            if (testNavigation && _this.testlets) {
                _this.testlets.forEach(function (testlet, idx) {
                    testlet.isSelected = testlet.testNavigation.testPartIndex === testNavigation.testPartIndex && testlet.testNavigation.testletIndex === testNavigation.testletIndex;
                });
            }
        });
    }
    NavigationModalComponent.prototype.ngOnDestroy = function () {
        if (this.isNavigationModalVisibleSubscription) {
            this.isNavigationModalVisibleSubscription.unsubscribe();
        }
        if (this.assessmentTestSubscription) {
            this.assessmentTestSubscription.unsubscribe();
        }
        if (this.testNavigationSubscription) {
            this.testNavigationSubscription.unsubscribe();
        }
    };
    NavigationModalComponent.prototype.setTestNavigation = function (testNavigation) {
        this.store.dispatch(new app_ui_action_namespaceObject.ToggleNavigationModal(false));
        this.store.dispatch(new test_taker_action_namespaceObject.SetTestNavigation(testNavigation));
    };
    NavigationModalComponent.prototype.closeNavigationModal = function () {
        this.store.dispatch(new app_ui_action_namespaceObject.ToggleNavigationModal(false));
    };
    return NavigationModalComponent;
}());
navigation_modal_component_NavigationModalComponent = navigation_modal_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'navigation-modal',
        template: __webpack_require__("j2yi"),
        changeDetection: core_es5["k" /* ChangeDetectionStrategy */].Default
    }),
    navigation_modal_component___metadata("design:paramtypes", [typeof (navigation_modal_component__a = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && navigation_modal_component__a || Object, typeof (navigation_modal_component__b = typeof test_navigation_service_TestNavigationService !== "undefined" && test_navigation_service_TestNavigationService) === "function" && navigation_modal_component__b || Object, typeof (navigation_modal_component__c = typeof core_es5["l" /* ChangeDetectorRef */] !== "undefined" && core_es5["l" /* ChangeDetectorRef */]) === "function" && navigation_modal_component__c || Object])
], navigation_modal_component_NavigationModalComponent);

var navigation_modal_component__a, navigation_modal_component__b, navigation_modal_component__c;
//# sourceMappingURL=navigation-modal.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/directives/prevent-double-click.directive.ts
var prevent_double_click_directive___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var prevent_double_click_directive___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var prevent_double_click_directive_PreventDoubleClickDirective = (function () {
    function PreventDoubleClickDirective() {
        this.throttleTime = 500;
        this.throttledClick = new core_es5["x" /* EventEmitter */]();
        this.clicks = new Rx["Subject"]();
    }
    PreventDoubleClickDirective.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.clicks
            .throttleTime(this.throttleTime)
            .subscribe(function (e) { return _this.emitThrottledClick(e); });
    };
    PreventDoubleClickDirective.prototype.emitThrottledClick = function (e) {
        this.throttledClick.emit(e);
    };
    PreventDoubleClickDirective.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    PreventDoubleClickDirective.prototype.clickEvent = function (event) {
        event.preventDefault();
        event.stopPropagation();
        this.clicks.next(event);
    };
    return PreventDoubleClickDirective;
}());
prevent_double_click_directive___decorate([
    Object(core_es5["F" /* Input */])(),
    prevent_double_click_directive___metadata("design:type", Object)
], prevent_double_click_directive_PreventDoubleClickDirective.prototype, "throttleTime", void 0);
prevent_double_click_directive___decorate([
    Object(core_es5["U" /* Output */])(),
    prevent_double_click_directive___metadata("design:type", Object)
], prevent_double_click_directive_PreventDoubleClickDirective.prototype, "throttledClick", void 0);
prevent_double_click_directive___decorate([
    Object(core_es5["A" /* HostListener */])('click', ['$event']),
    prevent_double_click_directive___metadata("design:type", Function),
    prevent_double_click_directive___metadata("design:paramtypes", [Object]),
    prevent_double_click_directive___metadata("design:returntype", void 0)
], prevent_double_click_directive_PreventDoubleClickDirective.prototype, "clickEvent", null);
prevent_double_click_directive_PreventDoubleClickDirective = prevent_double_click_directive___decorate([
    Object(core_es5["u" /* Directive */])({
        selector: '[preventDoubleClick]'
    }),
    prevent_double_click_directive___metadata("design:paramtypes", [])
], prevent_double_click_directive_PreventDoubleClickDirective);

//# sourceMappingURL=prevent-double-click.directive.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/pg-renderer.module.ts
var pg_renderer_module___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
















var PgRendererModule = (function () {
    function PgRendererModule() {
    }
    return PgRendererModule;
}());
PgRendererModule = pg_renderer_module___decorate([
    Object(core_es5["M" /* NgModule */])({
        imports: [
            forms_es5["b" /* FormsModule */],
            forms_es5["c" /* ReactiveFormsModule */],
            platform_browser_es5["a" /* BrowserModule */],
            SharedModule
        ],
        declarations: [
            prevent_double_click_directive_PreventDoubleClickDirective,
            pg_renderer_component_PgRendererComponent,
            ItemBodyComponent,
            page_nav_component_PageNavComponent,
            top_nav_component_TopNavComponent,
            nav_button_component_NavButtonComponent,
            timer_component_TimerComponent,
            ItemBodyPanelComponent,
            navigation_modal_component_NavigationModalComponent,
            test_form_validation_component_TestFormValidationComponent
        ],
        providers: [
            LoggerService,
            test_navigation_service_TestNavigationService
        ]
    })
], PgRendererModule);

//# sourceMappingURL=pg-renderer.module.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/tdp/lock-screen/lock-screen.component.ts
var lock_screen_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var lock_screen_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var lock_screen_component_LockScreenComponent = (function () {
    function LockScreenComponent(store, testTakerService, changeDetectorRef) {
        this.store = store;
        this.testTakerService = testTakerService;
        this.changeDetectorRef = changeDetectorRef;
        this.isLockScreenVisible = false;
    }
    LockScreenComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isLockScreenVisibleSubscription = this.store.select(reducers_getIsLockScreenVisible).subscribe(function (isLockScreenVisible) {
            _this.isLockScreenVisible = isLockScreenVisible;
            _this.changeDetectorRef.markForCheck();
        });
        this.testTakerInfoSubscription = this.store.select(reducers_getTestTakerInfo).subscribe(function (testTakerInfo) {
            if (testTakerInfo) {
                _this.testTakerPhotoUrl = _this.testTakerService.getTestTakerPhotoUrl(testTakerInfo.BrandName, testTakerInfo.TestSessionSiteCode, testTakerInfo.TestTakerId);
                _this.changeDetectorRef.markForCheck();
            }
        });
    };
    LockScreenComponent.prototype.ngOnDestroy = function () {
        this.isLockScreenVisibleSubscription.unsubscribe();
        this.testTakerInfoSubscription.unsubscribe();
    };
    LockScreenComponent.prototype.checkExitCode = function (exitCode) {
        this.errorMsg = "";
        if (this.testTakerService.testTakerInfo.CtcCode == exitCode) {
            this.store.dispatch(new app_ui_action_namespaceObject.HideLockScreen());
            this.testTakerService.saveTestTakerActivityWithoutCaching(TestTakerActivityTypeEnum.ScreenLockEnd);
        }
        else {
            this.errorMsg = LockScreen_ExitCode;
        }
    };
    return LockScreenComponent;
}());
lock_screen_component_LockScreenComponent = lock_screen_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'lock-screen',
        template: __webpack_require__("H/ZB"),
        changeDetection: core_es5["k" /* ChangeDetectionStrategy */].OnPush
    }),
    lock_screen_component___metadata("design:paramtypes", [typeof (lock_screen_component__a = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && lock_screen_component__a || Object, typeof (lock_screen_component__b = typeof test_taker_service_TestTakerService !== "undefined" && test_taker_service_TestTakerService) === "function" && lock_screen_component__b || Object, typeof (lock_screen_component__c = typeof core_es5["l" /* ChangeDetectorRef */] !== "undefined" && core_es5["l" /* ChangeDetectorRef */]) === "function" && lock_screen_component__c || Object])
], lock_screen_component_LockScreenComponent);

var lock_screen_component__a, lock_screen_component__b, lock_screen_component__c;
//# sourceMappingURL=lock-screen.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/tdp/exit-screen/exit-screen.component.ts
var exit_screen_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var exit_screen_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var exit_screen_component_ExitScreenComponent = (function () {
    function ExitScreenComponent(store, testTakerService, timerService, changeDetectorRef) {
        this.store = store;
        this.testTakerService = testTakerService;
        this.timerService = timerService;
        this.changeDetectorRef = changeDetectorRef;
        this.isExitScreenVisible = false;
        this.exitCode = "";
        this.selectedReason = -1;
        this.btnConfirmDisabled = false;
        this.exitReasons = [];
        this.hasTestTakerInfo = false;
        this.validationErrors = {
            exitCode: false,
            reason: false,
            description: false
        };
        this.confirmedExitEventName = "tdp:confirmed-exit";
    }
    ExitScreenComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isVisibleSubscription = this.store.select(reducers_getIsExitScreenVisible).subscribe(function (isVisible) {
            _this.isExitScreenVisible = isVisible;
            if (_this.testTakerService.testTakerInfo) {
                _this.hasTestTakerInfo = true;
            }
            _this.changeDetectorRef.markForCheck();
            if (_this.isExitScreenVisible) {
                _this.timerService.pauseTimer();
            }
            else {
                _this.changeDetectorRef.detectChanges();
            }
        });
        this.exitReasons = [
            { name: "Program Failure", value: TestTakerActivityTypeEnum.ApplicationShutdownProgramFailure },
            { name: "Hardware Issue", value: TestTakerActivityTypeEnum.ApplicationShutdownHardwareIssue },
            { name: "End of Test", value: TestTakerActivityTypeEnum.ApplicationShutdownEndOfTest },
            { name: "Other", value: TestTakerActivityTypeEnum.ApplicationShutdownOther }
        ];
    };
    ExitScreenComponent.prototype.ngOnDestroy = function () {
        this.isVisibleSubscription.unsubscribe();
    };
    ExitScreenComponent.prototype.confirmExit = function () {
        var _this = this;
        if (this.hasTestTakerInfo) {
            this.errorMsg = this.validateForm();
            if (this.errorMsg.length == 0) {
                this.btnConfirmDisabled = true;
                this.testTakerService.saveTestTakerActivityWithoutCaching(this.selectedReason, null, this.description);
                setTimeout(function () {
                    _this.sendConfirmedExitEventToSecureBrowser();
                }, 2000);
            }
            this.changeDetectorRef.detectChanges();
        }
        else {
            this.sendConfirmedExitEventToSecureBrowser();
        }
    };
    ExitScreenComponent.prototype.sendConfirmedExitEventToSecureBrowser = function () {
        if (this.testTakerService.testNavigation.isEndOfTest != true) {
            this.testTakerService.uploadTestTakerLog();
        }
        var event = new MessageEvent(this.confirmedExitEventName, {
            bubbles: true,
            cancelable: false,
            data: ""
        });
        document.dispatchEvent(event);
    };
    ExitScreenComponent.prototype.cancelExit = function () {
        this.timerService.unpauseTimer();
        this.store.dispatch(new app_ui_action_namespaceObject.HideExitScreen());
        this.changeDetectorRef.markForCheck();
    };
    ExitScreenComponent.prototype.validateForm = function () {
        this.validationErrors = {
            exitCode: false,
            reason: false,
            description: false
        };
        var errorMsg = "";
        if (this.hasTestTakerInfo) {
            if (this.testTakerService.testTakerInfo.CtcCode != this.exitCode) {
                errorMsg = Exit_ExitCode;
                this.validationErrors.exitCode = true;
            }
            else {
                switch (this.selectedReason.toString()) {
                    case TestTakerActivityTypeEnum.ApplicationShutdownProgramFailure.toString():
                    case TestTakerActivityTypeEnum.ApplicationShutdownHardwareIssue.toString():
                    case TestTakerActivityTypeEnum.ApplicationShutdownOther.toString():
                        if (!this.description || this.description.length < 1) {
                            errorMsg = Exit_ExitDescription;
                            this.validationErrors.description = true;
                        }
                        break;
                    case TestTakerActivityTypeEnum.ApplicationShutdownEndOfTest.toString():
                        break;
                    default:
                        errorMsg = Exit_ExitReason;
                        this.validationErrors.reason = true;
                        break;
                }
            }
        }
        return errorMsg;
    };
    ExitScreenComponent.prototype.onFormUpdate = function () {
        this.errorMsg = "";
        this.validateForm();
        this.changeDetectorRef.detectChanges();
    };
    return ExitScreenComponent;
}());
exit_screen_component_ExitScreenComponent = exit_screen_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'exit-screen',
        template: __webpack_require__("GBf1"),
        changeDetection: core_es5["k" /* ChangeDetectionStrategy */].OnPush
    }),
    exit_screen_component___metadata("design:paramtypes", [typeof (exit_screen_component__a = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && exit_screen_component__a || Object, typeof (exit_screen_component__b = typeof test_taker_service_TestTakerService !== "undefined" && test_taker_service_TestTakerService) === "function" && exit_screen_component__b || Object, typeof (exit_screen_component__c = typeof timer_service_TimerService !== "undefined" && timer_service_TimerService) === "function" && exit_screen_component__c || Object, typeof (exit_screen_component__d = typeof core_es5["l" /* ChangeDetectorRef */] !== "undefined" && core_es5["l" /* ChangeDetectorRef */]) === "function" && exit_screen_component__d || Object])
], exit_screen_component_ExitScreenComponent);

var exit_screen_component__a, exit_screen_component__b, exit_screen_component__c, exit_screen_component__d;
//# sourceMappingURL=exit-screen.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/tdp/audio-check/audio-check.component.ts
var audio_check_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var audio_check_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var audio_check_component_AudioCheckComponent = (function () {
    function AudioCheckComponent(changeDetectorRef, elementRef, myModal, loggerService) {
        var _this = this;
        this.changeDetectorRef = changeDetectorRef;
        this.elementRef = elementRef;
        this.myModal = myModal;
        this.loggerService = loggerService;
        this.audioCheckCompleted = new core_es5["x" /* EventEmitter */]();
        this.step = 1;
        this.playAudio = function () {
            _this.step = 2;
            _this.audioCheckAudioClip.play();
            _this.currentProgress = 0;
            _this.infoBoxVisible = true;
            _this.infoBoxText = "Playing...";
            _this.infoBoxMode = "ProgressBar";
            _this.iconCssClass = 'play-icon';
            _this.changeDetectorRef.markForCheck();
            var playbackTimeInSeconds = 16;
            _this.playbackSubscription = Rx["Observable"].interval(1000)
                .take(playbackTimeInSeconds + 1)
                .subscribe(function (x) {
                var timeElapsed = x + 1;
                _this.currentProgress = _this.setProgress(timeElapsed, playbackTimeInSeconds);
                _this.changeDetectorRef.detectChanges();
            }, null, function () {
                _this.step = 3;
                _this.infoBoxVisible = false;
                _this.changeDetectorRef.detectChanges();
            });
        };
        this.isWebDelivery = config_helper_ConfigHelper.isTdpMode(true);
    }
    AudioCheckComponent.prototype.ngOnDestroy = function () {
        if (this.playbackSubscription) {
            this.playbackSubscription.unsubscribe();
        }
    };
    AudioCheckComponent.prototype.ngAfterViewInit = function () {
        this.audioCheckAudioClip = this.createAudioElement("audio_check.mp3");
    };
    AudioCheckComponent.prototype.createAudioElement = function (src) {
        var elem = this.elementRef.nativeElement;
        var audioElem = document.createElement("audio");
        audioElem.autoplay = false;
        audioElem.controls = false;
        audioElem.autoplay = false;
        audioElem.src = config_helper_ConfigHelper.getAudioAssetUrl() + "/" + src;
        elem.appendChild(audioElem);
        return audioElem;
    };
    AudioCheckComponent.prototype.setProgress = function (current, totalTime) {
        return (current / totalTime) * 100;
    };
    AudioCheckComponent.prototype.badRecording = function () {
        this.step = 4;
    };
    AudioCheckComponent.prototype.goodRecording = function () {
        this.audioCheckCompleted.emit("done");
    };
    return AudioCheckComponent;
}());
audio_check_component___decorate([
    Object(core_es5["U" /* Output */])(),
    audio_check_component___metadata("design:type", typeof (audio_check_component__a = typeof core_es5["x" /* EventEmitter */] !== "undefined" && core_es5["x" /* EventEmitter */]) === "function" && audio_check_component__a || Object)
], audio_check_component_AudioCheckComponent.prototype, "audioCheckCompleted", void 0);
audio_check_component_AudioCheckComponent = audio_check_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'audio-check',
        template: __webpack_require__("ylRF")
    }),
    audio_check_component___metadata("design:paramtypes", [typeof (audio_check_component__b = typeof core_es5["l" /* ChangeDetectorRef */] !== "undefined" && core_es5["l" /* ChangeDetectorRef */]) === "function" && audio_check_component__b || Object, typeof (audio_check_component__c = typeof core_es5["v" /* ElementRef */] !== "undefined" && core_es5["v" /* ElementRef */]) === "function" && audio_check_component__c || Object, typeof (audio_check_component__d = typeof my_modal_component_MyModal !== "undefined" && my_modal_component_MyModal) === "function" && audio_check_component__d || Object, typeof (audio_check_component__e = typeof LoggerService !== "undefined" && LoggerService) === "function" && audio_check_component__e || Object])
], audio_check_component_AudioCheckComponent);

var audio_check_component__a, audio_check_component__b, audio_check_component__c, audio_check_component__d, audio_check_component__e;
//# sourceMappingURL=audio-check.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/tdp/pause-screen/pause-screen.component.ts
var pause_screen_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var pause_screen_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var pause_screen_component_PauseScreenComponent = (function () {
    function PauseScreenComponent(store, testTakerService, timerService, changeDetectorRef) {
        this.store = store;
        this.testTakerService = testTakerService;
        this.timerService = timerService;
        this.changeDetectorRef = changeDetectorRef;
    }
    PauseScreenComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.isVisibleSubscription = this.store.select(reducers_getIsPauseScreenVisible).subscribe(function (isVisible) {
            if (isVisible) {
                var testTakerInfo = _this.testTakerService.testTakerInfo;
                _this.testTakerPhotoUrl = _this.testTakerService.getTestTakerPhotoUrl(testTakerInfo.BrandName, testTakerInfo.TestSessionSiteCode, testTakerInfo.TestTakerId);
                if (!_this.timerService.isPaused()) {
                    _this.timerService.pauseTimer();
                }
            }
            _this.changeDetectorRef.detectChanges();
        });
    };
    PauseScreenComponent.prototype.ngOnDestroy = function () {
        this.isVisibleSubscription.unsubscribe();
    };
    return PauseScreenComponent;
}());
pause_screen_component_PauseScreenComponent = pause_screen_component___decorate([
    Object(core_es5["o" /* Component */])({
        selector: 'pause-screen',
        template: __webpack_require__("j+V+"),
        changeDetection: core_es5["k" /* ChangeDetectionStrategy */].OnPush
    }),
    pause_screen_component___metadata("design:paramtypes", [typeof (pause_screen_component__a = typeof store_es5["h" /* Store */] !== "undefined" && store_es5["h" /* Store */]) === "function" && pause_screen_component__a || Object, typeof (pause_screen_component__b = typeof test_taker_service_TestTakerService !== "undefined" && test_taker_service_TestTakerService) === "function" && pause_screen_component__b || Object, typeof (pause_screen_component__c = typeof timer_service_TimerService !== "undefined" && timer_service_TimerService) === "function" && pause_screen_component__c || Object, typeof (pause_screen_component__d = typeof core_es5["l" /* ChangeDetectorRef */] !== "undefined" && core_es5["l" /* ChangeDetectorRef */]) === "function" && pause_screen_component__d || Object])
], pause_screen_component_PauseScreenComponent);

var pause_screen_component__a, pause_screen_component__b, pause_screen_component__c, pause_screen_component__d;
//# sourceMappingURL=pause-screen.component.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/tdp/tdp.module.ts
var tdp_module___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};















var TdpModule = (function () {
    function TdpModule() {
    }
    return TdpModule;
}());
TdpModule = tdp_module___decorate([
    Object(core_es5["M" /* NgModule */])({
        imports: [
            platform_browser_es5["a" /* BrowserModule */],
            SharedModule,
            forms_es5["b" /* FormsModule */],
            forms_es5["c" /* ReactiveFormsModule */]
        ],
        declarations: [
            lock_screen_component_LockScreenComponent,
            exit_screen_component_ExitScreenComponent,
            audio_check_component_AudioCheckComponent,
            pause_screen_component_PauseScreenComponent,
            start_screen_pending_component_StartScreenPendingComponent,
            start_screen_pin_component_StartScreenPinComponent,
            start_screen_audio_check_component_StartScreenAudioCheckComponent,
            start_screen_microphone_check_component_StartScreenMicrophoneCheckComponent,
            start_screen_start_code_component_StartScreenStartCodeComponent,
            start_screen_web_component_StartScreenWebComponent
        ],
        exports: [
            lock_screen_component_LockScreenComponent,
            exit_screen_component_ExitScreenComponent,
            pause_screen_component_PauseScreenComponent
        ],
        providers: [
            LoggerService
        ]
    })
], TdpModule);

//# sourceMappingURL=tdp.module.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/app.module.ts
var app_module___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};













// import {
//   TestContentService, TestTakerService, PreviewService, ResponseService, HtmlService, TimerService, LoggerService,
//   AuthService, RepeatableRandomGeneratorService, AnswerKeyService, ScoringPageService
// } from './services';





















var AppModule = (function () {
    function AppModule() {
    }
    return AppModule;
}());
AppModule = app_module___decorate([
    Object(core_es5["M" /* NgModule */])({
        imports: [
            store_es5["i" /* StoreModule */].forRoot(reducers, { metaReducers: metaReducers }),
            effects_es5["c" /* EffectsModule */].forRoot([AppUiEffects, test_taker_effect_TestTakerEffects]),
            store_devtools_es5["a" /* StoreDevtoolsModule */].instrument({
                maxAge: 50
            }),
            platform_browser_es5["a" /* BrowserModule */],
            common_http_es5["b" /* HttpClientModule */],
            forms_es5["b" /* FormsModule */],
            forms_es5["c" /* ReactiveFormsModule */],
            http_es5["c" /* HttpModule */],
            SharedModule,
            PgRendererModule,
            TdpModule,
            appRouting,
            ng2_signalr["e" /* SignalRModule */].forRoot(createConfig)
        ],
        declarations: [
            app_component_AppComponent,
            BlankComponent
        ],
        providers: [
            FullscreenService,
            test_content_service_TestContentService,
            test_taker_service_TestTakerService,
            preview_service_PreviewService,
            keyboard_activity_service_KeyboardActivityService,
            response_service_ResponseService,
            html_service_HtmlService,
            timer_service_TimerService,
            LoggerService,
            auth_service_AuthService,
            my_modal_component_MyModal,
            repeatable_random_generator_service_RepeatableRandomGeneratorService,
            answerkey_service_AnswerKeyService,
            dynamic_component_service_DynamicComponentService,
            ScoringPageService,
            signalR_service_SignalRService
        ],
        bootstrap: [app_component_AppComponent],
    })
], AppModule);

function createConfig() {
    var signalRConfig = new ng2_signalr["d" /* SignalRConfiguration */]();
    signalRConfig.hubName = 'TestTakerHub';
    signalRConfig.url = _paragonConfig.testServerApiUrl;
    signalRConfig.logging = true;
    signalRConfig.transport = [ng2_signalr["b" /* ConnectionTransports */].webSockets];
    return signalRConfig;
}
//# sourceMappingURL=app.module.js.map
// CONCATENATED MODULE: C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/main.ts





if (environment.production) {
    Object(core_es5["_24" /* enableProdMode */])();
}
Object(platform_browser_dynamic_es5["a" /* platformBrowserDynamic */])().bootstrapModule(AppModule);
//# sourceMappingURL=main.js.map

/***/ }),

/***/ "cGR7":
/***/ (function(module, exports) {

module.exports = "<button class=\"btn btn-default\" (click)=\"showDialog()\">{{title}}</button>"

/***/ }),

/***/ "cb1k":
/***/ (function(module, exports) {

module.exports = "<div class=\"my-modal fade in\" *ngIf=\"visible === true\">\r\n    <div class=\"modal-dialog\" role=\"document\">\r\n        <div class=\"modal-content\">\r\n            <div class=\"modal-header\">\r\n                Test Form Validation\r\n            </div>\r\n            <div class=\"modal-body\">\r\n                <div *ngIf=\"!validating\">\r\n                    <p>Enter your email address below if you want a copy of the validation result.</p>\r\n                    <p><input type=\"email\" [(ngModel)]=\"email\" /></p>\r\n                    <br />\r\n                    <p>Click start to begin the validation process, which could take up to a few minutes to complete.</p>\r\n                </div>\r\n                <div *ngIf=\"validating\">\r\n                    Validating... Do not click anything until the process is finished.\r\n                </div>\r\n            </div>\r\n            <div class=\"modal-footer\" [hidden]=\"validating\">\r\n                <button type=\"button\" class=\"btn btn-modal\" (click)=\"validate()\">Start</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),

/***/ "efyd":
/***/ (function(module, exports) {

module.exports = "<router-outlet></router-outlet>\r\n<loading-overlay \r\n    [loading]=\"loading$ | async\"\r\n    >\r\n</loading-overlay>\r\n<pause-screen *ngIf=\"isPauseScreenVisible$ | async\"></pause-screen>\r\n<lock-screen *ngIf=\"isLockScreenVisible$ | async\"></lock-screen>\r\n<exit-screen *ngIf=\"isExitScreenVisible$ | async\"></exit-screen>\r\n<generic-page></generic-page>"

/***/ }),

/***/ "fxQu":
/***/ (function(module, exports) {

module.exports = "<div class=\"associate-interaction associate-interaction-{{interaction.InteractionId}}\" *ngIf=\"associateInteraction && associateInteraction != null\">\r\n    <p [innerHtml]=\"associateInteraction.Prompt\"></p>\r\n    <div class=\"choice-container\" [attr.data-parent-id]=\"interaction.InteractionId\">\r\n        <span class=\"draggable\" *ngFor=\"let choice of availableChoices\" [id]=\"choice.Identifier\" [attr.data-parent-id]=\"interaction.InteractionId\" [innerHtml]=\"choice.Html\"></span>\r\n    </div>\r\n\r\n    <div class=\"associate-interaction-pair\" *ngFor=\"let placeholder of placeholderPair\">\r\n        <span class=\"pair placeholder\" [id]=\"placeholder.SubKey\" [attr.data-parent-id]=\"interaction.InteractionId\">\r\n            <span class=\"draggable\" *ngIf=\"placeholder.Placeholder1\" [id]=\"placeholder.Placeholder1.Identifier\" [attr.data-parent-id]=\"interaction.InteractionId\">{{placeholder.Placeholder1.Html}}</span>\r\n        </span>\r\n        <span class=\"pair\">&nbsp;</span>\r\n        <span class=\"pair placeholder\" [id]=\"placeholder.SubKey\" [attr.data-parent-id]=\"interaction.InteractionId\">\r\n            <span class=\"draggable\" *ngIf=\"placeholder.Placeholder2\" [id]=\"placeholder.Placeholder2.Identifier\" [attr.data-parent-id]=\"interaction.InteractionId\">{{placeholder.Placeholder2.Html}}</span>\r\n        </span>\r\n    </div>\r\n</div>"

/***/ }),

/***/ "gFIY":
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncatched exception popping up in devtools
	return Promise.resolve().then(function() {
		throw new Error("Cannot find module '" + req + "'.");
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "gFIY";

/***/ }),

/***/ "iGoV":
/***/ (function(module, exports) {

module.exports = "<div class=\"btn-group\" *ngIf=\"assessmentTest != null && (mode == 'preview' || mode == 'ipp')\">\r\n    <button type=\"button\" class=\"btn btn-default\" (click)=\"showNavigationModal()\">\r\n        Navigation\r\n    </button>\r\n</div>"

/***/ }),

/***/ "iioE":
/***/ (function(module, exports) {

module.exports = "<loading-overlay [loading]=\"!(preTestDescription && imageReady)\"></loading-overlay>\r\n<div id=\"landing-page\" [hidden]=\"!(preTestDescription && imageReady)\">\r\n    <section id=\"landing-page-banner-section\">\r\n        <div class=\"container\">\r\n            <div class=\"jumbotron\">\r\n                <img src=\"{{imageData}}\" (load)=\"onImageReady()\"/>\r\n                <h2><br>{{productName}}</h2>\r\n            </div>\r\n        </div>\r\n    </section>\r\n    <section id=\"landing-page-action-section\">\r\n        <hr>\r\n        <div align=\"center\">\r\n            <button class=\"btn btn-default\" (click)=\"chooseIppTest()\">Start</button>\r\n        </div>\r\n        <hr>\r\n    </section>\r\n    <section id=\"landing-page-instruction-section\">\r\n        <div [innerHTML]=preTestDescription></div>\r\n    </section>\r\n</div>\r\n\r\n<div class=\"my-modal\" [hidden]=\"!isModalVisible\">\r\n    <div class=\"modal-dialog\" role=\"document\">\r\n        <div class=\"modal-content\">\r\n            <div class=\"modal-header\">\r\n                <h4 class=\"modal-title\">Please pick an option</h4>\r\n            </div>\r\n            <div class=\"modal-body\">\r\n                <div class=\"list-group\">\r\n                    <button type=\"button\" class=\"list-group-item\" *ngFor=\"let t of tests\" (click)=\"startIppTest(t.Id)\">{{t.Name}}</button>\r\n                </div>\r\n            </div>\r\n            <div class=\"modal-footer\">\r\n                <button type=\"button\" class=\"btn\" (click)=\"closeModal()\">Close</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),

/***/ "j+V+":
/***/ (function(module, exports) {

module.exports = "<div class=\"overlay-screen-wrapper\" style=\"z-index: 200001\">\r\n    <div class=\"overlay-screen\">\r\n        <div class=container>\r\n            <div class=\"row\">\r\n                <div class=\"col-md-6 col-md-offset-3\">\r\n                    <div class=\"form-horizontal\">\r\n                        <div class=\"form-group\">\r\n                            <h2 class=\"text-center\">Test Paused</h2>\r\n                        </div>\r\n                        <div class=\"form-group\">\r\n                            <div>\r\n                                <img src=\"{{testTakerPhotoUrl}}\" class=\"img-responsive\" style=\"margin: auto\" />\r\n                            </div>\r\n                            <p style=\"font-size: 1.2em\">Please wait for further instructions.</p>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),

/***/ "j2yi":
/***/ (function(module, exports) {

module.exports = "<button [hidden]=\"!isNavigationModalVisible\">asdads</button>\r\n<div class=\"my-modal\" [hidden]=\"!isNavigationModalVisible\">\r\n    <div class=\"modal-dialog\" role=\"document\">\r\n        <div class=\"modal-content\">\r\n            <div class=\"modal-header\">\r\n                <h4 class=\"modal-title\">Navigation</h4>\r\n            </div>\r\n            <div class=\"modal-body\" style=\"overflow-y: auto;\">\r\n                <div class=\"list-group\">\r\n                    <button type=\"button\" [class.active]=\"t.isSelected === true\" class=\"list-group-item\" *ngFor=\"let t of testlets\" (click)=\"setTestNavigation(t.testNavigation)\">{{t.title}}</button>\r\n                </div>\r\n            </div>\r\n            <div class=\"modal-footer\">\r\n                <button type=\"button\" class=\"btn btn-default\" (click)=\"closeNavigationModal()\">Close</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),

/***/ "jEjm":
/***/ (function(module, exports) {

module.exports = "<div class=\"speaking-interaction align-center\">\r\n    <div class=\"prompt\" *ngIf=\"prompt\"><span [innerHtml]=\"prompt\"></span></div>\r\n\r\n    <info-box\r\n        [text]=\"infoBoxText\"\r\n        [visible]=\"infoBoxVisible\"\r\n        [iconCssClass]=\"iconCssClass\"\r\n        [progressPercentage]=\"currentProgress\"\r\n        [counterText]=\"counterText\"\r\n        [mode]=\"infoBoxMode\"\r\n        [iconCover]=\"inputActivityLevel\"\r\n        >\r\n    </info-box>\r\n</div>\r\n"

/***/ }),

/***/ "jfyd":
/***/ (function(module, exports) {

module.exports = "<span *ngIf=\"interaction\">\r\n    <span [ngSwitch]=\"interaction.InteractionTypeId\">\r\n        <ng-template [ngSwitchCase]=\"1\">\r\n            <choice-interaction [interaction]=\"interaction\"></choice-interaction>\r\n        </ng-template>\r\n        <ng-template [ngSwitchCase]=\"2\">\r\n            <inline-choice-interaction [interaction]=\"interaction\"></inline-choice-interaction>\r\n        </ng-template>\r\n        <ng-template [ngSwitchCase]=\"3\">\r\n            <text-entry-interaction [interaction]=\"interaction\"></text-entry-interaction>\r\n        </ng-template>\r\n        <ng-template [ngSwitchCase]=\"4\">\r\n            <extended-text-interaction [interaction]=\"interaction\"></extended-text-interaction>\r\n        </ng-template>\r\n        <ng-template [ngSwitchCase]=\"5\">\r\n            <speaking-interaction [interaction]=\"interaction\"></speaking-interaction>\r\n        </ng-template>\r\n        <ng-template [ngSwitchCase]=\"6\">\r\n            <hotspot-interaction [interaction]=\"interaction\"></hotspot-interaction>\r\n        </ng-template>\r\n        <ng-template [ngSwitchCase]=\"7\">\r\n            <order-interaction [interaction]=\"interaction\"></order-interaction>\r\n        </ng-template>\r\n        <ng-template [ngSwitchCase]=\"8\">\r\n            <associate-interaction [interaction]=\"interaction\"></associate-interaction>\r\n        </ng-template>\r\n        <ng-template [ngSwitchCase]=\"9\">\r\n            <match-interaction [interaction]=\"interaction\"></match-interaction>\r\n        </ng-template>\r\n    </span>\r\n</span>\r\n"

/***/ }),

/***/ "k4W2":
/***/ (function(module, exports) {

module.exports = "<div [ngSwitch]=\"type\">\r\n    <ng-template [ngSwitchCase]=\"'picture'\">\r\n        <picture-resource [id]=\"id\"></picture-resource>\r\n    </ng-template>\r\n    <ng-template [ngSwitchCase]=\"'audio'\">\r\n        <media-resource [id]=\"id\" [type]=\"type\" [autoplay]=\"autoplay\"></media-resource>\r\n    </ng-template>\r\n    <ng-template [ngSwitchCase]=\"'video'\">\r\n        <media-resource [id]=\"id\" [type]=\"type\" [autoplay]=\"autoplay\"></media-resource>\r\n    </ng-template>\r\n    <ng-template [ngSwitchCase]=\"'html'\">\r\n        <html-resource [id]=\"id\"></html-resource>\r\n    </ng-template>\r\n    <ng-template [ngSwitchCase]=\"'pdf'\">\r\n        <pdf-resource [id]=\"id\" [hidepdf]=\"hidepdf\"></pdf-resource>\r\n    </ng-template>\r\n</div>"

/***/ }),

/***/ "kmoa":
/***/ (function(module, exports) {

module.exports = "<div class=\"microphone-check\" style=\"text-align: center;\">\r\n    <div *ngIf=\"step == 1\">\r\n        <p *ngIf=\"!isWebDelivery\">Make sure your headset is on, and click <strong>Play</strong> when you are ready.</p>\r\n        <p *ngIf=\"isWebDelivery\">Click <strong>Play</strong> when you are ready.</p>\r\n        <p><button class=\"btn btn-warning\" (click)=\"startRecording()\">Record</button></p>\r\n    </div>\r\n    <div *ngIf=\"step == 2\">\r\n        <p>Please read the following into the microphone. Your recording will not be scored.</p>\r\n        <p><strong>\"Canada is surrounded by three oceans: the Atlantic Ocean in the east, the Pacific Ocean in the west, and the Arctic Ocean to the north.\"</strong></p>\r\n    </div>\r\n    <div *ngIf=\"step == 3\">\r\n    </div>\r\n    <div *ngIf=\"step == 4\">\r\n        <p>Did you hear your voice?</p>\r\n        <p>\r\n            <button class=\"btn btn-warning\" (click)=\"goodRecording()\">Yes</button>\r\n            <button class=\"btn btn-warning\" (click)=\"badRecording()\">No</button>\r\n        </p>\r\n    </div>\r\n    <div *ngIf=\"step == 5\">\r\n        <p>Click <strong>Retry</strong> when you are ready to try again.</p>\r\n        <p>\r\n            <button class=\"btn btn-warning\" (click)=\"startRecording()\">Retry</button>\r\n        </p>\r\n    </div>\r\n</div>\r\n\r\n<audio id=\"audio-player\" autoplay controls class=\"hidden\"></audio>\r\n\r\n<info-box\r\n    [text]=\"infoBoxText\"\r\n    [visible]=\"infoBoxVisible\"\r\n    [iconCssClass]=\"iconCssClass\"\r\n    [progressPercentage]=\"currentProgress\"\r\n    [counterText]=\"counterText\"\r\n    [mode]=\"infoBoxMode\"\r\n    [iconCover]=\"inputActivityLevel\"\r\n    [forMicrophoneCheck]=\"true\"\r\n    >\r\n</info-box>\r\n"

/***/ }),

/***/ "m/j0":
/***/ (function(module, exports) {

module.exports = "<div class=\"overlay-screen-wrapper\" *ngIf=\"visible == true\">\r\n    <div class=\"overlay-screen\">\r\n        <h2 class=\"text-center\" [innerHTML]=\"title\"></h2>\r\n        <br />\r\n        <div [innerHTML]=\"content\"></div>\r\n    </div>\r\n</div>"

/***/ }),

/***/ "mB9l":
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"htmlContentReady\" id=\"#end-of-test-page\">\r\n    <section id=\"end-of-test-page-instructions\">\r\n        <hr>\r\n        <p>This is the end of the {{testName}}.</p>\r\n        <span class=\"reset-test\" (click)=\"resetTest()\">Restart Test</span>\r\n        <hr>\r\n        <div [innerHTML]=endOfTestDescription></div>\r\n    </section>\r\n</div>"

/***/ }),

/***/ "mZgk":
/***/ (function(module, exports) {

module.exports = "<button class=\"btn btn-default\" (click)=\"downloadResponses()\">{{title}}</button>"

/***/ }),

/***/ "orLx":
/***/ (function(module, exports) {

module.exports = "<div class=\"my-modal fade in\">\r\n    <div class=\"modal-dialog\" role=\"document\" *ngIf=\"mode\">\r\n        <div class=\"modal-content\">\r\n            <div class=\"modal-header\">\r\n                <h4 class=\"modal-title\" [innerHTML]=\"title\"></h4>\r\n            </div>\r\n            <div class=\"modal-body\" [innerHTML]=\"message\" *ngIf=\"mode == 'regular'\" style=\"overflow-y: auto;\"></div>\r\n            <div class=\"modal-body\" *ngIf=\"mode == 'times-up'\">\r\n                <p>The next page will appear in <strong [innerHTML]=\"timesUpCountDown\"></strong> seconds.</p>\r\n                <p>(Or click <strong>Next</strong> to continue)</p>\r\n            </div>\r\n            <div class=\"modal-footer\">\r\n                <button *ngFor=\"let btn of buttons\" type=\"button\" class=\"btn {{btn.style}} btn-modal\">{{btn.label}}</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),

/***/ "qAGO":
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\r\n    <div class=\"col-sm-5 panel-photo\" style=\"padding: 0 60px;\">\r\n        <img [src]=\"testTakerPhotoUrl\" style=\"width: 100%\" />\r\n    </div>\r\n    <div class=\"col-sm-7 panel-station\">\r\n        <div class=\"station\">\r\n            <div>{{label}}</div>\r\n            <div class=\"station-num\" [class.local-language-station-num]=\"showLocalLanguageNames\">{{stationNumber}}</div>\r\n        </div>\r\n        <div class=\"field\"><label>First Name:</label> <strong>{{_testTakerInfo.FirstName}}</strong></div>\r\n        <div class=\"field\"><label>Last Name:</label> <strong>{{_testTakerInfo.LastName}}</strong></div>\r\n        <div class=\"field local-language-name\" [class.local-language-name-show]=\"showLocalLanguageNames\"><label>First Name (Local):</label> <strong>{{_testTakerInfo.FirstNameLocalLanguage}}</strong></div>\r\n        <div class=\"field local-language-name\" [class.local-language-name-show]=\"showLocalLanguageNames\"><label>Last Name (Local):</label> <strong>{{_testTakerInfo.LastNameLocalLanguage}}</strong></div>\r\n    </div>\r\n</div>\r\n"

/***/ }),

/***/ "riDj":
/***/ (function(module, exports) {

module.exports = "<loading-overlay [loading]=\"!bandReady\"></loading-overlay>\r\n<div *ngIf=\"bandReady\">\r\n    <table class=\"table table-bordered feedback-page-table\">\r\n        <tr>\r\n            <th colspan=\"3\" class=\"text-center feedback-page-title\">CAEL CE Feedback</th>\r\n        </tr>\r\n        <tr>\r\n            <th class=\"text-center feedback-page-table-component-name\">Component</th>\r\n            <th class=\"text-center feedback-page-table-band-name\">Band</th>\r\n            <th class=\"text-center feedback-page-table-band-description\">Performance Description</th>\r\n        </tr>\r\n        <tr *ngFor=\"let componentSummary of scoreSummary.Components\">\r\n            <th class=\"text-center\" style=\"font-weight: lighter; vertical-align: middle;\">{{ componentSummary.ComponentName }}</th>\r\n            <th class=\"text-center\" style=\"font-weight: lighter; vertical-align: middle;\">{{ componentSummary.BandName }}</th>\r\n            <th style=\"font-weight: lighter;\">{{ componentSummary.BandDescription }}</th>\r\n        </tr>\r\n    </table>\r\n    <br>\r\n    <br>\r\n    <section id=\"feedback-page-disclaimer-text\" *ngIf=\"bandReady\">\r\n        <div style=\"text-align: center\"><strong>A Note About Your CAEL CE Feedback</strong></div>\r\n        <div [innerHTML]=disclaimerText></div>\r\n    </section>\r\n    <br>\r\n    <br>\r\n</div>\r\n"

/***/ }),

/***/ "rp94":
/***/ (function(module, exports) {

module.exports = "<form class=\"interaction-multi-choice\">\r\n    <div class=\"prompt\"><span [innerHtml]=\"choiceInteraction.Prompt\"></span></div>\r\n    <div *ngIf=\"choiceInteraction.MaxChoices == 1\">\r\n        <div class=\"choice-div\" *ngFor=\"let choice of choiceInteraction.SimpleChoices, let i = index\" [ngClass]=\"{ checked : selectedChoices.indexOf(choice.Identifier) >= 0 }\">\r\n            <input type=\"radio\" name=\"rad{{choiceInteraction.InteractionRefNum}}\" \r\n                [value]=\"choice.Identifier\" \r\n                [checked]=\"selectedChoices.indexOf(choice.Identifier) >= 0\" />\r\n            <span class=\"radio-content\" \r\n                (click)=\"setResponse(choice.Identifier)\">\r\n                <i class=\"radio-icon unchecked\"></i>\r\n                <i class=\"radio-icon checked\"></i>\r\n                <span class=\"choice\" [innerHtml]=\"replaceImageResourcePlaceHoldersWithTags(choice.Html)\"></span>\r\n            </span>\r\n        </div>\r\n    </div>\r\n    <div *ngIf=\"choiceInteraction.MaxChoices > 1\">\r\n        <div class=\"choice-div\" *ngFor=\"let choice of choiceInteraction.SimpleChoices, let i = index\" [ngClass]=\"{ checked : selectedChoices.indexOf(choice.Identifier) >= 0 }\">\r\n            <input type=\"checkbox\"\r\n                [checked]=\"selectedChoices.indexOf(choice.Identifier) >= 0\" />\r\n            <span class=\"check-content\"\r\n                (click)=\"setResponse(choice.Identifier)\">\r\n                <i class=\"check-icon unchecked\"></i>\r\n                <i class=\"check-icon checked\"></i>\r\n                <span class=\"choice\" [innerHtml]=\"replaceImageResourcePlaceHoldersWithTags(choice.Html)\"></span>\r\n            </span>\r\n        </div>\r\n    </div>         \r\n</form>"

/***/ }),

/***/ "sVWc":
/***/ (function(module, exports) {

module.exports = "<div>\r\n    <p><span [innerHtml]=\"orderInteraction.Prompt\"></span></p>\r\n    <ul id=\"order-interaction-{{interaction.InteractionId}}\" class=\"order-interaction\">\r\n        <li *ngFor=\"let choice of choices\" data-id=\"{{choice.Identifier}}\">\r\n            <span [innerHtml]=\"choice.Html\"></span>\r\n        </li>\r\n    </ul>\r\n</div>"

/***/ }),

/***/ "soNa":
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"hotspotInteraction && hotspotInteraction != null\">\r\n    <p>{{hotspotInteraction.Prompt}}</p>\r\n\r\n    <div class=\"hotspot-canvas\"\r\n        [style.width]=\"hotspotInteraction.ResourceObject.Width + 'px'\"\r\n        [style.height]=\"hotspotInteraction.ResourceObject.Height + 'px'\">\r\n\r\n        <img src=\"{{srcUrl}}\"\r\n            [style.width]=\"hotspotInteraction.ResourceObject.Width + 'px'\"\r\n            [style.height]=\"hotspotInteraction.ResourceObject.Height + 'px'\"\r\n            class=\"hot-spot-image\" />\r\n\r\n        <span *ngFor=\"let hotspot of hotspotInteraction.HotspotChoices\" [ngSwitch]=\"hotspot.Hotspot.Shape\">\r\n            <ng-template [ngSwitchCase]=\"2\">\r\n                <div\r\n                    class=\"rect draggable\"\r\n                    [class.selected]=\"isSelected(hotspot)\"\r\n                    (click)=\"toggleHotspot(hotspot)\"\r\n                    [style.width]=\"(hotspot.Hotspot.Coords.Data[2] - hotspot.Hotspot.Coords.Data[0]) + 'px'\"\r\n                    [style.height]=\"(hotspot.Hotspot.Coords.Data[3] - hotspot.Hotspot.Coords.Data[1]) + 'px'\"\r\n                    [style.top]=\"hotspot.Hotspot.Coords.Data[1] + 'px'\"\r\n                    [style.left]=\"hotspot.Hotspot.Coords.Data[0] + 'px'\"\r\n                    >\r\n                </div>\r\n            </ng-template>\r\n            <ng-template [ngSwitchCase]=\"3\">\r\n                <div\r\n                    class=\"circle draggable\"\r\n                    [class.selected]=\"isSelected(hotspot)\"\r\n                    (click)=\"toggleHotspot(hotspot)\"\r\n                    [style.width]=\"(hotspot.Hotspot.Coords.Data[2] * 2) + 'px'\"\r\n                    [style.height]=\"(hotspot.Hotspot.Coords.Data[2] * 2) + 'px'\"\r\n                    [style.top]=\"(hotspot.Hotspot.Coords.Data[1] - hotspot.Hotspot.Coords.Data[2]) + 'px'\"\r\n                    [style.left]=\"(hotspot.Hotspot.Coords.Data[0] - hotspot.Hotspot.Coords.Data[2]) + 'px'\"\r\n                    >\r\n                </div>\r\n            </ng-template>\r\n        </span>\r\n    </div>\r\n</div>"

/***/ }),

/***/ "wadJ":
/***/ (function(module, exports) {

module.exports = "<input\r\n    [type]=\"inputType\"\r\n    class=\"text-entry-input\"\r\n    [maxlength]=\"maxChar\"\r\n    [formControl]=\"textEntryControl\"\r\n    [style.width]=\"width + 'em'\"\r\n    [placeholder]=\"placeHolderText\"\r\n    spellcheck=\"false\"\r\n    />"

/***/ }),

/***/ "xPNa":
/***/ (function(module, exports) {

module.exports = "<div class=\"extended-text\">\r\n    <div [innerHTML]=\"extendedTextInteraction.Prompt\"></div>\r\n    <div class=\"ta-toolbar btn-toolbar\">\r\n        <div [class.hidden]=\"!extendedTextInteraction.FormattingBar\">\r\n            <div class=\"btn-group\" style=\"margin-right: 10px;\">\r\n                <button title=\"Bold\" (click)=\"execCommand('bold')\" class=\"btn btn-default\"><i class=\"fa fa-bold\"></i></button>\r\n                <button title=\"Italic\" (click)=\"execCommand('italic')\" class=\"btn btn-default\"><i class=\"fa fa-italic\"></i></button>\r\n                <button title=\"Underline\" (click)=\"execCommand('underline')\" class=\"btn btn-default\"><i class=\"fa fa-underline\"></i></button>\r\n            </div>\r\n            <div class=\"btn-group\" style=\"margin-right: 10px;\">\r\n                <button title=\"Cut\" (click)=\"execCommand('cut')\" class=\"btn btn-default\"><i class=\"fa fa-scissors\"></i></button>\r\n                <button title=\"Copy\" (click)=\"execCommand('copy')\" class=\"btn btn-default\"><i class=\"fa fa-clipboard\"></i></button>\r\n                <button title=\"Paste\" (click)=\"paste()\" class=\"btn btn-default\"><i class=\"fa fa-files-o\"></i></button>\r\n            </div>\r\n            <div class=\"btn-group\" style=\"margin-right: 10px;\">\r\n                <button title=\"Undo\" (click)=\"execCommand('undo')\" class=\"btn btn-default\"><i class=\"fa fa-undo\"></i></button>\r\n                <button title=\"Redo\" (click)=\"execCommand('redo')\" class=\"btn btn-default\"><i class=\"fa fa-repeat\"></i></button>\r\n            </div>\r\n            <div class=\"btn-group\" *ngIf=\"mode == 'ipp'\">\r\n                <button \r\n                    title=\"Download Response\" \r\n                    (click)=\"downloadWrittenResponse('my-response.doc', 'editor-container')\" \r\n                    class=\"btn btn-default\">\r\n                    <i class=\"fa fa-download\"></i>\r\n                </button>\r\n            </div>\r\n        </div>\r\n        <div class=\"btn-group float-right\">\r\n            <i *ngIf=\"!this.isReady\" class=\"fa fa-spinner fa-spin fa-fw\"></i>\r\n            <span *ngIf=\"this.isReady == true\">\r\n                Word Count: <strong>{{wordCount}}</strong>\r\n            </span>\r\n        </div>\r\n    </div>\r\n    <div\r\n        id=\"editor-container\"\r\n        data-gramm=\"false\"\r\n        class=\"editor-container text-area\"\r\n        [style.height]=\"editorHeight + 'px'\"\r\n        style=\"padding: 12px; overflow-y: scroll;\"\r\n        contenteditable\r\n        >\r\n    </div>\r\n</div>\r\n"

/***/ }),

/***/ "ylRF":
/***/ (function(module, exports) {

module.exports = "<div class=\"microphone-check\" style=\"text-align: center;\">\r\n    <div *ngIf=\"step == 1\">\r\n        <p *ngIf=\"!isWebDelivery\">Make sure your headset is on, and click <strong>Play</strong> when you are ready.</p>\r\n        <p *ngIf=\"isWebDelivery\">Click <strong>Play</strong> when you are ready.</p>\r\n        <p><button class=\"btn btn-warning\" (click)=\"playAudio()\">Play</button></p>\r\n    </div>\r\n    <div *ngIf=\"step == 2\">\r\n    </div>\r\n    <div *ngIf=\"step == 3\">\r\n        <p>Can you hear the recording well?</p>\r\n        <p>\r\n            <button class=\"btn btn-warning\" (click)=\"goodRecording()\">Yes</button>\r\n            <button class=\"btn btn-warning\" (click)=\"badRecording()\">No</button>\r\n        </p>\r\n    </div>\r\n    <div *ngIf=\"step == 4\">\r\n        <p>Click <strong>Retry</strong> when you are ready to try again.</p>\r\n        <p>\r\n            <button class=\"btn btn-warning\" (click)=\"playAudio()\">Retry</button>\r\n        </p>\r\n    </div>\r\n</div>\r\n\r\n<info-box\r\n    [text]=\"infoBoxText\"\r\n    [visible]=\"infoBoxVisible\"\r\n    [iconCssClass]=\"iconCssClass\"\r\n    [progressPercentage]=\"currentProgress\"\r\n    [counterText]=\"counterText\"\r\n    [mode]=\"infoBoxMode\"\r\n    [forMicrophoneCheck]=\"true\"\r\n    >\r\n</info-box>\r\n"

/***/ }),

/***/ "zLVS":
/***/ (function(module, exports) {

module.exports = "<div class=\"view-container\">\r\n    <div class=\"singlePane pane-content start-screen\">\r\n        <div class=\"main\">\r\n            <start-screen-photo\r\n                [testTakerPhotoUrl]=\"testTakerPhotoUrl\"\r\n                [stationNumber]=\"stationNumber\"\r\n                [testTakerInfo]=\"testTakerInfo\"\r\n            ></start-screen-photo>\r\n            <div style=\"clear: both;\"></div>\r\n            <div id=\"start-screen-error\" [class.visible]=\"errorMsg && errorMsg.length > 0\">\r\n                {{errorMsg}}\r\n            </div>\r\n            <div id=\"panel-content\">\r\n                <div style=\"text-align: center\" [innerHTML]=\"message\"></div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ })

},[0]);


// WEBPACK FOOTER //
// main.2ba3ac6d6009a162ad8e.bundle.js